(function() {
    'use strict';

    angular
        .module('winkballApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'ds.objectDiff',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ngMap',
            'ngTagsInput',
            'angucomplete-alt',
            'angularjs-dropdown-multiselect',
            'ngtweet',
            'AngularPrint'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('UserSearch', UserSearch);

    UserSearch.$inject = ['$resource'];

    function UserSearch($resource) {
        var resourceUrl =  'api/_search/users/:query';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.username = null;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        Principal.identity().then(function(account) {
            vm.username = account.login;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProtoHomeController', ProtoHomeController);

    ProtoHomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$stateParams', 'Reporter', 'Job', 'JobSearch', 'ParseLinks', 'AlertService'];

    function ProtoHomeController ($scope, Principal, LoginService, $state, $stateParams, Reporter, Job, JobSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = false;
        // default avatar
        vm.thumbnail = false;
        vm.login = LoginService.open;
        vm.register = register;
        vm.requestResetPassword = requestResetPassword;
        vm.reporter = null;

        vm.jobs = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'startDate';
        vm.reset = reset;
        vm.reverse = false;
        vm.inTransit = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.setApproved = setApproved;
        vm.canEdit = canEdit;
        vm.canDelete = canDelete;
        vm.filter = 'mine';
        vm.statuses = [];
        vm.setFilter = setFilter;
        vm.getImageSrc = getImageSrc;
        vm.goToReport = goToReport;
        vm.getHiddenStatusClass = getHiddenStatusClass;
        vm.setStatus = setStatus;

        if($stateParams.filter) {
            vm.filter = $stateParams.filter;
        }
        
        if($stateParams.status) {
            vm.statuses.push($stateParams.status);
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if(vm.account && vm.account.authorities.indexOf('ROLE_REPORTER') > -1){

                    var promise =  Reporter.getByLogin({login:vm.account.login}).$promise;
                    promise.then(function(reporter){
                        vm.reporter = reporter;
                        if(reporter.profilePicture) {
                            // 384,216
                            vm.thumbnail = 'https://streams2.winkball.com/images/' + reporter.profilePicture + '?w=256&h=144';
                        }
                    });
                }
                loadAll();
            });
        }

        function loadAll () {
            if (vm.currentSearch) {
                vm.filter = 'all';
                JobSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 10,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Job.query({
                    page: vm.page,
                    size: 10,
                    sort: sort(),
                    filter: vm.filter,
                    status: vm.statuses
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.jobs.push(data[i]);
                }
                
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.jobs = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.jobs = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'startDate';
            vm.reverse = false;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function setFilter($event, filter) {
            $event.stopPropagation();
            $event.preventDefault();

            if (filter) {
                vm.filter = filter;

                if (filter !== 'opened') {
                    vm.statuses = [];
                }
            }

            vm.page = 0;
            vm.jobs = [];
            vm.loadAll();
        }

        function setStatus(status) {

            var idx = vm.statuses.indexOf(status);

            // if currently selected
            if (idx > -1) {
                // remove status
                vm.statuses.splice(idx, 1);
            } else {
                // add status
                vm.statuses.push(status);
            }

            setFilter();
        }

        function getHiddenStatusClass(currentStatus, btnStatus) {
            if (currentStatus !== btnStatus) {
                return 'hidden-xs hidden-sm';
            }
            return '';
        }

        function setApproved(job, isApproved) {
            if(Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR'])) {
                job.approved = isApproved;
                Job.update(job, function () {
                    // vm.loadAll();
                    vm.clear();
                });
            }
        }

        function canEdit(job) {
            if(!vm.account) return false;
            return job.createdBy === vm.account.login ||
          (job.manager && job.manager.login === vm.account.login) ||
          Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function canDelete() {
            return Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }

            vm.jobs = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function register () {
            $state.go('register');
        }

        function requestResetPassword () {
            $state.go('requestReset');
        }

        function goToReport(jobId) {
            vm.inTransit = true;
            Job.events({id : jobId}).$promise.then(function(events) {
                vm.inTransit = false;
                if(angular.isArray(events) && events.length) {
                    $state.go('event-detail', {id: events[0].id});
                } else {
                    $state.go('job-detail', {id: jobId});
                }               
            }, function(){
                vm.inTransit = false;
                $state.go('job-detail', {id: jobId});
            });          
        }

        function getImageSrc(thumbnail, width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }
            
            if (thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + thumbnail + '?quality=ORIGINAL';
                }
            }

            return '';
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'wrapper',
            url: '/?filter',
            data: {
                authorities: []
            },
            views: {
                'wrapper@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('job');
                    $translatePartialLoader.addPart('global');
                    // $translatePartialLoader.addPart('sponsor');
                    return $translate.refresh();
                }]
            }
        }).state('member-software',{
            parent: 'wrapper',
            url: '/member-software',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Members Software'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/member-software.html'
                }
            }
        }).state('sales-documents',{
            parent: 'wrapper',
            url: '/sales-documents',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Sales Documents'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/sales-documents.html'
                }
            }
        }).state('social-media',{
            parent: 'wrapper',
            url: '/social-media',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Social Media'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/social-media.html'
                }
            }
        }).state('training-documents',{
            parent: 'wrapper',
            url: '/training-documents',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Training Documents'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/training-documents.html'
                }
            }
        }).state('winkball-chat',{
            parent: 'wrapper',
            url: '/winkball-chat',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Winkball Chat'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/winkball-chat.html'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('training-videos',{
            parent: 'wrapper',
            url: '/training-videos',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Training Videos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/training-videos.html'
                }
            }
        }).state('project-apply', {
            parent: 'home',
            url: 'new-project/{id}/apply',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job/job-apply-dialog.html',
                    controller: 'JobApplyController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Job', function(Job) {
                            return Job.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', {}, { location: 'replace' });
                });
            }]
        }).state('wizard', {
            abstract: true,
            parent: 'home',
            url: 'wizard'
        }).state('wizard.first', {
            parent: 'wizard',
            url: '/first',
            params: { project: null },
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-wizard-first.html',
                    controller: 'FirstProjectWizardController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                puid: null,
                                startDate: null,
                                endDate: null,
                                title: null,
                                description: null,
                                contactName: null,
                                contactPhone: null,
                                categories: [],
                            };
                        }
                    }
                }).result.then(function(result) {
                    $state.go('wizard.second', { project: result }, { reload: false });
                }, function() {
                    $state.go('home');
                });
            }]
        }).state('wizard.second', {
            parent: 'wizard',
            url: '/second',
            params: { project: null },
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-wizard-second.html',
                    controller: 'SecondProjectWizardController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function(result) {
                    $state.go('wizard.last', { project: result }, { reload: false });
                }, function(result) {
                    if(result === 'cancel') {
                        $state.go('home');
                    } else {
                        $state.go('wizard.first', { project: result }, { reload: false });
                    }
                });
            }]
        }).state('wizard.last', {
            parent: 'wizard',
            url: '/last',
            params: { project: null },
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-wizard-last.html',
                    controller: 'ProjectWizardController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('home', null, { reload: true });
                }, function(result) {
                    if(result === 'cancel') {
                        $state.go('home');
                    } else {
                        $state.go('wizard.second', { project: result }, { reload: false });
                    }
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$stateParams', 'Reporter', 'Job', 'JobSearch', 'ParseLinks', 'AlertService'];

    function HomeController ($scope, Principal, LoginService, $state, $stateParams, Reporter, Job, JobSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = false;
        // default avatar
        vm.thumbnail = false;
        vm.login = LoginService.open;
        vm.register = register;
        vm.requestResetPassword = requestResetPassword;
        vm.reporter = null;

        vm.jobs = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'startDate';
        vm.reset = reset;
        vm.reverse = false;
        vm.inTransit = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.setApproved = setApproved;
        vm.canEdit = canEdit;
        vm.canDelete = canDelete;
        
        if($stateParams.filter) {
            vm.filter = $stateParams.filter;
        } else {
            vm.filter = 'mine';
        }

        vm.statuses = [];
        vm.setFilter = setFilter;
        vm.getImageSrc = getImageSrc;
        vm.goToReport = goToReport;
        vm.getHiddenStatusClass = getHiddenStatusClass;
        vm.setStatus = setStatus;
        vm.sortBy = sortBy;
        
        if($stateParams.status) {
            vm.statuses.push($stateParams.status);
        }
        
        // TODO - remove this when filter is implemented on backend
        if(vm.filter === 'opened') {
            vm.statuses = [];
            vm.statuses.push('IN_PRODUCTION');
            vm.statuses.push('READY_TO_FILM');
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if(vm.account && vm.account.authorities.indexOf('ROLE_REPORTER') > -1){

                    var promise =  Reporter.getByLogin({login:vm.account.login}).$promise;
                    promise.then(function(reporter){
                        vm.reporter = reporter;
                        if(reporter.profilePicture) {
                            // 384,216
                            vm.thumbnail = 'https://streams2.winkball.com/images/' + reporter.profilePicture + '?w=256&h=144';
                        }
                    });
                }
                loadAll();
            });
        }

        function loadAll () {
            if (vm.currentSearch) {
                vm.filter = 'all';
                JobSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 16,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                // TODO - remove this when filter is implemented on backend
                if(vm.filter === 'opened') {
                    vm.statuses = [];
                    vm.statuses.push('IN_PRODUCTION');
                    vm.statuses.push('READY_TO_FILM');
                }
                Job.query({
                    page: vm.page,
                    size: 16,
                    sort: sort(),
                    filter: vm.filter,
                    status: vm.statuses
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.jobs.push(data[i]);
                }
                
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.jobs = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.jobs = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'startDate';
            vm.reverse = false;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function setFilter($event, filter) {
            $event.stopPropagation();
            $event.preventDefault();

            if (filter) {
                vm.filter = filter;
                if (filter !== 'opened') {
                    vm.statuses = [];
                }
            }
            vm.clear();
        }

        function sortBy($event, predicate, asc) {
            $event.stopPropagation();
            $event.preventDefault();

            vm.predicate = predicate;
            vm.reverse = asc;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.links = null;
            vm.reset();
        }

        function setStatus(status) {

            var idx = vm.statuses.indexOf(status);

            // if currently selected
            if (idx > -1) {
                // remove status
                vm.statuses.splice(idx, 1);
            } else {
                // add status
                vm.statuses.push(status);
            }

            vm.clear();
        }

        function getHiddenStatusClass(currentStatus, btnStatus) {
            if (currentStatus !== btnStatus) {
                return 'hidden-xs hidden-sm';
            }
            return '';
        }

        function setApproved(job, isApproved) {
            if(Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR'])) {
                job.approved = isApproved;
                Job.update(job, function () {
                    // vm.loadAll();
                    vm.clear();
                });
            }
        }

        function canEdit(job) {
            if(!vm.account) return false;
            return job.createdBy === vm.account.login ||
          (job.manager && job.manager.login === vm.account.login) ||
          Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function canDelete() {
            return Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }

            vm.jobs = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function register () {
            $state.go('register');
        }

        function requestResetPassword () {
            $state.go('requestReset');
        }

        function goToReport(jobId) {
            vm.inTransit = true;
            Job.events({id : jobId}).$promise.then(function(events) {
                vm.inTransit = false;
                if(angular.isArray(events) && events.length) {
                    $state.go('report-detail', {id: events[0].id, filter: vm.filter});
                } else {
                    $state.go('project-detail', {id: jobId, filter: vm.filter});
                }               
            }, function(){
                vm.inTransit = false;
                $state.go('project-detail', {id: jobId, filter: vm.filter});
            });          
        }

        function getImageSrc(thumbnail, width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }
            
            if (thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + thumbnail + '?quality=ORIGINAL';
                }
            }

            return '';
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('WebLinkDialogController', WebLinkDialogController);

    WebLinkDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'WebLink', 'Reporter'];

    function WebLinkDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, WebLink, Reporter) {
        var vm = this;

        vm.webLink = entity;
        vm.clear = clear;
        vm.save = save;
        
        // vm.customers = Customer.query();
        vm.reporters = Reporter.query({
            page: 0,
            size: 60,
            sort: ["user.firstName,asc"]
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.webLink.id !== null) {
                WebLink.update(vm.webLink, onSaveSuccess, onSaveError);
            } else {
                WebLink.save(vm.webLink, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:webLinkUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('WebLinkDetailController', WebLinkDetailController);

    WebLinkDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'WebLink', 'Customer', 'Reporter'];

    function WebLinkDetailController($scope, $rootScope, $stateParams, previousState, entity, WebLink, Customer, Reporter) {
        var vm = this;

        vm.webLink = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('winkballApp:webLinkUpdate', function(event, result) {
            vm.webLink = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('WebLinkDeleteController',WebLinkDeleteController);

    WebLinkDeleteController.$inject = ['$uibModalInstance', 'entity', 'WebLink'];

    function WebLinkDeleteController($uibModalInstance, entity, WebLink) {
        var vm = this;

        vm.webLink = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            WebLink.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('web-link', {
            parent: 'entity',
            url: '/web-link',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.webLink.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/web-link/web-links.html',
                    controller: 'WebLinkController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('webLink');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('web-link-detail', {
            parent: 'entity',
            url: '/web-link/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.webLink.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/web-link/web-link-detail.html',
                    controller: 'WebLinkDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('webLink');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'WebLink', function($stateParams, WebLink) {
                    return WebLink.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'web-link',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('web-link-detail.edit', {
            parent: 'web-link-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/web-link/web-link-dialog.html',
                    controller: 'WebLinkDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['WebLink', function(WebLink) {
                            return WebLink.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('web-link.new', {
            parent: 'web-link',
            url: '/new',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/web-link/web-link-dialog.html',
                    controller: 'WebLinkDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                url: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('web-link', null, { reload: true });
                }, function() {
                    $state.go('web-link');
                });
            }]
        })
        .state('web-link.edit', {
            parent: 'web-link',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/web-link/web-link-dialog.html',
                    controller: 'WebLinkDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['WebLink', function(WebLink) {
                            return WebLink.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('web-link', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('web-link.delete', {
            parent: 'web-link',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/web-link/web-link-delete-dialog.html',
                    controller: 'WebLinkDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['WebLink', function(WebLink) {
                            return WebLink.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('web-link', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('WebLink', WebLink);

    WebLink.$inject = ['$resource'];

    function WebLink ($resource) {
        var resourceUrl =  'api/web-links/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('WebLinkSearch', WebLinkSearch);

    WebLinkSearch.$inject = ['$resource'];

    function WebLinkSearch($resource) {
        var resourceUrl =  'api/_search/web-links/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('WebLinkController', WebLinkController);

    WebLinkController.$inject = ['$scope', '$state', 'WebLink', 'WebLinkSearch', 'ParseLinks', 'AlertService'];

    function WebLinkController ($scope, $state, WebLink, WebLinkSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.webLinks = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'createdDate';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                WebLinkSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                WebLink.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                // if (vm.predicate !== 'id') {
                //     result.push('id');
                // }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.webLinks.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.webLinks = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.webLinks = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.webLinks = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('VideoFileDialogController', VideoFileDialogController);

    VideoFileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VideoFile'];

    function VideoFileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VideoFile) {
        var vm = this;

        vm.videoFile = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(3)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.videoFile.id !== null) {
                VideoFile.update(vm.videoFile, onSaveSuccess, onSaveError);
            } else {
                VideoFile.save(vm.videoFile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:videoFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('VideoFileDetailController', VideoFileDetailController);

    VideoFileDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity'];

    function VideoFileDetailController($scope, $rootScope, previousState, entity) {
        var vm = this;

        vm.videoFile = entity;
        vm.previousState = previousState.name;
        vm.getVideoSrc = getVideoSrc;

        function getVideoSrc(quality, format) {
            quality = quality || "HD_720P";
            format = format || "MP4";

            if (vm.videoFile.guid) {
                return 'https://streams2.winkball.com/videos/'+vm.videoFile.guid+'?quality='+quality+'&format='+format;
            }
            return "";
        }

        var unsubscribe = $rootScope.$on('winkballApp:videoFileUpdate', function(event, result) {
            vm.videoFile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('VideoFileDeleteController',VideoFileDeleteController);

    VideoFileDeleteController.$inject = ['$uibModalInstance', 'entity', 'VideoFile'];

    function VideoFileDeleteController($uibModalInstance, entity, VideoFile) {
        var vm = this;

        vm.videoFile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VideoFile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('video-file', {
            parent: 'entity',
            url: '/video-file',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.videoFile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/video-file/video-files.html',
                    controller: 'VideoFileController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('videoFile');
                    $translatePartialLoader.addPart('videoStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('video-file-detail', {
            parent: 'entity',
            url: '/video-file/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.videoFile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/video-file/video-file-detail.html',
                    controller: 'VideoFileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('videoFile');
                    $translatePartialLoader.addPart('videoStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VideoFile', function($stateParams, VideoFile) {
                    return VideoFile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'video-file',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('video-file-detail.edit', {
            parent: 'video-file-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-file/video-file-dialog.html',
                    controller: 'VideoFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VideoFile', function(VideoFile) {
                            return VideoFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('video-file.new', {
            parent: 'video-file',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-file/video-file-dialog.html',
                    controller: 'VideoFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                guid: null,
                                puid: null,
                                status: null,
                                bitrate: null,
                                audiosamplerate: null,
                                filesize: null,
                                duration: null,
                                framerate: null,
                                width: null,
                                height: null,
                                codec: null,
                                audiocodec: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('video-file', null, { reload: true });
                }, function() {
                    $state.go('video-file');
                });
            }]
        })
        .state('video-file.edit', {
            parent: 'video-file',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-file/video-file-dialog.html',
                    controller: 'VideoFileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VideoFile', function(VideoFile) {
                            return VideoFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('video-file', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('video-file.delete', {
            parent: 'video-file',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-file/video-file-delete-dialog.html',
                    controller: 'VideoFileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VideoFile', function(VideoFile) {
                            return VideoFile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('video-file', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('VideoFile', VideoFile);

    VideoFile.$inject = ['$resource'];

    function VideoFile ($resource) {
        var resourceUrl =  'api/video-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('VideoFileSearch', VideoFileSearch);

    VideoFileSearch.$inject = ['$resource'];

    function VideoFileSearch($resource) {
        var resourceUrl =  'api/_search/video-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('VideoFileController', VideoFileController);

    VideoFileController.$inject = ['$scope', '$state', 'VideoFile', 'VideoFileSearch', 'ParseLinks', 'AlertService'];

    function VideoFileController ($scope, $state, VideoFile, VideoFileSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.videoFiles = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'createdDate';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                VideoFileSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                VideoFile.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                // if (vm.predicate !== 'id') {
                //     result.push('id');
                // }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.videoFiles.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.videoFiles = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.videoFiles = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.videoFiles = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('VideoDialogController', VideoDialogController);

    VideoDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', '$log', '$q', '$http', 'entity', 'Video', 'VideoFile', 'Location', 'LocationSearch', 'KeywordSearch', 'Upload'];

    function VideoDialogController ($timeout, $scope, $uibModalInstance, $log, $q, $http, entity, Video, VideoFile, Location, LocationSearch, KeywordSearch, Upload) {
        var vm = this;

        vm.video = entity;
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = vm.video.thumbnail;
        vm.tagLocation = [];
        vm.clear = clear;
        vm.save = save;
        vm.getVideoSrc = getVideoSrc;
        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.uploadFile = uploadFile;
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));
        vm.videofiles = VideoFile.query({filter: 'video-is-null'});
        vm.categories = [
            'GENERIC',
            'CHANNEL_BRANDING',
            'TRANSITION',
            'STUDIO_WORK',
            'SPECIAL_PARTNER',
            'MEDIA_PARTNER',
            'CHANNEL_SPONSOR',
            'EXTERNAL_CONTENT',
            'TRAINING'
        ];
        vm.searchLocation = searchLocation;

        $q.all([vm.video.$promise, vm.videofiles.$promise]).then(function() {
            if (!vm.video.videoFileId) {
                return $q.reject();
            }
            return VideoFile.get({id : vm.video.videoFileId}).$promise;
        }).then(function(videoFile) {
            vm.videofiles.push(videoFile);
        });

        $q.all([vm.video.$promise]).then(function() {
            if (!vm.video.locationId) {
                return $q.reject();
            }
            return Location.get({id : vm.video.locationId}).$promise;
        }).then(function(location) {
            vm.tagLocation = [location];
        });
        
        vm.loadKeywords = loadKeywords;

        function loadKeywords(query) {
            return KeywordSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        function searchLocation(query) {
            return LocationSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            vm.video.thumbnail = vm.originalThumbnail;

            var puids = vm.thumbnailsForDeletion.filter(function (value) {
                return vm.originalThumbnail !== value;
            });

            if(puids.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              puids, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    $log.error('error deleting images');
                }
            );
            }

            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.thumbnailsForDeletion.length > 0) {
                $http.post(
                'https://streams2.winkball.com/delete-images',
                vm.thumbnailsForDeletion, {
                    headers:{
                        'Authorization': 'Bearer ' + vm.authToken
                    }}).then(
                  function () {
                      vm.thumbnailsForDeletion = [];
                  },
                  function () {
                      $log.error('error deleting thumbnail');
                  }
              );
            }

            if(vm.tagLocation.length > 0) {
                vm.video.locationId = vm.tagLocation[0].id;
            } else {
                vm.video.locationId = null;
            }

            if (vm.video.id !== null) {
                Video.update(vm.video, onSaveSuccess, onSaveError);
            } else {
                Video.save(vm.video, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:videoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.originalThumbnail = vm.video.thumbnail;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function deleteThumbnail() {
            vm.thumbnailsForDeletion.push(vm.video.thumbnail);
            vm.video.thumbnail = null;
        }

        function getVideoSrc(quality, format) {
            quality = quality || "ORIGINAL";
            format = format || "MP4";

            if (vm.video.videoFileGuid) {
                return 'https://streams2.winkball.com/videos/'+vm.video.videoFileGuid+'?quality='+quality+'&format='+format;
            }
            return "";
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.video.thumbnail) {
                return 'https://streams2.winkball.com/images/'+vm.video.thumbnail+dimentions;
            }

            return '';
        }

        function uploadFile(file, errFiles, image) {
            vm.isSaving = true;
            vm.f = file;
            vm.videofile = !image;
            vm.errFile = errFiles && errFiles[0];

            if (file) {
                var uploadURL = "https://streams2.winkball.com/videos";

                if(image) {
                    uploadURL = "https://streams2.winkball.com/images";
                }
                file.upload = Upload.upload(
                    {
                        url: uploadURL,
                        data: { file: file },
                        headers: {
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }
              ).then(function (response) {
                  $timeout(function () {
                      file.result = response.data;
                      vm.isSaving = false;
                      if (response.status == '201') {
                          $log.log('Image upload status 201');
                          if(image) {
                              vm.video.thumbnail = response.data;
                          } else {
                              vm.video.videoFileGuid = response.data;
                              vm.video.videoFileName = file.name;
                          }
                      }
                  }, 1000);
              }, function (response) {
                  $log.log('Error...');
                  $log.debug(response);
                  vm.isSaving = false;
                  if (response.status > 0) {
                      vm.errorMsg = response.status + ': ' + response.data;
                  }
              }, function (evt) {
                  file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
              });
            }
        } // end of uploadFile
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('VideoDetailController', VideoDetailController);

    VideoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Video', 'VideoFile', 'Location', 'Keyword'];

    function VideoDetailController($scope, $rootScope, $stateParams, previousState, entity, Video, VideoFile, Location, Keyword) {
        var vm = this;

        vm.video = entity;
        vm.previousState = previousState.name;
        vm.getVideoSrc = getVideoSrc;
        vm.getImageSrc = getImageSrc;

        function getVideoSrc(quality, format) {
            quality = quality || "HD_720P";
            format = format || "MP4";

            if (vm.video.videoFileGuid) {
                return 'https://streams2.winkball.com/videos/'+vm.video.videoFileGuid+'?quality='+quality+'&format='+format;
            }
            return "";
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.video.thumbnail) {
                return 'https://streams2.winkball.com/images/'+vm.video.thumbnail+dimentions;
            }

            return '';
        }

        var unsubscribe = $rootScope.$on('winkballApp:videoUpdate', function(event, result) {
            vm.video = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('VideoDeleteController',VideoDeleteController);

    VideoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Video'];

    function VideoDeleteController($uibModalInstance, entity, Video) {
        var vm = this;

        vm.video = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Video.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('video', {
            parent: 'entity',
            url: '/video',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.video.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/video/videos.html',
                    controller: 'VideoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('video');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('video-detail', {
            parent: 'entity',
            url: '/video/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.video.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/video/video-detail.html',
                    controller: 'VideoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('video');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Video', function($stateParams, Video) {
                    return Video.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'video',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('video-detail.edit', {
            parent: 'video-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video/video-dialog.html',
                    controller: 'VideoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Video', function(Video) {
                            return Video.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('video.new', {
            parent: 'video',
            url: '/new',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video/video-dialog.html',
                    controller: 'VideoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                puid: null,
                                title: null,
                                description: null,
                                published: false,
                                category: 'GENERIC',
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('video', null, { reload: true });
                }, function() {
                    $state.go('video');
                });
            }]
        })
        .state('video.edit', {
            parent: 'video',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video/video-dialog.html',
                    controller: 'VideoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Video', function(Video) {
                            return Video.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('video', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('video.delete', {
            parent: 'video',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video/video-delete-dialog.html',
                    controller: 'VideoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Video', function(Video) {
                            return Video.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('video', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Video', Video);

    Video.$inject = ['$resource'];

    function Video ($resource) {
        var resourceUrl =  'api/videos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('VideoSearch', VideoSearch);

    VideoSearch.$inject = ['$resource'];

    function VideoSearch($resource) {
        var resourceUrl =  'api/_search/videos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('VideoController', VideoController);

    VideoController.$inject = ['$scope', '$state', 'Video', 'VideoSearch', 'ParseLinks', 'AlertService'];

    function VideoController ($scope, $state, Video, VideoSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.videos = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'createdDate';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                VideoSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Video.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                // if (vm.predicate !== 'id') {
                //     result.push('id');
                // }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.videos.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.videos = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.videos = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.videos = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SponsorInvoiceDialogController', SponsorInvoiceDialogController);

    SponsorInvoiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$q', '$uibModalInstance', 'entity', 'Sponsor', 'SponsorInvoice'];

    function SponsorInvoiceDialogController($timeout, $scope, $stateParams, $q, $uibModalInstance, entity, Sponsor, SponsorInvoice) {
      var vm = this;

      vm.sponsorInvoice = entity;
      vm.clear = clear;
      vm.save = save;
      vm.datePickerOpenStatus = {};
      vm.openCalendar = openCalendar;

      vm.sponsors = Sponsor.query({
        page: 0,
        size: 40,
        sort: "createdDate,desc"});

      $q.all([vm.sponsorInvoice.$promise]).then(function() {
        if(!vm.sponsorInvoice.id) {
          return $q.reject();
        }
        return Sponsor.get({id : vm.sponsorInvoice.id}).$promise;
      }).then(function(sponsor) {
        vm.sponsors.push(sponsor);
        vm.sponsorInvoice.sponsor = sponsor;
      });

      $q.all([vm.sponsorInvoice.$promise]).then(function() {
        if(vm.sponsorInvoice.id) {
          return $q.reject();
        }

        if(!$stateParams.sponsor) {
          return $q.reject();
        }
          return Sponsor.get({id : $stateParams.sponsor}).$promise;
      }).then(function(sponsor) {
        // set job if exists
        vm.sponsorInvoice.sponsor = sponsor;
        // copy project price into sponsorship ammount
        vm.sponsorInvoice.amount = sponsor.sponsorshipAmount;
      });

      $timeout(function (){
        angular.element('.form-group:eq(1)>input').focus();
      });

      function clear () {
        $uibModalInstance.dismiss('cancel');
      }

      function save () {
        vm.isSaving = true;
        if (vm.sponsorInvoice.id !== null) {
          SponsorInvoice.update(vm.sponsorInvoice, onSaveSuccess, onSaveError);
        } else {
          SponsorInvoice.save(vm.sponsorInvoice, onSaveSuccess, onSaveError);
        }
      }

      function onSaveSuccess (result) {
        $scope.$emit('winkballApp:sponsorInvoiceUpdate', result);
        $uibModalInstance.close(result);
        vm.isSaving = false;
      }

      function onSaveError () {
        vm.isSaving = false;
      }

      vm.datePickerOpenStatus.paymentDate = false;

      function openCalendar (date) {
        vm.datePickerOpenStatus[date] = true;
      }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SponsorInvoiceDetailController', SponsorInvoiceDetailController);

    SponsorInvoiceDetailController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'previousState', 'entity', 'Principal', 'Sponsor', 'SponsorInvoice'];

    function SponsorInvoiceDetailController($scope, $rootScope, $state, $stateParams, previousState, entity, Principal, Sponsor, SponsorInvoice) {
        var vm = this;

        vm.sponsorInvoice = entity;
        vm.previousState = previousState.name;
        vm.canEdit = canEdit;
        vm.isManager = isManager;
        vm.back = back;

        getAccount();

        var unsubscribe = $rootScope.$on('winkballApp:sponsorInvoiceUpdate', function(event, result) {
            vm.sponsorInvoice = result;
        });

        function getAccount() {
          Principal.identity().then(function(account) {
            console.log('identity loaded');
            vm.account = account;
          });
        }

        function canEdit() {
          if(!vm.account) return false;
          return vm.sponsorInvoice.createdBy === vm.account.login ||
          Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function isManager() {
          if(!vm.account) return false;
          return Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function back() {
          $state.go(previousState.name, previousState.params);
        }

        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SponsorInvoiceDeleteController',SponsorInvoiceDeleteController);

    SponsorInvoiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'SponsorInvoice'];

    function SponsorInvoiceDeleteController($uibModalInstance, entity, SponsorInvoice) {
        var vm = this;

        vm.sponsorInvoice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
          SponsorInvoice.delete({id: id},
              function () {
                  $uibModalInstance.close(true);
              });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sponsor-invoice', {
            parent: 'entity',
            url: '/sponsor-invoice',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_ADMIN'],
                pageTitle: 'winkballApp.sponsorInvoice.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sponsor-invoice/sponsor-invoices.html',
                    controller: 'SponsorInvoiceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sponsorInvoice');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sponsor-invoice-detail', {
            parent: 'entity',
            url: '/sponsor-invoice/{id}',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_MANAGER', 'ROLE_ADMIN'],
                pageTitle: 'winkballApp.sponsorInvoice.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sponsor-invoice/sponsor-invoice-detail.html',
                    controller: 'SponsorInvoiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sponsorInvoice');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SponsorInvoice', function($stateParams, SponsorInvoice) {
                    return SponsorInvoice.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sponsor-invoice',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sponsor-invoice-detail.edit', {
            parent: 'sponsor-invoice-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_MANAGER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sponsor-invoice/sponsor-invoice-dialog.html',
                    controller: 'SponsorInvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SponsorInvoice', function(SponsorInvoice) {
                            return SponsorInvoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sponsor-invoice.new', {
            parent: 'sponsor-invoice',
            url: '/new?sponsor',
            data: {
              authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sponsor-invoice/sponsor-invoice-dialog.html',
                    controller: 'SponsorInvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                paymentDate: null,
                                amount: 0,
                                sponsor: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                  if($stateParams.sponsor) {
                    $state.go('sponsor-detail', { id : $stateParams.sponsor }, { reload: true });
                  } else {
                    $state.go('sponsor-invoice', null, { reload: true });
                  }
                }, function() {
                  if($stateParams.sponsor) {
                    $state.go('sponsor-detail', { id : $stateParams.sponsor });
                  } else {
                    $state.go('sponsor-invoice');
                  }
                });
            }]
        })
        .state('sponsor-invoice.edit', {
            parent: 'sponsor-invoice',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sponsor-invoice/sponsor-invoice-dialog.html',
                    controller: 'SponsorInvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SponsorInvoice', function(SponsorInvoice) {
                            return SponsorInvoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sponsor-invoice', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sponsor-invoice.delete', {
            parent: 'sponsor-invoice',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sponsor-invoice/sponsor-invoice-delete-dialog.html',
                    controller: 'SponsorInvoiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SponsorInvoice', function(SponsorInvoice) {
                          return SponsorInvoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sponsor-invoice', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('SponsorInvoice', SponsorInvoice);

    SponsorInvoice.$inject = ['$resource', 'DateUtils'];

    function SponsorInvoice($resource, DateUtils) {
        var resourceUrl =  'api/sponsor-invoices/:id';

        return $resource(resourceUrl, {},
          {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.paymentDate = DateUtils.convertDateTimeFromServer(data.paymentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('SponsorInvoiceSearch', SponsorInvoiceSearch);

    SponsorInvoiceSearch.$inject = ['$resource'];

    function SponsorInvoiceSearch($resource) {
      var resourceUrl =  'api/_search/sponsor-invoices/:id';

      return $resource(resourceUrl, {}, {
          'query': { method: 'GET', isArray: true}
      });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SponsorInvoiceController', SponsorInvoiceController);

    SponsorInvoiceController.$inject = ['$scope', '$state', 'Principal', 'SponsorInvoice', 'SponsorInvoiceSearch', 'ParseLinks', 'AlertService'];

    function SponsorInvoiceController ($scope, $state, Principal, SponsorInvoice, SponsorInvoiceSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.sponsorInvoices = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.canEdit = canEdit;

        getAccount();
        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                SponsorInvoiceSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                SponsorInvoice.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.sponsorInvoices.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.sponsorInvoices = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.sponsorInvoices = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.sponsorInvoices = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function getAccount() {
          Principal.identity().then(function(account) {
            console.log('identity loaded');
            vm.account = account;
          });
        }

        function canEdit(sponsorInvoice) {
          if(!vm.account) return false;
          return sponsorInvoice.createdBy === vm.account.login ||
          Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SponsorDialogController', SponsorDialogController);

    SponsorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$q', '$uibModalInstance', 'entity', 'Principal', 'Sponsor', 'User', 'Job', 'PostalAddress', 'Event'];

    function SponsorDialogController ($timeout, $scope, $stateParams, $q, $uibModalInstance, entity, Principal, Sponsor, User, Job, PostalAddress, Event) {
        var vm = this;

        vm.sponsor = entity;
        vm.clear = clear;
        vm.save = save;
        vm.users = [];
        vm.address = "";
        vm.search = "";

        vm.jobs = Job.query({
            page: 0,
            size: 40,
            sort: "createdDate,desc"});

        vm.account = Principal.identity();

      // add current user as a finder for new sponsor
        vm.account.then(function(account){
            $q.all([vm.sponsor.$promise]).then(function() {
                if(vm.sponsor.id) {
                    return $q.reject();
                }

                return User.get({login:account.login}).$promise;
            }).then(function(user) {
                vm.sponsor.finder = user;
                vm.users.push(user);

                if(user.login !== 'winkball') {
                    var winkballUser = User.get({login:'winkball'}).$promise;
                    winkballUser.then(function (wbUser) {
                        vm.users.push(wbUser);
                    }, function (reason){
                        console.log(reason);
                    });
                }
            });
        });

        $q.all([vm.sponsor.$promise, vm.jobs.$promise]).then(function() {
            if(!vm.sponsor.job) {
                return $q.reject();
            }

            return Job.get({id : vm.sponsor.job.id}).$promise;
        }).then(function(job) {
            vm.sponsor.job = job;
            vm.jobs.push(job);
            if(!vm.sponsor.id) {
                // copy project price into sponsorship ammount
                vm.sponsor.sponsorshipAmount = job.projectPrice;
            }
        });

        $q.all([vm.sponsor.$promise, vm.jobs.$promise]).then(function() {
            if(vm.sponsor.id) {
                return $q.reject();
            }

            if(!$stateParams.job) {
                return $q.reject();
            }
            return Job.get({id : $stateParams.job}).$promise;
        }).then(function(job) {
            // set job if exists
            vm.sponsor.job = job;

            vm.jobs.push(job);

            // copy project price into sponsorship ammount
            vm.sponsor.sponsorshipAmount = job.projectPrice;
        });
        
        // required when adding sponsor on report/event page
        $q.all([vm.sponsor.$promise, vm.jobs.$promise]).then(function() {
            if(vm.sponsor.id && !$stateParams.type) {
                return $q.reject();
            }

            if($stateParams.type !== 'event') {
                return $q.reject();
            }

            return Event.get({id : $stateParams.id}).$promise;
        }).then(function(event) {
            // set job if exists
            vm.sponsor.job = event.job;

            vm.jobs.push(event.job);

            // copy project price into sponsorship ammount
            vm.sponsor.sponsorshipAmount = event.job.projectPrice;
        });

        $q.all([vm.sponsor.$promise]).then(function() {
            if(!vm.sponsor.finder) {
                return $q.reject();
            }
            vm.users.push(vm.sponsor.finder);

            if(vm.account.login !== 'winkball') {
                var winkballUser = User.get({login:'winkball'}).$promise;
                winkballUser.then(function (wbUser) {
                    vm.users.push(wbUser);
                }, function (reason){
                    console.log(reason);
                });
            }
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sponsor.address.id !== null) {
                PostalAddress.update(vm.sponsor.address, saveSponsor, onSaveError);
            } else {
                PostalAddress.save(vm.sponsor.address, saveSponsor, onSaveError);
            }
        }

        function saveSponsor(address) {
            vm.sponsor.address = address;
            if (vm.sponsor.id !== null) {
                Sponsor.update(vm.sponsor, onSaveSuccess, onSaveError);
            } else {
                Sponsor.save(vm.sponsor, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:sponsorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SponsorDetailController', SponsorDetailController);

    SponsorDetailController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', '$q', 'previousState', 'entity', 'Principal', 'Sponsor', 'SponsorInvoice'];

    function SponsorDetailController($scope, $rootScope, $state, $stateParams, $q, previousState, entity, Principal, Sponsor, SponsorInvoice) {
        var vm = this;

        vm.sponsor = entity;
        vm.previousState = previousState.name;
        vm.canEdit = canEdit;
        vm.isManager = isManager;
        vm.back = back;
        vm.sponsorInvoice = null;

        getAccount();

        $q.all([vm.sponsor.$promise]).then(function() {
            if (!vm.sponsor.id) {
              return $q.reject();
            }
            return SponsorInvoice.get({id : vm.sponsor.id}).$promise;
        }).then(function(invoice) {
          console.log('invoice found');
          vm.sponsorInvoice = invoice;
        });

        var unsubscribe = $rootScope.$on('winkballApp:sponsorUpdate', function(event, result) {
            vm.sponsor = result;
        });

        function getAccount() {
          Principal.identity().then(function(account) {
            console.log('identity loaded');
            vm.account = account;
          });
        }

        function canEdit() {
          if(!vm.account) return false;
          return vm.sponsor.createdBy === vm.account.login ||
          Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function isManager() {
          if(!vm.account) return false;
          return Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function back() {
          $state.go(previousState.name, previousState.params);
        }

        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SponsorDeleteController',SponsorDeleteController);

    SponsorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Sponsor'];

    function SponsorDeleteController($uibModalInstance, entity, Sponsor) {
        var vm = this;

        vm.sponsor = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
          Sponsor.delete({id: id},
              function () {
                  $uibModalInstance.close(true);
              });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sponsor', {
            parent: 'entity',
            url: '/sponsor',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.sponsor.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sponsor/sponsors.html',
                    controller: 'SponsorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sponsor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sponsor-detail', {
            parent: 'entity',
            url: '/sponsor/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.sponsor.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sponsor/sponsor-detail.html',
                    controller: 'SponsorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sponsor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Sponsor', function($stateParams, Sponsor) {
                    return Sponsor.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sponsor',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sponsor-detail.edit', {
            parent: 'sponsor-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sponsor/sponsor-dialog.html',
                    controller: 'SponsorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sponsor', function(Sponsor) {
                            return Sponsor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sponsor.new', {
            parent: 'sponsor',
            url: '/new?job',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sponsor/sponsor-dialog.html',
                    controller: 'SponsorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sponsorName: null,
                                puid: null,
                                createdDate: null,
                                contactName: null,
                                contactEmail: null,
                                telephone: null,
                                finder: null,
                                job: null,
                                address: { id: null, country: 'GBR'},
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    if($stateParams.job) {
                        $state.go('job-detail', { id : $stateParams.job }, { reload: true });
                    } else {
                        $state.go('sponsor', null, { reload: true });
                    }
                }, function() {
                    if($stateParams.job) {
                        $state.go('job-detail', { id : $stateParams.job });
                    } else {
                        $state.go('sponsor');
                    }
                });
            }]
        })
        .state('sponsor.edit', {
            parent: 'sponsor',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sponsor/sponsor-dialog.html',
                    controller: 'SponsorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sponsor', function(Sponsor) {
                            return Sponsor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sponsor', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sponsor.delete', {
            parent: 'sponsor',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sponsor/sponsor-delete-dialog.html',
                    controller: 'SponsorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Sponsor', function(Sponsor) {
                            return Sponsor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sponsor', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Sponsor', Sponsor);

    Sponsor.$inject = ['$resource', 'DateUtils'];

    function Sponsor ($resource, DateUtils) {
        var resourceUrl =  'api/sponsors/:id';

        return $resource(resourceUrl, {},
          {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('SponsorSearch', SponsorSearch);

    SponsorSearch.$inject = ['$resource'];

    function SponsorSearch($resource) {
      var resourceUrl =  'api/_search/sponsors/:id';

      return $resource(resourceUrl, {}, {
          'query': { method: 'GET', isArray: true}
      });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SponsorController', SponsorController);

    SponsorController.$inject = ['$scope', '$state', 'Principal', 'Sponsor', 'SponsorSearch', 'ParseLinks', 'AlertService'];

    function SponsorController ($scope, $state, Principal, Sponsor, SponsorSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.sponsors = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.canEdit = canEdit;
        vm.isManager = isManager;

        getAccount();
        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                SponsorSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Sponsor.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.sponsors.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.sponsors = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.sponsors = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.sponsors = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function getAccount() {
          Principal.identity().then(function(account) {
            console.log('identity loaded');
            vm.account = account;
          });
        }

        function canEdit(sponsor) {
          if(!vm.account) return false;
          return sponsor.createdBy === vm.account.login ||
          Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function isManager() {
          return Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SkillDialogController', SkillDialogController);

    SkillDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Skill', 'Reporter'];

    function SkillDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Skill, Reporter) {
        var vm = this;

        vm.skill = entity;
        vm.clear = clear;
        vm.save = save;
        vm.reporters = Reporter.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        $scope.$watch('vm.skill.name', function() {
          if(vm.skill.name) {
            vm.skill.name = vm.skill.name.toLowerCase();
          }
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.skill.id !== null) {
                Skill.update(vm.skill, onSaveSuccess, onSaveError);
            } else {
                Skill.save(vm.skill, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:skillUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SkillDetailController', SkillDetailController);

    SkillDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Skill', 'Reporter'];

    function SkillDetailController($scope, $rootScope, $stateParams, previousState, entity, Skill, Reporter) {
        var vm = this;

        vm.skill = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('winkballApp:skillUpdate', function(event, result) {
            vm.skill = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SkillDeleteController',SkillDeleteController);

    SkillDeleteController.$inject = ['$uibModalInstance', 'entity', 'Skill'];

    function SkillDeleteController($uibModalInstance, entity, Skill) {
        var vm = this;

        vm.skill = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Skill.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('skill', {
            parent: 'entity',
            url: '/skill',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.skill.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/skill/skills.html',
                    controller: 'SkillController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('skill');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('skill-detail', {
            parent: 'entity',
            url: '/skill/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.skill.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/skill/skill-detail.html',
                    controller: 'SkillDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('skill');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Skill', function($stateParams, Skill) {
                    return Skill.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'skill',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('skill-detail.edit', {
            parent: 'skill-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skill/skill-dialog.html',
                    controller: 'SkillDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Skill', function(Skill) {
                            return Skill.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('skill.new', {
            parent: 'skill',
            url: '/new',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skill/skill-dialog.html',
                    controller: 'SkillDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('skill', null, { reload: true });
                }, function() {
                    $state.go('skill');
                });
            }]
        })
        .state('skill.edit', {
            parent: 'skill',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skill/skill-dialog.html',
                    controller: 'SkillDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Skill', function(Skill) {
                            return Skill.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('skill', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('skill.delete', {
            parent: 'skill',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skill/skill-delete-dialog.html',
                    controller: 'SkillDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Skill', function(Skill) {
                            return Skill.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('skill', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Skill', Skill);

    Skill.$inject = ['$resource'];

    function Skill ($resource) {
        var resourceUrl =  'api/skills/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('SkillSearch', SkillSearch);

    SkillSearch.$inject = ['$resource'];

    function SkillSearch($resource) {
        var resourceUrl =  'api/_search/skills/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SkillController', SkillController);

    SkillController.$inject = ['$scope', '$state', 'Skill', 'SkillSearch'];

    function SkillController ($scope, $state, Skill, SkillSearch) {
        var vm = this;
        
        vm.skills = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Skill.query(function(result) {
                vm.skills = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SkillSearch.query({query: vm.searchQuery}, function(result) {
                vm.skills = result;
            });
        }    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ReporterDialogController', ReporterDialogController);

    ReporterDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$http', 'entity', 'Principal', 'Reporter', 'PostalAddress', 'User', 'WebLink', 'Job', 'Interview', 'Film', 'Skill', 'JhiLanguageService', 'Upload'];

    function ReporterDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, $http, entity, Principal, Reporter, PostalAddress, User, WebLink, Job, Interview, Film, Skill, JhiLanguageService, Upload) {
        var vm = this;

        vm.reporter = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.isAdmin = isAdmin;
        vm.isManager = isManager;
        vm.getImageSrc = getImageSrc;
        vm.deleteProfilePicture = deleteProfilePicture;
        vm.picturePUIDsForDeletion = [];
        vm.originalProfilePUID = vm.reporter.profilePicture;
        vm.authToken = JSON.parse(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        $q.all([vm.reporter.$promise]).then(function() {
            if (!vm.reporter.addressId) {
                return $q.reject();
            }
            return PostalAddress.get({id : vm.reporter.addressId}).$promise;
        }).then(function(address) {
            vm.address = address;
        });

        vm.users = User.query();
        vm.weblinks = [];
        vm.jobs = Job.query();
        vm.interviews = Interview.query();
        vm.films = Film.query({sort: 'id,desc'});
        vm.languages = null;
        vm.skills = Skill.query();
        vm.levels = ['NONE', 'BRONZE', 'SILVER', 'GOLD'];
        vm.checkedSkill = checkedSkill;
        vm.toggleSkill = toggleSkill;
        vm.address = { id: null, country: 'GBR'};

        vm.twitter = {id: null, title: 'twitter'};
        vm.facebook = {id: null, title: 'facebook'};
        vm.instagram = {id: null, title: 'instagram'};
        vm.website = {id: null, title: 'website'};
        vm.deleteLink = deleteLink;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        $q.all([vm.reporter.$promise]).then(function() {
            if (!vm.reporter.id) {
                return $q.reject();
            }
            return Reporter.getWebLinks({id : vm.reporter.id}).$promise;
        }).then(function(weblinks) {
            console.log(weblinks);
            vm.weblinks = weblinks;

            for (var i = 0; i < vm.weblinks.length; i++) {
                if(vm.weblinks[i].title.toLowerCase() === 'twitter') {
                    vm.twitter = vm.weblinks[i];
                }

                if(vm.weblinks[i].title.toLowerCase() === 'facebook') {
                    vm.facebook = vm.weblinks[i];
                }

                if(vm.weblinks[i].title.toLowerCase() === 'instagram') {
                    vm.instagram = vm.weblinks[i];
                }

                if(vm.weblinks[i].title.toLowerCase() === 'website') {
                    vm.website = vm.weblinks[i];
                }
            }

        });

        function checkedSkill(skill) {
            return containsObjectByID(skill, vm.reporter.skills);
        }

        function containsObjectByID(obj, list) {
            var i;
            for (i = 0; i < list.length; i++) {
                if (list[i].id === obj.id) {
                    return true;
                }
            }

            return false;
        }

        function toggleSkill(skill) {
            var found = vm.reporter.skills.some(function (el) {
                return el.id === skill.id;
            });

            if (!found) {
                vm.reporter.skills.push(skill);
            } else {
                vm.reporter.skills = vm.reporter.skills.filter(function(item) {
                    return item.id !== skill.id;
                });
            }
        }

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function isManager() {
            return Principal.hasAnyAuthority(['ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']);
        }

        function clear () {
            console.log('calling clear method..');
            console.log('originalProfilePUID: '+vm.originalProfilePUID);
            vm.reporter.profilePicture = vm.originalProfilePUID;

            var puids = vm.picturePUIDsForDeletion.filter(function (value) {
                return vm.originalProfilePUID !== value;
            });

            if(puids.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              puids, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    console.log('images deleted');
                    vm.picturePUIDsForDeletion = [];
                },
                function () {
                    console.log('error deleting images');
                }
            );
            }

            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.picturePUIDsForDeletion.length > 0) {
                $http.post(
                'https://streams2.winkball.com/delete-images',
                vm.picturePUIDsForDeletion, {
                    headers:{
                        'Authorization': 'Bearer ' + vm.authToken
                    }}).then(
                  function () {
                      console.log('images deleted');
                      vm.picturePUIDsForDeletion = [];
                  },
                  function () {
                      console.log('error deleting images');
                  }
              );
            }

            if (vm.reporter.addressId !== null) {
                PostalAddress.update(vm.address, saveReporter, onSaveError);
            } else {
                PostalAddress.save(vm.address, saveReporter, onSaveError);
            }
        }

        function saveReporter(address) {
            vm.reporter.addressId = address.id;
            if (vm.reporter.id !== null) {
                Reporter.update(vm.reporter, onSaveSuccess, onSaveError);
            } else {
                Reporter.save(vm.reporter, onSaveSuccess, onSaveError);
            }
        }

        function deleteLink(link) {
            link.url = null;
        }

        function onSaveSuccess (result) {

            if(vm.twitter.url) {
                vm.twitter.reporterId = result.id;
                if(vm.twitter.id !== null) {
                    WebLink.update(vm.twitter);
                } else {
                    WebLink.save(vm.twitter);
                }
            } else if (vm.twitter.id) {
                WebLink.delete({id: vm.twitter.id});
            }

            if(vm.facebook.url) {
                vm.facebook.reporterId = result.id;
                if(vm.facebook.id !== null) {
                    WebLink.update(vm.facebook);
                } else {
                    WebLink.save(vm.facebook);
                }
            } else if (vm.facebook.id) {
                WebLink.delete({id: vm.facebook.id});
            }

            if(vm.instagram.url) {
                vm.instagram.reporterId = result.id;
                if(vm.instagram.id !== null) {
                    WebLink.update(vm.instagram);
                } else {
                    WebLink.save(vm.instagram);
                }
            } else if (vm.instagram.id) {
                WebLink.delete({id: vm.instagram.id});
            }

            if(vm.website.url) {
                vm.website.reporterId = result.id;
                if(vm.website.id !== null) {
                    WebLink.update(vm.website);
                } else {
                    WebLink.save(vm.website);
                }
            } else if (vm.website.id) {
                WebLink.delete({id: vm.website.id});
            }

            $scope.$emit('winkballApp:reporterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.originalProfilePUID = vm.reporter.profilePicture;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateJoined = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function deleteProfilePicture() {
            vm.picturePUIDsForDeletion.push(vm.reporter.profilePicture);
            vm.reporter.profilePicture = null;
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.reporter.profilePicture) {
                return 'https://streams2.winkball.com/images/'+vm.reporter.profilePicture+dimentions;
            }

            return '';
        }

        $scope.uploadFile = function(file, errFiles){
            console.log('calling uploadFile...');
            vm.isSaving = true;
            $scope.f = file;
            $scope.errFile = errFiles && errFiles[0];

            if(file) {
                file.upload = Upload.upload(
                    {
                        url: "https://streams2.winkball.com/images",
                        data: {file: file},
                        headers: {'Authorization': 'Bearer ' + vm.authToken}
                    }
            );
                file.upload.then(function (response) {
                    $timeout(function() {
                        console.log(response);
                        file.result = response.data;
                        vm.isSaving = false;
                        if(response.status == "201") {
                            console.log('Image upload status 201');
                            vm.reporter.profilePicture = response.data;
                            console.log(vm.reporter.profilePicture);
                        }
                    });
                }, function(response){
                    console.log('Error...');
                    vm.isSaving = false;
                    if(response.status > 0) {
                        $scope.errorMsg = response.status +': ' + response.data;
                    }
                }, function(evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded/evt.total));
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ReporterDetailController', ReporterDetailController);

    ReporterDetailController.$inject = ['$scope', '$rootScope', '$state', '$q', 'entity', 'previousState', 'Reporter', 'PostalAddress', 'Principal'];

    function ReporterDetailController($scope, $rootScope, $state, $q, entity, previousState, Reporter, PostalAddress, Principal) {
        var vm = this;

        vm.reporter = entity;
        vm.getImageSrc = getImageSrc;
        vm.account = null;
        vm.checkEditPermission = checkEditPermission;
        vm.back = back;
        vm.address = null;
        vm.weblinks = [];

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        $q.all([vm.reporter.$promise]).then(function() {
            if (!vm.reporter.addressId) {
                return $q.reject();
            }
            return PostalAddress.get({id : vm.reporter.addressId}).$promise;
        }).then(function(address) {
            vm.address = address;
        });

        $q.all([vm.reporter.$promise]).then(function() {
            if (!vm.reporter.id) {
                return $q.reject();
            }
            return Reporter.getWebLinks({id : vm.reporter.id}).$promise;
        }).then(function(weblinks) {
          // console.log(weblinks);
            vm.weblinks = weblinks;
            if(vm.weblinks.length > 0) {
                vm.twitter = vm.weblinks.find(function(item) {
                    return item.title.toLowerCase() === 'twitter';
                });

                vm.facebook = vm.weblinks.find(function(item) {
                    return item.title.toLowerCase() === 'facebook';
                });

                vm.instagram = vm.weblinks.find(function(item) {
                    return item.title.toLowerCase() === 'instagram';
                });

                vm.website = vm.weblinks.find(function(item) {
                    return item.title.toLowerCase() === 'website';
                });
            }
        });

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.reporter.profilePicture) {
                return 'https://streams2.winkball.com/images/'+vm.reporter.profilePicture+dimentions;
            }

            return '';
        }

        function checkEditPermission() {
            return vm.reporter.login === vm.account.login ||
            vm.account.authorities.indexOf('ROLE_MANAGER') > -1 || vm.account.authorities.indexOf('ROLE_ADMIN') > -1;
        }

        function back() {
            if($state.current.name === 'reporter-detail-login' && previousState.name !== 'report-detail') {
                $state.go('home');
            } else {
                if(previousState.name === 'project-detail' || previousState.name === 'report-detail') {
                    $state.go(previousState.name, previousState.params);
                } else {
                    $state.go('reporter');
                }
            }
        }

        var unsubscribe = $rootScope.$on('winkballApp:reporterUpdate', function(event, result) {
            vm.reporter = result;
        });

        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ReporterDeleteController',ReporterDeleteController);

    ReporterDeleteController.$inject = ['$uibModalInstance', 'entity', 'Reporter'];

    function ReporterDeleteController($uibModalInstance, entity, Reporter) {
        var vm = this;

        vm.reporter = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Reporter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporter', {
            parent: 'entity',
            url: '/reporter',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.reporter.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/reporter/reporters.html',
                    controller: 'ReporterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reporter');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('reporter-detail', {
            parent: 'entity',
            url: '/reporter/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.reporter.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/reporter/reporter-detail.html',
                    controller: 'ReporterDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reporter');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Reporter', function($stateParams, Reporter) {
                    return Reporter.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'home',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('reporter-detail-login', {
            parent: 'entity',
            url: '/reporter/user/{login}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.reporter.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/reporter/reporter-detail.html',
                    controller: 'ReporterDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reporter');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Reporter', function($stateParams, Reporter) {
                    return Reporter.getByLogin({login : $stateParams.login}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'reporter',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('reporter-detail.edit', {
            parent: 'reporter-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'previousState', function($stateParams, $state, $uibModal, previousState) {
                $uibModal.open({
                    templateUrl: 'app/entities/reporter/reporter-dialog.html',
                    controller: 'ReporterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Reporter', function(Reporter) {
                            return Reporter.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                  if(previousState.name === 'reporter-detail-login') {
                    $state.go(previousState.name, previousState.params, {reload: true});
                  } else {
                    $state.go('^', {}, { reload: true });
                  }
                }, function() {
                  if(previousState.name === 'reporter-detail-login') {
                    $state.go(previousState.name, previousState.params, {reload: false});
                  } else {
                    $state.go('^');
                  }
                });
            }]
        })
        .state('reporter.new', {
            parent: 'reporter',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reporter/reporter-dialog.html',
                    controller: 'ReporterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                puid: null,
                                level: null,
                                rating: null,
                                contactEmail: null,
                                profilePicture: null,
                                dateJoined: null,
                                contactNumber: null,
                                aboutMe: null,
                                id: null,
                                published: false,
                                langKey: "en",
                                addressId: null,
                                skills: []
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('reporter', null, { reload: true });
                }, function() {
                    $state.go('reporter');
                });
            }]
        })
        .state('reporter.edit', {
            parent: 'reporter',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reporter/reporter-dialog.html',
                    controller: 'ReporterDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Reporter', function(Reporter) {
                            return Reporter.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('reporter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('reporter.delete', {
            parent: 'reporter',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reporter/reporter-delete-dialog.html',
                    controller: 'ReporterDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Reporter', function(Reporter) {
                            return Reporter.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('reporter', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Reporter', Reporter);

    Reporter.$inject = ['$resource', 'DateUtils'];

    function Reporter ($resource, DateUtils) {
        var resourceUrl =  'api/reporters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateJoined = DateUtils.convertDateTimeFromServer(data.dateJoined);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getByLogin': {
              url: 'api/reporters/user/:login',
              method: 'GET',
              transformResponse: function (data) {
                  if (data) {
                      data = angular.fromJson(data);
                      data.dateJoined = DateUtils.convertDateTimeFromServer(data.dateJoined);
                  }
                  return data;
              }
            },
            'getWebLinks': { url: 'api/reporters/:id/web-links', method: 'GET', isArray: true }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('ReporterSearch', ReporterSearch);

    ReporterSearch.$inject = ['$resource'];

    function ReporterSearch($resource) {
        var resourceUrl =  'api/_search/reporters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ReporterController', ReporterController);

    ReporterController.$inject = ['$scope', '$state', 'Principal', 'Reporter', 'ReporterSearch', 'ParseLinks', 'AlertService'];

    function ReporterController ($scope, $state, Principal, Reporter, ReporterSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.reporters = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.canEdit = canEdit;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ReporterSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 30,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Reporter.query({
                    page: vm.page,
                    size: 30,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.reporters.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.reporters = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.reporters = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.reporters = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function canEdit() {
            return Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN']);
        }
    }
})();
;
/* global google */
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SecondReportWizardController', SecondReportWizardController);

    SecondReportWizardController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$http', '$log', 
        'Event', 'Principal', 'UserSearch', 'Location', 'Upload'
    ];

    function SecondReportWizardController($timeout, $scope, $stateParams, $uibModalInstance, $q, $http, $log,
         Event, Principal, UserSearch, Location, Upload) {

        var vm = this;

        vm.event = $stateParams.report;

        vm.clear = clear;
        vm.save = save;
        vm.back = back;
        
        // pass this data from first wizard panel
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = angular.copy(vm.event.thumbnail);
        vm.datePickerOptions = {
            minDate: new Date(),
            initDate: new Date()
        };

        vm.account = Principal.identity();

        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.searchUser = searchUser;
        vm.getManager = getManager;

        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function back() {
            $uibModalInstance.dismiss(vm.event);
        }

        function searchUser(query) {
            return UserSearch.query({query: query}).$promise;
        }

        function getManager(data) {
            vm.event.manager = data.originalObject;
        }

        function clear () {
            vm.event.thumbnail = vm.originalThumbnail;

            var puids = vm.thumbnailsForDeletion.filter(function (value) {
                return vm.originalThumbnail !== value;
            });

            if(puids.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              puids, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    $log.log('error deleting videos');
                }
            );
            }

            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            onSaveSuccess(vm.event);
        }

        function onSaveSuccess (result) {
            vm.originalThumbnail = vm.event.thumbnail;
            if (vm.event.id !== null) {
                $scope.$emit('winkballApp:eventUpdate', result);
            }
               
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function getImageSrc(width, height) {
            var dimentions;

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.event.thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.event.thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.event.thumbnail + '?quality=ORIGINAL';
                }
            }

            return '';
        }

        function deleteThumbnail() {
            vm.thumbnailsForDeletion.push(vm.event.thumbnail);
            vm.event.thumbnail = null;
        }
    }
})();
;
/* global google */
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('LastReporttWizardController', LastReporttWizardController);

    LastReporttWizardController.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance', '$http', '$log', '$q', 'Event', 'Location', 'KeywordSearch', 'LocationSearch', 'NgMap'];

    function LastReporttWizardController ($timeout, $scope, $state, $stateParams, $uibModalInstance, $http, $log, $q, Event, Location, KeywordSearch, LocationSearch, NgMap) {
        var vm = this;
        // vm.event = entity;
        vm.event = $stateParams.report;

        vm.clear = clear;
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail =  angular.copy(vm.event.thumbnail);
        
        vm.save = save;
        vm.searchKeywords = searchKeywords;
        vm.searchLocations = searchLocations;
        vm.tagLocation = vm.event.location ? [vm.event.location] : [];
        vm.toggleCategory = toggleCategory;
        vm.saveLocation = saveLocation;
        vm.location = vm.event.location || {};
        vm.location.geoPoint = vm.location.geoPoint || {};
        vm.locationRemoved = locationRemoved;
        vm.locationAdded = locationAdded;
        vm.clearLocation = clearLocation;
        vm.addMarker = addMarker;
        vm.geoCode = geoCode;
        vm.search = "";

        // vm.multiSelectSettings = { externalIdProp: '', template: '<b>{{option.reporter.firstName}} {{option.reporter.lastName}} <small>({{option.reporterJobRole}})<smal></b>' };   
        // vm.selectReportersText = { buttonDefaultText: 'Select Reporters' };
        
        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        vm.categories = Event.categories();

        $q.all([vm.event.$promise]).then(function() {
            if (!vm.event.location) {
                return $q.reject();
            }

            return Location.get({id : vm.event.location.id}).$promise;
        }).then(function(location) {
            vm.tagLocation = [location];
        });

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function searchKeywords(query) {
            return KeywordSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        function searchLocations(query) {
            return LocationSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        $scope.$on('mapInitialized', function(evt, map) {
            $log.log('map initialised');

            vm.map = map;
            google.maps.event.trigger(vm.map, 'resize');
            if(vm.location.geoPoint.lat && vm.location.geoPoint.lon) {
                map.setCenter({lat: vm.location.geoPoint.lat, lng: vm.location.geoPoint.lon});
            }
        });

        function toggleCategory(category) {
            var idx = vm.event.categories.indexOf(category);
            if(idx > -1) {
                vm.event.categories.splice(idx, 1);
            } else {
                vm.event.categories.push(category);
            }
        }

        function clear () {
            $log.log('calling clear method..');

            $log.log('originalThumbnail: ' + vm.originalThumbnail);

            vm.event.thumbnail = vm.originalThumbnail;

            var puids = vm.thumbnailsForDeletion.filter(function (value) {
                return vm.originalThumbnail !== value;
            });

            if(puids.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              puids, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    $log.log('videos deleted');

                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    $log.log('error deleting videos');
                }
            );
            }

            vm.tagLocation = [];
            vm.selectedApplicants = [];

            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.thumbnailsForDeletion.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              vm.thumbnailsForDeletion, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    $log.log('error deleting thumbnail');
                }
            );
            }

            if(vm.tagLocation.length > 0) {
                vm.event.location = vm.tagLocation[0];
            } else {
                vm.event.location = null;
            }

            if (vm.event.id !== null) {
                Event.update(vm.event, onSaveSuccess, onSaveError);
            } else {
                Event.save(vm.event, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:eventUpdate', result);
            vm.isSaving = false;
            vm.originalThumbnail = vm.event.thumbnail;

            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function saveLocation() {
            vm.isSaving = true;
            if (!vm.location.id) {
                Location.save(vm.location, onSaveLocationSuccess, onSaveError);
            }
        }

        function onSaveLocationSuccess(result) {
            vm.event.location = result;
            vm.tagLocation[0] = result;
            vm.isSaving = false;
        }

        function locationRemoved() {
            vm.location = {};
            vm.location.geoPoint = {};
        }

        function locationAdded() {
            vm.location = vm.tagLocation[0];
        }

        function clearLocation() {
            vm.location = {};
            vm.location.geoPoint = {};
            vm.event.location = {};
            vm.tagLocation = [];
        }

        function addMarker(event) {
            var ll = event.latLng;
          // round coordinates to 5 decimal places
            vm.location.geoPoint.lon =  Math.floor(ll.lng()*100000+0.5)/100000;
            vm.location.geoPoint.lat =  Math.floor(ll.lat()*100000+0.5)/100000;
        }

        function geoCode() {
            if(vm.search && vm.search.length > 0) {
                if(!vm.geocoder) {
                    vm.geocoder = new google.maps.Geocoder();
                }
                vm.geocoder.geocode({'address': vm.search}, function(results, status){
                    if (status === google.maps.GeocoderStatus.OK){
                        var loc = results[0].geometry.location;
                        vm.search = results[0].formatted_address;
                        if(vm.location) {
                            vm.location.title = results[0].formatted_address;
                        } else {
                            vm.location = {title: results[0].formatted_address};
                        }
                        vm.location.geoPoint.lat = Math.floor(loc.lat()*100000+0.5)/100000;
                        vm.location.geoPoint.lon = Math.floor(loc.lng()*100000+0.5)/100000;
                        vm.map.setCenter({lat: vm.location.geoPoint.lat, lng: vm.location.geoPoint.lon});
                        $scope.$apply();
                    }
                });
            }
        } // end of geoCode

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.event.thumbnail) {
                return 'https://streams2.winkball.com/images/'+vm.event.thumbnail+dimentions;
            }

            return '';
        }

        function deleteThumbnail() {
            vm.thumbnailsForDeletion.push(vm.event.thumbnail);
            vm.event.thumbnail = null;
        }
    }
})();
;
/* global google */
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('FirstReportWizardController', FirstReportWizardController);

    FirstReportWizardController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$http', '$log', 
        'entity', 'Event', 'Job', 'Principal', 'User', 'Location', 'Upload'
    ];

    function FirstReportWizardController($timeout, $scope, $stateParams, $uibModalInstance, $q, $http, $log,
        entity, Event, Job, Principal, User, Location, Upload) {

        var vm = this;
        if ($stateParams.report) {
            vm.event = $stateParams.report;
        } else {
            vm.event = entity;
        }

        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.search = "";
        vm.users = [];
        vm.phoneRegex = /^[\+|\d]{1}[0-9|\s]{3,20}$/;
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = angular.copy(vm.event.thumbnail);
        vm.datePickerOptions = {
            minDate: new Date(),
            initDate: new Date()
        };

        vm.account = Principal.identity();

        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.uploadFile = uploadFile;

        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        // add current user as a manager for new jobs
        vm.account.then(function(account){
            $q.all([vm.event.$promise]).then(function() {
                if(vm.event.id) {
                    return $q.reject();
                }

                return User.get({login:account.login}).$promise;
            }).then(function(user) {
                vm.event.manager = user;
                vm.users.push(user);

                if(user.login !== 'winkball') {
                    var winkballUser = User.get({login:'winkball'}).$promise;
                    winkballUser.then(function (wbUser) {
                        vm.users.push(wbUser);
                    }, function (reason){
                        $log.log(reason);
                    });
                }
            });
        });

        // create a list of reporters from applicants
        $q.all([vm.event.$promise]).then(function() {
            if (!vm.event.id) {
                return $q.reject();
            }

            // set date picker min date depending on the start date
            // for editing of an existing Job
            vm.datePickerOptions.minDate = vm.event.startDate;

            return Job.reporters({id : vm.event.job.id}).$promise;
        }).then(function(reporters) {

            // unwraps reporter and removes duplicate based on id
            vm.users = reporters
                .map(function(resource){
                    return resource.reporter;})
                    .filter(function(reporter, pos, arr) { 
                        return arr.map(function(user){
                            return user.id;
                        }).indexOf(reporter.id) === pos;
                    });

            if(vm.event.manager) {
                vm.users.push(vm.event.manager);
            }
        });

        $q.all([vm.event.$promise]).then(function() {
            if (!vm.event.location) {
                return $q.reject();
            }

            return Location.get({id : vm.event.location.id}).$promise;
        }).then(function(location) {
            vm.tagLocation = [location];
        });

        function clear () {
            vm.event.thumbnail = vm.originalThumbnail;

            var puids = vm.thumbnailsForDeletion.filter(function (value) {
                return vm.originalThumbnail !== value;
            });

            if (puids.length > 0) {
                $http.post(
                    'https://streams2.winkball.com/delete-images',
                    puids, {
                        headers: {
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }).then(
                    function () {
                        vm.thumbnailsForDeletion = [];
                    },
                    function () {
                        $log.log('error deleting videos');
                    }
                );
            }

            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.thumbnailsForDeletion.length > 0) {
                $http.post(
                'https://streams2.winkball.com/delete-images',
                vm.thumbnailsForDeletion, {
                    headers:{
                        'Authorization': 'Bearer ' + vm.authToken
                    }}).then(
                    function () {
                        vm.thumbnailsForDeletion = [];
                    },
                    function () {
                        $log.log('error deleting thumbnail');
                    }
                );
            }

            onSaveSuccess(vm.event);
        }

        function onSaveSuccess (result) {
            vm.originalThumbnail = vm.event.thumbnail;
            if (vm.event.id !== null) {
                $scope.$emit('winkballApp:eventUpdate', result);
            }

            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getImageSrc(width, height) {
            var dimentions;

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.event.thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.event.thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.event.thumbnail + '?quality=ORIGINAL';
                }
            }

            return '';
        }

        function deleteThumbnail() {
            vm.thumbnailsForDeletion.push(vm.event.thumbnail);
            vm.event.thumbnail = null;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.reportDueDate = false;
        vm.datePickerOpenStatus.interviewsDueDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function uploadFile(file, errFiles) {
            $log.log('calling uploadFile...');
            vm.isSaving = true;
            vm.f = file;
            vm.errFile = errFiles && errFiles[0];

            if(file) {
                file.upload = Upload.upload(
                    {
                        url: "https://streams2.winkball.com/images",
                        data: {file: file},
                        headers: {
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }
            ).then(function (response) {
                $timeout(function() {
                    file.result = response.data;
                    vm.isSaving = false;
                    if(response.status == "201") {
                        $log.log('Image upload status 201');
                        vm.event.thumbnail = response.data;
                    }
                }, 1000);
            }, function(response){
                $log.log('Error...');
                $log.debug(response);
                vm.isSaving = false;
                if(response.status > 0) {
                    vm.errorMsg = response.status +': ' + response.data;
                }
            }, function(evt) {
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded/evt.total));
            });
            }
        } // end of uploadFile
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ReportFilmDetailController', ReportFilmDetailController);

    ReportFilmDetailController.$inject = ['$uibModalInstance', 'entity', 'Film'];

    function ReportFilmDetailController($uibModalInstance, entity, Film) {
        var vm = this;

        vm.film = entity;
        vm.clear = clear;
        vm.getImageSrc = getImageSrc;
        vm.getVideoSrc = getVideoSrc;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.film.thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.film.thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.film.thumbnail + '?quality=ORIGINAL';

                }
            }

            return '';
        }

        function getVideoSrc(quality, format) {
            quality = quality || "HD_720P";
            format = format || "MP4";
  
            if (vm.film.videoFileGuid) {
                return 'https://streams2.winkball.com/videos/'+ vm.film.videoFileGuid +'?quality=' + quality + '&format=' + format;
            }
            return "";
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ReportDetailController', ReportDetailController);

    ReportDetailController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', '$q', '$translate', 'previousState', 'entity', 'Principal', 'Event', 'MediaPackage', 'Job'];

    function ReportDetailController($scope, $rootScope, $state, $stateParams, $q, $translate, previousState, entity, Principal, Event, MediaPackage, Job) {
        var vm = this;

        vm.event = entity;
        vm.getImageSrc = getImageSrc;
        vm.getVideoSrc = getVideoSrc;
        vm.canEdit = canEdit;
        vm.canDelete = canDelete;
        vm.isCurrentUserApproved = isCurrentUserApproved;
        vm.back = back;
        vm.hasSponsorPack = hasSponsorPack;
        vm.sponsorPack = false;
        vm.jobApplicants = [];
        vm.sponsors = [];
        vm.getStatusClass = getStatusClass;
        vm.isManager = isManager;
        vm.toggleAccepted = toggleAccepted;
        vm.updateTeam = updateTeam;
        vm.categories = Job.categories();
        vm.getCategoryDisplayName = getCategoryDisplayName;
        vm.setFilter = setFilter;

        if($stateParams.filter) {
            vm.filter = $stateParams.filter;
        } else {
            vm.filter = 'mine';
        }
        
        $translate('reportStatus.' + vm.event.reportStatus).then(function(value){
            vm.statusName = value;
        });

        getAccount();

        $q.all([vm.event.$promise]).then(function() {
            if(!vm.event.id) {
                return $q.reject();
            }
          // ignore parameter tells global http interceptor to ignore status 404
          // we do not need 'Not found' error alert in this case
            return MediaPackage.get({id : vm.event.id, ignore: 404}).$promise;
        }).then(function(sponsorPack) {
            if(sponsorPack.id) {
                vm.sponsorPack = true;
            }
        });

        $q.all([vm.event.$promise]).then(function() {
            if(!vm.event.job) {
                return $q.reject();
            }

            // load job applicants
            return Job.reporters({id : vm.event.job.id}).$promise;
        }).then(function(reporters) {

            var counter = 0;

            vm.jobApplicants = reporters.map(function(item) {
                counter++;
                item.id = counter;
                return item;
            });

            // show only accepted applications to reporters
            if (!isManager()) {
                vm.jobApplicants = vm.jobApplicants.filter(function(item) {
                    return item.accepted;
                });
            }
            
        });

        $q.all([vm.event.$promise]).then(function() {
            if(!vm.event.job) {
                return $q.reject();
            }

          // load job applicants
            return Job.sponsors({id : vm.event.job.id}).$promise;
        }).then(function(sponsors) {
            vm.sponsors = sponsors;
        });

        $q.all([vm.event.$promise]).then(function() {
            if(!vm.event.id) {
                return $q.reject();
            }

          // load job applicants
            return Event.comments({id : vm.event.id}).$promise;
        }).then(function(comments) {
            vm.comments = comments;
        });

        function getCategoryDisplayName(name) {
            var cat = vm.categories.find(function(el){
                return el.name === name;
            });

            return cat ? cat.display : 'N/A';
        }

        function toggleAccepted(applicant) {
            applicant.accepted = !applicant.accepted;
        }

        function updateTeam() {
            $state.go('event-update-team', {id: vm.event.id, applicants: vm.jobApplicants});
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.event.thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.event.thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.event.thumbnail + '?quality=ORIGINAL';

                }
            }

            return '';
        }

        function getVideoSrc(film, quality, format) {
            
            quality = quality || "HD_720P";
            format = format || "MP4";

            if (film.videoFile.guid) {
                return 'https://streams2.winkball.com/videos/'+ film.videoFile.guid +'?quality=' + quality + '&format=' + format;
            }

            return '';
        }

        function canEdit() {
            if(!vm.account) return false;
            return vm.event.createdBy === vm.account.login ||
          (vm.event.manager && vm.event.manager.login === vm.account.login) ||
          vm.account.authorities.indexOf('ROLE_MANAGER') > -1 ||
          vm.account.authorities.indexOf('ROLE_ADMIN') > -1;
        }

        function isCurrentUserApproved() {
            var accepted = vm.jobApplicants.filter(function (item) {
                return item.reporter.login === vm.account.login && item.accepted;
            });
            var team = vm.event.reporters.filter(function (reporter){
                return reporter.user.login === vm.account.login;
            });

            return accepted.length > 0 || team.length > 0;
        }

        function canDelete() {
            if(!vm.account) return false;
            return Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SUPERVISOR']);
        }

        function isManager() {
            return Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function hasSponsorPack() {
            return vm.sponsorPack;
        }

        function getStatusClass() {
            switch (vm.event.reportStatus) {
            case 'PROPOSAL':
                return 'bkg-proposal';
            case 'IN_PRODUCTION':
                return 'bkg-in-production';
            case 'READY_TO_FILM':
                return 'bkg-ready-to-film';
            case 'AWATING_SIGN_OFF':
                return 'bkg-awaiting-signoff';
            case 'COMPLETED':
                return 'completed';
            case 'CANCELLED':
                return 'bkg-cancelled';
            default:
                return '';
            }
        }

        function back() {
            // if(previousState.name === 'project-detail') {
            //     $state.go(previousState.name, previousState.params);
            // } else {
            $state.go('home', { filter: vm.filter });
            //}
        }

        function setFilter($event, filter) {
            $event.stopPropagation();
            $event.preventDefault();

            if (filter) {
                vm.filter = filter;
            }
            
            $state.go('home', { filter: vm.filter }, { reload: true , location: 'replace'});
        }

        var unsubscribe = $rootScope.$on('winkballApp:eventUpdate', function(event, result) {
            vm.event = result;
        });

        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('report-detail', {
            parent: 'entity',
            url: '/report/{id}?filter',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.job.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/report/report-detail.html',
                    controller: 'ReportDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('event');
                    $translatePartialLoader.addPart('job');
                    $translatePartialLoader.addPart('sponsor');
                    $translatePartialLoader.addPart('location');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Event', function($stateParams, Event) {
                    return Event.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'home',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        }).state('report-detail.team', {
            parent: 'report-detail',
            url: '/team/{jobId}',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-team-dialog.html',
                    controller: 'ProjectTeamDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Job', function(Job) {
                            return Job.get({id : $stateParams.jobId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', {}, { location: 'replace' });
                });
            }]
        }).state('report-detail.sponsor', {
            parent: 'report-detail',
            url: '/sponsor?type',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sponsor/sponsor-dialog.html',
                    controller: 'SponsorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sponsorName: null,
                                puid: null,
                                createdDate: null,
                                contactName: null,
                                contactEmail: null,
                                telephone: null,
                                finder: null,
                                // job: { id : $stateParams.id },
                                address: { id: null, country: 'GBR'},
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', {}, { location: 'replace' });
                });
            }]
        }).state('report-detail.location', {
            parent: 'report-detail',
            url: '/location/{locationId}',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/location/location-dialog.html',
                    controller: 'LocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Location', function(Location) {
                            return Location.get({id : $stateParams.locationId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', {}, { location: 'replace' });
                });
            }]
        }).state('report-detail.first', {
            parent: 'report-detail',
            url: '/first',
            params: { report: null },
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/report/report-wizard-first.html',
                    controller: 'FirstReportWizardController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function(result) {
                    $state.go('report-detail.second', { report: result }, { reload: false });
                }, function() {
                    $state.go('^', {}, { location: 'replace', reload: true });
                });
            }]
        }).state('report-detail.second', {
            parent: 'report-detail',
            url: '/second',
            params: { report: null },
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/report/report-wizard-second.html',
                    controller: 'SecondReportWizardController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function(result) {
                    $state.go('report-detail.last', { report: result }, { reload: false });
                }, function(result) {
                    if(result === 'cancel') {
                        $state.go('report-detail', { id: $stateParams.id}, { reload: true });
                    } else {
                        $state.go('report-detail.first', { report: result }, { reload: false });
                    }
                });
            }]
        }).state('report-detail.last', {
            parent: 'report-detail',
            url: '/last',
            params: { report: null },
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/report/report-wizard-last.html',
                    controller: 'LastReporttWizardController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function(result) {
                    $state.go('report-detail', { id: $stateParams.id }, { reload: true });
                }, function(result) {
                    if(result === 'cancel') {
                        $state.go('report-detail', { id: $stateParams.id});
                    } else {
                        $state.go('report-detail.second', { report: result }, { reload: false });
                    }
                });
            }]
        }).state('report-detail.new-first', {
            parent: 'report-detail',
            url: '/new-first',
            params: { project: null },
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-wizard-first.html',
                    controller: 'FirstProjectWizardController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                puid: null,
                                startDate: null,
                                endDate: null,
                                title: null,
                                description: null,
                                contactName: null,
                                contactPhone: null,
                                categories: [],
                            };
                        }
                    }
                }).result.then(function(result) {
                    $state.go('report-detail.new-second', { project: result }, { reload: false });
                }, function() {
                    $state.go('^', {}, { location: 'replace' });
                });
            }]
        }).state('report-detail.new-second', {
            parent: 'report-detail',
            url: '/new-second',
            params: { project: null },
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-wizard-second.html',
                    controller: 'SecondProjectWizardController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function(result) {
                    $state.go('report-detail.last', { project: result }, { reload: false });
                }, function(result) {
                    if(result === 'cancel') {
                        $state.go('report-detail');
                    } else {
                        $state.go('report-detail.new-first', { project: result }, { reload: false });
                    }
                });
            }]
        }).state('report-detail.new-last', {
            parent: 'report-detail',
            url: '/new-last',
            params: { project: null },
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-wizard-last.html',
                    controller: 'ProjectWizardController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('home', null, { reload: true });
                }, function(result) {
                    if(result === 'cancel') {
                        $state.go('report-detail');
                    } else {
                        $state.go('report-detail.new-second', { project: result }, { reload: false });
                    }
                });
            }]
        }).state('report-email', {
            parent: 'report-detail',
            url: '/email',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-email-dialog.html',
                    controller: 'EventEmailController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false, location: 'replace' });
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        }).state('report-delete', {
            parent: 'report-detail',
            url: '/delete',
            data: {
                authorities: ['ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-delete-dialog.html',
                    controller: 'EventDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('home', null, { reload: true , location: 'replace'});
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        }).state('report-readytofilm', {
            parent: 'report-detail',
            url: '/readytofilm',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_SUPERVISOR', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-readytofilm-dialog.html',
                    controller: 'EventReadytofilmController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Event', function (Event) {
                            return Event.get({
                                id: $stateParams.id
                            }).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('^', null, {
                        reload: true, location: 'replace'
                    });
                }, function () {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        }).state('report-status', {
            parent: 'report-detail',
            url: '/reportstatus?status',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_SUPERVISOR', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-status-dialog.html',
                    controller: 'EventStatusDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Event', function (Event) {
                            return Event.get({
                                id: $stateParams.id
                            }).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('^', null, {
                        reload: true, location: 'replace'
                    });
                }, function () {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        }).state('report-detail.film', {
            parent: 'report-detail',
            url: '/film/{filmId}',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_SUPERVISOR', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/report/report-film-detail.html',
                    controller: 'ReportFilmDetailController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['Film', function (Film) {
                            return Film.get({
                                id: $stateParams.filmId
                            }).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('^', null, {
                        reload: true, location: 'replace'
                    });
                }, function () {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        }).state('report-detail.apply', {
            parent: 'report-detail',
            url: '/job/{jobId}/apply',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job/job-apply-dialog.html',
                    controller: 'JobApplyController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Job', function(Job) {
                            return Job.get({id : $stateParams.jobId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', {}, { location: 'replace' });
                });
            }]
        }).state('report-detail.share', {
            parent: 'report-detail',
            url: '/share',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-share-dialog.html',
                    controller: 'EventShareController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    // $state.go('event', null, { reload: false, location: 'replace' });
                    $state.go('^', null, { reload: false, location: 'replace' });
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        }).state('report-detail.share-interview', {
            parent: 'report-detail',
            url: '/interview/{interviewId}/share',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/interview/interview-share-dialog.html',
                    controller: 'InterviewShareController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Interview', function(Interview) {
                            return Interview.get({id : $stateParams.interviewId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false, location: 'replace' });
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        }).state('report-detail.new-media-package', {
            parent: 'report-detail',
            url: '/new-media?event',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/media-package/media-package-dialog.html',
                    controller: 'MediaPackageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                url: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    if($stateParams.event) {
                        $state.go('report-detail', { id : $stateParams.event }, { reload: true, location: 'replace'});
                    } else {
                        $state.go('media-package', null, { reload: true, location: 'replace' });
                    }
                }, function() {
                    if($stateParams.event) {
                        $state.go('report-detail', { id : $stateParams.event }, { reload: true, location: 'replace' });
                    } else {
                        $state.go('media-package', null, { location: 'replace' });
                    }
                });
            }]
        });

    }

})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('PublisherDialogController', PublisherDialogController);

    PublisherDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$log', 'entity', 'Publisher', 'User', 'WebLink', 'Upload'];

    function PublisherDialogController($timeout, $scope, $stateParams, $uibModalInstance, $q, $log, entity, Publisher, User, WebLink, Upload) {
        var vm = this;

        vm.publisher = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.toggleCategory = toggleCategory;
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = angular.copy(vm.publisher.profilePicture);

        vm.getImageSrc = getImageSrc;
        vm.getVideoBugSrc = getVideoBugSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.deleteVideoBug = deleteVideoBug;
        vm.deleteWebsite = deleteWebsite;
        vm.uploadFile = uploadFile;
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        vm.categories = Publisher.categories();
        vm.users = User.query();
        vm.weblinks = WebLink.query();

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function deleteWebsite() {
            vm.publisher.website = null;
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            
            if (vm.publisher.address && !vm.publisher.address.country) {
                vm.publisher.address.country = 'GBR';
            }

            if (vm.publisher.id !== null) {
                Publisher.update(vm.publisher, onSaveSuccess, onSaveError);
            } else {
                Publisher.save(vm.publisher, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:publisherUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function toggleCategory(category) {
            var idx = vm.publisher.categories.indexOf(category);
            if(idx > -1) {
                vm.publisher.categories.splice(idx, 1);
            } else {
                vm.publisher.categories.push(category);
            }
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }

            if (vm.publisher.profilePicture) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.publisher.profilePicture + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.publisher.profilePicture + '?quality=ORIGINAL';
    
                }
            }

            return '';
        }

        function getVideoBugSrc(width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }

            if (vm.publisher.videoBug) {
                
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.publisher.videoBug + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.publisher.videoBug + '?quality=ORIGINAL';
    
                }
            }
            
            return '';
        }

        function deleteThumbnail() {
            vm.thumbnailsForDeletion.push(vm.publisher.profilePicture);
            vm.publisher.profilePicture = null;
        }

        function deleteVideoBug() {
            vm.thumbnailsForDeletion.push(vm.publisher.videoBug);
            vm.publisher.videoBug = null;
        }

        function uploadFile(file, isVideoBug, errFiles) {
            vm.isSaving = true;
            vm.f = file;
            vm.errFile = errFiles && errFiles[0];

            if (file) {
                file.upload = Upload.upload(
                    {
                        url: "https://streams2.winkball.com/images",
                        data: { file: file },
                        headers: {
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }
                ).then(function (response) {
                    $timeout(function () {
                        file.result = response.data;
                        vm.isSaving = false;
                        if (response.status === 201) {
                            $log.log('Image upload status 201');
                            if (isVideoBug) {
                                vm.publisher.videoBug = response.data;
                            } else {
                                vm.publisher.profilePicture = response.data;    
                            }
                        }
                    }, 1000);
                }, function (response) {
                    $log.log('Error...');
                    $log.debug(response);
                    vm.isSaving = false;
                    if (response.status > 0) {
                        vm.errorMsg = response.status + ': ' + response.data;
                    }
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
        } // end of uploadFile

        vm.datePickerOpenStatus.dateJoined = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('PublisherDetailController', PublisherDetailController);

    PublisherDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Publisher', 'PostalAddress', 'User', 'WebLink'];

    function PublisherDetailController($scope, $rootScope, $stateParams, previousState, entity, Publisher, PostalAddress, User, WebLink) {
        var vm = this;

        vm.publisher = entity;
        vm.previousState = previousState.name;
        vm.getImageSrc = getImageSrc;
        vm.getVideoBugSrc = getVideoBugSrc;

        function getImageSrc(width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }

            if (vm.publisher.profilePicture) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.publisher.profilePicture + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.publisher.profilePicture + '?quality=ORIGINAL';
    
                }
            }

            return '';
        }

        function getVideoBugSrc(width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }

            if (vm.publisher.videoBug) {
                
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.publisher.videoBug + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.publisher.videoBug + '?quality=ORIGINAL';
    
                }
            }
            
            return '';
        }

        var unsubscribe = $rootScope.$on('winkballApp:publisherUpdate', function(event, result) {
            vm.publisher = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('PublisherDeleteController',PublisherDeleteController);

    PublisherDeleteController.$inject = ['$uibModalInstance', 'entity', 'Publisher'];

    function PublisherDeleteController($uibModalInstance, entity, Publisher) {
        var vm = this;

        vm.publisher = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Publisher.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('publisher', {
            parent: 'entity',
            url: '/publisher',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.publisher.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/publisher/publishers.html',
                    controller: 'PublisherController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publisher');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('publisher-detail', {
            parent: 'entity',
            url: '/publisher/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.publisher.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/publisher/publisher-detail.html',
                    controller: 'PublisherDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publisher');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Publisher', function($stateParams, Publisher) {
                    return Publisher.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'publisher',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('publisher-detail.edit', {
            parent: 'publisher-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_PUBLISHER', 'ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/publisher/publisher-dialog.html',
                    controller: 'PublisherDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Publisher', function(Publisher) {
                            return Publisher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('publisher.new', {
            parent: 'publisher',
            url: '/new',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/publisher/publisher-dialog.html',
                    controller: 'PublisherDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                puid: null,
                                companyName: null,
                                companyType: null,
                                profilePicture: null,
                                position: null,
                                aboutMe: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('publisher', null, { reload: true });
                }, function() {
                    $state.go('publisher');
                });
            }]
        })
        .state('publisher.edit', {
            parent: 'publisher',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/publisher/publisher-dialog.html',
                    controller: 'PublisherDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Publisher', function(Publisher) {
                            return Publisher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('publisher', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('publisher.delete', {
            parent: 'publisher',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/publisher/publisher-delete-dialog.html',
                    controller: 'PublisherDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Publisher', function(Publisher) {
                            return Publisher.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('publisher', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Publisher', Publisher);

    Publisher.$inject = ['$resource', 'DateUtils'];

    function Publisher($resource, DateUtils) {
        var resourceUrl =  'api/publishers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        ///data.dateJoined = DateUtils.convertDateTimeFromServer(data.dateJoined);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'categories': {method: 'GET', url: 'api/categories', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('PublisherSearch', PublisherSearch);

    PublisherSearch.$inject = ['$resource'];

    function PublisherSearch($resource) {
        var resourceUrl =  'api/_search/publishers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('PublisherController', PublisherController);

    PublisherController.$inject = ['$scope', '$state', 'Publisher', 'PublisherSearch', 'ParseLinks', 'AlertService'];

    function PublisherController ($scope, $state, Publisher, PublisherSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.publishers = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PublisherSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Publisher.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.publishers.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.publishers = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.publishers = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.publishers = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProspectiveReporterEmailController', ProspectiveReporterEmailController);

    ProspectiveReporterEmailController.$inject = ['$uibModalInstance', '$stateParams', 'entity', 'ProspectiveReporter'];

    function ProspectiveReporterEmailController($uibModalInstance, $stateParams, entity, ProspectiveReporter) {
        var vm = this;

        vm.reporter = entity;
        vm.clear = clear;
        vm.confirmEmail = confirmEmail;
        
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmEmail() {
            if($stateParams.accepted.toLowerCase() === 'true') {
                ProspectiveReporter.invite(vm.reporter,
                    function () {
                        $uibModalInstance.close(true);
                    }
                );
            } else {
                ProspectiveReporter.reject(vm.reporter,
                    function () {
                        $uibModalInstance.close(true);
                    }
                );
            }
            
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProspectiveReporterDialogController', ProspectiveReporterDialogController);

    ProspectiveReporterDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$log', 'DateUtils', 'entity', 'ProspectiveReporter', 'PostalAddress', 'User', 'WebLink', 'Reporter'];

    function ProspectiveReporterDialogController($timeout, $scope, $stateParams, $uibModalInstance, $q, $log, DateUtils, entity, ProspectiveReporter, PostalAddress, User, WebLink, Reporter) {
        var vm = this;

        vm.reporter = entity;
        vm.clear = clear;
        vm.save = save;
        vm.deleteShowreel = deleteShowreel;
        vm.openCalendar = openCalendar;
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        $timeout(function () {
            angular.element('.form-group:eq(2)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        // function save() {
        //     vm.isSaving = true;
        //     if (vm.reporter.id !== null) {
        //         ProspectiveReporter.update(vm.reporter, onSaveSuccess, onSaveError);
        //     } else {
        //         ProspectiveReporter.save(vm.reporter, onSaveSuccess, onSaveError);
        //     }
        // }

        function save() {
            vm.isSaving = true;
            if(vm.reporter.address.id !== null) {
                PostalAddress.update(vm.reporter.address, saveReporter, onSaveError);
            } else {
                PostalAddress.save(vm.reporter.address, saveReporter, onSaveError);
            }
        }

        // function saveShippingAddress() {
        //     vm.isSaving = true;
        //     if (vm.reporter.shippingAddress) {
        //         if(vm.reporter.shippingAddress.id !== null) {
        //             PostalAddress.update(vm.reporter.shippingAddress, saveReporter, onSaveError);
        //         } else {
        //             PostalAddress.save(vm.reporter.shippingAddress, saveReporter, onSaveError);
        //         }
        //     } else {
        //         saveReporter();
        //     }
        // }

        function saveReporter(address) {
            vm.isSaving = true;
            vm.reporter.address = address;
            
            if (vm.reporter.id !== null) {
                ProspectiveReporter.update(vm.reporter, onSaveSuccess, onSaveError);
            } else {
                ProspectiveReporter.save(vm.reporter, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('winkballApp:prospectiveReporterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function deleteShowreel() {
            vm.reporter.showreelLink = null;
        }

        vm.datePickerOpenStatus = { birthday: false };
        vm.datePickerOptions = {
            minDate: new Date(1940, 12, 31),
            initDate: new Date(2000, 12, 31)
        };
        vm.dateformat = DateUtils.dateformat();
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProspectiveReporterDetailController', ProspectiveReporterDetailController);

    ProspectiveReporterDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProspectiveReporter'];

    function ProspectiveReporterDetailController($scope, $rootScope, $stateParams, previousState, entity, ProspectiveReporter) {
        var vm = this;

        vm.reporter = entity;
        vm.previousState = previousState.name;
        vm.sendInvite = sendInvite;
        vm.getImageSrc = getImageSrc;

        function sendInvite() {
            ProspectiveReporter.invite(vm.reporter);
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }

            if (vm.reporter.profilePicture) {
                if(dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.reporter.profilePicture + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.reporter.profilePicture + '?quality=ORIGINAL';
                }
                
            }

            return '';
        }

        var unsubscribe = $rootScope.$on('winkballApp:prospectiveReporterUpdate', function (event, result) {
            vm.reporter = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProspectiveReporterDeleteController', ProspectiveReporterDeleteController);

    ProspectiveReporterDeleteController.$inject = ['$uibModalInstance', '$http', '$log', 'entity', 'ProspectiveReporter'];

    function ProspectiveReporterDeleteController($uibModalInstance, $http, $log, entity, ProspectiveReporter) {
        var vm = this;

        vm.reporter = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ProspectiveReporter.delete({ id: id },
                function () {
                    if(vm.reporter.resume) { 
                        $http.delete('https://streams2.winkball.com/files/' + vm.reporter.resume, {
                            headers:{
                                'Authorization': 'Bearer ' + vm.authToken
                            }
                        }).then(function () {
                            $uibModalInstance.close(true);
                        }, function () {
                            $log.error('error deleting resume');
                        });
                    } else {
                        $uibModalInstance.close(true);
                    }
                });
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('prospective-reporter', {
                parent: 'entity',
                url: '/prospective-reporter',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'winkballApp.prospectiveReporter.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/prospective-reporter/prospective-reporters.html',
                        controller: 'ProspectiveReporterController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('prospectiveReporter');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('prospective-reporter-detail', {
                parent: 'entity',
                url: '/prospective-reporter/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'winkballApp.prospectiveReporter.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/prospective-reporter/prospective-reporter-detail.html',
                        controller: 'ProspectiveReporterDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('prospectiveReporter');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ProspectiveReporter', function ($stateParams, ProspectiveReporter) {
                        return ProspectiveReporter.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'prospective-reporter',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('prospective-reporter-detail.edit', {
                parent: 'prospective-reporter-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prospective-reporter/prospective-reporter-dialog.html',
                        controller: 'ProspectiveReporterDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ProspectiveReporter', function (ProspectiveReporter) {
                                return ProspectiveReporter.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('prospective-reporter.new', {
                parent: 'prospective-reporter',
                url: '/new',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prospective-reporter/prospective-reporter-dialog.html',
                        controller: 'ProspectiveReporterDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    puid: null,
                                    companyName: null,
                                    companyType: null,
                                    profilePicture: null,
                                    id: null,
                                    address: { id: null, country: 'GBR'},
                                    shippingAddress: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('prospective-reporter', null, { reload: true });
                    }, function () {
                        $state.go('prospective-reporter');
                    });
                }]
            })
            .state('prospective-reporter.edit', {
                parent: 'prospective-reporter',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prospective-reporter/prospective-reporter-dialog.html',
                        controller: 'ProspectiveReporterDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ProspectiveReporter', function (ProspectiveReporter) {
                                return ProspectiveReporter.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prospective-reporter', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('prospective-reporter.delete', {
                parent: 'prospective-reporter',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prospective-reporter/prospective-reporter-delete-dialog.html',
                        controller: 'ProspectiveReporterDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ProspectiveReporter', function (ProspectiveReporter) {
                                return ProspectiveReporter.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prospective-reporter', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('prospective-reporter-detail.email', {
                parent: 'prospective-reporter-detail',
                url: '/detail/email?accepted',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prospective-reporter/prospective-reporter-email-dialog.html',
                        controller: 'ProspectiveReporterEmailController',
                        controllerAs: 'vm',
                        size: 'md',
                        backdrop: 'static',
                        resolve: {
                            entity: ['ProspectiveReporter', function (ProspectiveReporter) {
                                return ProspectiveReporter.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: true, location: 'replace' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('winkballApp')
        .factory('ProspectiveReporter', ProspectiveReporter);

    ProspectiveReporter.$inject = ['$resource', 'DateUtils'];

    function ProspectiveReporter($resource, DateUtils) {
        var resourceUrl = 'api/prospective-reporters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthday = DateUtils.convertLocalDateFromServer(data.birthday);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' },
            'categories': { method: 'GET', url: 'api/categories', isArray: true },
            'invite': { method: 'POST', url: 'api/prospective-reporters/invite', hasBody: true},
            'reject': { method: 'POST', url: 'api/prospective-reporters/reject', hasBody: true},
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .factory('ProspectiveReporterSearch', ProspectiveReporterSearch);

    ProspectiveReporterSearch.$inject = ['$resource'];

    function ProspectiveReporterSearch($resource) {
        var resourceUrl = 'api/_search/prospective-reporters/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProspectiveReporterController', ProspectiveReporterController);

    ProspectiveReporterController.$inject = ['$scope', '$state', 'ProspectiveReporter', 'ProspectiveReporterSearch', 'ParseLinks', 'AlertService'];

    function ProspectiveReporterController($scope, $state, ProspectiveReporter, ProspectiveReporterSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.reporters = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.getImageSrc = getImageSrc;

        loadAll();

        function loadAll() {
            if (vm.currentSearch) {
                ProspectiveReporterSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ProspectiveReporter.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.reporters.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset() {
            vm.page = 0;
            vm.reporters = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear() {
            vm.reporters = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.reporters = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function getImageSrc(thumbnail, width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }
            
            if (thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + thumbnail + '?quality=ORIGINAL';
                }
            }

            return '';
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProspectivePublisherEmailController', ProspectivePublisherEmailController);

    ProspectivePublisherEmailController.$inject = ['$uibModalInstance', 'entity', 'ProspectivePublisher'];

    function ProspectivePublisherEmailController($uibModalInstance, entity, ProspectivePublisher) {
        var vm = this;

        vm.publisher = entity;
        vm.clear = clear;
        vm.confirmEmail = confirmEmail;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmEmail() {
            ProspectivePublisher.invite(vm.publisher,
                function () {
                    $uibModalInstance.close(true);
                }
            );
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProspectivePublisherDialogController', ProspectivePublisherDialogController);

    ProspectivePublisherDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$log', 'entity', 'ProspectivePublisher', 'PostalAddress', 'User', 'WebLink', 'Publisher', 'Upload'];

    function ProspectivePublisherDialogController($timeout, $scope, $stateParams, $uibModalInstance, $q, $log, entity, ProspectivePublisher, PostalAddress, User, WebLink, Publisher, Upload) {
        var vm = this;

        vm.publisher = entity;
        vm.clear = clear;
        vm.save = save;
        vm.deleteWebsite = deleteWebsite;
        vm.toggleCategory = toggleCategory;
        vm.categories = Publisher.categories();
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = angular.copy(vm.publisher.profilePicture);

        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.uploadFile = uploadFile;
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        $timeout(function () {
            angular.element('.form-group:eq(2)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.publisher.id !== null) {
                ProspectivePublisher.update(vm.publisher, onSaveSuccess, onSaveError);
            } else {
                ProspectivePublisher.save(vm.publisher, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('winkballApp:prospectivePublisherUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function deleteWebsite() {
            vm.publisher.website = null;
        }

        function toggleCategory(category) {
            var idx = vm.publisher.categories.indexOf(category);
            if (idx > -1) {
                vm.publisher.categories.splice(idx, 1);
            } else {
                vm.publisher.categories.push(category);
            }
        }

        function getImageSrc(width, height) {
            var dimentions;

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }

            if (vm.publisher.profilePicture) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.publisher.profilePicture + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.publisher.profilePicture + '?quality=ORIGINAL';
                }        
            }

            return '';
        }

        function deleteThumbnail() {
            vm.thumbnailsForDeletion.push(vm.publisher.profilePicture);
            vm.publisher.profilePicture = null;
        }

        function uploadFile(file, errFiles) {
            vm.isSaving = true;
            vm.f = file;
            vm.errFile = errFiles && errFiles[0];

            if (file) {
                file.upload = Upload.upload(
                    {
                        url: "https://streams2.winkball.com/images",
                        data: { file: file },
                        headers: {
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }
                ).then(function (response) {
                    $timeout(function () {
                        file.result = response.data;
                        vm.isSaving = false;
                        if (response.status === 201) {
                            $log.log('Image upload status 201');
                            vm.publisher.profilePicture = response.data;
                        }
                    }, 1000);
                }, function (response) {
                    $log.log('Error...');
                    $log.debug(response);
                    vm.isSaving = false;
                    if (response.status > 0) {
                        vm.errorMsg = response.status + ': ' + response.data;
                    }
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
        } // end of uploadFile
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProspectivePublisherDetailController', ProspectivePublisherDetailController);

    ProspectivePublisherDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProspectivePublisher'];

    function ProspectivePublisherDetailController($scope, $rootScope, $stateParams, previousState, entity, ProspectivePublisher) {
        var vm = this;

        vm.publisher = entity;
        vm.previousState = previousState.name;
        vm.sendInvite = sendInvite;
        vm.getImageSrc = getImageSrc;

        function sendInvite() {
            ProspectivePublisher.invite(vm.publisher);
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }

            if (vm.publisher.profilePicture) {
                if(dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.publisher.profilePicture + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.publisher.profilePicture + '?quality=ORIGINAL';
                }
                
            }

            return '';
        }

        var unsubscribe = $rootScope.$on('winkballApp:prospectivePublisherUpdate', function (event, result) {
            vm.publisher = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProspectivePublisherDeleteController', ProspectivePublisherDeleteController);

    ProspectivePublisherDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProspectivePublisher'];

    function ProspectivePublisherDeleteController($uibModalInstance, entity, ProspectivePublisher) {
        var vm = this;

        vm.publisher = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            ProspectivePublisher.delete({ id: id },
                function () {
                    $uibModalInstance.close(true);
                });
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('prospective-publisher', {
                parent: 'entity',
                url: '/prospective-publisher',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'winkballApp.prospectivePublisher.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/prospective-publisher/prospective-publishers.html',
                        controller: 'ProspectivePublisherController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('prospectivePublisher');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('prospective-publisher-detail', {
                parent: 'entity',
                url: '/prospective-publisher/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'winkballApp.prospectivePublisher.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/prospective-publisher/prospective-publisher-detail.html',
                        controller: 'ProspectivePublisherDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('prospectivePublisher');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ProspectivePublisher', function ($stateParams, ProspectivePublisher) {
                        return ProspectivePublisher.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'prospective-publisher',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('prospective-publisher-detail.edit', {
                parent: 'prospective-publisher-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prospective-publisher/prospective-publisher-dialog.html',
                        controller: 'ProspectivePublisherDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ProspectivePublisher', function (ProspectivePublisher) {
                                return ProspectivePublisher.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('prospective-publisher.new', {
                parent: 'prospective-publisher',
                url: '/new',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prospective-publisher/prospective-publisher-dialog.html',
                        controller: 'ProspectivePublisherDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    puid: null,
                                    companyName: null,
                                    companyType: null,
                                    profilePicture: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('prospective-publisher', null, { reload: true });
                    }, function () {
                        $state.go('prospective-publisher');
                    });
                }]
            })
            .state('prospective-publisher.edit', {
                parent: 'prospective-publisher',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prospective-publisher/prospective-publisher-dialog.html',
                        controller: 'ProspectivePublisherDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ProspectivePublisher', function (ProspectivePublisher) {
                                return ProspectivePublisher.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prospective-publisher', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('prospective-publisher.delete', {
                parent: 'prospective-publisher',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prospective-publisher/prospective-publisher-delete-dialog.html',
                        controller: 'ProspectivePublisherDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ProspectivePublisher', function (ProspectivePublisher) {
                                return ProspectivePublisher.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prospective-publisher', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('prospective-publisher-detail.email', {
                parent: 'prospective-publisher-detail',
                url: '/detail/email',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prospective-publisher/prospective-publisher-email-dialog.html',
                        controller: 'ProspectivePublisherEmailController',
                        controllerAs: 'vm',
                        size: 'md',
                        backdrop: 'static',
                        resolve: {
                            entity: ['ProspectivePublisher', function (ProspectivePublisher) {
                                return ProspectivePublisher.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: true, location: 'replace' });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('winkballApp')
        .factory('ProspectivePublisher', ProspectivePublisher);

    ProspectivePublisher.$inject = ['$resource', 'DateUtils'];

    function ProspectivePublisher($resource, DateUtils) {
        var resourceUrl = 'api/prospective-publishers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' },
            'categories': { method: 'GET', url: 'api/categories', isArray: true },
            'invite': { method: 'POST', url: 'api/prospective-publishers/invite', hasBody: true},
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .factory('ProspectivePublisherSearch', ProspectivePublisherSearch);

    ProspectivePublisherSearch.$inject = ['$resource'];

    function ProspectivePublisherSearch($resource) {
        var resourceUrl = 'api/_search/prospective-publishers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProspectivePublisherController', ProspectivePublisherController);

    ProspectivePublisherController.$inject = ['$scope', '$state', 'ProspectivePublisher', 'ProspectivePublisherSearch', 'ParseLinks', 'AlertService'];

    function ProspectivePublisherController($scope, $state, ProspectivePublisher, ProspectivePublisherSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.publishers = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.getImageSrc = getImageSrc;

        loadAll();

        function loadAll() {
            if (vm.currentSearch) {
                ProspectivePublisherSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ProspectivePublisher.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.publishers.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset() {
            vm.page = 0;
            vm.publishers = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear() {
            vm.publishers = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.publishers = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function getImageSrc(thumbnail, width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }
            
            if (thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + thumbnail + '?quality=ORIGINAL';
                }
            }

            return '';
        }
    }
})();
;
/* global google */
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SecondProjectWizardController', SecondProjectWizardController);

    SecondProjectWizardController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$http', '$log', 
        'Job', 'Principal', 'User', 'Location', 'Upload'
    ];

    function SecondProjectWizardController($timeout, $scope, $stateParams, $uibModalInstance, $q, $http, $log,
         Job, Principal, User, Location, Upload) {

        var vm = this;

        vm.job = $stateParams.project;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.back = back;
        
        vm.search = "";
        
        vm.users = [];
        vm.phoneRegex = /^[\+|\d]{1}[0-9|\s]{3,20}$/;
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = angular.copy(vm.job.thumbnail);
        vm.datePickerOptions = {
            minDate: new Date(),
            initDate: new Date()
        };

        vm.account = Principal.identity();

        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.uploadFile = uploadFile;

        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        // add current user as a manager for new jobs
        vm.account.then(function(account){
            $q.all([vm.job.$promise]).then(function() {
                if(vm.job.id) {
                    return $q.reject();
                }

                return User.get({login:account.login}).$promise;
            }).then(function(user) {
                vm.job.manager = user;
                vm.users.push(user);

                if(user.login !== 'winkball') {
                    var winkballUser = User.get({login:'winkball'}).$promise;
                    winkballUser.then(function (wbUser) {
                        vm.users.push(wbUser);
                    }, function (reason){
                        $log.log(reason);
                    });
                }
            });
        });

        // create a list of reporters from applicants
        $q.all([vm.job.$promise]).then(function() {
            if (!vm.job.id) {
                return $q.reject();
            }

            // set date picker min date depending on the start date
            // for editing of an existing Job
            vm.datePickerOptions.minDate = vm.job.startDate;

            return Job.reporters({id : vm.job.id}).$promise;
        }).then(function(reporters) {

            // unwraps reporter and removes duplicate based on id
            vm.users = reporters
                .map(function(resource){
                    return resource.reporter;})
                    .filter(function(reporter, pos, arr) { 
                        return arr.map(function(user){
                            return user.id;
                        }).indexOf(reporter.id) === pos;
                    });

            if(vm.job.manager) {
                vm.users.push(vm.job.manager);
            }
        });

        $q.all([vm.job.$promise]).then(function() {
            if (!vm.job.location) {
                return $q.reject();
            }

            return Location.get({id : vm.job.location.id}).$promise;
        }).then(function(location) {
            vm.tagLocation = [location];
        });

        function back() {
            $uibModalInstance.dismiss(vm.job);
        }

        function clear () {
            vm.job.thumbnail = vm.originalThumbnail;

            var puids = vm.thumbnailsForDeletion.filter(function (value) {
                return vm.originalThumbnail !== value;
            });

            if(puids.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              puids, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    $log.log('error deleting videos');
                }
            );
            }

            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.thumbnailsForDeletion.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              vm.thumbnailsForDeletion, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    $log.log('error deleting thumbnail');
                }
            );
            }

            if (vm.job.id !== null) {
                //Job.update(vm.job, onSaveSuccess, onSaveError);
                onSaveSuccess(vm.job);
            } else {
                // Job.save(vm.job, onSaveSuccess, onSaveError);
                onSaveSuccess(vm.job);
            }
        }

        function onSaveSuccess (result) {
            vm.originalThumbnail = vm.job.thumbnail;
            if (vm.job.id !== null) {
                $scope.$emit('winkballApp:jobUpdate', result);
            }
               
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getImageSrc(width, height) {
            var dimentions;

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.job.thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.job.thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.job.thumbnail + '?quality=ORIGINAL';
                }
            }

            return '';
        }

        function deleteThumbnail() {
            vm.thumbnailsForDeletion.push(vm.job.thumbnail);
            vm.job.thumbnail = null;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.reportDueDate = false;


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function uploadFile(file, errFiles) {
            $log.log('calling uploadFile...');
            vm.isSaving = true;
            vm.f = file;
            vm.errFile = errFiles && errFiles[0];

            if(file) {
                file.upload = Upload.upload(
                    {
                        url: "https://streams2.winkball.com/images",
                        data: {file: file},
                        headers: {
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }
            ).then(function (response) {
                $timeout(function() {
                    file.result = response.data;
                    vm.isSaving = false;
                    if(response.status == "201") {
                        $log.log('Image upload status 201');
                        vm.job.thumbnail = response.data;
                    }
                }, 1000);
            }, function(response){
                $log.log('Error...');
                $log.debug(response);
                vm.isSaving = false;
                if(response.status > 0) {
                    vm.errorMsg = response.status +': ' + response.data;
                }
            }, function(evt) {
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded/evt.total));
            });
            }
        } // end of uploadFile
    }
})();
;
/* global google */
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('FirstProjectWizardController', FirstProjectWizardController);

    FirstProjectWizardController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$http', '$log', 
        'entity', 'Job', 'Principal', 'User', 'Location', 'Upload'
    ];

    function FirstProjectWizardController($timeout, $scope, $stateParams, $uibModalInstance, $q, $http, $log,
        entity, Job, Principal, User, Location, Upload) {

        var vm = this;
        if ($stateParams.project) {
            vm.job = $stateParams.project;
        } else {
            vm.job = entity;
        }

        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.search = "";
        vm.users = [];
        vm.phoneRegex = /^[\+|\d]{1}[0-9|\s]{3,20}$/;
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = angular.copy(vm.job.thumbnail);
        vm.datePickerOptions = {
            minDate: new Date(),
            initDate: new Date()
        };

        vm.account = Principal.identity();

        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.uploadFile = uploadFile;

        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        // add current user as a manager for new jobs
        vm.account.then(function(account){
            $q.all([vm.job.$promise]).then(function() {
                if(vm.job.id) {
                    return $q.reject();
                }

                return User.get({login:account.login}).$promise;
            }).then(function(user) {
                vm.job.manager = user;
                vm.users.push(user);

                if(user.login !== 'winkball') {
                    var winkballUser = User.get({login:'winkball'}).$promise;
                    winkballUser.then(function (wbUser) {
                        vm.users.push(wbUser);
                    }, function (reason){
                        $log.log(reason);
                    });
                }
            });
        });

        // create a list of reporters from applicants
        $q.all([vm.job.$promise]).then(function() {
            if (!vm.job.id) {
                return $q.reject();
            }

            // set date picker min date depending on the start date
            // for editing of an existing Job
            vm.datePickerOptions.minDate = vm.job.startDate;

            return Job.reporters({id : vm.job.id}).$promise;
        }).then(function(reporters) {

            // unwraps reporter and removes duplicate based on id
            vm.users = reporters
                .map(function(resource){
                    return resource.reporter;})
                    .filter(function(reporter, pos, arr) { 
                        return arr.map(function(user){
                            return user.id;
                        }).indexOf(reporter.id) === pos;
                    });

            if(vm.job.manager) {
                vm.users.push(vm.job.manager);
            }
        });

        $q.all([vm.job.$promise]).then(function() {
            if (!vm.job.location) {
                return $q.reject();
            }

            return Location.get({id : vm.job.location.id}).$promise;
        }).then(function(location) {
            vm.tagLocation = [location];
        });

        function clear () {
            vm.job.thumbnail = vm.originalThumbnail;

            var puids = vm.thumbnailsForDeletion.filter(function (value) {
                return vm.originalThumbnail !== value;
            });

            if (puids.length > 0) {
                $http.post(
                    'https://streams2.winkball.com/delete-images',
                    puids, {
                        headers: {
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }).then(
                    function () {
                        vm.thumbnailsForDeletion = [];
                    },
                    function () {
                        $log.log('error deleting videos');
                    }
                );
            }

            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.thumbnailsForDeletion.length > 0) {
                $http.post(
                'https://streams2.winkball.com/delete-images',
                vm.thumbnailsForDeletion, {
                    headers:{
                        'Authorization': 'Bearer ' + vm.authToken
                    }}).then(
                    function () {
                        vm.thumbnailsForDeletion = [];
                    },
                    function () {
                        $log.log('error deleting thumbnail');
                    }
                );
            }

            if (vm.job.id !== null) {
                // Job.update(vm.job, onSaveSuccess, onSaveError);
                onSaveSuccess(vm.job);
            } else {
                // Job.save(vm.job, onSaveSuccess, onSaveError);
                onSaveSuccess(vm.job);
            }
        }

        function onSaveSuccess (result) {
            vm.originalThumbnail = vm.job.thumbnail;
            if (vm.job.id !== null) {
                $scope.$emit('winkballApp:jobUpdate', result);
            }

            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getImageSrc(width, height) {
            var dimentions;

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.job.thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.job.thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.job.thumbnail + '?quality=ORIGINAL';
                }
            }

            return '';
        }

        function deleteThumbnail() {
            vm.thumbnailsForDeletion.push(vm.job.thumbnail);
            vm.job.thumbnail = null;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.reportDueDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function uploadFile(file, errFiles) {
            $log.log('calling uploadFile...');
            vm.isSaving = true;
            vm.f = file;
            vm.errFile = errFiles && errFiles[0];

            if(file) {
                file.upload = Upload.upload(
                    {
                        url: "https://streams2.winkball.com/images",
                        data: {file: file},
                        headers: {
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }
            ).then(function (response) {
                $timeout(function() {
                    file.result = response.data;
                    vm.isSaving = false;
                    if(response.status == "201") {
                        $log.log('Image upload status 201');
                        vm.job.thumbnail = response.data;
                    }
                }, 1000);
            }, function(response){
                $log.log('Error...');
                $log.debug(response);
                vm.isSaving = false;
                if(response.status > 0) {
                    vm.errorMsg = response.status +': ' + response.data;
                }
            }, function(evt) {
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded/evt.total));
            });
            }
        } // end of uploadFile
    }
})();
;
/* global google */
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProjectWizardController', ProjectWizardController);

    ProjectWizardController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$http', '$log', 
        'Job', 'LocationSearch', 'Principal', 'User', 'Location', 'NgMap', 'Upload'
    ];

    function ProjectWizardController($timeout, $scope, $stateParams, $uibModalInstance, $q, $http, $log,
        Job, LocationSearch, Principal, User, Location, NgMap, Upload) {

        var vm = this;

        vm.job = $stateParams.project;
        vm.clear = clear;
        vm.back = back;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.searchLocation = searchLocation;
        vm.tagLocation = [];
        vm.addMarker = addMarker;
        vm.geoCode = geoCode;
        vm.search = "";
        vm.saveLocation = saveLocation;
        vm.location = vm.job.location || {};
        vm.location.geoPoint = vm.location.geoPoint || {};
        vm.locationRemoved = locationRemoved;
        vm.locationAdded = locationAdded;
        vm.clearLocation = clearLocation;
        vm.users = [];
        vm.phoneRegex = /^[\+|\d]{1}[0-9|\s]{3,20}$/;
        vm.toggleCategory = toggleCategory;
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = angular.copy(vm.job.thumbnail);
        vm.datePickerOptions = {
            minDate: new Date(),
            initDate: new Date()
        };

        vm.categories = Job.categories();
        vm.account = Principal.identity();

        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.uploadFile = uploadFile;

        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        // add current user as a manager for new jobs
        vm.account.then(function(account){
            $q.all([vm.job.$promise]).then(function() {
                if(vm.job.id) {
                    return $q.reject();
                }

                return User.get({login:account.login}).$promise;
            }).then(function(user) {
                vm.job.manager = user;
                vm.users.push(user);

                if(user.login !== 'winkball') {
                    var winkballUser = User.get({login:'winkball'}).$promise;
                    winkballUser.then(function (wbUser) {
                        vm.users.push(wbUser);
                    }, function (reason){
                        $log.log(reason);
                    });
                }
            });
        });

        // create a list of reporters from applicants
        $q.all([vm.job.$promise]).then(function() {
            if (!vm.job.id) {
                return $q.reject();
            }

            // set date picker min date depending on the start date
            // for editing of an existing Job
            vm.datePickerOptions.minDate = vm.job.startDate;

            return Job.reporters({id : vm.job.id}).$promise;
        }).then(function(reporters) {

            // unwraps reporter and removes duplicate based on id
            vm.users = reporters
                .map(function(resource){
                    return resource.reporter;})
                    .filter(function(reporter, pos, arr) { 
                        return arr.map(function(user){
                            return user.id;
                        }).indexOf(reporter.id) === pos;
                    });

            if(vm.job.manager) {
                vm.users.push(vm.job.manager);
            }
        });

        $q.all([vm.job.$promise]).then(function() {
            if (!vm.job.location) {
                return $q.reject();
            }

            return Location.get({id : vm.job.location.id}).$promise;
        }).then(function(location) {
            vm.tagLocation = [location];
        });

        $scope.$on('mapInitialized', function(evt, map) {
            $log.log('map initialised');
            vm.map = map;
            google.maps.event.trigger(vm.map, 'resize');
            if(vm.location.geoPoint.lat && vm.location.geoPoint.lon) {
                map.setCenter({lat: vm.location.geoPoint.lat, lng: vm.location.geoPoint.lon});
            }
        });

        function searchLocation(query) {
            return LocationSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        function toggleCategory(category) {
            var idx = vm.job.categories.indexOf(category);
            if(idx > -1) {
                vm.job.categories.splice(idx, 1);
            } else {
                vm.job.categories.push(category);
            }
        }

        function back() {
            
            if(vm.tagLocation.length > 0) {
                vm.job.location = vm.tagLocation[0];
            }

            $uibModalInstance.dismiss(vm.job);
        }

        function clear () {
            vm.job.thumbnail = vm.originalThumbnail;

            var puids = vm.thumbnailsForDeletion.filter(function (value) {
                return vm.originalThumbnail !== value;
            });

            if(puids.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              puids, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    $log.log('error deleting videos');
                }
            );
            }

            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.thumbnailsForDeletion.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              vm.thumbnailsForDeletion, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    $log.log('error deleting thumbnail');
                }
            );
            }

            if(vm.tagLocation.length > 0) {
                vm.job.location = vm.tagLocation[0];
            } else {
                vm.job.location = null;
            }

            if (vm.job.id !== null) {
                Job.update(vm.job, onSaveSuccess, onSaveError);
            } else {
                Job.save(vm.job, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            vm.originalThumbnail = vm.job.thumbnail;
            $scope.$emit('winkballApp:jobUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function saveLocation() {
            vm.isSaving = true;
            if (!vm.location.id) {
                Location.save(vm.location, onSaveLocationSuccess, onSaveError);
            }
        }

        function onSaveLocationSuccess(result) {
            vm.job.location = result;
            vm.tagLocation[0] = result;
            vm.isSaving = false;
        }

        function clearLocation() {
            vm.location = {};
            vm.location.geoPoint = {};
            vm.job.location = {};
            vm.tagLocation = [];
        }

        function locationRemoved() {
            vm.location = {};
            vm.location.geoPoint = {};
        }

        function locationAdded() {
            vm.location = vm.tagLocation[0];
        }

        function getImageSrc(width, height) {
            var dimentions;

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.job.thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.job.thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.job.thumbnail + '?quality=ORIGINAL';
                }
            }

            return '';
        }

        function deleteThumbnail() {
            vm.thumbnailsForDeletion.push(vm.job.thumbnail);
            vm.job.thumbnail = null;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.reportDueDate = false;


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function addMarker(event) {
            var ll = event.latLng;
          // round coordinates to 5 decimal places
            vm.location.geoPoint.lon =  Math.floor(ll.lng()*100000+0.5)/100000;
            vm.location.geoPoint.lat =  Math.floor(ll.lat()*100000+0.5)/100000;
        }

        function geoCode() {
            if(vm.search && vm.search.length > 0) {
                if(!vm.geocoder) {
                    vm.geocoder = new google.maps.Geocoder();
                }
                vm.geocoder.geocode({'address': vm.search}, function(results, status){
                    if (status === google.maps.GeocoderStatus.OK) {
                        var loc = results[0].geometry.location;
                        $log.log('setting up vm.search');
                        vm.search = results[0].formatted_address;
                        if(vm.location) {
                            $log.log('location exist, setting title');
                            vm.location.title = results[0].formatted_address;
                        } else {
                            $log.log('location does not exist, setting title');
                            vm.location = {title: results[0].formatted_address};
                        }
                        vm.location.geoPoint.lat = Math.floor(loc.lat()*100000+0.5)/100000;
                        vm.location.geoPoint.lon = Math.floor(loc.lng()*100000+0.5)/100000;
                        vm.map.setCenter({lat: vm.location.geoPoint.lat, lng: vm.location.geoPoint.lon});
                        $scope.$apply();
                    }
                });
            }
        } // end of geoCode

        function uploadFile(file, errFiles) {
            $log.log('calling uploadFile...');
            vm.isSaving = true;
            vm.f = file;
            vm.errFile = errFiles && errFiles[0];

            if(file) {
                file.upload = Upload.upload(
                    {
                        url: "https://streams2.winkball.com/images",
                        data: {file: file},
                        headers: {
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }
            ).then(function (response) {
                $timeout(function() {
                    file.result = response.data;
                    vm.isSaving = false;
                    if(response.status == "201") {
                        $log.log('Image upload status 201');
                        vm.job.thumbnail = response.data;
                    }
                }, 1000);
            }, function(response){
                $log.log('Error...');
                $log.debug(response);
                vm.isSaving = false;
                if(response.status > 0) {
                    vm.errorMsg = response.status +': ' + response.data;
                }
            }, function(evt) {
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded/evt.total));
            });
            }
        } // end of uploadFile
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProjectTeamDialogController', ProjectTeamDialogController);

    ProjectTeamDialogController.$inject = ['$state', '$uibModalInstance', '$q', 'entity', 'Job', 'Principal', 'User'];

    function ProjectTeamDialogController($state, $uibModalInstance, $q, entity, Job, Principal, User) {
        var vm = this;

        vm.job = entity;
        vm.clear = clear;
        vm.jobApplicants = [];
        vm.isManager = isManager;
        vm.isCurrentUserApproved = isCurrentUserApproved;
        vm.toggleApproved = toggleApproved;
        vm.toggleAccepted = toggleAccepted;
        vm.updateTeam = updateTeam;

        getAccount();

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

         // load job applicants
        $q.all([vm.job.$promise]).then(function() {
            if(!vm.job.id) {
                return $q.reject();
            }

            return Job.reporters({id : vm.job.id}).$promise;
        }).then(function(reporters) {
            vm.jobApplicants = reporters;

          // set fake id for job applications multiselect directive
            if(vm.jobApplicants.length) {
                var counter = 0;
                vm.jobApplicants = vm.jobApplicants.map(function(item) {
                    counter++;
                    item.id = counter;
                    return item;
                });

                if(!canEdit()) {
                    vm.jobApplicants = vm.jobApplicants.filter(function (item) {
                        return item.reporter.login === vm.account.login || item.accepted;
                    });
                }
            }
        });
        
        function toggleAccepted(applicant) {
            applicant.accepted = !applicant.accepted;
        }
        
        function updateTeam() {
            vm.isSaving = true;
            // update reporter applicants which will also trigger Event update
            // Resource.action([parameters], postData, [success], [error])
            Job.updateReporters({ id : vm.job.id }, vm.jobApplicants, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
        
        function isCurrentUserApproved() {
            var accepted = vm.jobApplicants.filter(function (item) {
                return item.reporter.login === vm.account.login && item.accepted;
            });
            return accepted.length > 0;
        }

        function toggleApproved() {
            if(Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR'])) {
                vm.job.approved = !vm.job.approved;
                Job.update(vm.job, function () {
                    // console.log('job updated');
                });
            }
        }

        function isManager() {
            return Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function canEdit() {
            if(!vm.account) return false;
            return vm.job.createdBy === vm.account.login ||
          (vm.job.manager && vm.job.manager.login === vm.account.login) ||
          vm.account.authorities.indexOf('ROLE_MANAGER') > -1 ||
          vm.account.authorities.indexOf('ROLE_ADMIN') > -1;
        }

        function getAccount() {
            Principal.identity().then(function(account) {
                // console.log('identity loaded');
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ProjectDetailController', ProjectDetailController);

    ProjectDetailController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', '$translate', '$q', 'Principal', 'previousState', 'entity', 'Job', 'User'];

    function ProjectDetailController($scope, $rootScope, $state, $stateParams, $translate, $q, Principal, previousState, entity, Job, User) {
        var vm = this;

        vm.job = entity;
        vm.back = back;
        vm.canEdit = canEdit;
        vm.creator = null;
        vm.events = [];
        vm.getSponsors = hasSponsors;
        vm.sponsors = [];
        vm.toggleApproved = toggleApproved;
        vm.isManager = isManager;
        vm.jobApplicants = [];
        vm.getImageSrc = getImageSrc;
        vm.isCurrentUserApproved = isCurrentUserApproved;
        vm.getStatusClass = getStatusClass;
        vm.categories = Job.categories();
        vm.getCategoryDisplayName = getCategoryDisplayName;
        vm.setFilter = setFilter;

        if($stateParams.filter) {
            vm.filter = $stateParams.filter;
        } else {
            vm.filter = 'mine';
        }

        $translate('reportStatus.' + vm.job.reportStatus).then(function(value){
            vm.statusName = value;
        });

        getAccount();

        $q.all([vm.job.$promise]).then(function() {
            if (!vm.job.createdBy) {
              // console.log('no creator to load....');
                return $q.reject();
            }
            return User.get({login : vm.job.createdBy}).$promise;
        }).then(function(creator) {
          // console.log('creator found');
            vm.creator = creator;
        });

        $q.all([vm.job.$promise]).then(function() {
            if (!vm.job.id) {
                return $q.reject();
            }
            // console.log('Retrieving sponsors!!!');
            return Job.sponsors({id : vm.job.id}).$promise;
        }).then(function(sponsors) {
            // console.log('Sponsors found');
            vm.sponsors = sponsors;
        });

        $q.all([vm.job.$promise]).then(function() {
            return Job.events({id : vm.job.id}).$promise;
        }).then(function(events) {
            // console.log('events found');
            vm.events = events;
        });

        // load job applicants
        $q.all([vm.job.$promise]).then(function() {
            if(!vm.job.id) {
                return $q.reject();
            }

            return Job.reporters({id : vm.job.id}).$promise;
        }).then(function(reporters) {
            vm.jobApplicants = reporters;

          // set fake id for job applications multiselect directive
            if(vm.jobApplicants.length) {
                var counter = 0;
                vm.jobApplicants = vm.jobApplicants.map(function(item) {
                    counter++;
                    item.id = counter;
                    return item;
                });

                if(!canEdit()) {
                    vm.jobApplicants = vm.jobApplicants.filter(function (item) {
                        return item.reporter.login === vm.account.login;
                    });

                }
            }
        });

        function getAccount() {
            Principal.identity().then(function(account) {
                // console.log('identity loaded');
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function back() {
            // if(previousState.name === 'home') {
            $state.go('home', { filter: vm.filter } );
            // } else {
            //     $state.go('project-detail', { filter: vm.filter });
            // }
        }

        function canEdit() {
            if(!vm.account) return false;
            return vm.job.createdBy === vm.account.login ||
          (vm.job.manager && vm.job.manager.login === vm.account.login) ||
          vm.account.authorities.indexOf('ROLE_MANAGER') > -1 ||
          vm.account.authorities.indexOf('ROLE_ADMIN') > -1;
        }

        function isCurrentUserApproved() {
            var accepted = vm.jobApplicants.filter(function (item) {
                return item.reporter.login === vm.account.login && item.accepted;
            });
            return accepted.length > 0;
        }

        function toggleApproved() {
            if(Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR'])) {
                vm.job.approved = !vm.job.approved;
                Job.update(vm.job, function () {
                    // console.log('job updated');
                });
            }
        }

        function isManager() {
            return Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function hasSponsors() {
            return vm.sponsors.length > 0;
        }

        function getCategoryDisplayName(name) {
            var cat = vm.categories.find(function(el){
                return el.name === name;
            });

            return cat ? cat.display : 'N/A';
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.job.thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.job.thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.job.thumbnail + '?quality=ORIGINAL';

                }
            }

            return '';
        }

        function getStatusClass() {
            switch (vm.job.reportStatus) {
            case 'PROPOSAL':
                return 'bkg-proposal';
            case 'IN_PRODUCTION':
                return 'bkg-in-production';
            case 'READY_TO_FILM':
                return 'bkg-ready-to-film';
            case 'AWATING_SIGN_OFF':
                return 'bkg-awaiting-signoff';
            case 'COMPLETED':
                return 'bkg-black';
            case 'CANCELLED':
                return 'bkg-cancelled';
            default:
                return '';
            }
        }

        function setFilter($event, filter) {
            $event.stopPropagation();
            $event.preventDefault();

            if (filter) {
                vm.filter = filter;
            }
            
            $state.go('home', { filter: vm.filter }, { reload: true , location: 'replace'});
        }

        var unsubscribe = $rootScope.$on('winkballApp:jobUpdate', function(event, result) {
            vm.job = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project-detail', {
            parent: 'entity',
            url: '/project/{id}?filter',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.job.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project/project-detail.html',
                    controller: 'ProjectDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('job');
                    $translatePartialLoader.addPart('sponsor');
                    $translatePartialLoader.addPart('location');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Job', function($stateParams, Job) {
                    return Job.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'home',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        }).state('project-detail.team', {
            parent: 'project-detail',
            url: '/team',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-team-dialog.html',
                    controller: 'ProjectTeamDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Job', function(Job) {
                            return Job.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', {}, { location: 'replace' });
                });
            }]
        }).state('project-detail.sponsor', {
            parent: 'project-detail',
            url: '/sponsor',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sponsor/sponsor-dialog.html',
                    controller: 'SponsorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sponsorName: null,
                                puid: null,
                                createdDate: null,
                                contactName: null,
                                contactEmail: null,
                                telephone: null,
                                finder: null,
                                job: { id : parseInt($stateParams.id) },
                                address: { id: null, country: 'GBR'},
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', {}, { location: 'replace' });
                });
            }]
        }).state('project-detail.location', {
            parent: 'project-detail',
            url: '/location/{locationId}',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/location/location-dialog.html',
                    controller: 'LocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Location', function(Location) {
                            return Location.get({id : $stateParams.locationId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', {}, { location: 'replace' });
                });
            }]
        }).state('project-detail.first', {
            parent: 'project-detail',
            url: '/first',
            params: { project: null },
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-wizard-first.html',
                    controller: 'FirstProjectWizardController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Job', function(Job) {
                            return Job.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function(result) {
                    $state.go('project-detail.second', { project: result }, { reload: false });
                }, function() {
                    $state.go('^', {}, { location: 'replace' });
                });
            }]
        }).state('project-detail.second', {
            parent: 'project-detail',
            url: '/second',
            params: { project: null },
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-wizard-second.html',
                    controller: 'SecondProjectWizardController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function(result) {
                    $state.go('project-detail.last', { project: result }, { reload: false });
                }, function(result) {
                    if(result === 'cancel') {
                        $state.go('project-detail', { id: $stateParams.id});
                    } else {
                        $state.go('project-detail.first', { project: result }, { reload: false });
                    }
                });
            }]
        }).state('project-detail.last', {
            parent: 'project-detail',
            url: '/last',
            params: { project: null },
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-wizard-last.html',
                    controller: 'ProjectWizardController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function(result) {
                    $state.go('project-detail', { id: $stateParams.id }, { reload: true });
                }, function(result) {
                    if(result === 'cancel') {
                        $state.go('project-detail', { id: $stateParams.id});
                    } else {
                        $state.go('project-detail.second', { project: result }, { reload: false });
                    }
                });
            }]
        }).state('project-inproduction', {
            parent: 'project-detail',
            url: '/inproduction',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_SUPERVISOR', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job/job-inproduction-dialog.html',
                    controller: 'JobInproductionController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Job', function (Job) {
                            return Job.get({
                                id: $stateParams.id
                            }).$promise;
                        }]
                    }
                }).result.then(function (result) {
                    $state.go('report-detail', { id: result.id }, {
                        reload: true
                    });
                }, function () {
                    $state.go('^');
                });
            }]
        }).state('project-detail.apply', {
            parent: 'project-detail',
            url: '/apply',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job/job-apply-dialog.html',
                    controller: 'JobApplyController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Job', function(Job) {
                            return Job.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', {}, { location: 'replace' });
                });
            }]
        });

    }

})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('PostalAddressDialogController', PostalAddressDialogController);

    PostalAddressDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PostalAddress'];

    function PostalAddressDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PostalAddress) {
        var vm = this;

        vm.postalAddress = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.postalAddress.id !== null) {
                PostalAddress.update(vm.postalAddress, onSaveSuccess, onSaveError);
            } else {
                PostalAddress.save(vm.postalAddress, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:postalAddressUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('PostalAddressDetailController', PostalAddressDetailController);

    PostalAddressDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PostalAddress'];

    function PostalAddressDetailController($scope, $rootScope, $stateParams, previousState, entity, PostalAddress) {
        var vm = this;

        vm.postalAddress = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('winkballApp:postalAddressUpdate', function(event, result) {
            vm.postalAddress = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('PostalAddressDeleteController',PostalAddressDeleteController);

    PostalAddressDeleteController.$inject = ['$uibModalInstance', 'entity', 'PostalAddress'];

    function PostalAddressDeleteController($uibModalInstance, entity, PostalAddress) {
        var vm = this;

        vm.postalAddress = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PostalAddress.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('postal-address', {
            parent: 'entity',
            url: '/postal-address',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.postalAddress.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/postal-address/postal-addresses.html',
                    controller: 'PostalAddressController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('postalAddress');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('postal-address-detail', {
            parent: 'entity',
            url: '/postal-address/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.postalAddress.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/postal-address/postal-address-detail.html',
                    controller: 'PostalAddressDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('postalAddress');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PostalAddress', function($stateParams, PostalAddress) {
                    return PostalAddress.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'postal-address',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('postal-address-detail.edit', {
            parent: 'postal-address-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/postal-address/postal-address-dialog.html',
                    controller: 'PostalAddressDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PostalAddress', function(PostalAddress) {
                            return PostalAddress.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('postal-address.new', {
            parent: 'postal-address',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/postal-address/postal-address-dialog.html',
                    controller: 'PostalAddressDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                addressee: null,
                                businessName: null,
                                firlstLineOfAddress: null,
                                secondLineOfAddress: null,
                                town: null,
                                county: null,
                                postCode: null,
                                country: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('postal-address', null, { reload: true });
                }, function() {
                    $state.go('postal-address');
                });
            }]
        })
        .state('postal-address.edit', {
            parent: 'postal-address',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/postal-address/postal-address-dialog.html',
                    controller: 'PostalAddressDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                      entity: ['PostalAddress', function(PostalAddress) {
                          return PostalAddress.get({id : $stateParams.id}).$promise;
                      }]
                    }
                }).result.then(function() {
                    $state.go('postal-address', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('postal-address.delete', {
            parent: 'postal-address',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/postal-address/postal-address-delete-dialog.html',
                    controller: 'PostalAddressDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PostalAddress', function(PostalAddress) {
                            return PostalAddress.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('postal-address', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('PostalAddress', PostalAddress);

    PostalAddress.$inject = ['$resource'];

    function PostalAddress ($resource) {
        var resourceUrl =  'api/postal-addresses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('PostalAddressSearch', PostalAddressSearch);

    PostalAddressSearch.$inject = ['$resource'];

    function PostalAddressSearch($resource) {
        var resourceUrl =  'api/_search/postal-addresses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('PostalAddressController', PostalAddressController);

    PostalAddressController.$inject = ['$scope', '$state', 'PostalAddress', 'PostalAddressSearch', 'ParseLinks', 'AlertService'];

    function PostalAddressController ($scope, $state, PostalAddress, PostalAddressSearch, ParseLinks, AlertService) {
        var vm = this;
        
        vm.postalAddresses = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                PostalAddressSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PostalAddress.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.postalAddresses.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.postalAddresses = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.postalAddresses = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.postalAddresses = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('MediaPackageDialogController', MediaPackageDialogController);

    MediaPackageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$http','$localStorage', '$sessionStorage', 'entity', 'Event', 'Upload', 'MediaPackage', 'VideoFile'];

    function MediaPackageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, $http, $localStorage, $sessionStorage, entity, Event, Upload, MediaPackage, VideoFile) {
        var vm = this;

        vm.mediaPackage = entity;
        vm.filesForDeletion = [];
        vm.logosForDeletion = [];
        vm.originalFile = vm.mediaPackage.puid;

        if(!vm.mediaPackage.sponsorDetails) {
            vm.mediaPackage.sponsorDetails = {};
        }

        vm.originalLogo = vm.mediaPackage.sponsorDetails.logo;
        vm.originalPoster = vm.mediaPackage.poster;

        vm.clear = clear;
        vm.save = save;
        vm.getFileSrc = getFileSrc;
        vm.getImageSrc = getImageSrc;
        vm.getVideoSrc = getVideoSrc;
        vm.deleteFile = deleteFile;
        vm.deleteLogo = deleteLogo;
        vm.deletePoster = deletePoster;
        vm.deleteVideo = deleteVideo;
        vm.authToken = JSON.parse(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        vm.events = Event.query({
            page: 0,
            size: 50,
            sort: ["startDate,desc"],
            filter: 'media-package-is-null'});

          // if (vm.mediaPackage.eventId) {
          //   vm.events.push(Event.get({id : vm.mediaPackage.eventId}));
          // }

        $q.all([vm.mediaPackage.$promise, vm.events.$promise]).then(function() {
            if (!vm.mediaPackage.eventId) {
                return $q.reject();
            }
            return Event.get({id : vm.mediaPackage.eventId}).$promise;
        }).then(function(item) {
            vm.events.push(item);
        });

        $q.all([vm.mediaPackage.$promise]).then(function() {
            if(vm.mediaPackage.id) {
                return $q.reject();
            }

            if(!$stateParams.event) {
                return $q.reject();
            }
            return Event.get({id : $stateParams.event}).$promise;
        }).then(function(item) {
            vm.events.push(item);
            vm.mediaPackage.eventId = item.id;
        });

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function clear () {
            // console.log('calling clear method..');
            // console.log('originalFile: ' + vm.originalFile);
            // console.log('originalLogo: ' + vm.originalLogo);

            vm.mediaPackage.puid = vm.originalFile;


            var filePuids = vm.filesForDeletion.filter(function (value) {
                return vm.originalFile != value;
            });

            if(filePuids.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-files',
              filePuids, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    vm.filesForDeletion = [];
                },
                function () {
                    console.log('error deleting files');
                }
            );
            }

            vm.mediaPackage.sponsorDetails.logo = vm.originalLogo;

            var logoPuids = vm.logosForDeletion.filter(function (value) {
                return vm.originalLogo != value || vm.originalPoster != value;
            });

            if(logoPuids.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              logoPuids, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    vm.logosForDeletion = [];
                },
                function () {
                    console.log('error deleting images');
                }
            );
            }

            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.filesForDeletion.length > 0) {
                $http.post(
                'https://streams2.winkball.com/delete-files',
                vm.filesForDeletion, {
                    headers:{
                        'Authorization': 'Bearer ' + vm.authToken
                    }}).then(
                  function () {
                      vm.filesForDeletion = [];
                  },
                  function () {
                    console.log('error deleting files');
                  }
              );
            }

            if(vm.logosForDeletion.length > 0) {
                $http.post(
                'https://streams2.winkball.com/delete-images',
                vm.logosForDeletion, {
                    headers:{
                        'Authorization': 'Bearer ' + vm.authToken
                    }}).then(
                  function () {
                      vm.logosForDeletion = [];
                  },
                  function () {
                    console.log('error deleting logos');
                  }
              );
            }

            if (vm.mediaPackage.id !== null) {
                MediaPackage.update(vm.mediaPackage, onSaveSuccess, onSaveError);
            } else {
                MediaPackage.save(vm.mediaPackage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:mediaPackageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.originalFile = vm.mediaPackage.puid;
            vm.originalLogo = vm.mediaPackage.sponsorDetails.logo;
            vm.originalPoster = vm.mediaPackage.poster;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function deleteFile() {
            vm.filesForDeletion.push(vm.mediaPackage.puid);
            vm.mediaPackage.puid = null;
        }

        function deleteLogo() {
            vm.logosForDeletion.push(vm.mediaPackage.sponsorDetails.logo);
            vm.mediaPackage.sponsorDetails.logo = null;
        }

        function deletePoster() {
            vm.logosForDeletion.push(vm.mediaPackage.poster);
            vm.mediaPackage.poster = null;
        }

        function deleteVideo() {
          // TODO - delete actual file on streams2
            vm.mediaPackage.videoFileId = null;
            vm.mediaPackage.videoFileGuid = null;
        }

        function getFileSrc() {
            if (vm.mediaPackage.puid) {
                return 'https://streams2.winkball.com/files/'+vm.mediaPackage.puid+'/download';
            }

            return '';
        }

        function getVideoSrc(quality, format) {
            quality = quality || "ORIGINAL";
            format = format || "MP4";

            if (vm.mediaPackage.videoFileGuid) {
                return 'https://streams2.winkball.com/videos/'+vm.mediaPackage.videoFileGuid+'?quality='+quality+'&format='+format;
            }
            return "";
        }

        function getImageSrc(puid) {

            if (puid) {
                return 'https://streams2.winkball.com/images/'+puid+'?quality=original';
            }

            return '';
        }

        $scope.uploadFile = function(file, errFiles, image, poster, video){
            vm.isSaving = true;
            $scope.f = file;
            $scope.image = image;
            $scope.poster = poster;
            $scope.video = video;
            $scope.errFile = errFiles && errFiles[0];

            if(file) {
                var uploadURL = "https://streams2.winkball.com/files";

                if(image || poster) {
                    uploadURL = "https://streams2.winkball.com/images";
                }

                if(video) {
                    uploadURL = "https://streams2.winkball.com/videos";
                }

                file.upload = Upload.upload(
                    {
                        url: uploadURL,
                        data: {file: file},
                        headers: {'Authorization': 'Bearer ' + vm.authToken}
                    }
            );
                file.upload.then(function (response) {
                    $timeout(function() {
                        file.result = response.data;
                        vm.isSaving = false;

                        if(response.status == "201") {
                            if(image) {
                                vm.mediaPackage.sponsorDetails.logo = response.data;
                            } else if(poster){
                                vm.mediaPackage.poster = response.data;
                            } else if (video) {
                                vm.mediaPackage.videoFileGuid = response.data;
                                vm.mediaPackage.videoFileName = file.name;
                            } else {
                                vm.mediaPackage.puid = response.data;
                            }
                        }
                    });
                }, function(response){
                    console.log('Error...');
                    vm.isSaving = false;
                    if(response.status > 0) {
                        $scope.errorMsg = response.status +': ' + response.data;
                    }
                }, function(evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded/evt.total));
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('MediaPackageDetailController', MediaPackageDetailController);

    MediaPackageDetailController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'previousState', 'entity'];

    function MediaPackageDetailController($scope, $rootScope, $state, $stateParams, previousState, entity) {
        var vm = this;

        vm.mediaPackage = entity;
        vm.previousState = previousState.name;
        vm.getImageSrc = getImageSrc;
        vm.back = back;

        function getImageSrc() {

            if (vm.mediaPackage.sponsorDetails.logo) {
                return 'https://streams2.winkball.com/images/'+vm.mediaPackage.sponsorDetails.logo+'?quality=original';
            }

            return '';
        }

        var unsubscribe = $rootScope.$on('winkballApp:mediaPackageUpdate', function(event, result) {
            vm.mediaPackage = result;
        });

        function back() {
            $state.go(previousState.name, previousState.params);
        }

        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('MediaPackageDeleteController',MediaPackageDeleteController);

    MediaPackageDeleteController.$inject = ['$uibModalInstance', 'entity', 'MediaPackage'];

    function MediaPackageDeleteController($uibModalInstance, entity, MediaPackage) {
        var vm = this;

        vm.mediaPackage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MediaPackage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('media-package', {
            parent: 'entity',
            url: '/media-package',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN'],
                pageTitle: 'winkballApp.mediaPackage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/media-package/media-packages.html',
                    controller: 'MediaPackageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mediaPackage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('media-package-detail', {
            parent: 'entity',
            url: '/media-package/{id}',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN'],
                pageTitle: 'winkballApp.mediaPackage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/media-package/media-package-detail.html',
                    controller: 'MediaPackageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mediaPackage');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MediaPackage', function($stateParams, MediaPackage) {
                    return MediaPackage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'media-package',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('media-package-detail.edit', {
            parent: 'media-package-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/media-package/media-package-dialog.html',
                    controller: 'MediaPackageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MediaPackage', function(MediaPackage) {
                            return MediaPackage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false, location: 'replace' });
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        })
        .state('media-package.new', {
            parent: 'media-package',
            url: '/new?event',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/media-package/media-package-dialog.html',
                    controller: 'MediaPackageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                url: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    if($stateParams.event) {
                        $state.go('event-detail', { id : $stateParams.event }, { reload: true, location: 'replace'});
                    } else {
                        $state.go('media-package', null, { reload: true, location: 'replace' });
                    }
                }, function() {
                    if($stateParams.event) {
                        $state.go('event-detail', { id : $stateParams.event }, { reload: true, location: 'replace' });
                    } else {
                        $state.go('media-package', null, { location: 'replace' });
                    }
                });
            }]
        })
        .state('media-package.edit', {
            parent: 'media-package',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/media-package/media-package-dialog.html',
                    controller: 'MediaPackageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MediaPackage', function(MediaPackage) {
                            return MediaPackage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('media-package', null, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        })
        .state('media-package.delete', {
            parent: 'media-package',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/media-package/media-package-delete-dialog.html',
                    controller: 'MediaPackageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MediaPackage', function(MediaPackage) {
                            return MediaPackage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('media-package', null, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('MediaPackage', MediaPackage);

    MediaPackage.$inject = ['$resource', 'DateUtils'];

    function MediaPackage ($resource, DateUtils) {
        var resourceUrl =  'api/media-packages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('MediaPackageSearch', MediaPackageSearch);

    MediaPackageSearch.$inject = ['$resource'];

    function MediaPackageSearch($resource) {
        var resourceUrl =  'api/_search/media-packages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('MediaPackageController', MediaPackageController);

    MediaPackageController.$inject = ['$scope', '$state', 'MediaPackage', 'MediaPackageSearch', 'ParseLinks', 'AlertService'];

    function MediaPackageController ($scope, $state, MediaPackage, MediaPackageSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.mediaPackages = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'createdDate';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                MediaPackageSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MediaPackage.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                // if (vm.predicate !== 'id') {
                //     result.push('id');
                // }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.mediaPackages.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.mediaPackages = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.mediaPackages = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'createdDate';
            vm.reverse = false;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.mediaPackages = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('MediaContactDialogController', MediaContactDialogController);

    MediaContactDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MediaContact'];

    function MediaContactDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MediaContact) {
        var vm = this;

        vm.mediaContact = entity;
        vm.clear = clear;
        vm.save = save;
        vm.facebookPattern = /^((https?:\/\/)?(www\.)?(facebook\.com\/?)).*/;
        vm.twitterPattern = /^((https?:\/\/)?(www\.)?(twitter\.com\/?)).*/;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.mediaContact.facebook === "") {
              vm.mediaContact.facebook = null;
            }

            if(vm.mediaContact.twitter === "") {
              vm.mediaContact.twitter = null;
            }

            if(vm.mediaContact.contactPhone === "") {
              vm.mediaContact.contactPhone = null;
            }

            if (vm.mediaContact.id !== null) {
                MediaContact.update(vm.mediaContact, onSaveSuccess, onSaveError);
            } else {
                MediaContact.save(vm.mediaContact, onSaveSuccess, onSaveError);
            }

        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:mediaContactUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('MediaContactDetailController', MediaContactDetailController);

    MediaContactDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MediaContact', 'User'];

    function MediaContactDetailController($scope, $rootScope, $stateParams, previousState, entity, MediaContact, User) {
        var vm = this;

        vm.mediaContact = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('winkballApp:mediaContactUpdate', function(event, result) {
            vm.mediaContact = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('MediaContactDeleteController',MediaContactDeleteController);

    MediaContactDeleteController.$inject = ['$uibModalInstance', 'entity', 'MediaContact'];

    function MediaContactDeleteController($uibModalInstance, entity, MediaContact) {
        var vm = this;

        vm.mediaContact = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MediaContact.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('media-contact', {
            parent: 'entity',
            url: '/media-contact',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN'],
                pageTitle: 'winkballApp.mediaContact.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/media-contact/media-contacts.html',
                    controller: 'MediaContactController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mediaContact');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('media-contact-detail', {
            parent: 'entity',
            url: '/media-contact/{id}',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN'],
                pageTitle: 'winkballApp.mediaContact.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/media-contact/media-contact-detail.html',
                    controller: 'MediaContactDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mediaContact');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MediaContact', function($stateParams, MediaContact) {
                    return MediaContact.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'media-contact',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('media-contact-detail.edit', {
            parent: 'media-contact-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/media-contact/media-contact-dialog.html',
                    controller: 'MediaContactDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MediaContact', function(MediaContact) {
                            return MediaContact.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('media-contact.new', {
            parent: 'media-contact',
            url: '/new',
            data: {
                authorities: ['ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/media-contact/media-contact-dialog.html',
                    controller: 'MediaContactDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                url: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('media-contact', null, { reload: true });
                }, function() {
                    $state.go('media-contact');
                });
            }]
        })
        .state('media-contact.edit', {
            parent: 'media-contact',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/media-contact/media-contact-dialog.html',
                    controller: 'MediaContactDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MediaContact', function(MediaContact) {
                            return MediaContact.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('media-contact', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('media-contact.delete', {
            parent: 'media-contact',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/media-contact/media-contact-delete-dialog.html',
                    controller: 'MediaContactDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MediaContact', function(MediaContact) {
                            return MediaContact.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('media-contact', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('MediaContact', MediaContact);

    MediaContact.$inject = ['$resource', 'DateUtils'];

    function MediaContact ($resource, DateUtils) {
        var resourceUrl =  'api/media-contacts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('MediaContactSearch', MediaContactSearch);

    MediaContactSearch.$inject = ['$resource'];

    function MediaContactSearch($resource) {
        var resourceUrl =  'api/_search/media-contacts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('MediaContactController', MediaContactController);

    MediaContactController.$inject = ['$scope', '$state', 'MediaContact', 'MediaContactSearch', 'ParseLinks', 'AlertService'];

    function MediaContactController ($scope, $state, MediaContact, MediaContactSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.mediaContacts = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                MediaContactSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                MediaContact.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                // if (vm.predicate !== 'id') {
                //     result.push('id');
                // }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.mediaContacts.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.mediaContacts = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.mediaContacts = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.mediaContacts = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('LocationDialogController', LocationDialogController);

    LocationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Location', 'User', 'NgMap'];

    function LocationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Location, User, NgMap) {
        var vm = this;

        vm.location = entity;
        vm.location.geoPoint = vm.location.geoPoint || {};

        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.address = "";
        vm.addMarker = addMarker;
        vm.geoCode = geoCode;
        vm.search = "";

        $scope.$on('mapInitialized', function(evt, map) {
            vm.map = map;
            // eslint-disable-next-line no-undef
            google.maps.event.trigger(vm.map, 'resize');
            if(vm.location.geoPoint.lat && vm.location.geoPoint.lon) {
                map.setCenter({lat: vm.location.geoPoint.lat, lng: vm.location.geoPoint.lon});
            }
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.location.id !== null) {
                Location.update(vm.location, onSaveSuccess, onSaveError);
            } else {
                Location.save(vm.location, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:locationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function addMarker(event) {
            console.log(event);
            var ll = event.latLng;
          // round coordinates to 5 decimal places
            vm.location.geoPoint.lon =  Math.floor(ll.lng()*100000+0.5)/100000;
            vm.location.geoPoint.lat =  Math.floor(ll.lat()*100000+0.5)/100000;
        }

        function geoCode() {
            if(vm.search && vm.search.length > 0) {
                if(!vm.geocoder) {
                    vm.geocoder = new google.maps.Geocoder();
                }
                vm.geocoder.geocode({'address': vm.search}, function(results, status){
                    if (status == google.maps.GeocoderStatus.OK){
                        var loc = results[0].geometry.location;
                        vm.search = results[0].formatted_address;
                        // if(!vm.location.title) {
                        //   vm.location.title = vm.search;
                        // }
                        vm.location.geoPoint.lat = Math.floor(loc.lat()*100000+0.5)/100000;
                        vm.location.geoPoint.lon = Math.floor(loc.lng()*100000+0.5)/100000;
                        vm.map.setCenter({lat: vm.location.geoPoint.lat, lng: vm.location.geoPoint.lon});
                    } else {
                        console.log("search whith no results");
                    }
                });
            }
        } // end of geoCode
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('LocationDetailController', LocationDetailController);

    LocationDetailController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'Principal', 'previousState', 'entity', 'Location', 'User'];

    function LocationDetailController($scope, $rootScope, $state, $stateParams, Principal, previousState, entity, Location, User) {
        var vm = this;

        vm.location = entity;
        vm.previousState = previousState.name;
        vm.canEdit = canEdit;
        vm.canDelete = canDelete;
        vm.back = back;

        getAccount();

        function canEdit() {
          return canDelete() || vm.location.createdBy === vm.account.login;
        }

        function canDelete() {
          return Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SUPERVISOR']);
        }

        function getAccount() {
          Principal.identity().then(function(account) {
            console.log('identity loaded');
              vm.account = account;
              vm.isAuthenticated = Principal.isAuthenticated;
          });
        }

        var unsubscribe = $rootScope.$on('winkballApp:locationUpdate', function(event, result) {
            vm.location = result;
        });

        function back() {
          $state.go(previousState.name, previousState.params);
        }

        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('LocationDeleteController',LocationDeleteController);

    LocationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Location'];

    function LocationDeleteController($uibModalInstance, entity, Location) {
        var vm = this;

        vm.location = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Location.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('location', {
            parent: 'entity',
            url: '/location',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.location.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/location/locations.html',
                    controller: 'LocationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('location');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('location-detail', {
            parent: 'entity',
            url: '/location/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.location.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/location/location-detail.html',
                    controller: 'LocationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('location');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Location', function($stateParams, Location) {
                    return Location.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'location',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('location-detail.edit', {
            parent: 'location-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/location/location-dialog.html',
                    controller: 'LocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Location', function(Location) {
                            return Location.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('location.new', {
            parent: 'location',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/location/location-dialog.html',
                    controller: 'LocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                puid: null,
                                createdDate: null,
                                longitude: null,
                                latitude: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('location', null, { reload: true });
                }, function() {
                    $state.go('location');
                });
            }]
        })
        .state('location.edit', {
            parent: 'location',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/location/location-dialog.html',
                    controller: 'LocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Location', function(Location) {
                            return Location.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('location', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('location.delete', {
            parent: 'location',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/location/location-delete-dialog.html',
                    controller: 'LocationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Location', function(Location) {
                            return Location.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('location', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Location', Location);

    Location.$inject = ['$resource', 'DateUtils'];

    function Location ($resource, DateUtils) {
        var resourceUrl =  'api/locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('LocationSearch', LocationSearch);

    LocationSearch.$inject = ['$resource'];

    function LocationSearch($resource) {
        var resourceUrl =  'api/_search/locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('LocationController', LocationController);

    LocationController.$inject = ['$scope', '$state', 'Principal', 'Location', 'LocationSearch', 'ParseLinks', 'AlertService'];

    function LocationController ($scope, $state, Principal, Location, LocationSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.locations = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.canDelete = canDelete;
        vm.canEdit = canEdit;

        getAccount();

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                LocationSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Location.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.locations.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.locations = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.locations = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.locations = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

      function canEdit(location) {
        return canDelete() || location.createdBy === vm.account.login;
      }

      function canDelete() {
        return Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SUPERVISOR']);
      }

      function getAccount() {
        Principal.identity().then(function(account) {
          console.log('identity loaded');
            vm.account = account;
            vm.isAuthenticated = Principal.isAuthenticated;
        });
      }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('KeywordDialogController', KeywordDialogController);

    KeywordDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Keyword', 'Event', 'Job', 'Advert', 'Video', 'Interview', 'Film'];

    function KeywordDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Keyword, Event, Job, Advert, Video, Interview, Film) {
        var vm = this;

        vm.keyword = entity;
        vm.clear = clear;
        vm.save = save;
        vm.events = Event.query();
        vm.jobs = Job.query();
        vm.adverts = Advert.query();
        vm.videos = Video.query();
        vm.interviews = Interview.query();
        vm.films = Film.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        $scope.$watch('vm.keyword.text', function() {
          if(vm.keyword.text) {
            vm.keyword.text = vm.keyword.text.toLowerCase();            
          }
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.keyword.id !== null) {
                Keyword.update(vm.keyword, onSaveSuccess, onSaveError);
            } else {
                Keyword.save(vm.keyword, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:keywordUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('KeywordDetailController', KeywordDetailController);

    KeywordDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Keyword', 'Event', 'Job', 'Advert', 'Video', 'Interview', 'Film'];

    function KeywordDetailController($scope, $rootScope, $stateParams, previousState, entity, Keyword, Event, Job, Advert, Video, Interview, Film) {
        var vm = this;

        vm.keyword = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('winkballApp:keywordUpdate', function(event, result) {
            vm.keyword = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('KeywordDeleteController',KeywordDeleteController);

    KeywordDeleteController.$inject = ['$uibModalInstance', 'entity', 'Keyword'];

    function KeywordDeleteController($uibModalInstance, entity, Keyword) {
        var vm = this;

        vm.keyword = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Keyword.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('keyword', {
            parent: 'entity',
            url: '/keyword',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.keyword.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/keyword/keywords.html',
                    controller: 'KeywordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('keyword');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('keyword-detail', {
            parent: 'entity',
            url: '/keyword/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.keyword.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/keyword/keyword-detail.html',
                    controller: 'KeywordDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('keyword');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Keyword', function($stateParams, Keyword) {
                    return Keyword.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'keyword',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('keyword-detail.edit', {
            parent: 'keyword-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/keyword/keyword-dialog.html',
                    controller: 'KeywordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Keyword', function(Keyword) {
                            return Keyword.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('keyword.new', {
            parent: 'keyword',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/keyword/keyword-dialog.html',
                    controller: 'KeywordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                text: null,
                                weight: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('keyword', null, { reload: true });
                }, function() {
                    $state.go('keyword');
                });
            }]
        })
        .state('keyword.edit', {
            parent: 'keyword',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/keyword/keyword-dialog.html',
                    controller: 'KeywordDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Keyword', function(Keyword) {
                            return Keyword.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('keyword', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('keyword.delete', {
            parent: 'keyword',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/keyword/keyword-delete-dialog.html',
                    controller: 'KeywordDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Keyword', function(Keyword) {
                            return Keyword.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('keyword', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Keyword', Keyword);

    Keyword.$inject = ['$resource'];

    function Keyword ($resource) {
        var resourceUrl =  'api/keywords/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('KeywordSearch', KeywordSearch);

    KeywordSearch.$inject = ['$resource'];

    function KeywordSearch($resource) {
        var resourceUrl =  'api/_search/keywords/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('KeywordController', KeywordController);

    KeywordController.$inject = ['$scope', '$state', 'Keyword', 'KeywordSearch', 'ParseLinks', 'AlertService'];

    function KeywordController ($scope, $state, Keyword, KeywordSearch, ParseLinks, AlertService) {
        var vm = this;
        
        vm.keywords = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                KeywordSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Keyword.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.keywords.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.keywords = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.keywords = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.keywords = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('JobInproductionController', JobInproductionController);

    JobInproductionController.$inject = ['$uibModalInstance', '$q', '$scope', 'entity', 'Job', 'Event'];

    function JobInproductionController($uibModalInstance, $q, $scope, entity, Job, Event) {
        var vm = this;

        vm.job = entity;
        vm.clear = clear;
        vm.confirmMove = confirmMove;
        
        vm.event = {
            puid: null,
            title: null,
            description: null,
            startDate: null,
            endDate: null,
            published: false,
            categories: [],
            id: null
        };
        vm.isSaving = true;

        $q.all([vm.job.$promise]).then(function () {
            if (!vm.job.id) {
                return $q.reject();
            }

            // copy some properties of the job to the new event
            vm.event.job = vm.job;
            vm.event.title = vm.job.title;
            vm.event.description = vm.job.description;
            vm.event.manager = vm.job.manager;
            vm.event.startDate = vm.job.startDate;
            vm.event.reportDueDate = vm.job.reportDueDate;
            vm.event.keyTalent = vm.job.keyTalent;
            vm.event.socialMedia = vm.job.socialMedia;
            vm.event.editorialStoryline = vm.job.editorialStoryline;
            vm.event.contactName = vm.job.contactName;
            vm.event.contactPhone = vm.job.contactPhone;
            vm.event.contactEmail = vm.job.contactEmail;

            vm.event.categories = vm.job.categories;
            vm.event.reportStatus = 'IN_PRODUCTION';
            

            if (vm.job.location) {
                vm.event.location = vm.job.location;
            }

            vm.isSaving = false;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmMove() {
            vm.isSaving = true;
            Event.save(vm.event, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $scope.$emit('winkballApp:eventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('JobEstimatorController', JobEstimatorController);

    JobEstimatorController.$inject = ['$uibModalInstance'];

    function JobEstimatorController($uibModalInstance) {
      var vm = this;

      vm.clear = clear;
      vm.projectPrice = 500;

      vm.numReporters = 1;
      vm.numEditors = 1;
      vm.numFinders = 1;
      vm.numVideographers = 1;
      vm.numTeam = [1,2,3,4,5,6,7,8,9,10];
      vm.calculate = calculate;
      vm.reset = reset;

      calculate();

      function calculate() {
        var rawReporter = vm.projectPrice * 0.1875;
        vm.winkball = round((vm.projectPrice * 0.25), 2);
        vm.totalReporter = round(rawReporter, 2);
        vm.eachReporter = round(rawReporter / vm.numReporters, 2);
        vm.eachVideographer = round(rawReporter / vm.numVideographers, 2);
        vm.eachEditor = round(rawReporter / vm.numEditors, 2);
        vm.eachFinder = round(rawReporter / vm.numFinders, 2);
      }

      function round(number, precision) {
        var factor = Math.pow(10, precision);
        var tempNumber = number * factor;
        var roundedTempNumber = Math.round(tempNumber);
        return roundedTempNumber / factor;
      }

      function reset() {
        vm.projectPrice = 500;
        vm.numReporters = 1;
        vm.numEditors = 1;
        vm.numFinders = 1;
        vm.numVideographers = 1;
        calculate();
      }

      function clear () {
        $uibModalInstance.dismiss('cancel');
      }

    }
})();
;
/* global google */
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('JobDialogController', JobDialogController);

    JobDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$http', '$log', 
        'entity', 'Job', 'LocationSearch', 'Principal', 'User', 'Location', 'NgMap', 'Upload'
    ];

    function JobDialogController($timeout, $scope, $stateParams, $uibModalInstance, $q, $http, $log,
        entity, Job, LocationSearch, Principal, User, Location, NgMap, Upload) {

        var vm = this;

        vm.job = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.searchLocation = searchLocation;
        vm.tagLocation = [];
        vm.addMarker = addMarker;
        vm.geoCode = geoCode;
        vm.search = "";
        vm.saveLocation = saveLocation;
        vm.location = vm.job.location || {};
        vm.location.geoPoint = vm.location.geoPoint || {};
        vm.locationRemoved = locationRemoved;
        vm.locationAdded = locationAdded;
        vm.clearLocation = clearLocation;
        vm.users = [];
        vm.phoneRegex = /^[\+|\d]{1}[0-9|\s]{3,20}$/;
        vm.toggleCategory = toggleCategory;
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = angular.copy(vm.job.thumbnail);
        vm.datePickerOptions = {
            minDate: new Date(),
            initDate: new Date()
        };

        vm.categories = Job.categories();
        vm.account = Principal.identity();

        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.uploadFile = uploadFile;

        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        // add current user as a manager for new jobs
        vm.account.then(function(account){
            $q.all([vm.job.$promise]).then(function() {
                if(vm.job.id) {
                    return $q.reject();
                }

                return User.get({login:account.login}).$promise;
            }).then(function(user) {
                vm.job.manager = user;
                vm.users.push(user);

                if(user.login !== 'winkball') {
                    var winkballUser = User.get({login:'winkball'}).$promise;
                    winkballUser.then(function (wbUser) {
                        vm.users.push(wbUser);
                    }, function (reason){
                        $log.log(reason);
                    });
                }
            });
        });

        // create a list of reporters from applicants
        $q.all([vm.job.$promise]).then(function() {
            if (!vm.job.id) {
                return $q.reject();
            }

            // set date picker min date depending on the start date
            // for editing of an existing Job
            vm.datePickerOptions.minDate = vm.job.startDate;

            return Job.reporters({id : vm.job.id}).$promise;
        }).then(function(reporters) {

            // unwraps reporter and removes duplicate based on id
            vm.users = reporters
                .map(function(resource){
                    return resource.reporter;})
                    .filter(function(reporter, pos, arr) { 
                        return arr.map(function(user){
                            return user.id;
                        }).indexOf(reporter.id) === pos;
                    });

            if(vm.job.manager) {
                vm.users.push(vm.job.manager);
            }
        });

        $q.all([vm.job.$promise]).then(function() {
            if (!vm.job.location) {
                return $q.reject();
            }

            return Location.get({id : vm.job.location.id}).$promise;
        }).then(function(location) {
            vm.tagLocation = [location];
        });

        $scope.$on('mapInitialized', function(evt, map) {
            $log.log('map initialised');
            vm.map = map;
            google.maps.event.trigger(vm.map, 'resize');
            if(vm.location.geoPoint.lat && vm.location.geoPoint.lon) {
                map.setCenter({lat: vm.location.geoPoint.lat, lng: vm.location.geoPoint.lon});
            }
        });

        function searchLocation(query) {
            return LocationSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        function toggleCategory(category) {
            var idx = vm.job.categories.indexOf(category);
            if(idx > -1) {
                vm.job.categories.splice(idx, 1);
            } else {
                vm.job.categories.push(category);
            }
        }

        function clear () {
            vm.job.thumbnail = vm.originalThumbnail;

            var puids = vm.thumbnailsForDeletion.filter(function (value) {
                return vm.originalThumbnail !== value;
            });

            if(puids.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              puids, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    $log.log('error deleting videos');
                }
            );
            }

            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.thumbnailsForDeletion.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              vm.thumbnailsForDeletion, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    $log.log('error deleting thumbnail');
                }
            );
            }

            if(vm.tagLocation.length > 0) {
                vm.job.location = vm.tagLocation[0];
            } else {
                vm.job.location = null;
            }

            if (vm.job.id !== null) {
                Job.update(vm.job, onSaveSuccess, onSaveError);
            } else {
                Job.save(vm.job, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            vm.originalThumbnail = vm.job.thumbnail;
            $scope.$emit('winkballApp:jobUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function saveLocation() {
            vm.isSaving = true;
            if (!vm.location.id) {
                Location.save(vm.location, onSaveLocationSuccess, onSaveError);
            }
        }

        function onSaveLocationSuccess(result) {
            vm.job.location = result;
            vm.tagLocation[0] = result;
            vm.isSaving = false;
        }

        function clearLocation() {
            vm.location = {};
            vm.location.geoPoint = {};
            vm.job.location = {};
            vm.tagLocation = [];
        }

        function locationRemoved() {
            vm.location = {};
            vm.location.geoPoint = {};
        }

        function locationAdded() {
            vm.location = vm.tagLocation[0];
        }

        function getImageSrc(width, height) {
            var dimentions;

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.job.thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.job.thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.job.thumbnail + '?quality=ORIGINAL';
                }
            }

            return '';
        }

        function deleteThumbnail() {
            vm.thumbnailsForDeletion.push(vm.job.thumbnail);
            vm.job.thumbnail = null;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.reportDueDate = false;


        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function addMarker(event) {
            var ll = event.latLng;
          // round coordinates to 5 decimal places
            vm.location.geoPoint.lon =  Math.floor(ll.lng()*100000+0.5)/100000;
            vm.location.geoPoint.lat =  Math.floor(ll.lat()*100000+0.5)/100000;
        }

        function geoCode() {
            if(vm.search && vm.search.length > 0) {
                if(!vm.geocoder) {
                    vm.geocoder = new google.maps.Geocoder();
                }
                vm.geocoder.geocode({'address': vm.search}, function(results, status){
                    if (status === google.maps.GeocoderStatus.OK) {
                        var loc = results[0].geometry.location;
                        $log.log('setting up vm.search');
                        vm.search = results[0].formatted_address;
                        if(vm.location) {
                            $log.log('location exist, setting title');
                            vm.location.title = results[0].formatted_address;
                        } else {
                            $log.log('location does not exist, setting title');
                            vm.location = {title: results[0].formatted_address};
                        }
                        vm.location.geoPoint.lat = Math.floor(loc.lat()*100000+0.5)/100000;
                        vm.location.geoPoint.lon = Math.floor(loc.lng()*100000+0.5)/100000;
                        vm.map.setCenter({lat: vm.location.geoPoint.lat, lng: vm.location.geoPoint.lon});
                        $scope.$apply();
                    }
                });
            }
        } // end of geoCode

        function uploadFile(file, errFiles) {
            $log.log('calling uploadFile...');
            vm.isSaving = true;
            vm.f = file;
            vm.errFile = errFiles && errFiles[0];

            if(file) {
                file.upload = Upload.upload(
                    {
                        url: "https://streams2.winkball.com/images",
                        data: {file: file},
                        headers: {
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }
            ).then(function (response) {
                $timeout(function() {
                    file.result = response.data;
                    vm.isSaving = false;
                    if(response.status == "201") {
                        $log.log('Image upload status 201');
                        vm.job.thumbnail = response.data;
                    }
                }, 1000);
            }, function(response){
                $log.log('Error...');
                $log.debug(response);
                vm.isSaving = false;
                if(response.status > 0) {
                    vm.errorMsg = response.status +': ' + response.data;
                }
            }, function(evt) {
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded/evt.total));
            });
            }
        } // end of uploadFile
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('JobDetailController', JobDetailController);

    JobDetailController.$inject = ['$scope', '$rootScope', '$state', '$q', 'Principal', 'previousState', 'entity', 'Job', 'User'];

    function JobDetailController($scope, $rootScope, $state, $q, Principal, previousState, entity, Job, User) {
        var vm = this;

        vm.job = entity;
        vm.back = back;
        vm.canEdit = canEdit;
        vm.creator = null;
        vm.events = [];
        vm.getSponsors = hasSponsors;
        vm.sponsors = [];
        vm.toggleApproved = toggleApproved;
        vm.isManager = isManager;
        vm.jobApplicants = [];
        vm.getImageSrc = getImageSrc;
        vm.isCurrentUserApproved = isCurrentUserApproved;
        vm.getStatusClass = getStatusClass;

        getAccount();

        $q.all([vm.job.$promise]).then(function() {
            if (!vm.job.createdBy) {
              // console.log('no creator to load....');
                return $q.reject();
            }
            return User.get({login : vm.job.createdBy}).$promise;
        }).then(function(creator) {
          // console.log('creator found');
            vm.creator = creator;
        });

        $q.all([vm.job.$promise]).then(function() {
            if (!vm.job.id) {
                return $q.reject();
            }
            // console.log('Retrieving sponsors!!!');
            return Job.sponsors({id : vm.job.id}).$promise;
        }).then(function(sponsors) {
            // console.log('Sponsors found');
            vm.sponsors = sponsors;
        });

        $q.all([vm.job.$promise]).then(function() {
            return Job.events({id : vm.job.id}).$promise;
        }).then(function(events) {
            // console.log('events found');
            vm.events = events;
        });

        // load job applicants
        $q.all([vm.job.$promise]).then(function() {
            if(!vm.job.id) {
                return $q.reject();
            }

            return Job.reporters({id : vm.job.id}).$promise;
        }).then(function(reporters) {
            vm.jobApplicants = reporters;

          // set fake id for job applications multiselect directive
            if(vm.jobApplicants.length) {
                var counter = 0;
                vm.jobApplicants = vm.jobApplicants.map(function(item) {
                    counter++;
                    item.id = counter;
                    return item;
                });

                if(!canEdit()) {
                    vm.jobApplicants = vm.jobApplicants.filter(function (item) {
                        return item.reporter.login === vm.account.login;
                    });

                }
            }
        });

        function getAccount() {
            Principal.identity().then(function(account) {
                // console.log('identity loaded');
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function back() {
            if(previousState.name === 'home') {
                $state.go('home');
            } else {
                $state.go('job');
            }
        }

        function canEdit() {
            if(!vm.account) return false;
            return vm.job.createdBy === vm.account.login ||
          (vm.job.manager && vm.job.manager.login === vm.account.login) ||
          vm.account.authorities.indexOf('ROLE_MANAGER') > -1 ||
          vm.account.authorities.indexOf('ROLE_ADMIN') > -1;
        }

        function isCurrentUserApproved() {
            var accepted = vm.jobApplicants.filter(function (item) {
                return item.reporter.login === vm.account.login && item.accepted;
            });
            return accepted.length > 0;
        }

        function toggleApproved() {
            if(Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR'])) {
                vm.job.approved = !vm.job.approved;
                Job.update(vm.job, function () {
                    // console.log('job updated');
                });
            }
        }

        function isManager() {
            return Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function hasSponsors() {
            return vm.sponsors.length > 0;
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.job.thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.job.thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.job.thumbnail + '?quality=ORIGINAL';

                }
            }

            return '';
        }

        function getStatusClass() {
            switch (vm.job.reportStatus) {
            case 'PROPOSAL':
                return 'bkg-proposal';
            case 'IN_PRODUCTION':
                return 'bkg-in-production';
            case 'READY_TO_FILM':
                return 'bkg-ready-to-film';
            case 'AWATING_SIGN_OFF':
                return 'bkg-awaiting-signoff';
            case 'COMPLETED':
                return 'bkg-black';
            case 'CANCELLED':
                return 'bkg-cancelled';
            default:
                return '';
            }
        }

        var unsubscribe = $rootScope.$on('winkballApp:jobUpdate', function(event, result) {
            vm.job = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('JobDeleteController',JobDeleteController);

    JobDeleteController.$inject = ['$uibModalInstance', 'entity', 'Job'];

    function JobDeleteController($uibModalInstance, entity, Job) {
        var vm = this;

        vm.job = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Job.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('JobApplyController', JobApplyController);

    JobApplyController.$inject = ['$uibModalInstance', '$q', 'entity', 'Job', 'Principal', 'User'];

    function JobApplyController($uibModalInstance, $q, entity, Job, Principal, User) {
        var vm = this;

        vm.job = entity;
        vm.clear = clear;
        vm.roles = ["PRESENTER", "EDITOR", "CAMERA"];
        vm.selectedRoles = [];
        vm.applyForJob = applyForJob;
        vm.currentUser = null;
        vm.toggleRoles = toggleRoles;
        vm.originalRoles = [];

        getAccount();

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function applyForJob () {

            if(vm.currentUser) {

                if(vm.originalRoles.length > 0) {

                    var toSave = vm.selectedRoles.filter(function (item) {
                        return !vm.originalRoles.includes(item);
                    });

                    var toDelete = vm.originalRoles.filter(function (item) {
                        return !vm.selectedRoles.includes(item);
                    });

                    if (toSave.length > 0) {
                        // apply for new role, previously not saved
                        toSave.forEach(function(el) {
                            Job.applyForJob({id: vm.job.id, reporterId: vm.currentUser.id, role: el});
                        });
                    }

                    if(toDelete.length > 0) {
                        // delete existing applications
                        toDelete.forEach(function(el) {
                            Job.deleteJobApplications({id: vm.job.id, reporterId: vm.currentUser.id, role: el});
                        });
                    }

                } else {
                    save();
                }
            }

            $uibModalInstance.close(true);
        }

        function save(withDelete) {
            if(withDelete) {
                // console.log('Save with delete operation...');
                // delete existing application if exists
                var deleteOp = Job.deleteJobApplications({id: vm.job.id, reporterId: vm.currentUser.id}).$promise;

                deleteOp.then(function(success) {
                    vm.selectedRoles.forEach(function(el) {
                        Job.applyForJob({id: vm.job.id, reporterId: vm.currentUser.id, role: el});
                    });

                });
            } else {
                vm.selectedRoles.forEach(function(el) {
                    Job.applyForJob({id: vm.job.id, reporterId: vm.currentUser.id, role: el});
                });
            }
        }

        function toggleRoles(role) {
            var idx = vm.selectedRoles.indexOf(role);

          // if currently selected
            if (idx > -1) {
            // remove role
                vm.selectedRoles.splice(idx, 1);
            } else {
            // add role
                vm.selectedRoles.push(role);
            }
        }

        function getAccount() {
            Principal.identity().then(function(account) {
                // console.log('identity loaded');

                $q.all([vm.job.$promise]).then(function() {
                    if(!vm.job.id) {
                        return $q.reject();
                    }
                    return User.get({login:account.login}).$promise;
                }).then(function(user) {

                    // console.log('Current user is set');
                    vm.currentUser = user;

                    $q.all([vm.currentUser.$promise]).then(function() {
                        if(!vm.job.id) {
                            return $q.reject();
                        }

                        return Job.getJobApplicationsForReporter({id: vm.job.id, reporterId: vm.currentUser.id}).$promise;
                    }).then(function(jobs) {
                        // console.log('Job applications are set');
                        vm.selectedRoles = jobs.map(function(item) {
                            return item.reporterJobRole;
                        });
                        
                        // clone and save original set of roles
                        vm.originalRoles = vm.selectedRoles.slice();

                    });

                });

            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('job', {
            parent: 'entity',
            url: '/job?status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.job.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/job/jobs.html',
                    controller: 'JobController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('job');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('sponsor');
                    return $translate.refresh();
                }]
            }
        })
        .state('job-detail', {
            parent: 'entity',
            url: '/job/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.job.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/job/job-detail.html',
                    controller: 'JobDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('job');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Job', function($stateParams, Job) {
                    return Job.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'job',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('job-detail.edit', {
            parent: 'job-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job/job-dialog.html',
                    controller: 'JobDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Job', function(Job) {
                            return Job.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('job-detail', {}, {
                        reload: false, location: 'replace'
                    });
                }, function() {
                    $state.go('job-detail', null, { location: 'replace' });
                });
            }]
        })
        .state('job.new', {
            parent: 'job',
            url: '/new',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job/job-dialog.html',
                    controller: 'JobDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                puid: null,
                                startDate: null,
                                endDate: null,
                                title: null,
                                description: null,
                                contactName: null,
                                contactPhone: null,
                                categories: [],
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('job', null, { reload: true });
                }, function() {
                    $state.go('job');
                });
            }]
        })
        .state('job.edit', {
            parent: 'job',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job/job-dialog.html',
                    controller: 'JobDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Job', function(Job) {
                            return Job.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('job', null, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        })
        .state('job.delete', {
            parent: 'job',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job/job-delete-dialog.html',
                    controller: 'JobDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Job', function(Job) {
                            return Job.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('job', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('job-detail.apply', {
            parent: 'job-detail',
            url: '/apply',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job/job-apply-dialog.html',
                    controller: 'JobApplyController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Job', function(Job) {
                            return Job.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', {}, { location: 'replace' });
                });
            }]
        }).state('job-estimator', {
            parent: 'job-detail',
            url: '/estimator',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job/job-estimator.html',
                    controller: 'JobEstimatorController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                }).result.then(function() {
                    $state.go('^', {}, { reload: false, location: 'replace' });
                }, function() {
                    $state.go('^', {}, {location: 'replace'});
                });
            }]
        }).state('job-inproduction', {
            parent: 'job-detail',
            url: '/inproduction',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_SUPERVISOR', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job/job-inproduction-dialog.html',
                    controller: 'JobInproductionController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Job', function (Job) {
                            return Job.get({
                                id: $stateParams.id
                            }).$promise;
                        }]
                    }
                }).result.then(function (result) {
                    $state.go('event-detail', { id: result.id }, {
                        reload: true
                    });
                }, function () {
                    $state.go('^');
                });
            }]
        }).state('new-sponsor', {
            parent: 'job-detail',
            url: '/new-sponsor?job',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sponsor/sponsor-dialog.html',
                    controller: 'SponsorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sponsorName: null,
                                puid: null,
                                createdDate: null,
                                contactName: null,
                                contactEmail: null,
                                telephone: null,
                                finder: null,
                                job: null,
                                address: { id: null, country: 'GBR'},
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    if($stateParams.job) {
                        $state.go('job-detail', { id : $stateParams.job }, { reload: true });
                    } else {
                        $state.go('sponsor', null, { reload: true });
                    }
                }, function() {
                    if($stateParams.job) {
                        $state.go('job-detail', { id : $stateParams.job });
                    } else {
                        $state.go('sponsor');
                    }
                });
            }]
        });

    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Job', Job);

    Job.$inject = ['$resource', 'DateUtils'];

    function Job ($resource, DateUtils) {
        var resourceUrl =  'api/jobs/:id';

        return $resource(resourceUrl,
            {
                jobId: '@id',
                reporterId: '@reporterId',
                role: '@role'
            },
            {
                'query': { method: 'GET', isArray: true},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                            data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                            data.reportDueDate = DateUtils.convertDateTimeFromServer(data.reportDueDate);
                        }
                        return data;
                    }
                },
                'update': { method:'PUT' },
                'events': { url: 'api/jobs/:id/events', method: 'GET', isArray: true},
                'reporters': { url: 'api/jobs/:id/reporters', method: 'GET', isArray: true},
                'updateReporters': { url: 'api/jobs/:id/reporters', method: 'PUT', isArray: true},
                'sponsors': { url: 'api/jobs/:id/sponsors', method: 'GET', isArray: true},
                'applyForJob': {
                    url: 'api/jobs/:jobId/reporters/:reporterId',
                    method: 'PUT',
                    hasBody: false
                },
                'getJobApplicationsForReporter' : {
                    url: 'api/jobs/:id/reporters/:reporterId',
                    method: 'GET',
                    isArray: true
                },
                'deleteJobApplications' : {
                    url: 'api/jobs/:id/reporters/:reporterId',
                    method: 'DELETE',
                    hasBody: false
                },
                'categories': { method: 'GET', url: 'api/categories', isArray: true }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('JobSearch', JobSearch);

    JobSearch.$inject = ['$resource'];

    function JobSearch($resource) {
        var resourceUrl =  'api/_search/jobs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('JobController', JobController);

    JobController.$inject = ['$scope', '$state', '$stateParams', 'Job', 'JobSearch', 'ParseLinks', 'AlertService', 'Principal'];

    function JobController ($scope, $state, $stateParams, Job, JobSearch, ParseLinks, AlertService, Principal) {
        var vm = this;

        vm.jobs = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'startDate';
        vm.reset = reset;
        vm.reverse = false;
        vm.inTransit = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.setApproved = setApproved;
        vm.canEdit = canEdit;
        vm.canDelete = canDelete;
        vm.filter = 'all';
        vm.statuses = [];
        vm.setFilter = setFilter;
        vm.getImageSrc = getImageSrc;
        vm.goToReport = goToReport;
        vm.setStatus = setStatus;

        if($stateParams.filter) {
            vm.filter = $stateParams.filter;
        }

        if($stateParams.status) {
            vm.statuses.push($stateParams.status);
        }

        //Principal.identity();
        getAccount();
        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                vm.filter = 'all';
                JobSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 15,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Job.query({
                    page: vm.page,
                    size: 15,
                    sort: sort(),
                    filter: vm.filter,
                    status: vm.statuses
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.jobs.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.jobs = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.jobs = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'startDate';
            vm.reverse = false;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function setFilter() {
            vm.page = 0;
            vm.jobs = [];
            vm.loadAll();
        }

        function setStatus(status) {

            var idx = vm.statuses.indexOf(status);

            // if currently selected
            if (idx > -1) {
                // remove status
                vm.statuses.splice(idx, 1);
            } else {
                // add status
                vm.statuses.push(status);
            }

            setFilter();
        }

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function setApproved(job, isApproved) {
            if(Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR'])) {
                job.approved = isApproved;
                Job.update(job, function () {
                    // vm.loadAll();
                    vm.clear();
                });
            }
        }

        function canEdit(job) {
            if(!vm.account) return false;
            return job.createdBy === vm.account.login ||
          (job.manager && job.manager.login === vm.account.login) ||
          Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function canDelete() {
            return Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }

            vm.jobs = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function getImageSrc(thumbnail, width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }
            
            if (thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + thumbnail + '?quality=ORIGINAL';
                }
            }

            return '';
        }

        function goToReport(jobId) {
            vm.inTransit = true;
            Job.events({id : jobId}).$promise.then(function(events) {
                vm.inTransit = false;
                if(angular.isArray(events) && events.length) {
                    $state.go('event-detail', {id: events[0].id});
                } else {
                    $state.go('job-detail', {id: jobId});
                }               
            }, function(){
                vm.inTransit = false;
                $state.go('job-detail', {id: jobId});
            });          
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('InventoryItemDialogController', InventoryItemDialogController);

    InventoryItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InventoryItem', 'User'];

    function InventoryItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InventoryItem, User) {
        var vm = this;

        vm.inventoryItem = entity;
        vm.clear = clear;
        vm.save = save;
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.inventoryItem.id !== null) {
                InventoryItem.update(vm.inventoryItem, onSaveSuccess, onSaveError);
            } else {
                InventoryItem.save(vm.inventoryItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:inventoryItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('InventoryItemDetailController', InventoryItemDetailController);

    InventoryItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InventoryItem', 'User'];

    function InventoryItemDetailController($scope, $rootScope, $stateParams, previousState, entity, InventoryItem, User) {
        var vm = this;

        vm.inventoryItem = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('winkballApp:inventoryItemUpdate', function(event, result) {
            vm.inventoryItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('InventoryItemDeleteController',InventoryItemDeleteController);

    InventoryItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'InventoryItem'];

    function InventoryItemDeleteController($uibModalInstance, entity, InventoryItem) {
        var vm = this;

        vm.inventoryItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InventoryItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('inventory-item', {
            parent: 'entity',
            url: '/inventory-item',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.inventoryItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/inventory-item/inventory-items.html',
                    controller: 'InventoryItemController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('inventoryItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('inventory-item-detail', {
            parent: 'entity',
            url: '/inventory-item/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.inventoryItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/inventory-item/inventory-item-detail.html',
                    controller: 'InventoryItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('inventoryItem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'InventoryItem', function($stateParams, InventoryItem) {
                    return InventoryItem.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'inventory-item',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('inventory-item-detail.edit', {
            parent: 'inventory-item-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/inventory-item/inventory-item-dialog.html',
                    controller: 'InventoryItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InventoryItem', function(InventoryItem) {
                            return InventoryItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('inventory-item.new', {
            parent: 'inventory-item',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/inventory-item/inventory-item-dialog.html',
                    controller: 'InventoryItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                assetNumber: null,
                                model: null,
                                name: null,
                                quantity: null,
                                serialNumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('inventory-item', null, { reload: true });
                }, function() {
                    $state.go('inventory-item');
                });
            }]
        })
        .state('inventory-item.edit', {
            parent: 'inventory-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/inventory-item/inventory-item-dialog.html',
                    controller: 'InventoryItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InventoryItem', function(InventoryItem) {
                            return InventoryItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('inventory-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('inventory-item.delete', {
            parent: 'inventory-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/inventory-item/inventory-item-delete-dialog.html',
                    controller: 'InventoryItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InventoryItem', function(InventoryItem) {
                            return InventoryItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('inventory-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('InventoryItem', InventoryItem);

    InventoryItem.$inject = ['$resource'];

    function InventoryItem ($resource) {
        var resourceUrl =  'api/inventory-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('InventoryItemSearch', InventoryItemSearch);

    InventoryItemSearch.$inject = ['$resource'];

    function InventoryItemSearch($resource) {
        var resourceUrl =  'api/_search/inventory-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('InventoryItemController', InventoryItemController);

    InventoryItemController.$inject = ['$scope', '$state', 'InventoryItem', 'InventoryItemSearch', 'ParseLinks', 'AlertService'];

    function InventoryItemController ($scope, $state, InventoryItem, InventoryItemSearch, ParseLinks, AlertService) {
        var vm = this;
        
        vm.inventoryItems = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                InventoryItemSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                InventoryItem.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.inventoryItems.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.inventoryItems = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.inventoryItems = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.inventoryItems = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('InterviewCommentDialogController', InterviewCommentDialogController);

    InterviewCommentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InterviewComment', 'Interview'];

    function InterviewCommentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InterviewComment, Interview) {
        var vm = this;

        vm.interviewComment = entity;
        vm.clear = clear;
        vm.save = save;
        vm.interviews = Interview.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.interviewComment.id !== null) {
                InterviewComment.update(vm.interviewComment, onSaveSuccess, onSaveError);
            } else {
                InterviewComment.save(vm.interviewComment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:interviewCommentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('InterviewCommentDetailController', InterviewCommentDetailController);

    InterviewCommentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InterviewComment', 'Interview'];

    function InterviewCommentDetailController($scope, $rootScope, $stateParams, previousState, entity, InterviewComment, Interview) {
        var vm = this;

        vm.interviewComment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('winkballApp:interviewCommentUpdate', function(event, result) {
            vm.interviewComment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('InterviewCommentDeleteController',InterviewCommentDeleteController);

    InterviewCommentDeleteController.$inject = ['$uibModalInstance', 'entity', 'InterviewComment'];

    function InterviewCommentDeleteController($uibModalInstance, entity, InterviewComment) {
        var vm = this;

        vm.interviewComment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InterviewComment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('interview-comment', {
            parent: 'entity',
            url: '/interview-comment?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.interviewComment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/interview-comment/interview-comments.html',
                    controller: 'InterviewCommentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('interviewComment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('interview-comment-detail', {
            parent: 'entity',
            url: '/interview-comment/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.interviewComment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/interview-comment/interview-comment-detail.html',
                    controller: 'InterviewCommentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('interviewComment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'InterviewComment', function($stateParams, InterviewComment) {
                    return InterviewComment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'interview-comment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('interview-comment-detail.edit', {
            parent: 'interview-comment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/interview-comment/interview-comment-dialog.html',
                    controller: 'InterviewCommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InterviewComment', function(InterviewComment) {
                            return InterviewComment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('interview-comment.new', {
            parent: 'interview-comment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/interview-comment/interview-comment-dialog.html',
                    controller: 'InterviewCommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                comment: null,
                                rating: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('interview-comment', null, { reload: true });
                }, function() {
                    $state.go('interview-comment');
                });
            }]
        })
        .state('interview-comment.edit', {
            parent: 'interview-comment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/interview-comment/interview-comment-dialog.html',
                    controller: 'InterviewCommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InterviewComment', function(InterviewComment) {
                            return InterviewComment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('interview-comment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('interview-comment.delete', {
            parent: 'interview-comment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/interview-comment/interview-comment-delete-dialog.html',
                    controller: 'InterviewCommentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InterviewComment', function(InterviewComment) {
                            return InterviewComment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('interview-comment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('InterviewComment', InterviewComment);

    InterviewComment.$inject = ['$resource'];

    function InterviewComment ($resource) {
        var resourceUrl =  'api/interview-comments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('InterviewCommentSearch', InterviewCommentSearch);

    InterviewCommentSearch.$inject = ['$resource'];

    function InterviewCommentSearch($resource) {
        var resourceUrl =  'api/_search/interview-comments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('InterviewCommentController', InterviewCommentController);

    InterviewCommentController.$inject = ['$scope', '$state', 'InterviewComment', 'InterviewCommentSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function InterviewCommentController ($scope, $state, InterviewComment, InterviewCommentSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                InterviewCommentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                InterviewComment.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.interviewComments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('InterviewShareController', InterviewShareController);

    InterviewShareController.$inject = ['$uibModalInstance', '$http', 'entity', 'Interview'];

    function InterviewShareController($uibModalInstance, $http, entity, Interview) {
        var vm = this;

        vm.interview = entity;
        vm.clear = clear;
        vm.shareInterview = shareInterview;
        vm.share = {};
        vm.share.message = vm.interview.title+' https://www.winkball.com/interviews/' + vm.interview.id;
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));
        vm.twitterUrl = getTwitterUrl();
        vm.mailToUrl = getMailToUrl();
        vm.pinterestUrl = getPinterestUrl();
        vm.videoEmbed = getVideoEmbedCode();

        //console.dir(vm.interview);

        function clear () {
            console.log('clear is called');
            $uibModalInstance.dismiss('cancel');
        }

        function shareInterview (id) {
            console.log('shareInterview is called');

            if(vm.share.twitter) {
                console.log('sharing on Twitter');
                console.log(vm.share.message);

                $http.post('https://social.winkball.com/tweets/winkball',
                { message: vm.share.message }, {
                    headers:{
                        'Authorization': 'Bearer ' + vm.authToken
                    }}).then(
                function () {
                    console.log('Tweet sent...');
                },
                function () {
                    console.log('Error twitting...');
                }
            );
            }
            var url = 'https://streams2.winkball.com/videos/'+vm.interview.videoFileGuid+'?quality=HD_720P';

            if(vm.share.youtube) {
                console.log('sharing on Youtube');

                var kw = [];
                for (var keyword in vm.interview.keywords) {
                    kw.push(keyword.text);
                }

                var youtube = {
                    videoLink: url,
                    title: vm.interview.title,
                    description: vm.interview.description,
                    tags: kw,
                    channelId: "UC6KIYZw-S2GvisuHd9PC-4g"
                };

                $http.post(
              'https://social.winkball.com/youtube/winkball/video',
              youtube, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    console.log('Youtube video sent...');
                },
                function () {
                    console.log('Error sendign Youtube video...');
                }
            );
            }

            if(vm.share.facebook) {
                console.log('sharing on Facebook');

                var facebook = {
                    linkUrl: 'https://www.winkball.com/interviews/' + vm.interview.id,
                    title: vm.interview.title,
                    description: vm.interview.description,
                    caption: 'https://www.winkball.com',
                    message: vm.share.message
                };

                $http.post(
              'https://social.winkball.com/facebook/winkball/page',
              facebook, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    console.log('Facebook video sent...');
                },
                function () {
                    console.log('Error sendign Facebook video...');
                }
            );
            }

            $uibModalInstance.close(true);
        }

        function getTwitterUrl() {
            return 'https://twitter.com/intent/tweet?url=https://www.winkball.com/interviews/'+vm.interview.id+'&text='+ window.encodeURIComponent(vm.interview.title);
        }

        function getMailToUrl() {
            return 'mailto:?subject='+ window.encodeURIComponent(vm.interview.title) +'&body=https://www.winkball.com/interviews/' + vm.interview.id;
        }

        function getPinterestUrl() {
            return 'https://pinterest.com/pin/create/button/?url=https://www.winkball.com/interviews/'+vm.interview.id+'&description='+ window.encodeURIComponent(vm.interview.title) +'&media=video';
        }

        function getVideoEmbedCode(width, height) {
            if (!width || !height) {
              // youtube defaults
                width = 560;
                height = 315;
            }
            return '<iframe src="https://www.winkball.com/playercard/' + vm.interview.videoFileGuid + '" frameborder="0" scrolling="no" width="' + width + '" height="' + height + '"></iframe>';
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('InterviewDialogController', InterviewDialogController);

    InterviewDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$http', 'entity', 'Interview', 'VideoFile', 'Location', 'KeywordSearch', 'Reporter', 'Event', 'Upload', 'LocationSearch', 'EventSearch', 'ReporterSearch'];

    function InterviewDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, $http, entity, Interview, VideoFile, Location, KeywordSearch, Reporter, Event, Upload, LocationSearch, EventSearch, ReporterSearch) {
        var vm = this;

        vm.interview = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = vm.interview.thumbnail;
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.getVideoSrc = getVideoSrc;
        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.searchLocations = searchLocations;
        vm.tagLocation = [];
        vm.searchEvents = searchEvents;
        vm.getEvent = getEvent;
        vm.searchReporters = searchReporters;

        console.debug(vm.tagLocation);
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));
        vm.videofiles = VideoFile.query({filter: 'interview-is-null'});

        $q.all([vm.interview.$promise, vm.videofiles.$promise]).then(function() {
            if (!vm.interview.videoFileId) {
                return $q.reject();
            }
            return VideoFile.get({id : vm.interview.videoFileId}).$promise;
        }).then(function(videoFile) {
            vm.videofiles.push(videoFile);
        });
        $q.all([vm.interview.$promise]).then(function() {
            if (!vm.interview.locationId) {
                return $q.reject();
            }
            return Location.get({id : vm.interview.locationId}).$promise;
        }).then(function(location) {
            vm.tagLocation = [location];
        });

        function searchEvents(query) {
            return EventSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        function getEvent(data) {
            vm.interview.eventId = data.originalObject.id;
        }

        function searchReporters(query) {
            return ReporterSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        $q.all([vm.interview.$promise]).then(function() {
            if (!vm.interview.eventId) {
                return $q.reject();
            }

            return Event.get({id : vm.interview.eventId}).$promise;
        }).then(function(item) {
            // used for setting a value on Event autocomplete input field
            $scope.$broadcast('angucomplete-alt:changeInput', 'field_event', item);
        });

        vm.searchKeywords = searchKeywords;

        function searchKeywords(query) {
            return KeywordSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        function searchLocations(query) {
            return LocationSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function clear () {
            console.log('calling clear method..');
            console.log('originalThumbnail: '+vm.originalThumbnail);
            vm.interview.thumbnail = vm.originalThumbnail;

            var puids = vm.thumbnailsForDeletion.filter(function (value) {
                return vm.originalThumbnail != value;
            });

            if(puids.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              puids, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    console.log('images deleted');
                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    console.log('error deleting images');
                }
            );
            }

            vm.tagLocation = [];

            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.thumbnailsForDeletion.length > 0) {
                $http.post(
                'https://streams2.winkball.com/delete-images',
                vm.thumbnailsForDeletion, {
                    headers:{
                        'Authorization': 'Bearer ' + vm.authToken
                    }}).then(
                  function () {
                      console.log('thumbnail deleted');
                      vm.thumbnailsForDeletion = [];
                  },
                  function () {
                      console.log('error deleting thumbnail');
                  }
              );
            }

            console.debug(vm.tagLocation);

            if(vm.tagLocation.length > 0) {
                vm.interview.locationId = vm.tagLocation[0].id;
            } else {
                vm.interview.locationId = null;
            }

            if (vm.interview.id !== null) {
                Interview.update(vm.interview, onSaveSuccess, onSaveError);
            } else {
                Interview.save(vm.interview, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:interviewUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.originalThumbnail = vm.interview.thumbnail;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function deleteThumbnail() {
            console.log('calling deleteThumbnail');
            vm.thumbnailsForDeletion.push(vm.interview.thumbnail);
            vm.interview.thumbnail = null;
        }

        function getVideoSrc(quality, format) {
            quality = quality || "HD_720P";
            format = format || "MP4";

            if (vm.interview.videoFileGuid) {
                return 'https://streams2.winkball.com/videos/'+vm.interview.videoFileGuid+'?quality='+quality+'&format='+format;
            }
            return "";
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.interview.thumbnail) {
                return 'https://streams2.winkball.com/images/'+vm.interview.thumbnail+dimentions;
            }

            return '';
        }

        vm.datePickerOpenStatus.interviewDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $scope.uploadFile = function(file, errFiles, image){
            console.log('calling uploadFile...');
            vm.isSaving = true;
            $scope.f = file;
            $scope.video = !image;
            $scope.errFile = errFiles && errFiles[0];

            if(file) {
                var uploadURL = "https://streams2.winkball.com/videos";

                if(image) {
                  uploadURL = "https://streams2.winkball.com/images";
              }

                file.upload = Upload.upload(
                  {
                      url: uploadURL,
                      data: {file: file},
                      headers: {'Authorization': 'Bearer ' + vm.authToken}
                  }
            );

                file.upload.then(function (response) {
                  $timeout(function() {

                    file.result = response.data;
                    vm.isSaving = false;

                    if(response.status == "201") {
                      console.log('Video upload status 201');
                      if(image) {
                        vm.interview.thumbnail = response.data;
                    } else {
                        vm.interview.videoFileGuid = response.data;
                        vm.interview.videoFileName = file.name;
                    //console.log(vm.interview.videoFileName);
                    }
                  }
                });
              }, function(response){
                  console.log('Error...');
                  vm.isSaving = false;
                  if(response.status > 0) {
                    $scope.errorMsg = response.status +': ' + response.data;
                }
              }, function(evt) {
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded/evt.total));
            });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('InterviewDetailController', InterviewDetailController);

    InterviewDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity', 'Principal', 'Interview', 'VideoFile', 'Location', 'Keyword', 'Reporter', 'Event'];

    function InterviewDetailController($scope, $rootScope, previousState, entity, Principal, Interview, VideoFile, Location, Keyword, Reporter, Event) {
        var vm = this;

        vm.interview = entity;
        vm.previousState = previousState.name;
        vm.getVideoSrc = getVideoSrc;
        vm.getImageSrc = getImageSrc;
        vm.isManager = isManager;

        function getVideoSrc(quality, format) {
            quality = quality || "HD_720P";
            format = format || "MP4";

            if (vm.interview.videoFileGuid) {
                return 'https://streams2.winkball.com/videos/'+vm.interview.videoFileGuid+'?quality='+quality+'&format='+format;
            }
            return "";
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.interview.thumbnail) {
                return 'https://streams2.winkball.com/images/'+vm.interview.thumbnail+dimentions;
            }

            return '';
        }

        function isManager() {
            return Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        var unsubscribe = $rootScope.$on('winkballApp:interviewUpdate', function(event, result) {
            vm.interview = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('InterviewDeleteController',InterviewDeleteController);

    InterviewDeleteController.$inject = ['$uibModalInstance', 'entity', 'Interview'];

    function InterviewDeleteController($uibModalInstance, entity, Interview) {
        var vm = this;

        vm.interview = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Interview.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('interview', {
            parent: 'entity',
            url: '/interview',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.interview.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/interview/interviews.html',
                    controller: 'InterviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('interview');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('interview-detail', {
            parent: 'entity',
            url: '/interview/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.interview.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/interview/interview-detail.html',
                    controller: 'InterviewDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('interview');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Interview', function($stateParams, Interview) {
                    return Interview.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    
                    var currentStateData = {
                        name: $state.current.name || 'interview',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('interview-detail.edit', {
            parent: 'interview-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/interview/interview-dialog.html',
                    controller: 'InterviewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Interview', function(Interview) {
                            return Interview.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('interview.new', {
            parent: 'interview',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_REPORTER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/interview/interview-dialog.html',
                    controller: 'InterviewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                puid: null,
                                title: null,
                                description: null,
                                published: false,
                                interviewDate: null,
                                interviewRating: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('interview', null, { reload: true });
                }, function() {
                    $state.go('interview');
                });
            }]
        })
        .state('interview.edit', {
            parent: 'interview',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/interview/interview-dialog.html',
                    controller: 'InterviewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Interview', function(Interview) {
                            return Interview.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('interview', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('interview.delete', {
            parent: 'interview',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/interview/interview-delete-dialog.html',
                    controller: 'InterviewDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Interview', function(Interview) {
                            return Interview.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('interview', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('interview.share', {
            parent: 'interview',
            url: '/{id}/share',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/interview/interview-share-dialog.html',
                    controller: 'InterviewShareController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Interview', function(Interview) {
                            return Interview.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('interview', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Interview', Interview);

    Interview.$inject = ['$resource', 'DateUtils'];

    function Interview ($resource, DateUtils) {
        var resourceUrl =  'api/interviews/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.interviewDate = DateUtils.convertDateTimeFromServer(data.interviewDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('InterviewSearch', InterviewSearch);

    InterviewSearch.$inject = ['$resource'];

    function InterviewSearch($resource) {
        var resourceUrl =  'api/_search/interviews/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('InterviewController', InterviewController);

    InterviewController.$inject = ['$scope', '$state', 'Principal','Interview', 'InterviewSearch', 'ParseLinks', 'AlertService'];

    function InterviewController ($scope, $state, Principal, Interview, InterviewSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.interviews = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'createdDate';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.canDelete = canDelete;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                InterviewSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Interview.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.interviews.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.interviews = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.interviews = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'createdDate';
            vm.reverse = false;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.interviews = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function canDelete() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SUPERVISOR']);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ImageDialogController', ImageDialogController);

    ImageDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', '$log', '$q', '$http', 'entity', 'Image', 'Upload'];

    function ImageDialogController ($timeout, $scope, $uibModalInstance, $log, $q, $http, entity, Image, Upload) {
        var vm = this;

        vm.image = entity;
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = vm.image.puid;
        vm.originalFileName = vm.image.fileName;
        vm.originalSize = vm.image.size;
        vm.originalType = vm.image.type;
        vm.clear = clear;
        vm.save = save;
        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.uploadFile = uploadFile;
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            vm.image.puid = vm.originalThumbnail;
            vm.image.size = vm.originalSize;
            vm.image.fileName = vm.originalFileName;
            vm.image.type = vm.originalType;

            var puids = vm.thumbnailsForDeletion.filter(function (value) {
                return vm.originalThumbnail !== value;
            });

            if(puids.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              puids, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    $log.error('error deleting images');
                }
            );
            }

            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.thumbnailsForDeletion.length > 0) {
                $http.post(
                'https://streams2.winkball.com/delete-images',
                vm.thumbnailsForDeletion, {
                    headers:{
                        'Authorization': 'Bearer ' + vm.authToken
                    }}).then(
                  function () {
                      vm.thumbnailsForDeletion = [];
                  },
                  function () {
                      $log.error('error deleting thumbnail');
                  }
              );
            }

            if (vm.image.id !== null) {
                Image.update(vm.image, onSaveSuccess, onSaveError);
            } else {
                Image.save(vm.image, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:imageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.originalThumbnail = vm.image.puid;
            vm.originalSize = vm.image.size;
            vm.originalFileName = vm.image.fileName;
            vm.originalType = vm.image.type;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function deleteThumbnail() {
            vm.thumbnailsForDeletion.push(vm.image.puid);
            vm.image.puid = null;
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.image.puid) {
                return 'https://streams2.winkball.com/images/'+ vm.image.puid + dimentions;
            }

            return '';
        }

        function uploadFile(file, errFiles) {
            vm.isSaving = true;
            vm.f = file;
            vm.errFile = errFiles && errFiles[0];
            // $log.log(vm.f);
            if (file) {
                file.upload = Upload.upload(
                    {
                        url: "https://streams2.winkball.com/images",
                        data: { file: file },
                        headers: {
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }
              ).then(function (response) {
                  $timeout(function () {
                      file.result = response.data;
                      vm.isSaving = false;
                      if (response.status === 201) {
                          $log.log('Image upload status 201');  
                          vm.image.puid = response.data;
                          vm.image.fileName = file.name;
                          vm.image.size = file.size;
                          vm.image.type = file.type;
                          $log.log(vm.image);
                      }
                  }, 1000);
              }, function (response) {
                  $log.log('Error...');
                  $log.debug(response);
                  vm.isSaving = false;
                  if (response.status > 0) {
                      vm.errorMsg = response.status + ': ' + response.data;
                  }
              }, function (evt) {
                  file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
              });
            }
        } // end of uploadFile
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ImageDetailController', ImageDetailController);

    ImageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Image'];

    function ImageDetailController($scope, $rootScope, $stateParams, previousState, entity, Image) {
        var vm = this;

        vm.image = entity;
        vm.previousState = previousState.name;
        vm.getImageSrc = getImageSrc;

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.image.puid) {
                return 'https://streams2.winkball.com/images/'+ vm.image.puid + dimentions;
            }

            return '';
        }

        var unsubscribe = $rootScope.$on('winkballApp:imageUpdate', function(event, result) {
            vm.image = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ImageDeleteController',ImageDeleteController);

    ImageDeleteController.$inject = ['$uibModalInstance', 'entity', 'Image'];

    function ImageDeleteController($uibModalInstance, entity, Image) {
        var vm = this;

        vm.image = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Image.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('image', {
            parent: 'entity',
            url: '/image',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.image.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/image/images.html',
                    controller: 'ImageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('image');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('image-detail', {
            parent: 'entity',
            url: '/image/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.image.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/image/image-detail.html',
                    controller: 'ImageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('image');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Image', function($stateParams, Image) {
                    return Image.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'image',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('image-detail.edit', {
            parent: 'image-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/image/image-dialog.html',
                    controller: 'ImageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Image', function(Image) {
                            return Image.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('image.new', {
            parent: 'image',
            url: '/new',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/image/image-dialog.html',
                    controller: 'ImageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                puid: null,
                                title: null,
                                fileName: null,
                                size: null,
                                type: null,
                                published: false
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('image', null, { reload: true });
                }, function() {
                    $state.go('image');
                });
            }]
        })
        .state('image.edit', {
            parent: 'image',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/image/image-dialog.html',
                    controller: 'ImageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Image', function(Image) {
                            return Image.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('image', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('image.delete', {
            parent: 'image',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/image/image-delete-dialog.html',
                    controller: 'ImageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Image', function(Image) {
                            return Image.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('image', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Image', Image);

    Image.$inject = ['$resource'];

    function Image ($resource) {
        var resourceUrl =  'api/images/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'deleteByPuid': { method:'DELETE', url: 'api/images/puid/:puid' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('ImageSearch', ImageSearch);

    ImageSearch.$inject = ['$resource'];

    function ImageSearch($resource) {
        var resourceUrl =  'api/_search/images/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ImageController', ImageController);

    ImageController.$inject = ['$scope', '$state', 'Image', 'ImageSearch', 'ParseLinks', 'AlertService'];

    function ImageController ($scope, $state, Image, ImageSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.images = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'createdDate';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.getImageSrc = getImageSrc;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                ImageSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Image.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                // if (vm.predicate !== 'id') {
                //     result.push('id');
                // }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.images.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.images = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.images = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.images = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function getImageSrc(puid, width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (puid) {
                return 'https://streams2.winkball.com/images/'+ puid + dimentions;
            }

            return '';
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('FilmCommentDialogController', FilmCommentDialogController);

    FilmCommentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FilmComment', 'Film'];

    function FilmCommentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FilmComment, Film) {
        var vm = this;

        vm.filmComment = entity;
        vm.clear = clear;
        vm.save = save;
        vm.films = Film.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.filmComment.id !== null) {
                FilmComment.update(vm.filmComment, onSaveSuccess, onSaveError);
            } else {
                FilmComment.save(vm.filmComment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:filmCommentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('FilmCommentDetailController', FilmCommentDetailController);

    FilmCommentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FilmComment', 'Film'];

    function FilmCommentDetailController($scope, $rootScope, $stateParams, previousState, entity, FilmComment, Film) {
        var vm = this;

        vm.filmComment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('winkballApp:filmCommentUpdate', function(event, result) {
            vm.filmComment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('FilmCommentDeleteController',FilmCommentDeleteController);

    FilmCommentDeleteController.$inject = ['$uibModalInstance', 'entity', 'FilmComment'];

    function FilmCommentDeleteController($uibModalInstance, entity, FilmComment) {
        var vm = this;

        vm.filmComment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FilmComment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('film-comment', {
            parent: 'entity',
            url: '/film-comment?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.filmComment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/film-comment/film-comments.html',
                    controller: 'FilmCommentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('filmComment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('film-comment-detail', {
            parent: 'entity',
            url: '/film-comment/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.filmComment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/film-comment/film-comment-detail.html',
                    controller: 'FilmCommentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('filmComment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FilmComment', function($stateParams, FilmComment) {
                    return FilmComment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'film-comment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('film-comment-detail.edit', {
            parent: 'film-comment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/film-comment/film-comment-dialog.html',
                    controller: 'FilmCommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FilmComment', function(FilmComment) {
                            return FilmComment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('film-comment.new', {
            parent: 'film-comment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/film-comment/film-comment-dialog.html',
                    controller: 'FilmCommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                comment: null,
                                rating: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('film-comment', null, { reload: true });
                }, function() {
                    $state.go('film-comment');
                });
            }]
        })
        .state('film-comment.edit', {
            parent: 'film-comment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/film-comment/film-comment-dialog.html',
                    controller: 'FilmCommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FilmComment', function(FilmComment) {
                            return FilmComment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('film-comment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('film-comment.delete', {
            parent: 'film-comment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/film-comment/film-comment-delete-dialog.html',
                    controller: 'FilmCommentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FilmComment', function(FilmComment) {
                            return FilmComment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('film-comment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('FilmComment', FilmComment);

    FilmComment.$inject = ['$resource'];

    function FilmComment ($resource) {
        var resourceUrl =  'api/film-comments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('FilmCommentSearch', FilmCommentSearch);

    FilmCommentSearch.$inject = ['$resource'];

    function FilmCommentSearch($resource) {
        var resourceUrl =  'api/_search/film-comments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('FilmCommentController', FilmCommentController);

    FilmCommentController.$inject = ['$scope', '$state', 'FilmComment', 'FilmCommentSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function FilmCommentController ($scope, $state, FilmComment, FilmCommentSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                FilmCommentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                FilmComment.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.filmComments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('FilmShareController', FilmShareController);

    FilmShareController.$inject = ['$uibModalInstance', '$http', 'entity', 'Film'];

    function FilmShareController($uibModalInstance, $http, entity, Film) {
        var vm = this;

        vm.film = entity;
        vm.clear = clear;
        vm.shareFilm = shareFilm;
        vm.share = {};
        vm.share.message = vm.film.title+' https://www.winkball.com/film/' + vm.film.id;
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));
        vm.twitterUrl = getTwitterUrl();
        vm.mailToUrl = getMailToUrl();
        vm.pinterestUrl = getPinterestUrl();
        vm.videoEmbed = getVideoEmbedCode();

        //console.dir(vm.film);

        function clear () {
            console.log('clear is called');
            $uibModalInstance.dismiss('cancel');
        }

        function shareFilm (id) {
            console.log('shareFilm is called');

            if(vm.share.twitter) {
                console.log('sharing on Twitter');
                console.log(vm.share.message);

                $http.post('https://social.winkball.com/tweets/winkball', {
                    message: vm.share.message
                }, {
                    headers:{
                        'Authorization': 'Bearer ' + vm.authToken
                    }
                }).then(
                function () {
                    console.log('Tweet sent...');
                },
                function () {
                    console.log('Error twitting...');
                }
            );
            }

            if(vm.share.youtube && vm.film.videoFileGuid) {
                console.log('sharing on Youtube');

                var url = 'https://streams2.winkball.com/videos/'+vm.film.videoFileGuid+'?quality=HD_720P';

                var kw = [];
                for (var keyword in vm.film.keywords) {
                    kw.push(keyword.text);
                }

                var youtube = {
                    videoLink: url,
                    title: vm.film.title,
                    description: vm.film.description,
                    tags: kw,
                    channelId: "UC6KIYZw-S2GvisuHd9PC-4g"
                };

                $http.post('https://social.winkball.com/youtube/winkball/video',
                  youtube, {
                      headers: {
                          'Authorization': 'Bearer ' + vm.authToken
                      }
                  }).then(
                    function () {
                        console.log('Youtube video sent...');
                    },
                    function () {
                        console.log('Error sendign Youtube video...');
                    }
                  );
            }

            if(vm.share.facebook) {
                console.log('sharing on Facebook');

                var facebook = {
                    linkUrl: 'https://www.winkball.com/film/' + vm.film.id,
                    title: vm.film.title,
                    description: vm.film.description,
                    caption: 'https://www.winkball.com',
                    message: vm.share.message
                };

                $http.post(
              'https://social.winkball.com/facebook/winkball/page',
              facebook, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    console.log('Facebook video sent...');
                },
                function () {
                    console.log('Error sendign Facebook video...');
                }
            );
            }

            $uibModalInstance.close(true);
        }

        function getTwitterUrl() {
            return 'https://twitter.com/intent/tweet?url=https://www.winkball.com/films/'+vm.film.id+'&text='+ window.encodeURIComponent(vm.film.title);
        }

        function getMailToUrl() {
            return 'mailto:?subject='+ window.encodeURIComponent(vm.film.title) +'&body=https://www.winkball.com/films/' + vm.film.id;
        }

        function getPinterestUrl() {
            return 'https://pinterest.com/pin/create/button/?url=https://www.winkball.com/films/'+vm.film.id+'&description='+ window.encodeURIComponent(vm.film.title) +'&media=video';
        }

        function getVideoEmbedCode(width, height) {
            if (!width || !height) {
              // youtube defaults
                width = 560;
                height = 315;
            }
            return '<iframe src="https://www.winkball.com/playercard/' + vm.film.videoFileGuid + '" frameborder="0" scrolling="no" width="' + width + '" height="' + height + '"></iframe>';
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('FilmDialogController', FilmDialogController);

    FilmDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$http', 'entity', 'Film', 'VideoFile', 'Location', 'KeywordSearch', 'Reporter', 'Event', 'Upload', 'LocationSearch', 'ReporterSearch', 'EventSearch'];

    function FilmDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, $http, entity, Film, VideoFile, Location, KeywordSearch, Reporter, Event, Upload, LocationSearch, ReporterSearch, EventSearch) {
        var vm = this;

        vm.film = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = vm.film.thumbnail;
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.getVideoSrc = getVideoSrc;
        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.searchLocation = searchLocation;
        vm.searchReporters = searchReporters;
        vm.tagLocation = [];
        vm.getLeadReporter = getLeadReporter;
        vm.getEditor = getEditor;
        vm.searchEvents = searchEvents;
        vm.getEvent = getEvent;

        vm.authToken = JSON.parse(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        vm.videofiles = VideoFile.query({filter: 'film-is-null'});
        $q.all([vm.film.$promise, vm.videofiles.$promise]).then(function() {
            if (!vm.film.videoFileId) {
                return $q.reject();
            }
            return VideoFile.get({id : vm.film.videoFileId}).$promise;
        }).then(function(videoFile) {
            vm.videofiles.push(videoFile);
        });

        vm.locations = Location.query({filter: 'film-is-null'});

        $q.all([vm.film.$promise, vm.locations.$promise]).then(function() {
            if (!vm.film.locationId) {
                return $q.reject();
            }
            return Location.get({id : vm.film.locationId}).$promise;
        }).then(function(location) {
            vm.locations.push(location);
            vm.tagLocation = [location];
        });

        $q.all([vm.film.$promise]).then(function() {
              if (!vm.film.eventId) {
                  return $q.reject();
              }

              return Event.get({id : vm.film.eventId}).$promise;
          }).then(function(item) {
            // used for setting a value on Event autocomplete input field
            $scope.$broadcast('angucomplete-alt:changeInput', 'field_event', item);
        });

        vm.searchKeywords = searchKeywords;

        function searchLocation(query) {
          return LocationSearch.query({
              query: query,
              page: 0,
              size: 10
          }).$promise;
        }

        function searchReporters(query) {
          return ReporterSearch.query({
              query: query,
              page: 0,
              size: 10
          }).$promise;
        }

        function searchEvents(query) {
          return EventSearch.query({
              query: query,
              page: 0,
              size: 10
          }).$promise;
        }

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function searchKeywords(query) {
          return KeywordSearch.query({
              query: query,
              page: 0,
              size: 10
          }).$promise;
        }

        function getEditor(data) {
          vm.film.editor = data.originalObject;
        }

        function getLeadReporter(data) {
          vm.film.leadReporter = data.originalObject;
        }

        function getEvent(data) {
          vm.film.eventId = data.originalObject.id;
        }

        function clear () {
          vm.film.thumbnail = vm.originalThumbnail;

          var puids = vm.thumbnailsForDeletion.filter(function (value) {
              return vm.originalThumbnail != value;
          });

          if(puids.length > 0) {
            $http.post(
              'https://streams2.winkball.com/delete-images',
              puids, {
              headers:{
                'Authorization': 'Bearer ' + vm.authToken
              }}).then(
                function () {
                  vm.thumbnailsForDeletion = [];
                },
                function () {
                  console.log('error deleting images');
                }
            );
          }
          vm.tagLocation = [];

          $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.thumbnailsForDeletion.length > 0) {
              $http.post(
                'https://streams2.winkball.com/delete-images',
                vm.thumbnailsForDeletion, {
                headers:{
                  'Authorization': 'Bearer ' + vm.authToken
                }}).then(
                  function () {
                    vm.thumbnailsForDeletion = [];
                  },
                  function () {
                    console.log('error deleting thumbnail');
                  }
              );
            }

            if(vm.tagLocation.length > 0) {
              vm.film.locationId = vm.tagLocation[0].id;
            } else {
              vm.film.locationId = null;
            }

            if (vm.film.id !== null) {
                Film.update(vm.film, onSaveSuccess, onSaveError);
            } else {
                Film.save(vm.film, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:filmUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.originalThumbnail = vm.film.thumbnail;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getVideoSrc(quality, format) {
            quality = quality || "HD_720P";
            format = format || "MP4";

            if (vm.film.videoFileGuid) {
                return 'https://streams2.winkball.com/videos/'+vm.film.videoFileGuid+'?quality='+quality+'&format='+format;
            }
            return "";
        }

        function getImageSrc(width, height) {
          var dimentions = '';

          if(width && height) {
            dimentions = '?w='+width+'&h='+height;
          }

          if (vm.film.thumbnail) {
            return 'https://streams2.winkball.com/images/'+vm.film.thumbnail+dimentions;
          }

          return '';
        }

        function deleteThumbnail() {
          console.log('calling deleteThumbnail');
          vm.thumbnailsForDeletion.push(vm.film.thumbnail);
          vm.film.thumbnail = null;
        }

        vm.datePickerOpenStatus.dateCompleted = false;
        vm.datePickerOpenStatus.internalSignOffDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $scope.uploadFile = function(file, errFiles, image){
          console.log('calling uploadFile...');
          vm.isSaving = true;
          $scope.f = file;
          $scope.video = !image;
          $scope.errFile = errFiles && errFiles[0];

          if(file) {
            var uploadURL = "https://streams2.winkball.com/videos";

            if(image) {
              uploadURL = "https://streams2.winkball.com/images";
            }

            file.upload = Upload.upload(
              {
                url: uploadURL,
                data: {file: file},
                headers: {'Authorization': 'Bearer ' + vm.authToken}
              }
            );

            file.upload.then(function (response) {
              $timeout(function() {
                file.result = response.data;
                vm.isSaving = false;

                if(response.status == "201") {
                  console.log('Upload status 201');
                  if(image) {
                    vm.film.thumbnail = response.data;
                  } else {
                    vm.film.videoFileGuid = response.data;
                    vm.film.videoFileName = file.name;
                  }
                }
              });
            }, function(response){
              console.log('Error...');
              vm.isSaving = false;
              if(response.status > 0) {
                $scope.errorMsg = response.status +': ' + response.data;
              }
            }, function(evt) {
              file.progress = Math.min(100, parseInt(100.0 * evt.loaded/evt.total));
            });
          }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('FilmDetailController', FilmDetailController);

    FilmDetailController.$inject = ['$scope', '$rootScope', '$state', 'previousState', 'entity', 'Film', 'VideoFile', 'Location', 'Keyword', 'Reporter', 'Event'];

    function FilmDetailController($scope, $rootScope, $state, previousState, entity, Film, VideoFile, Location, Keyword, Reporter, Event) {
        var vm = this;

        vm.film = entity;
        vm.back = back;
        vm.getVideoSrc = getVideoSrc;
        vm.getImageSrc = getImageSrc;

        function getVideoSrc(quality, format) {
            quality = quality || "HD_720P";
            format = format || "MP4";

            if (vm.film.videoFileGuid) {
                return 'https://streams2.winkball.com/videos/'+vm.film.videoFileGuid+'?quality='+quality+'&format='+format;
            }
            return "";
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.film.thumbnail) {
                return 'https://streams2.winkball.com/images/'+vm.film.thumbnail+dimentions;
            }

            return '';
        }

        function back() {
            if(previousState.name === 'event-detail') {
                $state.go(previousState.name, previousState.params);
            } else {
                if(previousState.name === 'home') {
                    $state.go('home');
                } else {
                    $state.go('film');
                }
                
            }
            
        }

        var unsubscribe = $rootScope.$on('winkballApp:filmUpdate', function(event, result) {
            vm.film = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('FilmDeleteController',FilmDeleteController);

    FilmDeleteController.$inject = ['$uibModalInstance', 'entity', 'Film'];

    function FilmDeleteController($uibModalInstance, entity, Film) {
        var vm = this;

        vm.film = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Film.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('film', {
            parent: 'entity',
            url: '/film',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.film.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/film/films.html',
                    controller: 'FilmController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('film');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('film-detail', {
            parent: 'entity',
            url: '/film/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.film.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/film/film-detail.html',
                    controller: 'FilmDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('film');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Film', function($stateParams, Film) {
                    return Film.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'film',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('film-detail.edit', {
            parent: 'film-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/film/film-dialog.html',
                    controller: 'FilmDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Film', function(Film) {
                            return Film.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('film-detail.delete', {
            parent: 'film-detail',
            url: '/detail/delete',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_MANAGER', 'ROLE_SUPERVISOR', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/film/film-delete-dialog.html',
                    controller: 'FilmDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Film', function (Film) {
                            return Film.get({ id: $stateParams.id }).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('film', null, { reload: true });
                }, function () {
                    $state.go('^');
                });
            }]
        })
        .state('film.new', {
            parent: 'film',
            url: '/new',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/film/film-dialog.html',
                    controller: 'FilmDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                puid: null,
                                title: null,
                                description: null,
                                published: false,
                                dateCompleted: null,
                                internalSignOffDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('film', null, { reload: true });
                }, function() {
                    $state.go('film');
                });
            }]
        })
        .state('film.edit', {
            parent: 'film',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/film/film-dialog.html',
                    controller: 'FilmDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Film', function(Film) {
                            return Film.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('film', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('film.delete', {
            parent: 'film',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/film/film-delete-dialog.html',
                    controller: 'FilmDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Film', function(Film) {
                            return Film.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('film', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('film.share', {
            parent: 'film',
            url: '/{id}/share',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/film/film-share-dialog.html',
                    controller: 'FilmShareController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Film', function(Film) {
                            return Film.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('film', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Film', Film);

    Film.$inject = ['$resource', 'DateUtils'];

    function Film ($resource, DateUtils) {
        var resourceUrl =  'api/films/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateCompleted = DateUtils.convertDateTimeFromServer(data.dateCompleted);
                        data.internalSignOffDate = DateUtils.convertDateTimeFromServer(data.internalSignOffDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('FilmSearch', FilmSearch);

    FilmSearch.$inject = ['$resource'];

    function FilmSearch($resource) {
        var resourceUrl =  'api/_search/films/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('FilmController', FilmController);

    FilmController.$inject = ['$scope', '$state','Principal', 'Film', 'FilmSearch', 'ParseLinks', 'AlertService'];

    function FilmController ($scope, $state, Principal, Film, FilmSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.films = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'createdDate';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.canEdit = canEdit;
        vm.canDelete = canDelete;

        getAccount();

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                FilmSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Film.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.films.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.films = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.films = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'createdDate';
            vm.reverse = false;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.films = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function canEdit(film) {
          if(!vm.account) return false;
          return film.createdBy === vm.account.login ||
          (film.leadReporter && film.leadReporter.login === vm.account.login) ||
          (film.editor && film.editor.login === vm.account.login) ||
          Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SUPERVISOR']);
        }

        function canDelete() {
          if(!vm.account) return false;
          return Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SUPERVISOR']);
        }

        function getAccount() {
          Principal.identity().then(function(account) {
            console.log('identity loaded');
              vm.account = account;
              vm.isAuthenticated = Principal.isAuthenticated;
          });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventCommentDialogController', EventCommentDialogController);

    EventCommentDialogController.$inject = ['$timeout', '$scope', '$q', '$uibModalInstance', 'entity', 'EventComment', 'Event', 'EventSearch'];

    function EventCommentDialogController ($timeout, $scope, $q, $uibModalInstance, entity, EventComment, Event, EventSearch) {
        var vm = this;

        vm.eventComment = entity;
        vm.clear = clear;
        vm.save = save;
        // vm.events = Event.query();
        vm.searchEvents = searchEvents;
        vm.getEvent = getEvent;
        vm.event = null;
        vm.readonly = false;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        $q.all([vm.eventComment.$promise]).then(function() {
            if(!vm.eventComment.eventId) {
                return $q.reject();
            }

            return Event.get({id : vm.eventComment.eventId}).$promise;
        }).then(function(event) {
            vm.event = event;
            vm.readonly = true;
        });

        function searchEvents(query) {
            return EventSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        function getEvent(data) {
            vm.eventComment.eventId = data.originalObject.id;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.eventComment.id !== null) {
                EventComment.update(vm.eventComment, onSaveSuccess, onSaveError);
            } else {
                EventComment.save(vm.eventComment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:eventCommentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventCommentDetailController', EventCommentDetailController);

    EventCommentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'EventComment', 'Event'];

    function EventCommentDetailController($scope, $rootScope, $stateParams, previousState, entity, EventComment, Event) {
        var vm = this;

        vm.eventComment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('winkballApp:eventCommentUpdate', function(event, result) {
            vm.eventComment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventCommentDeleteController',EventCommentDeleteController);

    EventCommentDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventComment'];

    function EventCommentDeleteController($uibModalInstance, entity, EventComment) {
        var vm = this;

        vm.eventComment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EventComment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-comment', {
            parent: 'entity',
            url: '/event-comment?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.eventComment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-comment/event-comments.html',
                    controller: 'EventCommentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventComment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-comment-detail', {
            parent: 'entity',
            url: '/event-comment/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.eventComment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event-comment/event-comment-detail.html',
                    controller: 'EventCommentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventComment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventComment', function($stateParams, EventComment) {
                    return EventComment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'event-comment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('event-comment-detail.edit', {
            parent: 'event-comment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-comment/event-comment-dialog.html',
                    controller: 'EventCommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventComment', function(EventComment) {
                            return EventComment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-comment.new', {
            parent: 'event-comment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-comment/event-comment-dialog.html',
                    controller: 'EventCommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                comment: null,
                                rating: null,
                                eventId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-comment', null, { reload: true });
                }, function() {
                    $state.go('event-comment');
                });
            }]
        })
        .state('event-comment.edit', {
            parent: 'event-comment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-comment/event-comment-dialog.html',
                    controller: 'EventCommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventComment', function(EventComment) {
                            return EventComment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-comment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-comment.delete', {
            parent: 'event-comment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-comment/event-comment-delete-dialog.html',
                    controller: 'EventCommentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventComment', function(EventComment) {
                            return EventComment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-comment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('EventComment', EventComment);

    EventComment.$inject = ['$resource'];

    function EventComment ($resource) {
        var resourceUrl =  'api/event-comments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('EventCommentSearch', EventCommentSearch);

    EventCommentSearch.$inject = ['$resource'];

    function EventCommentSearch($resource) {
        var resourceUrl =  'api/_search/event-comments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventCommentController', EventCommentController);

    EventCommentController.$inject = ['$scope', '$state', 'EventComment', 'EventCommentSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function EventCommentController ($scope, $state, EventComment, EventCommentSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                EventCommentSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                EventComment.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.eventComments = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventUpdateTeamController', EventUpdateTeamController);

    EventUpdateTeamController.$inject = ['$uibModalInstance', '$stateParams', '$q', '$scope', 'entity', 'Job'];

    function EventUpdateTeamController($uibModalInstance, $stateParams, $q, $scope, entity, Job) {
        var vm = this;

        vm.event = entity;
        vm.applicants = $stateParams.applicants;
        vm.clear = clear;
        vm.confirmUpdate = confirmUpdate;
        vm.isSaving = true;

        $q.all([vm.event.$promise]).then(function () {
            if (!vm.event.id) {
                return $q.reject();
            }
            vm.isSaving = false;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmUpdate(status) {
            vm.isSaving = true;
            // update reporter applicants which will also trigger Event update
            // Resource.action([parameters], postData, [success], [error])
            Job.updateReporters({ id : vm.event.job.id }, vm.applicants, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventStatusDialogController', EventStatusDialogController);

    EventStatusDialogController.$inject = ['$uibModalInstance', '$q', '$scope', '$stateParams', '$translate', 'entity', 'Event'];

    function EventStatusDialogController($uibModalInstance, $q, $scope, $stateParams, $translate, entity, Event) {
        var vm = this;

        vm.event = entity;
        vm.clear = clear;
        vm.confirmMove = confirmMove;
        vm.status = $stateParams.status;
        
        $translate('reportStatus.' + vm.status).then(function(value){
            vm.statusName = value;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmMove() {
            vm.isSaving = true;

            if($stateParams.status) {
                vm.event.reportStatus = $stateParams.status;
            }

            if(vm.event.reportStatus === 'CANCELLED') {
                vm.event.published = false;
            }

            if(vm.event.reportStatus === 'COMPLETED') {
                vm.event.published = true;
            }

            // if(!vm.event.published) {
            //     // unpublish films too
            //     if (vm.event.films) {
            //         vm.event.films.array.forEach(function(element) {
            //             element.published = false;
            //         });
            //     }
            // } else {
            //     if (vm.event.films && vm.event.length > 0) {
            //         vm.event.films[0].published = true;
            //     }
            // }

            Event.update(vm.event, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $scope.$emit('winkballApp:eventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventShareController', EventShareController);

    EventShareController.$inject = ['$window','$uibModalInstance', '$http', '$log', 'entity', 'Event'];

    function EventShareController($window, $uibModalInstance, $http, $log, entity, Event) {
        var vm = this;

        vm.event = entity;
        vm.clear = clear;
        vm.shareEvent = shareEvent;
        vm.share = {};
        vm.share.message = vm.event.title+' https://www.winkball.com/events/' + vm.event.id;
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));
        vm.twitterUrl = getTwitterUrl();
        vm.mailToUrl = getMailToUrl();
        vm.pinterestUrl = getPinterestUrl();
        vm.videoEmbed = getVideoEmbedCode();

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function shareEvent (id) {
            if(vm.share.twitter) {
                $http.post(
              'https://social.winkball.com/tweets/winkball',
              {message: vm.share.message}, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    $log.log('Tweet sent...');
                },
                function () {
                    $log.log('Error twitting...');
                }
            );
            }

            if(vm.share.youtube && vm.event.films.length > 0) {
                // selecting first film in the array - not ideal
                var video = vm.event.films[0].videoFile;

                var url = 'https://streams2.winkball.com/videos/'+video.guid+'?quality=HD_720P';

                var kw = [];
                for (var keyword in vm.event.keywords) {
                    kw.push(keyword.text);
                }

                var youtube = {
                    videoLink: url,
                    title: vm.event.title,
                    description: vm.event.description,
                    tags: kw,
                    channelId: "UCR_vjXrVpV9TI-GMGUVETcg"
                };

                $http.post(
              'https://social.winkball.com/youtube/winkball/video',
              youtube, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    $log.log('Youtube video sent...');
                },
                function () {
                    $log.log('Error sendign Youtube video...');
                }
            );
            }

            if(vm.share.facebook) {
                $log.log('sharing on Facebook');

                var facebook = {
                    linkUrl: 'https://www.winkball.com/events/' + vm.event.id,
                    title: vm.event.title,
                    description: vm.event.description,
                    caption: 'https://www.winkball.com',
                    message: vm.share.message
                };

                $http.post(
              'https://social.winkball.com/facebook/winkball/page',
              facebook, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    $log.log('Facebook video sent...');
                },
                function () {
                    $log.log('Error sendign Facebook video...');
                }
            );
            }

            $uibModalInstance.close(true);
        }

        function getTwitterUrl() {
            return 'https://twitter.com/intent/tweet?url=https://www.winkball.com/events/'+vm.event.id+'&text='+ $window.encodeURIComponent(vm.event.title);
        }

        function getMailToUrl() {
            return 'mailto:?subject='+ $window.encodeURIComponent(vm.event.title) +'&body=https://www.winkball.com/events/' + vm.event.id;
        }

        function getPinterestUrl() {
            return 'https://pinterest.com/pin/create/button/?url=https://www.winkball.com/events/'+vm.event.id+'&description='+ $window.encodeURIComponent(vm.event.title) +'&media=video';
        }

        function getVideoEmbedCode(width, height) {
            if (!width || !height) {
              // youtube defaults
                width = 560;
                height = 315;
            }

            if(vm.event.films.length > 0) {
                var video = vm.event.films[0].videoFile;
                return '<iframe src="https://www.winkball.com/playercard/' + video.guid + '" frameborder="0" scrolling="no" width="' + width + '" height="' + height + '"></iframe>';
            } else {
                return '';
            }
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventReadytofilmController', EventReadytofilmController);

    EventReadytofilmController.$inject = ['$uibModalInstance', '$q', '$scope', 'entity', 'Job', 'Event'];

    function EventReadytofilmController($uibModalInstance, $q, $scope, entity, Job, Event) {
        var vm = this;

        vm.event = entity;
        vm.clear = clear;
        vm.confirmMove = confirmMove;
        vm.isSaving = true;

        $q.all([vm.event.$promise]).then(function () {
            if (!vm.event.id) {
                return $q.reject();
            }

            // set new status
            vm.event.reportStatus = 'READY_TO_FILM';

            vm.isSaving = false;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmMove(status) {
            vm.isSaving = true;
            if(status) {
                vm.event.reportStatus = status;
            }
            Event.update(vm.event, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $scope.$emit('winkballApp:eventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventEmailProspectivePublisherController', EventEmailProspectivePublisherController);

    EventEmailProspectivePublisherController.$inject = ['$window','$uibModalInstance', '$q', '$http', '$log', 'entity', 'ProspectivePublisher', 'ProspectivePublisherSearch', 'ParseLinks', 'AlertService'];

    function EventEmailProspectivePublisherController($window, $uibModalInstance, $q, $http, $log, entity, ProspectivePublisher, ProspectivePublisherSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.event = entity;
        vm.clear = clear;
        vm.email = {
            toAll: false,
            to: 'editorial@winkball.com', // ignored
            publisherId: 0, // ignored
            subject: vm.event.title // set subject to report title
        };
        vm.sendEmail = sendEmail;
        vm.contacts = [];
        vm.publishers = [];
        vm.page = 0;        
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reverse = true;
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));
        vm.toggleContact = toggleContact;
        vm.loadAll = loadAll;
        vm.reset = reset;
        vm.clearPublishers = clearPublishers;
        vm.loadPage = loadPage;
        vm.search = search;

        loadAll();

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function sendEmail() {
            $log.log('sendEmail called');
            vm.email.eventId = vm.event.id;

            if (vm.email.toAll) {
                vm.contacts = [];
                $http.post(
                    '/api/mail/report/prospective-publishers',
                    vm.email, 
                    {
                        headers:{
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }).then(
                      function () {
                          $log.log('email sent');
                          $uibModalInstance.close(vm.event);
                      },
                      function (error) {
                          $log.error('error sending emails');
                          $log.error(error);
                          AlertService.error(error.data.message);
                      }
                  );
            } else {
                vm.contacts.forEach(function (publisher) {
                    $log.log(publisher);
                    $http.post(
                        '/api/mail/report/prospective-publishers',
                        { 
                            to: publisher.email, 
                            subject: vm.email.subject, 
                            message: vm.email.message, 
                            greetings:  vm.email.greetings, 
                            eventId: vm.event.id,
                            publisherId: publisher.id
                        }, 
                        {
                            headers:{
                                'Authorization': 'Bearer ' + vm.authToken
                            }
                        }).then(
                          function () {
                              $log.log('email sent');
                          },
                          function (error) {
                              $log.error('error sending emails');
                              $log.error(error);
                              AlertService.error(error.data.message);
                          }
                      );
                });
                $uibModalInstance.close(vm.event);
            }
        }

        function toggleContact(contact) {
            var idx = vm.contacts.indexOf(contact);
            if(idx > -1) {
                vm.contacts.splice(idx, 1);
            } else {
                vm.contacts.push(contact);
            }
        }

        function loadAll() {
            if (vm.currentSearch) {
                ProspectivePublisherSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 10,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ProspectivePublisher.query({
                    page: vm.page,
                    size: 10,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.publishers.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset() {
            vm.page = 0;
            vm.publishers = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clearPublishers() {
            vm.publishers = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.publishers = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventEmailController', EventEmailController);

    EventEmailController.$inject = ['$window','$uibModalInstance', '$q', '$http', '$log', 'entity', 'Job'];

    function EventEmailController($window, $uibModalInstance, $q, $http, $log, entity, Job) {
        var vm = this;

        vm.event = entity;
        vm.clear = clear;
        vm.email = {};
        vm.sendEmail = sendEmail;
        vm.contacts = [];
        vm.jobApplicants = [];
        vm.reporters = [];
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));
        vm.toggleContact = toggleContact;
        vm.eventUrl = '';

        $q.all([vm.event.$promise]).then(function() {
            if(vm.event.reporters.length) {
                vm.reporters = vm.event.reporters.map(function(reporter){
                    return { reporter: reporter.user, reporterJobRole : 'UNKNOWN', accepted: true };
                });
            }
            // set subject to report title
            vm.email.subject = vm.event.title;

            if(!vm.event.job) {
                $log.log('No job rejecting...');
                return $q.reject();
            }

            // load job applicants
            return Job.reporters({id : vm.event.job.id}).$promise;
        }).then(function(reporters) {
            // holds unique email addresses
            var emails = [];
            
            reporters.forEach(function(item) {
                if(item.accepted) {
                    vm.jobApplicants.push(item);
                    if (emails.indexOf(item.reporter.email) === -1) {
                        emails.push(item.reporter.email);
                    }
                }
            });

            if (vm.reporters.length) {
                vm.reporters.forEach(function(item){
                    if (emails.indexOf(item.reporter.email) === -1) {
                        vm.jobApplicants.push(item);
                    }
                });
            }
        }, function () {
            $log.log('No job present'); 
            vm.jobApplicants = vm.reporters;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function sendEmail() {
            $log.log('email called');
            vm.contacts.forEach(function (to) {
                $http.post(
                    '/api/mail/message',
                    { to: to, subject: vm.email.subject, message: vm.email.message, eventId: vm.event.id }, 
                    {
                        headers:{
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }).then(
                      function () {
                          $log.log('email sent');
                      },
                      function () {
                          $log.error('error sending emails');
                      }
                  );
            });
            $uibModalInstance.close(vm.event);
        }

        function toggleContact(contact) {
            var idx = vm.contacts.indexOf(contact);
            if(idx > -1) {
                vm.contacts.splice(idx, 1);
            } else {
                vm.contacts.push(contact);
            }
        }
    }
})();
;
/* global google */
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventDialogController', EventDialogController);

    EventDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance', '$http', '$log', '$q', 'entity', 'Event', 'Location', 'User', 'UserSearch', 'Upload', 'KeywordSearch', 'LocationSearch', 'ReporterSearch', 'Job', 'NgMap'];

    function EventDialogController ($timeout, $scope, $state, $stateParams, $uibModalInstance, $http, $log, $q, entity, Event, Location, User, UserSearch, Upload, KeywordSearch, LocationSearch, ReporterSearch, Job, NgMap) {
        var vm = this;

        vm.event = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = vm.event.thumbnail;
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.searchKeywords = searchKeywords;
        vm.searchLocations = searchLocations;
        vm.tagLocation = vm.event.location ? [vm.event.location] : [];
        vm.searchReporters = searchReporters;
        vm.reporters = [];
        vm.users = [];
        vm.jobs = [];
        vm.searchUser = searchUser;
        vm.getManager = getManager;
        vm.uploadFile = uploadFile;

        vm.saveLocation = saveLocation;
        vm.location = vm.event.location || {};
        vm.location.geoPoint = vm.location.geoPoint || {};
        vm.locationRemoved = locationRemoved;
        vm.locationAdded = locationAdded;
        vm.clearLocation = clearLocation;
        vm.addMarker = addMarker;
        vm.geoCode = geoCode;
        vm.search = "";
        vm.jobApplicants = [];
        vm.selectedApplicants = [];
        vm.multiSelectSettings = {externalIdProp: '', template: '<b>{{option.reporter.firstName}} {{option.reporter.lastName}} <small>({{option.reporterJobRole}})<smal></b>'};
        vm.toggleCategory = toggleCategory;
        vm.selectReportersText = {buttonDefaultText: 'Select Reporters'};

        vm.categories = Event.categories();

        vm.jobs = Job.query({
            filter: "approved",
            page: 0,
            size: 40,
            sort: "createdDate,desc"});

        $q.all([vm.event.$promise, vm.jobs.$promise]).then(function() {
            if(!vm.event.id) {
                return $q.reject();
            }
            return Event.reporters({id : vm.event.id}).$promise;
        }).then(function(reporters) {
            vm.reporters = reporters;
        });

        $q.all([vm.event.$promise]).then(function() {
            if(!vm.event.job) {
                return $q.reject();
            }

            return Job.get({id : vm.event.job.id}).$promise;
        }).then(function(job) {
            vm.jobs.push(job);
        });

        // load job and job applicants for new event
        $q.all([vm.event.$promise]).then(function() {
            if(vm.event.id) {
                return $q.reject();
            }

            if(!$stateParams.job) {
                return $q.reject();
            }
            return Job.get({id : $stateParams.job}).$promise;
        }).then(function(job) {
            vm.event.job = job;
            vm.event.title = job.title;
            vm.event.description = job.description;
            vm.event.manager = job.manager;
            vm.event.startDate = job.startDate;
            vm.event.reportDueDate = job.reportDueDate;
            vm.event.keyTalent = job.keyTalent;
            vm.event.socialMedia = job.socialMedia;
            vm.event.editorialStoryline = job.editorialStoryline;
            vm.event.contactName = job.contactName;
            vm.event.contactPhone = job.contactPhone;
            vm.event.contactEmail = job.contactEmail;
            vm.event.categories = job.categories;

            if(job.location) {
                vm.event.location = job.location;
                vm.tagLocation.push(job.location);
            }

            var applicants = Job.reporters({id : vm.event.job.id}).$promise;
            applicants.then(function(reporters) {
                vm.jobApplicants = reporters;

                $log.log('Retrieved jobApplicants');
                $log.log(vm.jobApplicants);

              // set fake id for job applications multiselect directive
                if(vm.jobApplicants.length > 0) {
                    var counter = 0;
                    vm.jobApplicants = vm.jobApplicants.map(function(item) {
                        counter++;
                        item.id = counter;
                        return item;
                    });

                    $log.log('Filtered applicants');
                    $log.log(vm.jobApplicants);

                    vm.selectedApplicants = vm.jobApplicants.filter(function(item) {
                        return item.accepted;
                    });
                }
            });

        });

        // load job applicants for existing event
        $q.all([vm.event.$promise]).then(function() {
            $log.log('Trying to load applicants....');

            if (!vm.event.id || (!vm.event.job || !vm.event.job.id)) {
                return $q.reject();
            }
          
            return Job.reporters({id : vm.event.job.id}).$promise;
        }).then(function(reporters) {
            vm.jobApplicants = reporters;

          // set fake id for job applications multiselect directive
            if(vm.jobApplicants.length > 0) {
                var counter = 0;
                vm.jobApplicants = vm.jobApplicants.map(function(item) {
                    counter++;
                    item.id = counter;
                    return item;
                });

                vm.selectedApplicants = vm.jobApplicants.filter(function(item) {
                    return item.accepted;
                });
            }
        });

        $q.all([vm.event.$promise]).then(function() {
            if (!vm.event.location) {
                return $q.reject();
            }

            return Location.get({id : vm.event.location.id}).$promise;
        }).then(function(location) {
            vm.tagLocation = [location];
        });

        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function searchReporters(query) {
            return ReporterSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        function searchKeywords(query) {
            return KeywordSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        function searchLocations(query) {
            return LocationSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        $scope.$on('mapInitialized', function(evt, map) {
            $log.log('map initialised');

            vm.map = map;
            google.maps.event.trigger(vm.map, 'resize');
            if(vm.location.geoPoint.lat && vm.location.geoPoint.lon) {
                map.setCenter({lat: vm.location.geoPoint.lat, lng: vm.location.geoPoint.lon});
            }
        });

        function searchUser(query) {
            return UserSearch.query({query: query}).$promise;
        }

        function getManager(data) {
            vm.event.manager = data.originalObject;
        }

        function toggleCategory(category) {
            var idx = vm.event.categories.indexOf(category);
            if(idx > -1) {
                vm.event.categories.splice(idx, 1);
            } else {
                vm.event.categories.push(category);
            }
        }

        function clear () {
            $log.log('calling clear method..');

            $log.log('originalThumbnail: ' + vm.originalThumbnail);

            vm.event.thumbnail = vm.originalThumbnail;

            var puids = vm.thumbnailsForDeletion.filter(function (value) {
                return vm.originalThumbnail !== value;
            });

            if(puids.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              puids, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    $log.log('videos deleted');

                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    $log.log('error deleting videos');
                }
            );
            }

            vm.tagLocation = [];
            vm.selectedApplicants = [];

            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if(vm.thumbnailsForDeletion.length > 0) {
                $http.post(
              'https://streams2.winkball.com/delete-images',
              vm.thumbnailsForDeletion, {
                  headers:{
                      'Authorization': 'Bearer ' + vm.authToken
                  }}).then(
                function () {
                    vm.thumbnailsForDeletion = [];
                },
                function () {
                    $log.log('error deleting thumbnail');
                }
            );
            }

            if(vm.tagLocation.length > 0) {
                vm.event.location = vm.tagLocation[0];
            } else {
                vm.event.location = null;
            }

            if(vm.selectedApplicants.length > 0) {
                // extract reporters
                var selectedReporters = vm.selectedApplicants.map(function (item) {
                    return item.reporter;
                });

                // remove duplicate reporters
                vm.reporters = selectedReporters.filter(function( item, index, selectedReporters) {
                    return selectedReporters.map(function (obj) { return obj.id; }).indexOf(item.id) === index;
                });
            }

            if(vm.reporters.length > 0) {
                // HACK - vm.reporters are DTOs but vm.event.reporters are Reporter objects
                // still works when saving or updating
                vm.event.reporters = vm.reporters;

                var selectedIDs = vm.selectedApplicants.map(function(item) {
                    return item.id;
                });

                vm.jobApplicants = vm.jobApplicants.map(function(item) {
                    item.accepted = selectedIDs.indexOf(item.id) > -1;
                    delete item.id;
                    return item;
                });

                if(vm.event.job && vm.jobApplicants.length > 0) {
                    // update reporter applicants
                    Job.updateReporters({ id : vm.event.job.id }, vm.jobApplicants);
                }

            } else {
                vm.event.reporters = [];
                vm.jobApplicants = vm.jobApplicants.map(function(item) {
                    item.accepted = false;
                    delete item.id;
                    return item;
                });

                if(vm.event.job && vm.jobApplicants.length > 0) {
                    // update reporter applicants
                    Job.updateReporters({ id : vm.event.job.id }, vm.jobApplicants);
                }
            }

            if (vm.event.id !== null) {
                Event.update(vm.event, onSaveSuccess, onSaveError);
            } else {
                Event.save(vm.event, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:eventUpdate', result);
            vm.isSaving = false;
            vm.originalThumbnail = vm.event.thumbnail;

            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function saveLocation() {
            vm.isSaving = true;
            if (!vm.location.id) {
                Location.save(vm.location, onSaveLocationSuccess, onSaveError);
            }
        }

        function onSaveLocationSuccess(result) {
            vm.event.location = result;
            vm.tagLocation[0] = result;
            vm.isSaving = false;
        }

        function locationRemoved() {
            vm.location = {};
            vm.location.geoPoint = {};
        }

        function locationAdded() {
            vm.location = vm.tagLocation[0];
        }

        function clearLocation() {
            vm.location = {};
            vm.location.geoPoint = {};
            vm.event.location = {};
            vm.tagLocation = [];
        }

        function addMarker(event) {
            var ll = event.latLng;
          // round coordinates to 5 decimal places
            vm.location.geoPoint.lon =  Math.floor(ll.lng()*100000+0.5)/100000;
            vm.location.geoPoint.lat =  Math.floor(ll.lat()*100000+0.5)/100000;
        }

        function geoCode() {
            if(vm.search && vm.search.length > 0) {
                if(!vm.geocoder) {
                    vm.geocoder = new google.maps.Geocoder();
                }
                vm.geocoder.geocode({'address': vm.search}, function(results, status){
                    if (status === google.maps.GeocoderStatus.OK){
                        var loc = results[0].geometry.location;
                        vm.search = results[0].formatted_address;
                        if(vm.location) {
                            vm.location.title = results[0].formatted_address;
                        } else {
                            vm.location = {title: results[0].formatted_address};
                        }
                        vm.location.geoPoint.lat = Math.floor(loc.lat()*100000+0.5)/100000;
                        vm.location.geoPoint.lon = Math.floor(loc.lng()*100000+0.5)/100000;
                        vm.map.setCenter({lat: vm.location.geoPoint.lat, lng: vm.location.geoPoint.lon});
                        $scope.$apply();
                    }
                });
            }
        } // end of geoCode

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.event.thumbnail) {
                return 'https://streams2.winkball.com/images/'+vm.event.thumbnail+dimentions;
            }

            return '';
        }

        function deleteThumbnail() {
            vm.thumbnailsForDeletion.push(vm.event.thumbnail);
            vm.event.thumbnail = null;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function uploadFile(file, errFiles) {
            $log.log('calling uploadFile...');

            vm.isSaving = true;
            vm.f = file;
            vm.errFile = errFiles && errFiles[0];

            if(file) {
                file.upload = Upload.upload(
                    {
                        url: "https://streams2.winkball.com/images",
                        data: {file: file},
                        headers: {
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }
            ).then(function (response) {
                $timeout(function() {
                    file.result = response.data;
                    vm.isSaving = false;
                    if(response.status == "201") {
                        $log.log('Image upload status 201');
                        vm.event.thumbnail = response.data;
                    }
                }, 1000);
            }, function(response){
                $log.log('Error...');
                $log.debug(response);

                vm.isSaving = false;
                if(response.status > 0) {
                    vm.errorMsg = response.status +': ' + response.data;
                }
            }, function(evt) {
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded/evt.total));
            });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventDetailController', EventDetailController);

    EventDetailController.$inject = ['$scope', '$rootScope', '$state', '$q', '$translate', 'previousState', 'entity', 'Principal', 'Event', 'MediaPackage', 'Job'];

    function EventDetailController($scope, $rootScope, $state, $q, $translate, previousState, entity, Principal, Event, MediaPackage, Job) {
        var vm = this;

        vm.event = entity;
        vm.getImageSrc = getImageSrc;
        vm.getVideoSrc = getVideoSrc;
        vm.canEdit = canEdit;
        vm.canDelete = canDelete;
        vm.isCurrentUserApproved = isCurrentUserApproved;
        vm.back = back;
        vm.hasSponsorPack = hasSponsorPack;
        vm.sponsorPack = false;
        vm.jobApplicants = [];
        vm.sponsors = [];
        vm.getStatusClass = getStatusClass;
        vm.isManager = isManager;
        vm.toggleAccepted = toggleAccepted;
        vm.updateTeam = updateTeam;

        $translate('reportStatus.' + vm.event.reportStatus).then(function(value){
            vm.statusName = value;
        });

        getAccount();

        $q.all([vm.event.$promise]).then(function() {
            if(!vm.event.id) {
                return $q.reject();
            }
          // ignore parameter tells global http interceptor to ignore status 404
          // we do not need 'Not found' error alert in this case
            return MediaPackage.get({id : vm.event.id, ignore: 404}).$promise;
        }).then(function(sponsorPack) {
            if(sponsorPack.id) {
                vm.sponsorPack = true;
            }
        });

        $q.all([vm.event.$promise]).then(function() {
            if(!vm.event.job) {
                return $q.reject();
            }

            // load job applicants
            return Job.reporters({id : vm.event.job.id}).$promise;
        }).then(function(reporters) {

            var counter = 0;

            vm.jobApplicants = reporters.map(function(item) {
                counter++;
                item.id = counter;
                return item;
            });

            // show only accepted applications to reporters
            if (!isManager()) {
                vm.jobApplicants = vm.jobApplicants.filter(function(item) {
                    return item.accepted;
                });
            }
            
        });

        $q.all([vm.event.$promise]).then(function() {
            if(!vm.event.job) {
                return $q.reject();
            }

          // load job applicants
            return Job.sponsors({id : vm.event.job.id}).$promise;
        }).then(function(sponsors) {
            vm.sponsors = sponsors;
        });

        $q.all([vm.event.$promise]).then(function() {
            if(!vm.event.id) {
                return $q.reject();
            }

          // load job applicants
            return Event.comments({id : vm.event.id}).$promise;
        }).then(function(comments) {
            vm.comments = comments;
        });

        function toggleAccepted(applicant) {
            applicant.accepted = !applicant.accepted;
        }

        function updateTeam() {
            $state.go('event-update-team', {id: vm.event.id, applicants: vm.jobApplicants});
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if(width && height) {
                dimentions = '?w='+width+'&h='+height;
            }

            if (vm.event.thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + vm.event.thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + vm.event.thumbnail + '?quality=ORIGINAL';

                }
            }

            return '';
        }

        function getVideoSrc(film, quality, format) {
            
            quality = quality || "HD_720P";
            format = format || "MP4";

            if (film.videoFile.guid) {
                return 'https://streams2.winkball.com/videos/'+ film.videoFile.guid +'?quality=' + quality + '&format=' + format;
            }

            return '';
        }

        function canEdit(event) {
            if(!vm.account) return false;
            return event.createdBy === vm.account.login ||
          (event.manager && event.manager.login === vm.account.login) ||
          vm.account.authorities.indexOf('ROLE_MANAGER') > -1 ||
          vm.account.authorities.indexOf('ROLE_ADMIN') > -1;
        }

        function isCurrentUserApproved() {
            var accepted = vm.jobApplicants.filter(function (item) {
                return item.reporter.login === vm.account.login && item.accepted;
            });
            var team = vm.event.reporters.filter(function (reporter){
                return reporter.user.login === vm.account.login;
            });

            return accepted.length > 0 || team.length > 0;
        }

        function canDelete() {
            if(!vm.account) return false;
            return Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SUPERVISOR']);
        }

        function isManager() {
            return Principal.hasAnyAuthority(['ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_SUPERVISOR']);
        }

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function hasSponsorPack() {
            return vm.sponsorPack;
        }

        function getStatusClass() {
            switch (vm.event.reportStatus) {
            case 'PROPOSAL':
                return 'bkg-proposal';
            case 'IN_PRODUCTION':
                return 'bkg-in-production';
            case 'READY_TO_FILM':
                return 'bkg-ready-to-film';
            case 'AWATING_SIGN_OFF':
                return 'bkg-awaiting-signoff';
            case 'COMPLETED':
                return 'bkg-black';
            case 'CANCELLED':
                return 'bkg-cancelled';
            default:
                return '';
            }
        }

        function back() {
            if(previousState.name === 'job-detail') {
                $state.go(previousState.name, previousState.params);
            } else {
                if(previousState.name === 'home') {
                    $state.go('home');
                } else {
                    $state.go('event');
                }
                
            }
            
        }

        var unsubscribe = $rootScope.$on('winkballApp:eventUpdate', function(event, result) {
            vm.event = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventDeleteController',EventDeleteController);

    EventDeleteController.$inject = ['$uibModalInstance', 'entity', 'Event'];

    function EventDeleteController($uibModalInstance, entity, Event) {
        var vm = this;

        vm.event = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Event.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event', {
            parent: 'entity',
            url: '/event?filter',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.event.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event/events.html',
                    controller: 'EventController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('event');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-detail', {
            parent: 'entity',
            url: '/event/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.event.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/event/event-detail.html',
                    controller: 'EventDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('event');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Event', function($stateParams, Event) {
                    return Event.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'event',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('event-detail.edit', {
            parent: 'event-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-dialog.html',
                    controller: 'EventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        })
        .state('event.new', {
            parent: 'event',
            url: '/new?job',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-dialog.html',
                    controller: 'EventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                puid: null,
                                title: null,
                                description: null,
                                startDate: null,
                                endDate: null,
                                published: false,
                                categories: [],
                                reportStatus: 'IN_PRODUCTION',
                                id: null
                            };
                        }
                    }
                }).result.then(function(result) {
                    if($stateParams.job) {
                        $state.go('job-detail', { id : $stateParams.job }, { reload: true });
                    } else {
                        $state.go('event', null, { reload: true });
                    }
                }, function(result) {
                    if($stateParams.job) {
                        $state.go('job-detail', { id : $stateParams.job });
                    } else {
                        $state.go('event');
                    }
                });
            }]
        })
        .state('event.edit', {
            parent: 'event',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-dialog.html',
                    controller: 'EventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('event', null, { reload: true , location: 'replace'});
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        })
        .state('event-delete', {
            parent: 'event-detail',
            url: '/delete',
            data: {
                authorities: ['ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-delete-dialog.html',
                    controller: 'EventDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('event', null, { reload: true , location: 'replace'});
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        })
        .state('event-share', {
            parent: 'event-detail',
            url: '/share',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-share-dialog.html',
                    controller: 'EventShareController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    // $state.go('event', null, { reload: false, location: 'replace' });
                    $state.go('^', null, { reload: false, location: 'replace' });
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        }).state('event-readytofilm', {
            parent: 'event-detail',
            url: '/readytofilm',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_SUPERVISOR', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-readytofilm-dialog.html',
                    controller: 'EventReadytofilmController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Event', function (Event) {
                            return Event.get({
                                id: $stateParams.id
                            }).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('^', null, {
                        reload: true, location: 'replace'
                    });
                }, function () {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        }).state('event-status', {
            parent: 'event-detail',
            url: '/eventstatus?status',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_SUPERVISOR', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-status-dialog.html',
                    controller: 'EventStatusDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Event', function (Event) {
                            return Event.get({
                                id: $stateParams.id
                            }).$promise;
                        }]
                    }
                }).result.then(function () {
                    $state.go('^', null, {
                        reload: true, location: 'replace'
                    });
                }, function () {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        }).state('new-media-package', {
            parent: 'event-detail',
            url: '/new-media?event',
            data: {
                authorities: ['ROLE_REPORTER','ROLE_MANAGER','ROLE_SUPERVISOR','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/media-package/media-package-dialog.html',
                    controller: 'MediaPackageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                url: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    if($stateParams.event) {
                        $state.go('event-detail', { id : $stateParams.event }, { reload: true, location: 'replace'});
                    } else {
                        $state.go('media-package', null, { reload: true, location: 'replace' });
                    }
                }, function() {
                    if($stateParams.event) {
                        $state.go('event-detail', { id : $stateParams.event }, { reload: true, location: 'replace' });
                    } else {
                        $state.go('media-package', null, { location: 'replace' });
                    }
                });
            }]
        }).state('event-email', {
            parent: 'event-detail',
            url: '/email',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-email-dialog.html',
                    controller: 'EventEmailController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false, location: 'replace' });
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        }).state('event-email-prospective-publisher', {
            parent: 'event-detail',
            url: '/email-prospective-publisher',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-email-prospective-publisher-dialog.html',
                    controller: 'EventEmailProspectivePublisherController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false, location: 'replace' });
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        }).state('event-update-team', {
            parent: 'event-detail',
            url: '/update-team',
            data: {
                authorities: ['ROLE_USER']
            },
            params: {applicants: null},
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event/event-update-team-dialog.html',
                    controller: 'EventUpdateTeamController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Event', function(Event) {
                            return Event.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        }).state('event-add-comment', {
            parent: 'event-detail',
            url: '/add-comment',
            data: {
                authorities: ['ROLE_USER']
            },
            params: {applicants: null},
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/event-comment/event-comment-dialog.html',
                    controller: 'EventCommentDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                comment: null,
                                rating: null,
                                eventId: $stateParams.id,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true, location: 'replace' });
                }, function() {
                    $state.go('^', null, { location: 'replace' });
                });
            }]
        });

    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Event', Event);

    Event.$inject = ['$resource', 'DateUtils'];

    function Event ($resource, DateUtils) {
        var resourceUrl =  'api/events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'reporters': { url: 'api/events/:id/reporters', method: 'GET', isArray: true},
            'categories': {method: 'GET', url: 'api/categories', isArray: true},
            'comments': {method: 'GET', url: 'api/events/:id/comments', isArray: true},
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('EventSearch', EventSearch);

    EventSearch.$inject = ['$resource'];

    function EventSearch($resource) {
        var resourceUrl =  'api/_search/events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EventController', EventController);

    EventController.$inject = ['$scope', '$state', '$stateParams', 'Principal', 'Event', 'EventSearch', 'ParseLinks', 'AlertService'];

    function EventController ($scope, $state, $stateParams, Principal, Event, EventSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.events = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'startDate';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.account = null;
        vm.canEdit = canEdit;
        vm.canDelete = canDelete;
        vm.filter = 'all';
        vm.statuses = [];
        vm.setFilter = setFilter;
        vm.setStatus = setStatus;
        vm.getImageSrc = getImageSrc;
        vm.goToProposals = goToProposals;

        if($stateParams.filter) {
            vm.filter = $stateParams.filter;
        }
        
        getAccount();
        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                vm.filter = 'all';
                EventSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Event.query({
                    page: vm.page,
                    size: 20,
                    sort: sort(),
                    filter: vm.filter,
                    status: vm.statuses
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                // if (vm.predicate !== 'startDate') {
                //     result.push('startDate');
                // }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.events.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.events = [];
            loadAll();
        }

        function setFilter() {
            vm.page = 0;
            vm.events = [];
            vm.loadAll();
        }

        function setStatus(status) {

            var idx = vm.statuses.indexOf(status);

            // if currently selected
            if (idx > -1) {
                // remove status
                vm.statuses.splice(idx, 1);
            } else {
                // add status
                vm.statuses.push(status);
            }

            setFilter();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.events = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'startDate';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.events = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        function canEdit(event) {
            if(!vm.account) return false;
            return event.createdBy === vm.account.login ||
          (event.manager && event.manager.login === vm.account.login) ||
          vm.account.authorities.indexOf('ROLE_MANAGER') > -1 ||
          vm.account.authorities.indexOf('ROLE_ADMIN') > -1;
        }

        function canDelete() {
            if(!vm.account) return false;
            return Principal.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SUPERVISOR']);
        }

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function getImageSrc(thumbnail, width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }
            
            if (thumbnail) {
                if (dimentions) {
                    return 'https://streams2.winkball.com/images/' + thumbnail + dimentions;
                } else {
                    return 'https://streams2.winkball.com/images/' + thumbnail + '?quality=ORIGINAL';
                }
            }

            return '';
        }

        function goToProposals() {
            $state.go('job', { status: 'PROPOSAL'});
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'wrapper'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('CustomerDialogController', CustomerDialogController);

    CustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', '$log', 'entity', 'Principal', 'Customer', 'User', 'WebLink', 'Upload'];

    function CustomerDialogController($timeout, $scope, $stateParams, $uibModalInstance, $q, $log, entity, Principal, Customer, User, WebLink, Upload) {
        var vm = this;

        vm.customer = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.thumbnailsForDeletion = [];
        vm.originalThumbnail = angular.copy(vm.customer.profilePicture);
        vm.getImageSrc = getImageSrc;
        vm.deleteThumbnail = deleteThumbnail;
        vm.deleteWebsite = deleteWebsite;
        vm.uploadFile = uploadFile;

        vm.authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));
        vm.toggleCategory = toggleCategory;
        vm.categories = Customer.categories();

        vm.account = Principal.identity();

        // add current user as a manager for new jobs
        vm.account.then(function (account) {
            $q.all([vm.customer.$promise]).then(function () {
                if (vm.customer.id) {
                    return $q.reject();
                }
                return User.get({ login: account.login }).$promise;
            }).then(function (user) {
                vm.customer.referrerId = user.id;
            });
        });

        vm.weblinks = WebLink.query();

        function deleteWebsite() {
            vm.customer.website = null;
        }

        $timeout(function (){
            angular.element('.form-group:eq(2)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            
            if (vm.customer.address && !vm.customer.address.country) {
                vm.customer.address.country = 'GBR';
            }

            if (vm.customer.id !== null) {
                Customer.update(vm.customer, onSaveSuccess, onSaveError);
            } else {
                Customer.save(vm.customer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:customerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function toggleCategory(category) {
            var idx = vm.customer.categories.indexOf(category);
            if(idx > -1) {
                vm.customer.categories.splice(idx, 1);
            } else {
                vm.customer.categories.push(category);
            }
        }

        function getImageSrc(width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }

            if (vm.customer.profilePicture) {
                return 'https://streams2.winkball.com/images/' + vm.customer.profilePicture + dimentions;
            }

            return '';
        }

        function deleteThumbnail() {
            //console.log('calling deleteThumbnail');
            vm.thumbnailsForDeletion.push(vm.customer.profilePicture);
            vm.customer.profilePicture = null;
        }

        function uploadFile(file, errFiles) {
            // console.log('calling uploadFile...');
            vm.isSaving = true;
            vm.f = file;
            vm.errFile = errFiles && errFiles[0];

            if (file) {
                file.upload = Upload.upload(
                    {
                        url: "https://streams2.winkball.com/images",
                        data: { file: file },
                        headers: {
                            'Authorization': 'Bearer ' + vm.authToken
                        }
                    }
                ).then(function (response) {
                    $timeout(function () {
                        file.result = response.data;
                        vm.isSaving = false;
                        if (response.status === 201) {
                            $log.log('Image upload status 201');
                            vm.customer.profilePicture = response.data;
                        }
                    }, 1000);
                }, function (response) {
                    $log.log('Error...');
                    $log.debug(response);
                    vm.isSaving = false;
                    if (response.status > 0) {
                        vm.errorMsg = response.status + ': ' + response.data;
                    }
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
        } // end of uploadFile

        vm.datePickerOpenStatus.dateJoined = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('CustomerDetailController', CustomerDetailController);

    CustomerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Customer', 'WebLink'];

    function CustomerDetailController($scope, $rootScope, $stateParams, previousState, entity, Customer, WebLink) {
        var vm = this;

        vm.customer = entity;
        vm.previousState = previousState.name;
        vm.getImageSrc = getImageSrc;

        function getImageSrc(width, height) {
            var dimentions = '';

            if (width && height) {
                dimentions = '?w=' + width + '&h=' + height;
            }

            if (vm.customer.profilePicture) {
                return 'https://streams2.winkball.com/images/' + vm.customer.profilePicture + dimentions;
            }

            return '';
        }

        var unsubscribe = $rootScope.$on('winkballApp:customerUpdate', function(event, result) {
            vm.customer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('CustomerDeleteController',CustomerDeleteController);

    CustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Customer'];

    function CustomerDeleteController($uibModalInstance, entity, Customer) {
        var vm = this;

        vm.customer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Customer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer', {
            parent: 'entity',
            url: '/customer',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.customer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer/customers.html',
                    controller: 'CustomerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customer-detail', {
            parent: 'entity',
            url: '/customer/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.customer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer/customer-detail.html',
                    controller: 'CustomerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Customer', function($stateParams, Customer) {
                    return Customer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'customer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('customer-detail.edit', {
            parent: 'customer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_CUSTOMER', 'ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Customer', function(Customer) {
                            return Customer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer.new', {
            parent: 'customer',
            url: '/new',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                puid: null,
                                companyName: null,
                                companyType: null,
                                profilePicture: null,
                                position: null,
                                aboutMe: null,
                                id: null,
                                categories: []
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customer', null, { reload: true });
                }, function() {
                    $state.go('customer');
                });
            }]
        })
        .state('customer.edit', {
            parent: 'customer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_REPORTER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-dialog.html',
                    controller: 'CustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Customer', function(Customer) {
                            return Customer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customer.delete', {
            parent: 'customer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_MANAGER', 'ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customer/customer-delete-dialog.html',
                    controller: 'CustomerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Customer', function(Customer) {
                            return Customer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource', 'DateUtils'];

    function Customer ($resource, DateUtils) {
        var resourceUrl =  'api/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        ///data.dateJoined = DateUtils.convertDateTimeFromServer(data.dateJoined);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'categories': {method: 'GET', url: 'api/categories', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('CustomerSearch', CustomerSearch);

    CustomerSearch.$inject = ['$resource'];

    function CustomerSearch($resource) {
        var resourceUrl =  'api/_search/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('CustomerController', CustomerController);

    CustomerController.$inject = ['$scope', '$state', 'Customer', 'CustomerSearch', 'ParseLinks', 'AlertService'];

    function CustomerController ($scope, $state, Customer, CustomerSearch, ParseLinks, AlertService) {
        var vm = this;
        
        vm.customers = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                CustomerSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Customer.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.customers.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.customers = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.customers = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.customers = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('CommissionReportRequestDialogController', CommissionReportRequestDialogController);

    CommissionReportRequestDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CommissionReportRequest', 'Reporter'];

    function CommissionReportRequestDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CommissionReportRequest, Reporter) {
        var vm = this;

        vm.commissionReportRequest = entity;
        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus = {};
        vm.deleteWebsite = deleteWebsite;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.commissionReportRequest.id !== null) {
                CommissionReportRequest.update(vm.commissionReportRequest, onSaveSuccess, onSaveError);
            } else {
                CommissionReportRequest.save(vm.commissionReportRequest, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('winkballApp:commissionReportRequestUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
        
        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function deleteWebsite() {
            vm.commissionReportRequest.website = null;
        }

    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('CommissionReportRequestDetailController', CommissionReportRequestDetailController);

    CommissionReportRequestDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CommissionReportRequest', 'Customer', 'Reporter'];

    function CommissionReportRequestDetailController($scope, $rootScope, $stateParams, previousState, entity, CommissionReportRequest, Customer, Reporter) {
        var vm = this;

        vm.commissionReportRequest = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('winkballApp:commissionReportRequestUpdate', function (event, result) {
            vm.commissionReportRequest = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('CommissionReportRequestDeleteController', CommissionReportRequestDeleteController);

    CommissionReportRequestDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommissionReportRequest'];

    function CommissionReportRequestDeleteController($uibModalInstance, entity, CommissionReportRequest) {
        var vm = this;

        vm.commissionReportRequest = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            CommissionReportRequest.delete({ id: id },
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('commission-report-request', {
                parent: 'entity',
                url: '/commission-report-request',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'winkballApp.webLink.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/commission-report-request/commission-report-requests.html',
                        controller: 'CommissionReportRequestController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('commissionReportRequest');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('commission-report-request-detail', {
                parent: 'entity',
                url: '/commission-report-request/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'winkballApp.commissionReportRequest.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/commission-report-request/commission-report-request-detail.html',
                        controller: 'CommissionReportRequestDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('commissionReportRequest');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CommissionReportRequest', function ($stateParams, CommissionReportRequest) {
                        return CommissionReportRequest.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'commission-report-request',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('commission-report-request-detail.edit', {
                parent: 'commission-report-request-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_REPORTER', 'ROLE_MANAGER', 'ROLE_SUPERVISOR', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/commission-report-request/commission-report-request-dialog.html',
                        controller: 'CommissionReportRequestDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CommissionReportRequest', function (CommissionReportRequest) {
                                return CommissionReportRequest.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, { reload: false });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('commission-report-request.new', {
                parent: 'commission-report-request',
                url: '/new',
                data: {
                    authorities: ['ROLE_REPORTER', 'ROLE_MANAGER', 'ROLE_SUPERVISOR', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/commission-report-request/commission-report-request-dialog.html',
                        controller: 'CommissionReportRequestDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    title: null,
                                    url: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('commission-report-request', null, { reload: true });
                    }, function () {
                        $state.go('commission-report-request');
                    });
                }]
            })
            .state('commission-report-request.edit', {
                parent: 'commission-report-request',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_SUPERVISOR', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/commission-report-request/commission-report-request-dialog.html',
                        controller: 'CommissionReportRequestDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['CommissionReportRequest', function (CommissionReportRequest) {
                                return CommissionReportRequest.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('commission-report-request', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('commission-report-request.delete', {
                parent: 'commission-report-request',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_MANAGER', 'ROLE_SUPERVISOR', 'ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/commission-report-request/commission-report-request-delete-dialog.html',
                        controller: 'CommissionReportRequestDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CommissionReportRequest', function (CommissionReportRequest) {
                                return CommissionReportRequest.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('commission-report-request', null, { reload: true });
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
;
(function () {
    'use strict';
    angular
        .module('winkballApp')
        .factory('CommissionReportRequest', CommissionReportRequest);

    CommissionReportRequest.$inject = ['$resource', 'DateUtils'];

    function CommissionReportRequest($resource, DateUtils) {
        var resourceUrl = 'api/commission-report-requests/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .factory('CommissionReportRequestSearch', CommissionReportRequestSearch);

    CommissionReportRequestSearch.$inject = ['$resource'];

    function CommissionReportRequestSearch($resource) {
        var resourceUrl = 'api/_search/commission-report-requests/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true }
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .controller('CommissionReportRequestController', CommissionReportRequestController);

    CommissionReportRequestController.$inject = ['$scope', '$state', 'CommissionReportRequest', 'CommissionReportRequestSearch', 'ParseLinks', 'AlertService'];

    function CommissionReportRequestController($scope, $state, CommissionReportRequest, CommissionReportRequestSearch, ParseLinks, AlertService) {
        var vm = this;

        vm.commissionReportRequests = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'createdDate';
        vm.reset = reset;
        vm.reverse = false;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll() {
            if (vm.currentSearch) {
                CommissionReportRequestSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                CommissionReportRequest.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                // if (vm.predicate !== 'id') {
                //     result.push('id');
                // }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.commissionReportRequests.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset() {
            vm.page = 0;
            vm.commissionReportRequests = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear() {
            vm.commissionReportRequests = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.commissionReportRequests = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('AdvertDialogController', AdvertDialogController);

    AdvertDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Advert', 'VideoFile', 'KeywordSearch', 'Upload'];

    function AdvertDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Advert, VideoFile, KeywordSearch, Upload) {
        var vm = this;

        vm.advert = entity;
        vm.clear = clear;
        vm.save = save;
        vm.getVideoSrc = getVideoSrc;
        vm.searchKeywords = searchKeywords;

        vm.videofiles = VideoFile.query({filter: 'advert-is-null'});
        $q.all([vm.advert.$promise, vm.videofiles.$promise]).then(function() {
            if (!vm.advert.videoFileId) {
                return $q.reject();
            }
            return VideoFile.get({id : vm.advert.videoFileId}).$promise;
        }).then(function(videoFile) {
            vm.videofiles.push(videoFile);
        });

        function searchKeywords(query) {
            return KeywordSearch.query({
                query: query,
                page: 0,
                size: 10
            }).$promise;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.advert.id !== null) {
                Advert.update(vm.advert, onSaveSuccess, onSaveError);
            } else {
                Advert.save(vm.advert, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('winkballApp:advertUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getVideoSrc(quality, format) {
            quality = quality || "HD_720P";
            format = format || "MP4";

            if (vm.advert.videoFileGuid) {
                return 'https://streams2.winkball.com/videos/'+vm.advert.videoFileGuid+'?quality='+quality+'&format='+format;
            }
            return "";
        }

        $scope.uploadFile = function(file, errFiles){
            vm.isSaving = true;
            $scope.f = file;
            $scope.errFile = errFiles && errFiles[0];

            var authToken = angular.fromJson(localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken"));

            if(file) {
                file.upload = Upload.upload(
                    {
                        url: "https://streams2.winkball.com/videos",
                        data: {file: file},
                        headers: {'Authorization': 'Bearer ' + authToken}
                    }
            );
                file.upload.then(function (response) {
                    $timeout(function() {
                        file.result = response.data;
                        vm.isSaving = false;
                        if(response.status == '201') {
                          vm.advert.videoFileGuid = response.data;
                          vm.advert.videoFileName = file.name;
                      }
                    });
                }, function(response){
                    console.log('Error...');
                    vm.isSaving = false;
                    if(response.status > 0) {
                        $scope.errorMsg = response.status +': ' + response.data;
                    }
                }, function(evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded/evt.total));
                });
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('AdvertDetailController', AdvertDetailController);

    AdvertDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Advert', 'VideoFile', 'Keyword'];

    function AdvertDetailController($scope, $rootScope, $stateParams, previousState, entity, Advert, VideoFile, Keyword) {
        var vm = this;

        vm.advert = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('winkballApp:advertUpdate', function(event, result) {
            vm.advert = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('AdvertDeleteController',AdvertDeleteController);

    AdvertDeleteController.$inject = ['$uibModalInstance', 'entity', 'Advert'];

    function AdvertDeleteController($uibModalInstance, entity, Advert) {
        var vm = this;

        vm.advert = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Advert.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('advert', {
            parent: 'entity',
            url: '/advert',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.advert.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/advert/adverts.html',
                    controller: 'AdvertController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('advert');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('advert-detail', {
            parent: 'entity',
            url: '/advert/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'winkballApp.advert.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/advert/advert-detail.html',
                    controller: 'AdvertDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('advert');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Advert', function($stateParams, Advert) {
                    return Advert.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'advert',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('advert-detail.edit', {
            parent: 'advert-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_MANAGER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/advert/advert-dialog.html',
                    controller: 'AdvertDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Advert', function(Advert) {
                            return Advert.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('advert.new', {
            parent: 'advert',
            url: '/new',
            data: {
                authorities: ['ROLE_MANAGER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/advert/advert-dialog.html',
                    controller: 'AdvertDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                puid: null,
                                title: null,
                                description: null,
                                published: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('advert', null, { reload: true });
                }, function() {
                    $state.go('advert');
                });
            }]
        })
        .state('advert.edit', {
            parent: 'advert',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_MANAGER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/advert/advert-dialog.html',
                    controller: 'AdvertDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Advert', function(Advert) {
                            return Advert.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('advert', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('advert.delete', {
            parent: 'advert',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_MANAGER','ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/advert/advert-delete-dialog.html',
                    controller: 'AdvertDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Advert', function(Advert) {
                            return Advert.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('advert', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('winkballApp')
        .factory('Advert', Advert);

    Advert.$inject = ['$resource'];

    function Advert ($resource) {
        var resourceUrl =  'api/adverts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('AdvertSearch', AdvertSearch);

    AdvertSearch.$inject = ['$resource'];

    function AdvertSearch($resource) {
        var resourceUrl =  'api/_search/adverts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('AdvertController', AdvertController);

    AdvertController.$inject = ['$scope', '$state', 'Advert', 'AdvertSearch', 'ParseLinks', 'AlertService'];

    function AdvertController ($scope, $state, Advert, AdvertSearch, ParseLinks, AlertService) {
        var vm = this;
        
        vm.adverts = [];
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;

        loadAll();

        function loadAll () {
            if (vm.currentSearch) {
                AdvertSearch.query({
                    query: vm.currentSearch,
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Advert.query({
                    page: vm.page,
                    size: 20,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.adverts.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.adverts = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.adverts = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.adverts = [];
            vm.links = null;
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .filter('trustURL', trustURL);

    trustURL.$inject = ['$sce'];

    function trustURL($sce) {
        return trustURLFilter;

        function trustURLFilter(url) {
            return $sce.trustAsResourceUrl(url);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function(){
    'use strict';

    angular
        .module('winkballApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('winkballApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'dd-MM-yyyy');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'dd-MM-yyyy';
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .filter('bytesFilter', bytesFilter);

    function bytesFilter() {
        return function(bytes, precision) {
            if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
            if (angular.isUndefined(precision)) precision = 1;
            var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
                number = Math.floor(Math.log(bytes) / Math.log(1024));
            return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) +  ' ' + units[number];
        };
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('winkballApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'fr',
            'de',
            'ru'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('winkballApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('winkballApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-winkballApp-error');
                var entityKey = httpResponse.headers('X-winkballApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('winkballApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
              console.log(httpResponse);
              if(!(httpResponse.config.params.ignore && httpResponse.config.params.ignore === 404)) {
                addErrorAlert('Not found','error.url.not.found');
              }
              break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('winkballApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {    
            var alertKey = response.headers('X-winkballApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-winkballApp-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('winkballApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            
            return config;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(tagsInputConfig);

    tagsInputConfig.$inject = ['tagsInputConfigProvider'];

    function tagsInputConfig(tagsInputConfigProvider) {
      // set below to true to make tagsInput watch placeholder dynamic value
      tagsInputConfigProvider.setActiveInterpolation('tagsInput', { placeholder: true });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        }).state('wrapper', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('winkballApp')
        .constant('VERSION', "1.5.2")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_REPORTER', 'ROLE_SUPERVISOR', 'ROLE_CUSTOMER', 'ROLE_PUBLISHER', 'ROLE_MANAGER', 'ROLE_TRANSCODER'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'previousState', 'User'];

    function UserManagementDetailController ($stateParams, previousState, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};
        vm.previousState = previousState.name;

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'user-management.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'User', function($stateParams, User) {
                    return User.get({login : $stateParams.login}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'user-management',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'UserSearch', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, UserSearch, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_REPORTER', 'ROLE_SUPERVISOR', 'ROLE_CUSTOMER', 'ROLE_MANAGER', 'ROLE_TRANSCODER'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.search = search;

        vm.loadAll();

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
          if (vm.currentSearch) {
            UserSearch.query({
              query: vm.currentSearch
            }, onSuccessSearch, onError);
          } else {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
          }
        }

        function onSuccessSearch(data) {
          //hide anonymous user from user management: it's a required user for Spring Security
          for (var i in data) {
              if (data[i]['login'] === 'anonymoususer') {
                  data.splice(i, 1);
              }
          }
          vm.links = null;
          vm.totalItems = data.length;
          vm.queryCount = vm.totalItems;
          vm.page = 1;
          vm.users = data;
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
          vm.currentSearch = null;
          vm.users = [];
          vm.links = null;
          vm.page = 1;
          vm.predicate = pagingParams.predicate;
          vm.reverse = pagingParams.ascending;
          vm.loadAll();
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.users = [];
            vm.links = null;
            vm.page = 1;
            vm.predicate = pagingParams.predicate;
            vm.reverse = pagingParams.ascending;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();
;
(function() {
    'use strict';

    angular.module('winkballApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity-audit', {
            parent: 'admin',
            url: '/entity-audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/entity-audit/entity-audits.html',
                    controller: 'EntityAuditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('EntityAuditService', EntityAuditService);

    EntityAuditService.$inject = ['$http'];

    function EntityAuditService ($http) {

        var service = {
            findAllAudited: findAllAudited,
            findByEntity: findByEntity,
            getPrevVersion: getPrevVersion
        };

        return service;

        function findAllAudited() {
            return $http.get('api/audits/entity/all').then(function (response) {
                return response.data;
            });
        }

        function findByEntity(entityType, limit) {
            return $http.get('api/audits/entity/changes', {
                params: {
                    entityType: entityType,
                    limit: limit
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function getPrevVersion(qualifiedName, entityId, commitVersion) {
            return $http.get('api/audits/entity/changes/version/previous', {
                params: {
                    qualifiedName: qualifiedName,
                    entityId: entityId,
                    commitVersion: commitVersion
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('AuditDetailModalCtrl', AuditDetailModalCtrl);

    AuditDetailModalCtrl.$inject = ['$scope', '$uibModalInstance', 'ObjectDiff', 'diff', 'audit'];

    function AuditDetailModalCtrl($scope, $uibModalInstance, ObjectDiff, diff, audit) {
        var vm = this;
        
        vm.diffValue = ObjectDiff.toJsonView(diff);
        vm.diffValueChanges = ObjectDiff.toJsonDiffView(diff);
        vm.audit = audit;
        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        };
    };
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('EntityAuditController', EntityAuditController);

    EntityAuditController.$inject = ['$scope', '$filter', '$uibModal', 'EntityAuditService', 'AlertService', 'ObjectDiff'];

    function EntityAuditController ($scope, $filter, $uibModal, EntityAuditService, AlertService, ObjectDiff) {
        var vm = this;

        vm.entities = [];
        vm.audits = [];
        vm.limits = [25, 50, 100, 200];
        vm.limit = 25;
        vm.loading = false;
        vm.loadChanges = loadChanges;
        vm.findAllAudited = findAllAudited;
        vm.getEntityName = getEntityName;
        vm.format = format;
        vm.isObject = isObject;
        vm.isDate = isDate;
        vm.openChange = openChange;

        vm.findAllAudited();

        function findAllAudited() {
            EntityAuditService.findAllAudited().then(function (data) {
                vm.entities = data;
            });
        }

        function loadChanges() {
            vm.loading = true;
            var entityType = vm.qualifiedName;
            EntityAuditService.findByEntity(entityType, vm.limit).then(function (data) {
                vm.audits = data.map(function(it){
                    it.entityValue = JSON.parse(it.entityValue);
                    return it;
                });
                vm.loading = false;
            }, function(){
                vm.loading = false;
            });
        };

        function getEntityName(qualifiedName) {
            if (qualifiedName) {
                var splits = qualifiedName.split(".");
                return splits[splits.length - 1];
            }
            else return null;
        };

        function format(val){
            if(val)
                return ObjectDiff.objToJsonView(val);
            else return '';
        };

        function isObject(val){
            return (val && (typeof val) == 'object');
        };

        function isDate(key){
            return (key && key.indexOf("Date") != -1);
        };

        function openChange(audit){

            if(audit.commitVersion < 2){
                AlertService.warning("There is no previous version available for this entry.\nThis is the first" +
                    " audit entry captured for this object");
            } else {
                EntityAuditService.getPrevVersion(audit.entityType, audit.entityId, audit.commitVersion).then(function (data) {
                    var previousVersion = JSON.parse(data.entityValue),
                        currentVersion = audit.entityValue;
                    // enable below to have the dates formatted
                    //previousVersion = convertDates(previousVersion);
                    //currentVersion = convertDates(currentVersion);
                    var diff = ObjectDiff.diffOwnProperties(previousVersion, currentVersion);

                    $uibModal.open({
                        templateUrl: 'app/admin/entity-audit/entity-audit.detail.html',
                        controller: 'AuditDetailModalCtrl',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            diff: function () {
                                return diff;
                            },
                            audit: function () {
                                return audit;
                            }
                        }
                    });
                });
            }
        };

        function convertDates(obj) {
            for(var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key]) {
                    if (key.indexOf("Date") != -1 && (obj[key] instanceof Date || Object.prototype.toString.call(obj[key]) === '[object Date]' || (new Date(obj[key]) !== "Invalid Date" && !isNaN(new Date(obj[key]))))) {
                        obj[key] = $filter('date')(obj[key]);
                    }
                }
            }
            return obj;
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('winkballApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;(function(){angular.module('winkballApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row main protohome"><div class="col-lg-3" ng-if="!vm.isAuthenticated()"><div class="well text-dark-grey rounded-0"><p>WinkBall is a global network of local reporters. WinkBall reporters specialise in interviews. They create professional video reports covering events and feature stories from a cultural perspective.</p><p>WinkBall offers membership for those who wish to further their skills and gain practical experience as an independent reporter, film-maker, editor or presenter.</p><p>If you already have a relevant background in media, then you may simply wish to polish your skills, have fun or report on your favorite subjects.</p></div></div><div class="col-lg-3" ng-cloak ng-if="vm.isAuthenticated()"><div class="rounded-0 bkg-dark-grey"><div class="side-panel-holder"><div class="panel rounded-0 border-none"><button class="btn btn-success rounded-0 text-center" ui-sref="wizard.first" style="width: 100%"><!-- <span class="glyphicon glyphicon-plus"></span> --> <span class="">Create new project</span></button></div><div class="panel rounded-0 bkg-dark-grey"><div class="panel-heading rounded-0 border-none" style="padding: 0 15px"><div class="row"><a ui-sref="reporter-detail-login({login: vm.account.login})"><div class="img-container"><img ng-if="vm.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{vm.thumbnail | trustURL}}" alt="Profile Picture"> <img ng-if="!vm.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{\'content/images/noperson.png\'}}" alt="Profile Picture"></div></a></div></div><a ui-sref="reporter-detail-login({login: vm.account.login})"><div class="panel-footer rounded-0 text-dark-grey bkg-light-grey"><span class="pull-left">View Profile</span> <span class="pull-right"><span class="glyphicon glyphicon-circle-arrow-right"></span></span><div class="clearfix"></div></div></a></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><a href="https://webmail.winkball.com" target="_blank"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left"><span>WinkBall Email</span></div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-envelope"></i></div></div></a></div></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><!-- <a ui-sref="winkball-chat"> --> <a href="https://chat.winkballhub.com" target="_blank"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left"><span>WinkBall Chat</span></div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-bell"></i></div></div></a></div></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><a ui-sref="reporter" target="_blank"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Members Directory</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-list-alt"></i></div></div></a></div></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><a ui-sref="member-software"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Members Software</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-save-file"></i></div></div></a></div></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><a ui-sref="sales-documents"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Sales Documents</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-briefcase"></i></div></div></a></div></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><a ui-sref="social-media"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Social Media</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-share"></i></div></div></a></div><!-- <a ui-sref="social-media"> --></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><a ui-sref="training-videos"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Training Videos</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-expand"></i></div></div></a></div></div><div class="panel rounded-0 text-center"><h4>Project status colour codes</h4></div><div class="panel rounded-0 bkg-proposal"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Proposal</div></div></div></div><div class="panel rounded-0 bkg-in-production"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">In-Production</div></div></div></div><div class="panel rounded-0 bkg-ready-to-film"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Ready to Film</div></div></div></div><div class="panel rounded-0 bkg-awaiting-signoff"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Awaiting Sign Off</div></div></div></div><div class="panel rounded-0 completed"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Completed</div></div></div></div><div class="panel rounded-0 bkg-cancelled"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Cancelled</div></div></div></div></div></div></div><div ng-cloak ng-class="vm.isAuthenticated() ? \'col-lg-9\' : \'col-lg-6\'"><div class="embed-responsive embed-responsive-16by9" ng-if="!vm.isAuthenticated()">--><video ng-if="!vm.isAuthenticated()" class="embed-responsive-item" controls="" onclick="this.play();"><source src="https://streams2.winkball.com/videos/35022a59-0db8-4aea-8aa0-5dac66022b89?quality=HD_720P&amp;format=MP4" type="video/mp4"></video></div><div class="rounded-0 bkg-dark-grey"><div ng-switch="vm.isAuthenticated()"><div class="panel-grey border-none text-white" ng-switch-when="false"><button type="button" name="button" class="btn bkg-wb-red rounded-0" ng-click="vm.login()">Sign in</button> <span><b>OR</b> <a href="https://www.winkball.com/apply">apply for a membership</a></span></div><div class="panel-grey border-none text-white" ng-switch-when="false"><a class="alert-link" href="" ng-click="vm.requestResetPassword()">Reset password</a></div><jhi-alert></jhi-alert><div ng-switch-when="true"><ul class="nav nav-tabs"><li ng-class="vm.filter == \'mine\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'mine\');">My projects</a></li><li ng-class="vm.filter == \'accepted\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'accepted\');">Accepted projects</a></li><li ng-class="vm.filter == \'new\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'new\')">New projects</a></li><li ng-class="vm.filter == \'opened\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'opened\')">Opened projects</a></li></ul></div><div class="row bkg-white" ng-switch-when="true"><!-- <div class="container-fluid"> --><div class="filter-search-panel clearfix"><div class="col-xs-12 col-md-3"><!-- Add Calendar Btn Here --></div><div class="col-xs-12 col-md-3"><div class="dropdown" uib-dropdown><button class="btn btn-default dropdown-toggle rounded-0" uib-dropdown-toggle id="filter-by-menu" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="width: 100%; text-align: left">Filter by <span class="caret pull-right" style="margin-top: .5em"></span></button><ul class="dropdown-menu rounded-0 mw" role="menu" uib-dropdown-menu aria-labelledby="filter-by-menu"><li role="presentation" ng-class="vm.statuses.indexOf(\'PROPOSAL\') > -1 ? \'active\' : \'\'"><a role="menuitem" href="#" ng-click="vm.setStatus(\'PROPOSAL\')">Proposal</a></li><li role="presentation" ng-class="vm.statuses.indexOf(\'IN_PRODUCTION\') > -1 ? \'active\' : \'\'"><a role="menuitem" href="#" ng-click="vm.setStatus(\'IN_PRODUCTION\')">In-Production</a></li><li role="presentation" ng-class="vm.statuses.indexOf(\'READY_TO_FILM\') > -1 ? \'active\' : \'\'"><a role="menuitem" href="#" ng-click="vm.setStatus(\'READY_TO_FILM\')">Ready To Film</a></li><li role="presentation" ng-class="vm.statuses.indexOf(\'AWATING_SIGN_OFF\') > -1 ? \'active\' : \'\'"><a role="menuitem" href="#" ng-click="vm.setStatus(\'AWATING_SIGN_OFF\')">Awaiting Sign Off</a></li><li role="presentation" ng-class="vm.statuses.indexOf(\'COMPLETED\') > -1 ? \'active\' : \'\'"><a role="menuitem" href="#" ng-click="vm.setStatus(\'COMPLETED\')">Completed</a></li><li role="presentation" ng-class="vm.statuses.indexOf(\'CANCELLED\') > -1 ? \'active\' : \'\'"><a role="menuitem" href="#" ng-click="vm.setStatus(\'CANCELLED\')">Cancelled</a></li></ul></div></div><div class="col-xs-12 col-md-3"><div class="dropdown" uib-dropdown><button class="btn btn-default dropdown-toggle rounded-0" uib-dropdown-toggle id="sort-by-menu" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="width: 100%; text-align: left">Sort by <span class="caret pull-right" style="margin-top: .5em"></span></button><ul class="dropdown-menu rounded-0 mw" role="menu" uib-dropdown-menu aria-labelledby="sort-by-menu"><li role="presentation" ng-class="vm.predicate === \'title\' && vm.reverse ? \'active\' : \'\'"><a role="menuitem" href="#" ng-click="vm.sortBy($event, \'title\', true)">Title: A-Z</a></li><li role="presentation" ng-class="vm.predicate === \'title\' && !vm.reverse ? \'active\' : \'\'"><a role="menuitem" href="#" ng-click="vm.sortBy($event, \'title\', false)">Title: Z-A</a></li><li role="presentation" ng-class="vm.predicate === \'startDate\' && !vm.reverse ? \'active\' : \'\'"><a role="menuitem" href="#" ng-click="vm.sortBy($event, \'startDate\', false)">Start date: approaching</a></li><li role="presentation" ng-class="vm.predicate === \'reportDueDate\' && !vm.reverse ? \'active\' : \'\'"><a role="menuitem" href="#" ng-click="vm.sortBy($event, \'reportDueDate\', false)">Due date: approaching</a></li><li role="presentation" ng-class="vm.predicate === \'id\' && !vm.reverse ? \'active\' : \'\'"><a role="menuitem" href="#" ng-click="vm.sortBy($event, \'id\', false)">ID: High to Low</a></li><li role="presentation" ng-class="vm.predicate === \'id\' && vm.reverse ? \'active\' : \'\'"><a role="menuitem" href="#" ng-click="vm.sortBy($event, \'id\', true)">ID: Low to High</a></li></ul></div></div><div class="col-xs-12 col-md-3"><form name="searchForm" class="form-inline"><div class="input-group"><input type="text" class="form-control rounded-0" style="border-right: none" ng-model="vm.searchQuery" id="searchQuery" placeholder="Search Projects"> <span class="input-group-btn width-min"><button class="btn btn-search rounded-0" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-search rounded-0" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><!-- </div> --></div><div class="row home-tiles bkg-white" ng-switch-when="true"><div infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']" class="mw"><div class="col-md-3 tile" ng-repeat="job in vm.jobs track by job.id"><div class="tile-head bkg-light-grey" ng-click="vm.goToReport(job.id)"><div class="img-container"><img ng-if="job.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{vm.getImageSrc(job.thumbnail) | trustURL}}" alt="Thumbnail"> <img ng-if="!job.thumbnail" class="img-responsive" ng-src="{{\'content/images/noperson.png\'}}" alt="Thumbnail"> <span class="img-overlay text-white" ng-if="!job.claimed">Awaiting Sponsor</span> <span class="img-overlay sponsored text-white" ng-if="job.claimed">Sponsored</span></div></div><div class="tile-body bkg-light-grey"><div class="h5 clamp-fade" ng-click="vm.goToReport(job.id)">{{job.title}}</div><p class="tile-description clamp-fade" ng-click="vm.goToReport(job.id)">{{job.description}}</p><div class="mg-t-1" ng-if="vm.filter == \'new\'"><button class="btn btn-warning rounded-0 text-center" ui-sref="project-apply({id:job.id})" style="width: 100%"><span class="">Apply to Work</span></button></div></div><div class="tile-footer" ng-class="job.reportStatus.toLowerCase()"><div class="clearfix"><span>Status</span> <strong class="pull-right" translate="reportStatus.{{job.reportStatus}}">{{job.reportStatus}}</strong></div><div class="clearfix"><span>Start date</span> <span class="pull-right">{{job.startDate | date:\'dd/MM/yyyy\'}}</span></div><div class="clearfix"><span>Due date</span> <span class="pull-right">{{job.reportDueDate | date:\'dd/MM/yyyy\'}}</span></div><div class="clearfix"><span>Created by</span> <a ui-sref="reporter-detail-login({login: job.createdBy})" class="pull-right">{{job.createdBy}}</a></div><!-- <div class="clearfix">\n                                        <span>ID</span>\n                                        <span class="pull-right">{{job.id}}</span>\n                                    </div> --></div></div></div></div><!-- end of .row --></div></div></div><div class="col-lg-3" ng-cloak ng-if="!vm.isAuthenticated()"><div class="panel timeline rounded-0 bkg-white"><twitter-timeline><a class="twitter-timeline" data-theme="light" href="https://twitter.com/winkball?ref_src=twsrc%5Etfw">Tweets by winkball</a></twitter-timeline></div></div></div></div>');
$templateCache.put('app/home/member-software.html','<div><h2>Members Software</h2><h4><br>WinkBall Reporter Tool (Uploader)</h4><div class="mindent"><div><a href="https://itunes.apple.com/us/app/winkball-reporter-tool/id1285184425" target="_blank">Download for Mac</a></div><div><a href="https://www.winkball.com/misc/rt/win/uploader.exe" target="_blank">Download for Windows</a></div><div class="hhead"><span>This tool is designed to ease the job of preparing Interviews and Report Films for uploading to WinkBall.</span> <span>The application supports the following features:</span></div><div><ul><li>Topping and Tailing (cropping videos)</li><li>Watermarking</li><li>Thumbnail selection</li><li>Automatic creation of sponsored prefaces,trailers and overlays</li><li>Video captioning</li><li>Entry of Report/Interview meta information</li><li>Previewing and Uploading to winkball.com</li></ul></div></div><div class="container-fluid uhelpmain"><h4>Creating Interviews using the Reporter Tool</h4><ol><li class="edlist"><button class="btn btn-primary captionbtn" onclick="$(\'#laa\').slideToggle();">Login</button><div class="cwell mhide" id="laa"><h4>Login and authentication</h4><p>The application loads with the Login tab open showing the Username and Password fields. Enter your credentials and click <button class="btn btn-primary">Login</button></p></div></li><li class="edlist"><button class="btn btn-primary captionbtn" onclick="$(\'#se\').slideToggle();">Select Event</button><div class="cwell mhide" id="se"><div class="cwell"><h4>Event selection and loading Sponsored Content</h4><p><ol><li>Select the event for which to upload interviews. <img src="../images/eselection.png" alt="event selection"></li><li>Click <button class="btn btn-primary">Set and download SponsorPack</button> to confirm the selection and to download the Sponsor pack. The Sponsor Pack will download and automatically unzip.</li><li>Select &nbsp;&nbsp;<input type="radio" name="eventinterviewsel" checked="checked">&nbsp;<b>Create Interviews</b> or &nbsp;&nbsp;<input type="radio" name="eventinterviewsel">&nbsp;<b>Create Event Report</b> appropriately.</li></ol></p></div><div class="cwell"><h4>Sponsored Content Panels</h4>The <b>Watermark</b> and <b>Sponsored Content</b> panels contain <button class="btn btn-secondary">Load</button> buttons for loading sponsored content. These buttons open the folder into which the Sponsor Pack was unzipped. Click into that folder to find the contents of the Pack.<ul><li><b>Watermark image</b> allows selection of an image which will appear throughout the video.</li><li><b>Video Overlay</b> selects the Overlay template which is displayed repeatedly throughout the video.</li><li>The <b>Front Video</b> and <b>Ending Video</b> sections allow selection of the corresponding front and end videos.</li><li>Click <button class="btn btn-primary">Next</button> to proceed to the next section.</li></ul></div></div></li><li class="edlist"><button class="btn btn-primary captionbtn" onclick="$(\'#iv\').slideToggle();">Import Videos</button><div class="cwell mhide" id="iv"><h4>Import videos for processing</h4><ol><li>Click <button class="btn btn-secondary">Select Videos</button> and navigate to a folder with some videos and select one or more of them.</li><li>Imported items may be previewed <button type="button" class="btn"><i class="fa fa-play"></i></button> or deleted <button type="button" class="btn"><i class="fa fa-times" style="color: red"></i></button></li><li>Click the corresponding &nbsp;&nbsp;<input id="" type="checkbox" class="largechkbox checkbox-primary" checked="">&nbsp;&nbsp; checkbox next to the items you wish to import.</li><li class="margtop">Click <button class="btn btn-success">Import Selected Items</button> to begin the import process</li><li>When importing is complete click <button class="btn btn-primary">Next</button></li></ol></div></li><li class="edlist"><button class="btn btn-primary captionbtn" onclick="$(\'#pv\').slideToggle();">Process Videos</button><div class="cwell mhide" id="pv"><h4>Edit video, set options and begin processing</h4><div class="cwell"><button type="button" class="btn"><i class="fa fa-video-camera"></i></button> Launches the <b>Edit Video</b> window<ul><li class="edlist"><div>Slide the<div class="thumb edbutt" style=""></div>markers to set the start and end selection points. The video will play between these positions.</div></li><li class="edlist">Clicking on time-line<div class="track" style="width: 40px"></div>will set the current playback position to the selected point.</li><li class="edlist"><div class="rangesettingscontainer">The <button id="ntimestartbutt" type="button" class="btn btn-primary sebutt" onclick=""><i class="fa fa-step-backward"></i></button> and <button id="ntimeendbutt" type="button" class="btn btn-primary sebutt et" onclick=""><i class="fa fa-step-forward"></i></button> buttons set the start or end points to the current playback position.</div></li><li class="edlist">When paused, use the <b>Left Arrow</b> and <b>Right Arrow</b> keys on your keyboard to move frame by frame</li><li class="edlist"><button class="btn btn-secondary">Default Range</button> resets the range to play form the start to the end i.e selects the entire video.</li><li class="edlist"><button class="btn btn-primary">Save Changes</button> saves the selection and closes the window.</li><li class="edlist"><button class="btn btn-secondary">Close</button> exits the window without saving changes.</li></ul></div><div class="cwell"><button type="button" class="btn"><i class="fa fa-camera"></i></button> Launches the <b>Thumbnail selection</b> window<ul><li class="edlist">Allows selection of a thumbnail by clicking anywhere on the<div class="track" style="width: 40px"></div>timeline.</li><li class="edlist">When paused, use the <b>Left Arrow</b> and <b>Right Arrow</b> keys on your keyboard to move frame by frame</li><li class="edlist"><button class="btn btn-primary">Save changes</button> Saves the thumbnail and closes the window.</li><li class="edlist"><button class="btn btn-secondary">Remove</button> Removes any existing selection and closes the window.</li></ul></div><div class="cwell"><button class="btn btn-secondary">Edit Details</button> Launches the <b>Edit Details</b> window.<ul><li>Before an item can be processed, this window <b>must</b> be opened and at least a <b>Title</b> entered.</li><li><b>Interviewee Name</b> and <b>Interviewee Job Title</b> are used to Caption the video</li><li>Reporters assigned to the Event are added automatically to the <b>Reporters list</b>.</li><li><b>Keywords</b> from the Event are automatically added. Add more, specific to the Interview</li><li><button class="btn btn-primary">Interviewee details</button> reveals additional meta data relating to the Interviewee. E.g Email Address, Telephone and social media details.</li></ul></div><div class="cwell"><h4>Checkbox options</h4><ul><li class="edlist">If an option isn\'t available it means the coresponding asset hasn\'t been loaded in the <button class="btn btn-primary captionbtn">Select Event</button> section</li><li class="nobullet edlist"><input id="" type="checkbox" class="largechkbox checkbox-primary">&nbsp;&nbsp;<b>Overlay</b> - Overlay the content selected in the \'Video overlay\' section of the \'Select Event\' section.</li><li class="nobullet edlist"><input id="" type="checkbox" class="largechkbox checkbox-primary">&nbsp;&nbsp;<b>WM</b> - Watermark the video with the watermark selected of the \'Select Event\' section.</li><li class="nobullet edlist"><input id="" type="checkbox" class="largechkbox checkbox-primary">&nbsp;&nbsp;<b>FSM</b> - Add the video selected in the Front Video section of the \'Select Event\' section to the front of the video.</li><li class="nobullet edlist"><input id="" type="checkbox" class="largechkbox checkbox-primary">&nbsp;&nbsp;<b>BSM</b> - Add the video selected in the \'Ending Video\' section of the \'Select Event\' section to the end of the video.</li><li class="nobullet edlist"><input id="" type="checkbox" class="largechkbox checkbox-primary">&nbsp;&nbsp;<b>Captioned</b> - Add the IntervieweeName and Job Title as captions to the video</li></ul></div><ul><li class="nobullet edlist">Select the items to wish to process by clicking &nbsp;&nbsp;<input id="" type="checkbox" class="largechkbox checkbox-primary" checked="checked">&nbsp;&nbsp; in the Transcode column.</li><li class="nobullet edlist">Click <button class="btn btn-success">Transcode Selected Items</button> to initiate the transcode process.</li><li class="nobullet edlist">An orange progress bar will scroll horizontally several times. Green indicates the final stage.</li><li class="nobullet edlist">When processing is complete, click <button class="btn btn-primary">Next</button> to proceed to the next section.</li><ul></ul></ul></div></li><li class="edlist"><button class="btn btn-primary captionbtn" onclick="$(\'#uv\').slideToggle();">Upload Videos</button><div class="cwell mhide" id="uv"><h4>Lists items that are ready for uploading</h4><ul><li class="nobullet edlist"><button type="button" class="btn"><i class="fa fa-play"></i></button> Allows checking via playback of the transcoded video</li><li class="nobullet edlist"><button type="button" class="btn"><i class="fa fa-camera"></i></button> Preview the selected thumbnail</li><li class="nobullet edlist"><button type="button" class="btn"><i class="fa fa-download"></i></button> Copies the processed file to an external location such as USB drive or other network location</li><li class="nobullet edlist"><button type="button" class="btn"><i class="fa fa-undo"></i></button> Push the video back to the<button class="btn btn-primary captionbtn">Process Videos</button> section</li><li class="nobullet edlist">Select the items to upload by clicking &nbsp;&nbsp;<input id="" type="checkbox" class="largechkbox checkbox-primary" checked="checked">&nbsp;&nbsp; in the Upload column.</li><li class="nobullet edlist">Click <button class="btn btn-success">Upload Selected Items</button> uploads all selected items.</li></ul></div></li></ol></div></div>');
$templateCache.put('app/home/proto-home.html','<div ng-cloak><div class="row main protohome"><div class="col-lg-3" ng-if="!vm.isAuthenticated()"><span class="hipster img-responsive img-rounded"></span><div class="well"><p>WinkBall is a global network of local reporters. WinkBall reporters specialise in interviews. They create professional video reports covering events and feature stories from a cultural perspective.</p><p>WinkBall offers membership for those who wish to further their skills and gain practical experience as an independent reporter, film-maker, editor or presenter.</p><p>If you already have a relevant background in media, then you may simply wish to polish your skills, have fun or report on your favorite subjects.</p></div></div><div class="col-lg-3" ng-cloak ng-if="vm.isAuthenticated()"><div class="rounded-0 bkg-dark-grey"><div class="side-panel-holder"><div class="panel rounded-0 border-none"><button class="btn btn-success rounded-0 text-center" ui-sref="job.new" style="width: 100%"><!-- <span class="glyphicon glyphicon-plus"></span> --> <span class="">Create new project</span></button></div><div class="panel rounded-0 bkg-dark-grey"><div class="panel-heading rounded-0 border-none" style="padding: 0 15px"><div class="row"><a ui-sref="reporter-detail-login({login: vm.account.login})"><div class="img-container"><img ng-if="vm.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{vm.thumbnail | trustURL}}" alt="Profile Picture"> <img ng-if="!vm.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{\'content/images/noperson.png\'}}" alt="Profile Picture"></div></a></div></div><a ui-sref="reporter-detail-login({login: vm.account.login})"><div class="panel-footer rounded-0 text-dark-grey bkg-light-grey"><span class="pull-left">View Profile</span> <span class="pull-right"><span class="glyphicon glyphicon-circle-arrow-right"></span></span><div class="clearfix"></div></div></a></div><div class="panel rounded-0"><div class="h4"><a href="https://webmail.winkball.com" target="_blank"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left"><span>WinkBall Email</span></div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-envelope"></i></div></div></a></div></div><div class="panel rounded-0"><div class="h4"><!-- <a ui-sref="winkball-chat"> --> <a href="https://chat.winkballhub.com" target="_blank"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left"><span>WinkBall Chat</span></div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-bell"></i></div></div></a></div></div><div class="panel rounded-0"><div class="h4"><a ui-sref="reporter" target="_blank"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Members Directory</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-list-alt"></i></div></div></a></div></div><div class="panel rounded-0"><div class="h4"><a ui-sref="member-software"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Members Software</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-save-file"></i></div></div></a></div></div><div class="panel rounded-0"><div class="h4"><a ui-sref="sales-documents"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Sales Documents</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-briefcase"></i></div></div></a></div></div><div class="panel rounded-0"><div class="h4"><a ui-sref="#"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Social Media</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-share"></i></div></div></a></div><!-- <a ui-sref="social-media"> --></div><div class="panel rounded-0"><div class="h4"><a ui-sref="training-videos"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Training Videos</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-expand"></i></div></div></a></div></div></div></div></div><div ng-cloak ng-class="vm.isAuthenticated() ? \'col-lg-9\' : \'col-lg-6\'"><div class="well" ng-if="!vm.isAuthenticated()"><video controls="" poster="content/images/athumbnail.jpg" onclick="this.play();"><source src="https://streams2.winkball.com/videos/35022a59-0db8-4aea-8aa0-5dac66022b89?quality=HD_720P&amp;format=MP4" type="video/mp4"></video></div><div class="rounded-0 bkg-dark-grey"><div ng-switch="vm.isAuthenticated()"><div class="panel-grey" ng-switch-when="false"><button type="button" name="button" class="btn btn-primary" ng-click="vm.login()">Sign in</button> <span><b>OR</b> <a href="https://www.winkball.com/apply">apply for a membership</a></span></div><div class="panel-grey" ng-switch-when="false"><a class="alert-link" href="" ng-click="vm.requestResetPassword()">Reset password</a></div><div ng-switch-when="true"><ul class="nav nav-tabs"><li ng-class="vm.filter == \'mine\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'mine\');">My projects</a></li><li ng-class="vm.filter == \'all\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'all\')">New progects</a></li></ul></div><jhi-alert></jhi-alert><div class="row bkg-white" ng-switch-when="true"><div class="clearfix"><div class="col-xs-12 col-sm-2 no-padding-left"><h2>Projects</h2></div><div class="col-xs-12 col-sm-10 no-padding-right"><form name="filterForm" class="form-inline pull-right"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="filter7" class="btn btn-info bkg-proposal rounded-0"><input id="filter7" type="checkbox" value="PROPOSAL" ng-checked="vm.statuses.indexOf(\'PROPOSAL\') > -1" ng-click="vm.setStatus(\'PROPOSAL\')"> Proposal</label></div><div class="form-group"><label for="filter2" class="btn btn-info bkg-in-production rounded-0"><input id="filter2" type="checkbox" value="IN_PRODUCTION" ng-checked="vm.statuses.indexOf(\'IN_PRODUCTION\') > -1" ng-click="vm.setStatus(\'IN_PRODUCTION\')"> In-Production</label></div><div class="form-group"><label for="filter3" class="btn btn-info bkg-ready-to-film rounded-0"><input id="filter3" type="checkbox" value="READY_TO_FILM" ng-checked="vm.statuses.indexOf(\'READY_TO_FILM\') > -1" ng-click="vm.setStatus(\'READY_TO_FILM\')"> Ready To Film</label></div><div class="form-group"><label for="filter4" class="btn btn-info bkg-awaiting-signoff rounded-0"><input id="filter4" type="checkbox" value="AWATING_SIGN_OFF" ng-checked="vm.statuses.indexOf(\'AWATING_SIGN_OFF\') > -1" ng-click="vm.setStatus(\'AWATING_SIGN_OFF\')"> Awaiting Sign Off</label></div><div class="form-group"><label for="filter5" class="btn btn-info bkg-black rounded-0"><input id="filter5" type="checkbox" value="COMPLETED" ng-checked="vm.statuses.indexOf(\'COMPLETED\') > -1" ng-click="vm.setStatus(\'COMPLETED\')"> Completed</label></div></form></div></div><!-- <div class="container-fluid"> --><div class="clearfix"><div class="col-xs-12 col-md-6"></div><div class="col-xs-12 col-md-3"><form name="sortForm" class="form-inline"><div class="input-group"><select name="sortBy" ng-model="vm.predicate" id="sort-by"><option value="title,asc">Title A-Z</option><option value="title,desc">Title Z-A</option></select></div></form></div><div class="col-xs-12 col-md-3"><form name="searchForm" class="form-inline"><div class="input-group"><input type="text" class="form-control rounded-0" style="border-right: none" ng-model="vm.searchQuery" id="searchQuery" placeholder="Search Projects"> <span class="input-group-btn width-min"><button class="btn btn-search rounded-0" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-search rounded-0" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><!-- </div> --></div><!-- <hr ng-switch-when="true"> --><div class="row home-tiles bkg-white" ng-switch-when="true"><div class="table-responsive table-home"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id" class="mw-3-em"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs hidden-sm">Logo</th><th jh-sort-by="title"><span>Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="startDate" class="mw-7-em"><span translate="winkballApp.job.startDate">Start Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']" infinite-scroll-container="\'.table-home\'"><tr ng-repeat="job in vm.jobs track by job.id"><td><a ui-sref="job-detail({id:job.id})">{{job.id}}</a></td><td class="hidden-xs hidden-sm"><div class="img-container list-thumbnail"><img ng-if="job.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{vm.getImageSrc(job.thumbnail) | trustURL}}" alt="Thumbnail"> <img ng-if="!job.thumbnail" class="img-responsive" ng-src="{{\'content/images/noperson.png\'}}" alt="Thumbnail"> <span class="img-overlay" ng-if="!job.claimed">Awaiting Sponsor</span> <span class="img-overlay sponsored" ng-if="job.claimed">Sponsored</span></div></td><td>{{job.title}}</td><td>{{job.startDate | date:\'dd/MM/yyyy\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container status-btn-group"><button type="submit" ng-if="job.reportStatus !== \'CANCELLED\'" ng-disabled="job.reportStatus !== \'PROPOSAL\' || vm.inTransit" ui-sref="job-detail({id:job.id})" class="btn btn-info bkg-proposal rounded-0" ng-class="vm.getHiddenStatusClass(job.reportStatus, \'PROPOSAL\')"><span class="glyphicon glyphicon-eye-open visible-xs visible-sm"></span> <span class="hidden-xs hidden-sm">Proposal</span></button> <button type="submit" ng-if="job.reportStatus !== \'CANCELLED\'" ng-disabled="job.reportStatus !== \'IN_PRODUCTION\' || vm.inTransit" ng-click="vm.goToReport(job.id)" class="btn btn-info bkg-in-production rounded-0" ng-class="vm.getHiddenStatusClass(job.reportStatus, \'IN_PRODUCTION\')"><span class="glyphicon glyphicon-eye-open visible-xs visible-sm"></span> <span class="hidden-xs hidden-sm">In-Production</span></button> <button type="submit" ng-if="job.reportStatus !== \'CANCELLED\'" ng-disabled="job.reportStatus !== \'READY_TO_FILM\' || vm.inTransit" ng-click="vm.goToReport(job.id)" class="btn btn-info bkg-ready-to-film rounded-0" ng-class="vm.getHiddenStatusClass(job.reportStatus, \'READY_TO_FILM\')"><span class="glyphicon glyphicon-eye-open visible-xs visible-sm"></span> <span class="hidden-xs hidden-sm">Ready To Film</span></button> <button type="submit" ng-if="job.reportStatus !== \'CANCELLED\'" ng-disabled="job.reportStatus !== \'AWATING_SIGN_OFF\' || vm.inTransit " ng-click="vm.goToReport(job.id)" class="btn btn-info bkg-awaiting-signoff rounded-0" ng-class="vm.getHiddenStatusClass(job.reportStatus, \'AWATING_SIGN_OFF\')"><span class="glyphicon glyphicon-eye-open visible-xs visible-sm"></span> <span class="hidden-xs hidden-sm">Awaiting Sign Off</span></button> <button type="submit" ng-if="job.reportStatus !== \'CANCELLED\'" ng-disabled="job.reportStatus !== \'COMPLETED\' || vm.inTransit" ng-click="vm.goToReport(job.id)" class="btn btn-info bkg-black rounded-0" ng-class="vm.getHiddenStatusClass(job.reportStatus, \'COMPLETED\')"><span class="glyphicon glyphicon-eye-open visible-xs visible-sm"></span> <span class="hidden-xs hidden-sm">Completed</span></button> <button type="submit" ng-if="job.reportStatus === \'CANCELLED\'" ng-click="vm.goToReport(job.id)" ng-disabled="vm.inTransit" class="btn btn-info bkg-cancelled rounded-0"><span class="glyphicon glyphicon-eye-open visible-xs visible-sm"></span> <span class="hidden-xs hidden-sm">Cancelled</span></button></div></td></tr></tbody></table></div></div><!-- end of .row --></div></div></div><div class="col-lg-3" ng-cloak ng-if="!vm.isAuthenticated()"><div class="panel timeline"><twitter-timeline><a class="twitter-timeline" data-theme="dark" href="https://twitter.com/winkball?ref_src=twsrc%5Etfw">Tweets by winkball</a></twitter-timeline></div></div></div></div>');
$templateCache.put('app/home/sales-documents.html','<div><h2>Members Pack</h2><div class="list-group"><a class="list-group-item" href="https://www.winkball.com/misc/docs/members/memberspackage.pdf" target="_blank">Members package</a></div><h2>NewsWire Pack</h2><div class="list-group"><a class="list-group-item" href="https://www.winkball.com/misc/docs/newswire/business-benefits-diagram.pdf" target="_blank">Business Benefits Diagram</a> <a class="list-group-item" href="https://www.winkball.com/misc/docs/newswire/uploader-process.pdf" target="_blank">Uploader Process</a></div><h2>Sales Documents</h2><div class="list-group"><a class="list-group-item" href="https://www.winkball.com/misc/docs/sales/winkball-awards-salesdeck.pdf" target="_blank">WinkBall Awards Sales Deck</a> <a class="list-group-item" href="https://www.winkball.com/misc/docs/sales/2p-ratecard.pdf" target="_blank">Rate Card</a> <a class="list-group-item" href="https://www.winkball.com/misc/docs/sales/offering-letter-winkball.docx" target="_blank">Offering Letter</a></div></div>');
$templateCache.put('app/home/social-media.html','<div><h2>Social Media Pack</h2><div class="list-group"><a class="list-group-item" href="https://www.winkball.com/misc/docs/newswire/social-media-guide.pptx" target="_blank">Social Media Guide</a> <a class="list-group-item" href="https://www.winkball.com/misc/docs/newswire/social-media-form.xlsx" target="_blank">Social Media Form</a></div></div>');
$templateCache.put('app/home/training-documents.html','<div class=""><h2>Training Documents</h2></div>');
$templateCache.put('app/home/training-videos.html','<div class="text-center"><h2>Training Videos</h2><iframe scrolling="no" src="https://www.winkball.com/training" style="position: absolute; left:0; right:0; bottom: 0; top: 130px; width: 100%; height: 100%; border: 0px"></iframe></div>');
$templateCache.put('app/home/winkball-chat.html','<div class=""><iframe scrolling="no" src="https://chat.winkballhub.com/" style="width: 100%; min-height: 42em; border: 0px"></iframe></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 translate="configuration.title">Configuration</h2><span translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span translate="configuration.table.prefix">Prefix</span></th><th translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/entity-audit/entity-audit.detail.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Audit Details</h4></div><div class="modal-body pad"><div><strong>{{vm.audit.action}} action was performed on below data</strong><br><br><del class="diff diff-key">Old/Removed value</del> &nbsp; <ins class="diff diff-key">New/Added value</ins></div><br><label>Changed Fields</label><pre id="resultChanges" ng-bind-html="vm.diffValueChanges"></pre><label>All Fields</label><pre id="result" ng-bind-html="vm.diffValue"></pre></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/entity-audit/entity-audits.html','<div ng-cloak class="pad"><div class="row"><h3 class="col-sm-12">Entity Audits</h3></div><jhi-alert></jhi-alert><div class="row"><div class="col-md-12 pad"><h4>Filter</h4><form name="auditForm" role="form" novalidate show-validation><div class="row"><div class="col-md-8 form-group"><label>Entity/Table</label><select class="input-sm form-control" name="qualifiedName" id="qualifiedName" required ng-options="vm.getEntityName(entity) for entity in vm.entities" ng-model="vm.qualifiedName"></select><div ng-show="auditForm.qualifiedName.$invalid"><p class="help-block" ng-show="auditForm.qualifiedName.$error.required">This field is required</p></div></div><div class="col-md-4 form-group"><label>Limit to</label><select class="input-sm form-control" name="limit" id="limit" required ng-options="option for option in vm.limits" ng-model="vm.limit"></select></div></div><div class="row pad"><button ng-disabled="auditForm.$invalid" class="btn btn-primary pull-right" ng-click="vm.loadChanges()"><i class="glyphicon glyphicon-import"></i>&nbsp;Load Change List</button></div></form></div></div><div ng-show="!vm.loading"><div class="table-responsive" ng-if="vm.audits.length > 0"><p ng-if="vm.qualifiedName">Last <strong>{{vm.limit}}</strong> Changes for <strong>{{vm.getEntityName(vm.qualifiedName)}}</strong></p><form class="form-inline"><div class="form-group"><label for="searchField">Filter:</label><input type="text" class="form-control" id="searchField" ng-model="filter.$" placeholder="global filter"></div><div class="form-group"><input type="text" class="form-control" id="searchFieldEntityId" ng-model="filter.entityId" placeholder="entity id filter"></div></form><table class="table table-bordered table-hover table-striped"><thead><tr><th>Entity Id</th><th>Action</th><th>Version</th><th>Value</th><th>Modified Date</th><th>Modified By</th><th><i class="glyphicon glyphicon-eye-open"></i></th></tr></thead><tbody><tr ng-repeat="audit in vm.audits | filter:filter"><td>{{audit.entityId}}</td><td>{{audit.action}}</td><td>{{audit.commitVersion}}</td><td><pre class="audit-obj" ng-bind-html="vm.format(audit.entityValue)"></pre></td><!-- comment above line and uncomment below to have Table view of value --><!--td class="no-pad">\r\n                        <div class="audit-obj">\r\n                            <table class="table table-bordered table-hover no-margin">\r\n                                <tr>\r\n                                    <th>Field</th>\r\n                                    <th>Value</th>\r\n                                </tr>\r\n                                <tr ng-repeat="(k,v) in audit.entityValue" ng-if="!vm.isObject(v)">\r\n                                    <td>{{k}}</td>\r\n                                    <td>\r\n                                        <span ng-if="vm.isDate(k)">{{v | date:\'medium\'}}</span>\r\n                                        <span ng-if="!vm.isDate(k)">{{v}}</span>\r\n                                    </td>\r\n                                </tr>\r\n                            </table>\r\n                        </div>\r\n                    </td--><td>{{audit.modifiedDate | date:\'medium\'}}</td><td>{{audit.modifiedBy}}</td><td><button type="button" ng-click="vm.openChange(audit)" uib-tooltip="View Audit Change Details" uib-tooltip-placement="auto" class="btn btn-info btn-xs"><i class="glyphicon glyphicon-eye-open"></i></button></td></tr></tbody></table></div><p ng-if="vm.displayedChanges.length == 0">No Data found for the filters</p></div></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" translate="health.table.service">Service Name</th><th class="col-md-2 text-center" translate="health.table.status">Status</th><th class="col-md-2 text-center" translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" translate="health.details.name">Name</th><th class="col-md-6 text-left" translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 translate="logs.title">Logs</h2><p translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="metrics.refresh.button">Refresh</span></button></p><h3 translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b translate="metrics.jvm.memory.title">Memory</b><p><span translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" translate="metrics.updating">Updating...</div><h3 translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.jvm.http.table.code">Code</th><th translate="metrics.jvm.http.table.count">Count</th><th class="text-right" translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" translate="metrics.servicesstats.table.count">Count</th><th class="text-right" translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" translate="metrics.servicesstats.table.min">Min</th><th class="text-right" translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate="metrics.ehcache.title">Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.ehcache.cachename">Cache name</th><th class="text-right" translate="metrics.ehcache.objects">Objects</th><th class="text-right" translate="metrics.ehcache.hits">Hits</th><th class="text-right" translate="metrics.ehcache.misses">Misses</th><th class="text-right" translate="metrics.ehcache.evictioncount">Eviction count</th><th class="text-right" translate="metrics.ehcache.mean">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class="text-right" translate="metrics.datasource.count">Count</th><th class="text-right" translate="metrics.datasource.mean">Mean</th><th class="text-right" translate="metrics.datasource.min">Min</th><th class="text-right" translate="metrics.datasource.p50">p50</th><th class="text-right" translate="metrics.datasource.p75">p75</th><th class="text-right" translate="metrics.datasource.p95">p95</th><th class="text-right" translate="metrics.datasource.p99">p99</th><th class="text-right" translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" ng-model="vm.user.activated"> <span translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span translate="userManagement.home.createLabel">Create a new User</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Search for User"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="lastModifiedBy"><span translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" translate="userManagement.deactivated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()">Reset password</a></div><!-- <div class="alert alert-warning" translate="global.messages.info.register" translate-compile>\n                You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a>\n            </div> --></div></div></div>');
$templateCache.put('app/entities/advert/advert-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.advert.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.advert.delete.question" translate-values="{id: \'{{vm.advert.id}}\'}">Are you sure you want to delete this Advert?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/advert/advert-detail.html','<div><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="advert-detail.edit({id:vm.advert.id})" class="btn btn-primary btn-lg rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button><h2><span translate="winkballApp.advert.detail.title">Advert</span> {{vm.advert.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.advert.puid">Puid</span></dt><dd><span>{{vm.advert.puid}}</span></dd><dt><span translate="winkballApp.advert.title">Title</span></dt><dd><span>{{vm.advert.title}}</span></dd><dt><span translate="winkballApp.advert.description">Description</span></dt><dd><span>{{vm.advert.description}}</span></dd><dt><span translate="winkballApp.advert.published">Published</span></dt><dd><span>{{vm.advert.published}}</span></dd><dt><span translate="winkballApp.advert.videoFile">Video File</span></dt><dd><a ui-sref="video-file-detail({id:vm.advert.videoFileId})">{{vm.advert.videoFileId}}</a></dd><dt><span translate="winkballApp.advert.keywords">Keywords</span></dt><dd><span ng-repeat="keywords in vm.advert.keywords"><a ui-sref="keyword-detail({id: keywords.id})">{{keywords.text}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl></div>');
$templateCache.put('app/entities/advert/advert-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAdvertLabel" translate="winkballApp.advert.home.createOrEditLabel">Create or edit an Advert</h4></div><div class="modal-body"><form id="advert-edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" ng-show="vm.advert.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.advert.id" readonly="readonly"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.advert.puid" for="field_puid">Puid</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.advert.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"></div></div><div class="form-group"><label class="control-label" translate="winkballApp.advert.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.advert.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.advert.description" for="field_description">Description</label><textarea class="form-control" name="description" id="field_description" rows="5" ng-model="vm.advert.description"></textarea></div><div class="form-group"><label class="control-label" translate="winkballApp.advert.published" for="field_published">Published</label><input type="checkbox" class="form-control" name="published" id="field_published" ng-model="vm.advert.published"><div ng-show="editForm.published.$invalid"><p class="help-block" ng-show="editForm.published.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><h4>Keywords</h4><tags-input ng-model="vm.advert.keywords" replace-spaces-with-dashes="false" display-property="text" placeholder="{{vm.advert.keywords.length > 0 ? \' \' : \'Type to add a keyword\'}}" add-from-autocomplete-only="false"><auto-complete source="vm.searchKeywords($query)" min-length="3" max-results-to-show="10"></auto-complete></tags-input></div></form><div class="file-holder"><div ng-if="!vm.advert.videoFileGuid" id="field_videoFile"><h4>Video File</h4><button type="file" class="btn btn-primary" ng-disabled="editForm.$invalid || vm.isSaving" ngf-select="uploadFile($file, $invalidFiles)" accept="video/mp4" ngf-max-size="800MB"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button> <span style="font:smaller">{{f.name}} {{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}}</span> <span class="progress" ng-show="f.progress >= 0"><div style="width:{{f.progress}}%" ng-bind="f.progress + \'%\'"></div></span><p>{{errorMsg}}</p></div><div ng-if="vm.advert.videoFileGuid"><h4>Video File</h4><span>GUID: {{vm.advert.videoFileGuid}}</span><hr><video ng-src="{{vm.getVideoSrc() | trustURL}}" controls></video></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" form="advert-edit-form"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/entities/advert/adverts.html','<div><h2 translate="winkballApp.advert.home.title">Adverts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary rounded-0" ui-sref="advert.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.advert.home.createLabel">Create new Advert</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.advert.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="puid"><span translate="winkballApp.advert.puid">Puid</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span translate="winkballApp.advert.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span translate="winkballApp.advert.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="published"><span translate="winkballApp.advert.published">Published</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="videoFileId"><span translate="winkballApp.advert.videoFile">Video File</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="advert in vm.adverts track by advert.id"><td><a ui-sref="advert-detail({id:advert.id})">{{advert.id}}</a></td><td>{{advert.puid}}</td><td>{{advert.title}}</td><td>{{advert.description}}</td><td>{{advert.published}}</td><td><a ui-sref="video-file-detail({id:advert.videoFile.id})">{{advert.videoFile.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="advert-detail({id:advert.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="advert.edit({id:advert.id})" class="btn btn-primary btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="advert.delete({id:advert.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/commission-report-request/commission-report-request-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.commissionReportRequest.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.commissionReportRequest.delete.question" translate-values="{id: \'{{vm.commissionReportRequest.id}}\'}">Are you sure you want to delete this Commission Report Request?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/commission-report-request/commission-report-request-detail.html','<div><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp; <span translate="entity.action.back">Back</span></button> <button type="button" ui-sref="commission-report-request-detail.edit({id:vm.commissionReportRequest.id})" class="btn btn-primary btn-lg rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button><h2><span translate="winkballApp.commissionReportRequest.detail.title">Commission Report Request</span> {{vm.commissionReportRequest.id}}</h2><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.commissionReportRequest.title">Title</span></dt><dd><span>{{vm.commissionReportRequest.title}}</span></dd><dt><span>Start Date</span></dt><dd><span>{{vm.commissionReportRequest.startDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.commissionReportRequest.description}}</span></dd><dt><span>Editorial Story Line</span></dt><dd><p>{{vm.commissionReportRequest.editorialStoryline}}</p></dd><dt><span>Key Talent(s)</span></dt><dd><p>{{vm.commissionReportRequest.keyTalent}}</p></dd><dt><span>Social Media</span></dt><dd><p>{{vm.commissionReportRequest.socialMedia}}</p></dd></dl><div><h4>Contact for this Event</h4><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.commissionReportRequest.contactName">Contact Name</span></dt><dd><span>{{vm.commissionReportRequest.contactName}}</span></dd><dt><span translate="winkballApp.commissionReportRequest.contactEmail">Contact Email</span></dt><dd><span>{{vm.commissionReportRequest.contactEmail}}</span></dd><dt>Website</dt><dd>{{vm.commissionReportRequest.website}}</dd></dl></div><div ng-if="vm.commissionReportRequest.address"><h4>Location/Address for this Event</h4><dl class="dl-horizontal jh-entity-details"><dt>1st Line of address</dt><dd>{{vm.commissionReportRequest.address.firlstLineOfAddress}}</dd><dt>2nd Line of address</dt><dd>{{vm.commissionReportRequest.address.secondLineOfAddress}}</dd><dt>Town</dt><dd>{{vm.commissionReportRequest.address.town}}</dd><dt>County</dt><dd>{{vm.commissionReportRequest.address.county}}</dd><dt>Post code</dt><dd>{{vm.commissionReportRequest.address.postCode}}</dd></dl></div></div>');
$templateCache.put('app/entities/commission-report-request/commission-report-request-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myWebLinkLabel" translate="winkballApp.commissionReportRequest.home.createOrEditLabel">Create or edit a Web Link</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.commissionReportRequest.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.commissionReportRequest.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="winkballApp.commissionReportRequest.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.commissionReportRequest.title" required ng-maxlength="255"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_startDate">Event Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" datetime-picker="{{dateformat}}" ng-model="vm.commissionReportRequest.startDate" is-open="vm.datePickerOpenStatus.startDate" required="required"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><p class="help-block">Please enter a provisional start date</p></div><div class="form-group"><label class="control-label" for="field_description">Description</label><textarea class="form-control" name="description" id="field_description" ng-model="vm.commissionReportRequest.description" required="required" rows="6"></textarea><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="panel"><h4>Brief for the Event</h4></div><div class="form-group"><label class="control-label" for="field_editorial_storyline">Editorial Story Line</label><textarea class="form-control" name="editorialStoryline" id="field_editorial_storyline" ng-model="vm.commissionReportRequest.editorialStoryline" ng-maxlength="1000" rows="5"></textarea><div ng-show="editForm.editorialStoryline.$invalid"><p class="help-block" ng-show="editForm.editorialStoryline.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_key_talent">Key Talent(s)</label><textarea class="form-control" name="keytalent" id="field_key_talent" ng-model="vm.commissionReportRequest.keyTalent" ng-maxlength="1000" rows="5"></textarea><div ng-show="editForm.keytalent.$invalid"><p class="help-block" ng-show="editForm.keytalent.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" for="social_media">Social Media</label><textarea class="form-control" name="socialMedia" id="social_media" placeholder="Facebook, Instagram, Twitter, etc" ng-model="vm.commissionReportRequest.socialMedia" ng-maxlength="400" rows="4"></textarea><div ng-show="editForm.socialMedia.$invalid"><p class="help-block" ng-show="editForm.socialMedia.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="400">This field cannot be longer than 400 characters.</p></div></div><div class="panel"><h4>Contact Detais for the Event</h4></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.commissionReportRequest.contactName" for="field_contactName">Contact Name</label><input type="text" class="form-control" name="contactName" id="field_contactName" ng-model="vm.commissionReportRequest.contactName" ng-maxlength="100" required><div ng-show="editForm.contactName.$invalid"><p class="help-block" ng-show="editForm.contactName.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.website.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-md-6"><label class="control-label" for="field_email">Contact Email</label><input type="email" class="form-control" name="email" id="field_email" ng-model="vm.commissionReportRequest.contactEmail" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_contactNumber">Contact Number</label><input type="text" class="form-control" name="contactNumber" id="field_contactNumber" ng-model="vm.commissionReportRequest.contactNumber" ng-maxlength="22"><div ng-show="editForm.contactNumber.$invalid"><p class="help-block" ng-show="editForm.contactNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="22">This field cannot be longer than 22 characters.</p></div></div><div class="col-md-6"><label class="control-label" for="field_website">Website</label><div class="input-group"><input type="text" class="form-control" name="website" id="field_website" ng-model="vm.commissionReportRequest.website" ng-maxlength="250" placeholder="e.g. https://www.winkball.com"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-disabled="!vm.commissionReportRequest.website" ng-click="vm.deleteWebsite()"><span class="glyphicon glyphicon-trash"></span></button></span></div><div ng-show="editForm.website.$invalid"><p class="help-block" ng-show="editForm.website.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="250">This field cannot be longer than 250 characters.</p><!-- <p class="help-block" ng-show="editForm.website.$error.url" translate="global.messages.validate.url.invalid">\n                        Your URL link is invalid.\n                    </p> --></div></div></div><div class="panel"><h4>Location/Address of the Event</h4></div><div class="form-group"><label class="control-label" for="field_firlstLineOfAddress">1st Line Of Address</label><input type="text" class="form-control" name="firlstLineOfAddress" id="field_firlstLineOfAddress" ng-model="vm.commissionReportRequest.address.firlstLineOfAddress" ng-maxlength="150" required><div ng-show="editForm.firlstLineOfAddress.$invalid"><p class="help-block" ng-show="editForm.firlstLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.firlstLineOfAddress.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_secondLineOfAddress">2nd Line Of Address</label><input type="text" class="form-control" name="secondLineOfAddress" id="field_secondLineOfAddress" ng-model="vm.commissionReportRequest.address.secondLineOfAddress" ng-maxlength="150"><div ng-show="editForm.secondLineOfAddress.$invalid"><p class="help-block" ng-show="editForm.secondLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_town">Town</label><input type="text" class="form-control" name="town" id="field_town" ng-model="vm.commissionReportRequest.address.town" ng-maxlength="100"><div ng-show="editForm.town.$invalid"><p class="help-block" ng-show="editForm.town.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_county">County</label><input type="text" class="form-control" name="county" id="field_county" ng-model="vm.commissionReportRequest.address.county"></div><div class="form-group"><label class="control-label" for="field_postCode">Post Code</label><input type="text" class="form-control" name="postCode" id="field_postCode" ng-model="vm.commissionReportRequest.address.postCode" ng-maxlength="50" required><div ng-show="editForm.postCode.$invalid"><p class="help-block" ng-show="editForm.postCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.postCode.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp; <span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/commission-report-request/commission-report-requests.html','<div><h2 translate="winkballApp.commissionReportRequest.home.title">Commission Report Requests</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary rounded-0" ui-sref="commission-report-request.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.commissionReportRequest.home.createLabel">Create new Commission Report Request</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.commissionReportRequest.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span translate="winkballApp.commissionReportRequest.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="startDate"><span translate="winkballApp.commissionReportRequest.startDate">Start Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contactName"><span translate="winkballApp.commissionReportRequest.contactName">Contact Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contactEmail"><span translate="winkballApp.commissionReportRequest.contactEmail">Contact Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="commissionReportRequest in vm.commissionReportRequests track by commissionReportRequest.id"><td><a ui-sref="commission-report-request-detail({id:commissionReportRequest.id})">{{commissionReportRequest.id}}</a></td><td>{{commissionReportRequest.title}}</td><td>{{commissionReportRequest.startDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{commissionReportRequest.contactName}}</td><td>{{commissionReportRequest.contactEmail}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="commission-report-request-detail({id:commissionReportRequest.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="commission-report-request.edit({id:commissionReportRequest.id})" class="btn btn-primary btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="commission-report-request.delete({id:commissionReportRequest.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/customer/customer-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customer.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.customer.delete.question" translate-values="{id: \'{{vm.customer.id}}\'}">Are you sure you want to delete this Customer?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/customer/customer-detail.html','<div><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="customer-detail.edit({id:vm.customer.id})" has-any-authority="ROLE_ADMIN,ROLE_MANAGER" class="btn btn-primary btn-lg rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button><h2><span>Business</span> {{vm.customer.id}}</h2><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-4"><img ng-if="vm.customer.profilePicture" class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Logo"> <img ng-if="!vm.customer.profilePicture" class="img-responsive" ng-src="{{\'content/images/noperson.png\' | trustURL}}" alt="Logo"></div><div class="col-md-8"><h2><span>Company Name</span>: {{vm.customer.companyName}}</h2></div></div><hr><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.customer.companyName">Company Name</span></dt><dd><span>{{vm.customer.companyName}}</span></dd><dt><span>User Name</span></dt><dd><span>{{vm.customer.firstName +\' \'+ vm.customer.lastName}}</span></dd><dt><span>Position</span></dt><dd>{{vm.customer.position}}</dd><dt><span>Login</span></dt><dd>{{vm.customer.login}}</dd><dt><span>Email</span></dt><dd><span>{{vm.customer.email}}</span></dd><dt><span translate="winkballApp.customer.contactNumber">Contact Number</span></dt><dd><span>{{vm.customer.contactNumber}}</span></dd><dt><span>Website</span></dt><dd>{{vm.customer.website}}</dd><dt ng-if="vm.customer.referrerId"><span>Referrer</span></dt><dd ng-if="vm.customer.referrerId"><a ui-sref="reporter-detail({id:vm.customer.referrerId})">{{vm.customer.referrerId}}</a></dd><dt><span>Categories</span></dt><dd><span ng-repeat="category in vm.customer.categories"><mark>{{category}}</mark>&nbsp;</span></dd><!-- <dt><span>Monthly Visitors</span></dt>\n        <dd>\n            {{vm.customer.monthlyVisitors}}\n        </dd> --><!-- <dt><span translate="winkballApp.customer.aboutMe">About Me</span></dt>\n        <dd>\n            <span>{{vm.customer.aboutMe}}</span>\n        </dd> --></dl><h3 ng-if="vm.customer.address"><span translate="winkballApp.customer.address">Address</span></h3><dl ng-if="vm.customer.address" class="dl-horizontal jh-entity-details"><dt>1st Line of address</dt><dd>{{vm.customer.address.firlstLineOfAddress}}</dd><dt>2nd Line of address</dt><dd>{{vm.customer.address.secondLineOfAddress}}</dd><dt>Town</dt><dd>{{vm.customer.address.town}}</dd><dt>County</dt><dd>{{vm.customer.address.county}}</dd><dt>Post code</dt><dd>{{vm.customer.address.postCode}}</dd></dl></div>');
$templateCache.put('app/entities/customer/customer-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustomerLabel" translate="winkballApp.customer.home.createOrEditLabel">Create or edit a Customer</h4></div><div class="modal-body"><form id="customerForm" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" ng-show="vm.customer.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.customer.id" readonly="readonly"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.customer.puid" for="field_puid">Puid</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.customer.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.customer.firstName" ng-maxlength="50" required><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.firstName.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6"><label>Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.customer.lastName" ng-maxlength="50" required><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.lastName.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-model="vm.customer.login" ng-required="vm.customer.userId == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="col-md-6"><label class="control-label" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" ng-model="vm.customer.email" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.customer.companyName" for="field_companyName">Company Name</label><input type="text" class="form-control" name="companyName" id="field_companyName" ng-model="vm.customer.companyName" required><div ng-show="editForm.companyName.$invalid"><p class="help-block" ng-show="editForm.companyName.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6"><label class="control-label" for="field_position">Position</label><input type="text" class="form-control" name="position" id="field_position" ng-model="vm.customer.position" required><div ng-show="editForm.position.$invalid"><p class="help-block" ng-show="editForm.position.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_contactName">Company Type</label><input type="text" class="form-control" name="contactName" id="field_contactName" ng-model="vm.customer.companyType"></div><div class="col-md-6"><label for="field_region">Region</label><select class="form-control" id="field_region" name="region" ng-model="vm.customer.region"><option value="LONDON">London</option><option value="CYMRU_WALES">Cymru Wales</option><option value="EAST_OF_ENGLAND">East of England</option><option value="NORTH_EAST_AND_CUMBRIA">North East and Cumbria</option><option value="NORTHERN_IRELAND">Northern Ireland</option><option value="SOUTH_EAST">South East</option><option value="WEST_MIDLANDS">West Midlands</option><option value="EAST_MIDLANDS">East Midlands</option><option value="NORTH_WEST">North West</option><option value="SCOTLAND">Scotland</option><option value="SOUTH_WEST">South West</option><option value="YORKSHIRE_AND_THE_HUMBER">Yorkshire and The Humber</option><option value="NATIONWIDE">Nationwide</option></select></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.customer.contactNumber" for="field_contactNumber">Contact Number</label><input type="text" class="form-control" name="contactNumber" id="field_contactNumber" ng-model="vm.customer.contactNumber" ng-maxlength="100"><div ng-show="editForm.contactNumber.$invalid"><p class="help-block" ng-show="editForm.contactNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-md-6"><label class="control-label" for="field_website">Website</label><div class="input-group"><input type="url" class="form-control" name="website" id="field_website" ng-model="vm.customer.website" ng-maxlength="150" placeholder="e.g. https://www.winkball.com"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-disabled="!vm.customer.website" ng-click="vm.deleteWebsite()"><span class="glyphicon glyphicon-trash"></span></button></span></div><div ng-show="editForm.website.$invalid"><p class="help-block" ng-show="editForm.website.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.website.$error.url" translate="global.messages.validate.url.invalid">Your URL link is invalid.</p></div></div></div><div class="form-group"><h4>Postal Address</h4></div><div class="form-group"><label class="control-label" for="field_firlstLineOfAddress">1st Line Of Address</label><input type="text" class="form-control" name="firlstLineOfAddress" id="field_firlstLineOfAddress" ng-model="vm.customer.address.firlstLineOfAddress" ng-maxlength="150" required><div ng-show="editForm.firlstLineOfAddress.$invalid"><p class="help-block" ng-show="editForm.firlstLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.firlstLineOfAddress.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_secondLineOfAddress">2nd Line Of Address</label><input type="text" class="form-control" name="secondLineOfAddress" id="field_secondLineOfAddress" ng-model="vm.customer.address.secondLineOfAddress" ng-maxlength="150"><div ng-show="editForm.secondLineOfAddress.$invalid"><p class="help-block" ng-show="editForm.secondLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_town">Town</label><input type="text" class="form-control" name="town" id="field_town" ng-model="vm.customer.address.town" ng-maxlength="100"><div ng-show="editForm.town.$invalid"><p class="help-block" ng-show="editForm.town.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_county">County</label><input type="text" class="form-control" name="county" id="field_county" ng-model="vm.customer.address.county"></div><div class="form-group"><label class="control-label" for="field_postCode">Post Code</label><input type="text" class="form-control" name="postCode" id="field_postCode" ng-model="vm.customer.address.postCode" ng-maxlength="50" required><div ng-show="editForm.postCode.$invalid"><p class="help-block" ng-show="editForm.postCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.postCode.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><h4>Categories of Interest</h4><label class="category-label" ng-repeat="category in vm.categories"><input type="checkbox" name="selectedCategories[]" value="{{category.name}}" ng-checked="vm.customer.categories.indexOf(category.name) > -1" ng-click="vm.toggleCategory(category.name)"> {{category.display}}</label></div><div class="form-group"><label class="control-label" translate="winkballApp.customer.aboutMe" for="field_aboutMe">About Me</label><textarea type="text" class="form-control" name="aboutMe" id="field_aboutMe" ng-model="vm.customer.aboutMe"></textarea></div><div class="file-holder"><div ng-if="!vm.customer.profilePicture" id="field_videoFile"><div class="form-group clearfix"><div class="col-md-6"><h4>Logo</h4></div><div class="col-md-6"><button type="file" class="btn btn-primary pull-right" ng-disabled="(editForm.$invalid || vm.isSaving) && !vm.errFile" ngf-select="vm.uploadFile($file, $invalidFiles)" ngf-accept="\'image/jpeg,image/png\'" ngf-max-size="5MB" ngf-min-height="216" ngf-min-width="384"><span class="glyphicon glyphicon-upload"></span>&nbsp; <span>Upload Logo</span></button></div><div class="col-md-12"><div ng-show="vm.errFile.$error"><span style="font-size:smaller">{{vm.errFile.name}}</span><p class="alert-danger" ng-show="vm.errFile.$error == \'minHeight\'">Minimum image height should be 216px</p><p class="alert-danger" ng-show="vm.errFile.$error == \'minWidth\'">Minimum image width should be 384px</p><p class="alert-danger" ng-show="vm.errFile.$error == \'maxSize\'">Maximum image size permitted is 3MB</p></div><span style="font-size:smaller">{{vm.f.name}}</span> <span class="progress" ng-show="vm.f.progress >= 0"><div ng-style="{width: vm.f.progress + \'%\'}" ng-bind="vm.f.progress + \'%\'"></div></span><p>{{vm.errorMsg}}</p></div></div></div><div ng-if="vm.customer.profilePicture"><div class="form-group clearfix"><div class="col-md-6"><h4>Logo</h4></div><div class="col-md-6"><button type="button" ng-click="vm.deleteThumbnail()" class="btn btn-danger pull-right"><span class="glyphicon glyphicon-remove"></span>&nbsp; <span>Delete Logo</span></button></div></div><hr><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Event Thumbnail"></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" form="customerForm"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/entities/customer/customers.html','<div><h2>Businesses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary rounded-0" ui-sref="customer.new" has-any-authority="ROLE_ADMIN,ROLE_MANAGER"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.customer.home.createLabel">Create new Customer</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.customer.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="companyName"><span translate="winkballApp.customer.companyName">Company Name</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Contact Name</span></th><th><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contactNumber"><span translate="winkballApp.customer.contactNumber">Contact Number</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="customer in vm.customers track by customer.id"><td><a ui-sref="customer-detail({id:customer.id})">{{customer.id}}</a></td><td>{{customer.companyName}}</td><td>{{customer.firstName + \' \' + customer.lastName}}</td><td>{{customer.email}}</td><td>{{customer.contactNumber}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="customer-detail({id:customer.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" has-any-authority="ROLE_ADMIN,ROLE_MANAGER" ui-sref="customer.edit({id:customer.id})" class="btn btn-primary btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" has-any-authority="ROLE_ADMIN,ROLE_MANAGER" ui-sref="customer.delete({id:customer.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/event-comment/event-comment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.eventComment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.eventComment.delete.question" translate-values="{id: \'{{vm.eventComment.id}}\'}">Are you sure you want to delete this Event Comment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/event-comment/event-comment-detail.html','<div><h2><span translate="winkballApp.eventComment.detail.title">Event Comment</span> {{vm.eventComment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.eventComment.comment">Comment</span></dt><dd><span>{{vm.eventComment.comment}}</span></dd><dt><span translate="winkballApp.eventComment.rating">Rating</span></dt><dd><span>{{vm.eventComment.rating}}</span></dd><dt><span>Report</span></dt><dd><a ui-sref="event-detail({id:vm.eventComment.eventId})">{{vm.eventComment.eventId}}</a></dd><dt><span translate="winkballApp.eventComment.author">Author</span></dt><dd>{{vm.eventComment.createdBy}}</dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="event-comment-detail.edit({id:vm.eventComment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/event-comment/event-comment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEventCommentLabel">Create or edit a Report Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.eventComment.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.eventComment.id" readonly="readonly"></div><div class="form-group"><h4>Report</h4><angucomplete-alt id="field_event" placeholder="Type a Report name" pause="400" selected-object="vm.getEvent" remote-api-handler="vm.searchEvents" title-field="title" initial-value="vm.event" disable-input="vm.readonly" input-class="form-control form-control-small"></div><div class="form-group"><label class="control-label" for="field_comment">Comment</label><textarea class="form-control" name="comment" id="field_comment" ng-model="vm.eventComment.comment" placeholder="Type your comments" required rows="8"></textarea><div ng-show="editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.required" translate="entity.validation.required">This field is required.</p></div></div><!-- <div class="form-group">\n            <label class="control-label" translate="winkballApp.eventComment.rating" for="field_rating">Rating</label>\n            <input type="number" class="form-control" name="rating" id="field_rating" min="0" step="1"\n                    ng-model="vm.eventComment.rating"\n                     />\n        </div> --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/event-comment/event-comments.html','<div><h2 translate="winkballApp.eventComment.home.title">Event Comments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="event-comment.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.eventComment.home.createLabel">Create new Event Comment</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.eventComment.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span translate="winkballApp.eventComment.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="rating"><span translate="winkballApp.eventComment.rating">Rating</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="event.id"><span translate="winkballApp.eventComment.event">Event</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="author.login"><span translate="winkballApp.eventComment.author">Author</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="eventComment in vm.eventComments track by eventComment.id"><td><a ui-sref="event-comment-detail({id:eventComment.id})">{{eventComment.id}}</a></td><td>{{eventComment.comment}}</td><td>{{eventComment.rating}}</td><td><a ui-sref="event-detail({id:eventComment.event.id})">{{eventComment.event.id}}</a></td><td>{{eventComment.author.login}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="event-comment-detail({id:eventComment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="event-comment.edit({id:eventComment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="event-comment.delete({id:eventComment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/event/event-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.event.id)"><div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.event.delete.question" translate-values="{id: \'{{vm.event.id}}\'}">Are you sure you want to delete this Event?</p></div><div class="modal-footer bkg-wb-yellow"><button type="button" class="btn btn-default rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger rounded-0"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/event/event-detail.html','<div ng-class="vm.getStatusClass()" print-section><div class="clearfix"><button type="submit" print-remove ng-click="vm.back()" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp; <span translate="entity.action.back" class="hidden-xs hidden-sm">Back</span></button> <button type="button" ui-sref="event-detail.edit({id:vm.event.id})" ng-if="vm.canEdit(vm.event)" print-remove class="btn btn-success btn-lg rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit Report</span></button> <button print-btn class="btn btn-info btn-lg rounded-0" print-remove><span class="glyphicon glyphicon-print"></span> <span class="hidden-xs hidden-sm">Print</span></button> <button type="submit" ng-disabled="!vm.event.published" ui-sref="event-share({id:vm.event.id})" class="btn btn-warning btn-lg rounded-0"><span class="glyphicon glyphicon-share-alt"></span> <span class="hidden-xs hidden-sm">Share</span></button> <span class="pull-right btn-lg rounded-0 bkg-darkslategray text-white">{{vm.statusName}} <span class="glyphicon glyphicon-info-sign hidden-xs hidden-sm"></span></span></div><h2 class="bkg-darkslategray text-white"><strong>REPORT</strong> : {{vm.event.title}}</h2><hr><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-4" print-remove><div ng-if="vm.event.films && vm.event.films.length"><video ng-src="{{vm.getVideoSrc(vm.event.films[0]) | trustURL}}" ng-attr-poster="{{vm.getImageSrc() | trustURL}}" controls></video></div><img ng-if="vm.event.thumbnail && !vm.event.films.length" src="content/images/spinner.svg" class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Thumbnail"> <img ng-if="!vm.event.thumbnail && !vm.event.films.length" class="img-responsive" ng-src="{{\'content/images/noperson.png\' | trustURL}}" alt="Thumbnail"></div><div class="col-md-8"><p>{{vm.event.description}}</p></div></div><hr><dl class="dl-horizontal jh-entity-details"><dt ng-if="vm.isManager()"><span translate="global.field.id">ID</span></dt><dd ng-if="vm.isManager()"><span>{{vm.event.id}}</span></dd><dt><span translate="winkballApp.event.startDate">Start Date</span></dt><dd><span>{{vm.event.startDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span translate="winkballApp.event.endDate">End Date</span></dt><dd><span>{{vm.event.endDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span>Film Due Date</span></dt><dd><span>{{vm.event.reportDueDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span>Interviews Due Date</span></dt><dd><span>{{vm.event.interviewsDueDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt print-remove><span>Films</span></dt><dd print-remove><span ng-repeat="films in vm.event.films"><a ui-sref="film-detail({id: films.id})">{{films.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt print-remove><span translate="winkballApp.event.published">Published</span></dt><dd print-remove><span>{{vm.event.published}}</span></dd><dt><span translate="winkballApp.event.manager">Manager</span></dt><dd><a ui-sref="reporter-detail({id: vm.event.manager.id})">{{vm.event.manager.firstName + \' \' + vm.event.manager.lastName}}</a></dd><dt><span>Reporters</span></dt><dd><span ng-repeat="reporter in vm.event.reporters"><a ui-sref="reporter-detail({id: reporter.id})">{{reporter.user.firstName +\' \'+reporter.user.lastName}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt print-remove><span translate="winkballApp.event.keywords">Keywords</span></dt><dd print-remove><span ng-repeat="keywords in vm.event.keywords"><a ui-sref="keyword-detail({id: keywords.id})">{{keywords.text}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt print-remove><span>Categories</span></dt><dd print-remove><span ng-repeat="category in vm.event.categories"><mark>{{category}}</mark>&nbsp;</span></dd><dt><span>Editorial Story Line</span></dt><dd><p>{{vm.event.editorialStoryline}}</p></dd><dt><span>Key Talent(s)</span></dt><dd><p>{{vm.event.keyTalent}}</p></dd><dt><span>Social Media</span></dt><dd><p>{{vm.event.socialMedia}}</p></dd><dt print-remove><span>Project Proposal</span></dt><dd style="padding: 1em 0 1em 180px" print-remove><a class="btn btn-primary rounded-0" ui-sref="job-detail({id:vm.event.job.id})">{{vm.event.job.title}}</a></dd></dl><div ng-if="(vm.isCurrentUserApproved() || vm.canEdit(vm.event))"><h3>Contact Details</h3><dl class="dl-horizontal jh-entity-details"><dt><span>Contact Name</span></dt><dd><span>{{vm.event.contactName || vm.event.job.contactName}}</span></dd><dt><span>Contact Phone</span></dt><dd><span>{{vm.event.contactPhone || vm.event.job.contactPhone}}</span></dd><dt><span>Contact Email</span></dt><dd><span>{{vm.event.contactEmail || vm.event.job.contactEmail}}</span></dd></dl></div><div class="map-holder" ng-show="vm.event.location.geoPoint.lon && vm.event.location.geoPoint.lat"><h3>Location: <a ui-sref="location-detail({id:vm.event.location.id})">{{vm.event.location.title}}</a></h3><ng-map zoom="16" center="[{{vm.event.location.geoPoint.lat}}, {{vm.event.location.geoPoint.lon}}]"><marker position="[{{vm.event.location.geoPoint.lat}}, {{vm.event.location.geoPoint.lon}}]" title="{{vm.event.location.title}}" centered="true"></marker></ng-map></div><div class="table-responsive clearfix" print-remove><div class="btn-group pull-left"><button type="button" ng-if="!vm.hasSponsorPack() && vm.event.reportStatus !== \'CANCELLED\'" ui-sref="new-media-package({event:vm.event.id})" class="btn btn-primary btn-lg rounded-0"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs hidden-sm">Add Media Package</span></button> <button type="button" ng-if="vm.hasSponsorPack()" ui-sref="media-package-detail({id:vm.event.id})" class="btn btn-primary btn-lg rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">View Media Package</span></button></div></div><div class="table-responsive" ng-if="vm.sponsors.length > 0"><h3>Sponsor</h3><table class="jh-table table table-striped"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span>Sponsor Name</span></th><th><span>Contact Name</span></th><th><span>Contact Email</span></th><th><span>Created Date</span></th><th><span>Sponsor Finder</span></th><th></th></tr></thead><tbody><tr ng-repeat="sponsor in vm.sponsors track by sponsor.id"><td><a ui-sref="sponsor-detail({id:sponsor.id})">{{sponsor.id}}</a></td><td>{{sponsor.sponsorName}}</td><td>{{sponsor.contactName}}</td><td>{{sponsor.contactEmail}}</td><td>{{sponsor.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{sponsor.finder.firstName +\' \'+sponsor.finder.lastName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sponsor-detail({id:sponsor.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button></div></td></tr></tbody></table></div><div print-remove class="table-responsive" ng-if="vm.jobApplicants.length > 0"><button type="button" ng-if="vm.isManager() && vm.event.reportStatus === \'COMPLETED\'" class="btn btn-primary rounded-0 pull-right hidden"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs hidden-sm">Generate Team Payments</span></button><h3>Team</h3><!-- <button type="button" ui-sref="job-detail.apply({id:vm.event.job.id})" class="btn btn-info btn-lg rounded-0">\n            <span class="glyphicon glyphicon-edit"></span>\n            <span class="hidden-xs"> Apply to work on this Project</span>\n        </button> --><table class="jh-table table table-striped" style="text-align: center"><thead><tr><th><span>No</span></th><th><span>First Name</span></th><th><span>Last Name</span></th><th><span>Email</span></th><th><span>Role</span></th><th><span>Application Date</span></th><th><span>Accepted</span></th><th></th></tr></thead><tbody><tr ng-repeat="applicant in vm.jobApplicants track by applicant.id"><td>{{applicant.id}}</td><td>{{applicant.reporter.firstName}}</td><td>{{applicant.reporter.lastName}}</td><td>{{applicant.reporter.email}}</td><td>{{applicant.reporterJobRole}}</td><td>{{applicant.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td><!-- <span class="label label-danger" ng-show="!applicant.accepted">\n                    <span class="glyphicon glyphicon-minus-sign"></span>\n                  </span>\n                  <span class="label label-success" ng-show="applicant.accepted">\n                    <span class="glyphicon glyphicon-ok-sign"></span>\n                  </span> --><label class="category-label"><input type="checkbox" name="applicants[]" ng-disabled="!vm.isManager() || vm.event.reportStatus !== \'IN_PRODUCTION\'" ng-checked="applicant.accepted" ng-click="vm.toggleAccepted(applicant)"></label></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="reporter-detail({id:applicant.reporter.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button></div></td></tr></tbody></table><div class="btn-group pull-right" ng-if="vm.isManager() && vm.event.reportStatus === \'IN_PRODUCTION\'" style="margin-bottom: 1em"><button type="button" ng-click="vm.updateTeam()" class="btn btn-lg btn-primary rounded-0"><span class="glyphicon glyphicon-check"></span> <span class="hidden-xs hidden-sm">Update Team</span></button></div></div><div ng-if="vm.event.interviews.length" class="table-responsive"><h3>Interviews <span ng-if="vm.event.interviewsDueDate">(Due date: {{vm.event.interviewsDueDate | date:\'dd/MM/yyyy HH:mm\'}})</span></h3><table class="jh-table table table-striped"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span>Title</span></th><th><span>Interview Date</span></th><th><span>Interview Creation Date</span></th><th><span>Published</span></th><th></th></tr></thead><tbody><tr ng-repeat="interview in vm.event.interviews track by interview.id"><td><a ui-sref="interview-detail({id:interview.id})">{{interview.id}}</a></td><td>{{interview.title}}</td><td>{{interview.interviewDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{interview.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{interview.published}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-disabled="!interview.published" ui-sref="interview.share({id:interview.id})" class="btn btn-success btn-sm rounded-0"><span class="glyphicon glyphicon-share-alt"></span> <span class="hidden-xs hidden-sm">Share</span></button> <button type="submit" ui-sref="interview-detail({id:interview.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view">View</span></button> <button type="submit" ui-sref="interview.edit({id:interview.id})" ng-if="vm.canEdit(vm.event)" class="btn btn-primary btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button> <button type="submit" ui-sref="interview.delete({id:interview.id})" ng-if="vm.isManager()" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete">Delete</span></button></div></td></tr></tbody></table></div><div print-remove class="table-responsive" ng-if="vm.comments.length > 0 && (vm.isCurrentUserApproved() || vm.isManager())"><h3>Feedback</h3><table class="jh-table table table-striped" style="text-align: center"><thead><tr><!-- <th><span translate="global.field.id">ID</span></th> --><th><span>Comments</span></th><th><span>Created Date</span></th><th><span>Author</span></th></tr></thead><tbody><tr ng-repeat="comment in vm.comments track by comment.id"><!-- <td>{{comment.id}}</td> --><td style="text-align: left">{{comment.comment}}</td><td>{{comment.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td><a ui-sref="reporter-detail-login({login: comment.createdBy})">{{comment.createdBy}}</a></td></tr></tbody></table></div><div print-remove class="clearfix"><div class="btn-group pull-right" ng-if="vm.isManager() || vm.isCurrentUserApproved()" style="margin-bottom: 1em"><button type="button" ui-sref="event-add-comment({id:vm.event.id})" class="btn btn-lg btn-primary rounded-0"><span class="glyphicon glyphicon-comment"></span> <span class="hidden-xs hidden-sm">Add Comment</span></button></div></div><div print-remove class="clearfix"><div class="btn-group pull-right" ng-if="vm.isManager()"><button type="button" ng-if="vm.event.published" ui-sref="event-email-prospective-publisher({id:vm.event.id})" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-envelope"></span> <span class="hidden-xs hidden-sm">Email Publishers</span></button> <button type="button" ui-sref="event-email({id:vm.event.id})" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-envelope"></span> <span class="hidden-xs hidden-sm">Email Team</span></button> <button type="button" ui-sref="event-delete({id:vm.event.id})" class="btn btn-danger btn-lg rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete">Delete</span></button> <button type="button" ng-if="vm.event.reportStatus !== \'COMPLETED\' && vm.event.reportStatus !== \'CANCELLED\'" ui-sref="event-status({id:vm.event.id, status: \'CANCELLED\'})" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-remove"></span> <span class="">Cancel Report</span></button> <button type="button" ng-disabled="!vm.hasSponsorPack()" ng-if="vm.event.reportStatus === \'IN_PRODUCTION\'" ui-sref="event-status({id:vm.event.id, status: \'READY_TO_FILM\'})" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-right"></span> <span class="">Move to Ready to Film</span></button> <button type="button" ng-if="vm.event.reportStatus === \'READY_TO_FILM\'" ui-sref="event-status({id:vm.event.id, status:\'AWATING_SIGN_OFF\'})" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-right"></span> <span class="">Move to Awaiting Sign Off</span></button> <button type="button" ng-if="vm.event.reportStatus === \'AWATING_SIGN_OFF\'" ui-sref="event-status({id:vm.event.id, status:\'COMPLETED\'})" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-right"></span> <span class="">Move to Completed</span></button> <button type="button" ng-if="vm.event.reportStatus === \'CANCELLED\'" ui-sref="event-status({id:vm.event.id, status: \'IN_PRODUCTION\'})" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-right"></span> <span class="">Move to In-Production</span></button></div></div></div>');
$templateCache.put('app/entities/event/event-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEventLabel">Create or edit a Report</h4></div><div class="modal-body"><form id="evnet-edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" ng-show="vm.event.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.event.id" readonly="readonly"></div><div class="col-md-6" ng-show="vm.event.puid"><label class="control-label" translate="winkballApp.event.puid" for="field_puid">Puid</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.event.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"><div ng-show="editForm.puid.$invalid"><p class="text-danger" ng-show="editForm.puid.$error.required" translate="entity.validation.required">This field is required.</p><p class="text-danger" ng-show="editForm.puid.$error.minlength" translate="entity.validation.minlength" translate-value-min="12">This field is required to be at least 12 characters.</p><p class="text-danger" ng-show="editForm.puid.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="12">This field cannot be longer than 12 characters.</p></div></div></div><div class="form-group"><label class="control-label" translate="winkballApp.event.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.event.title" required><div ng-show="editForm.title.$invalid"><p class="text-danger" ng-show="editForm.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.event.description" for="field_description">Description</label><textarea class="form-control" name="description" id="field_description" required ng-model="vm.event.description" rows="8"></textarea><div ng-show="editForm.description.$invalid"><p class="text-danger" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_editorial_storyline">Editorial Story Line</label><textarea class="form-control" name="editorialStoryline" id="field_editorial_storyline" ng-model="vm.event.editorialStoryline" ng-maxlength="1000" rows="4"></textarea><div ng-show="editForm.editorialStoryline.$invalid"><p class="text-danger" ng-show="editForm.editorialStoryline.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_key_talent">Key Talent(s)</label><textarea class="form-control" name="keytalent" id="field_key_talent" ng-model="vm.event.keyTalent" ng-maxlength="1000" rows="5"></textarea><div ng-show="editForm.keytalent.$invalid"><p class="text-danger" ng-show="editForm.keytalent.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" for="social_media">Social Media</label><textarea class="form-control" name="socialMedia" id="social_media" placeholder="Facebook, Instagram, Twitter, etc" ng-model="vm.event.socialMedia" ng-maxlength="400" rows="4"></textarea><div ng-show="editForm.socialMedia.$invalid"><p class="text-danger" ng-show="editForm.socialMedia.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="400">This field cannot be longer than 400 characters.</p></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_contactName">Contact Name</label><input type="text" class="form-control" name="contactName" id="field_contactName" ng-model="vm.event.contactName"></div><div class="col-md-6"><label class="control-label" for="field_contactPhone">Contact Phone</label><input type="text" class="form-control" name="contactPhone" id="field_contactPhone" ng-maxlength="21" ng-pattern="vm.phoneRegex" ng-model="vm.event.contactPhone" placeholder="e.g. +440123456789"><div ng-show="editForm.contactPhone.$invalid"><p class="text-danger" ng-show="editForm.contactPhone.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="text-danger" ng-show="editForm.contactPhone.$error.pattern">Phone number is invalid. Please make sure there is no white spaces or braces.</p></div></div></div><div class="form-group"><div class="col-md-6"><label class="control-label" for="field_contact_email">Contact Email</label><input class="form-control" id="field_contact_email" name="email" ng-maxlength="100" ng-model="vm.event.contactEmail" type="email"><div ng-show="editForm.email.$invalid"><p class="text-danger" ng-show="editForm.email.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p><p class="text-danger" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="col-md-6" ng-show="vm.event.id"><label class="control-label" translate="winkballApp.event.published" for="field_published">Published</label><input type="checkbox" class="form-control" name="published" id="field_published" ng-model="vm.event.published"><div ng-show="editForm.published.$invalid"><p class="text-danger" ng-show="editForm.published.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.event.startDate" for="field_startDate">Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" datetime-picker="{{dateformat}}" ng-model="vm.event.startDate" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-6"><label class="control-label" translate="winkballApp.event.endDate" for="field_endDate">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" datetime-picker="{{dateformat}}" ng-model="vm.event.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_reportDueDate">Film Due Date</label><div class="input-group"><input id="field_reportDueDate" type="text" class="form-control" name="reportDueDate" datetime-picker="{{dateformat}}" ng-model="vm.event.reportDueDate" is-open="vm.datePickerOpenStatus.reportDueDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'reportDueDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-6"><label class="control-label" for="field_interviewsDueDate">Interviews Due Date</label><div class="input-group"><input id="field_interviewsDueDate" type="text" class="form-control" name="interviewsDueDate" datetime-picker="{{dateformat}}" ng-model="vm.event.interviewsDueDate" is-open="vm.datePickerOpenStatus.interviewsDueDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'interviewsDueDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label for="field_job">Project Proposal</label><select class="form-control" id="field_job" name="job" ng-model="vm.event.job" ng-options="job as job.title for job in vm.jobs track by job.id"><option value=""></option></select></div><div class="form-group"><h4>Categories</h4><label class="category-label" ng-repeat="category in vm.categories"><input type="checkbox" name="selectedCategories[]" value="{{category.name}}" ng-checked="vm.event.categories.indexOf(category.name) > -1" ng-click="vm.toggleCategory(category.name)"> {{category.display}}</label></div><!-- <div class="form-group">\n            <label translate="winkballApp.event.manager" for="field_manager">Manager</label>\n            <select class="form-control" id="field_manager" name="manager"\n            ng-model="vm.event.manager"\n            ng-options="user as (user.firstName + \' \' + user.lastName) for user in vm.users track by user.id">\n            <option value=""></option>\n            </select>\n        </div> --><div class="form-group" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><h4>Manager</h4><angucomplete-alt id="field_manager" placeholder="Add a manager" pause="400" selected-object="vm.getManager" initial-value="vm.event.manager" remote-api-handler="vm.searchUser" title-field="firstName,lastName" description-field="email" input-class="form-control form-control-small"></div><div class="form-group" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><h4>Reporters</h4><tags-input ng-model="vm.reporters" display-property="login" placeholder="{{vm.reporters.length > 0 ? \' \' : \'Type reporter name\'}}" add-from-autocomplete-only="true" template="reporter-tag-template"><auto-complete source="vm.searchReporters($query)" min-length="2" max-results-to-show="10" template="reporter-tag-autocomplete-template"></auto-complete></tags-input></div><div class="form-group"><h4>Applicants</h4><div class="row"><div class="col-lg-6"><div ng-dropdown-multiselect="" options="vm.jobApplicants" translation-texts="vm.selectReportersText" selected-model="vm.selectedApplicants" extra-settings="vm.multiSelectSettings"></div></div></div></div><div class="form-group"><h4>Keywords</h4><tags-input ng-model="vm.event.keywords" replace-spaces-with-dashes="false" display-property="text" placeholder="{{vm.event.keywords.length > 0 ? \' \' : \'Type to add a keyword\'}}" add-from-autocomplete-only="false"><auto-complete source="vm.searchKeywords($query)" min-length="3" max-results-to-show="10"></auto-complete></tags-input></div><div class="form-group"><h4 translate="winkballApp.event.location">Location</h4><tags-input ng-model="vm.tagLocation" max-tags="1" replace-spaces-with-dashes="false" display-property="title" key-property="id" placeholder="{{(vm.tagLocation.length > 0) ? \' \' : \'Type to search for an existing location\'}}" add-from-autocomplete-only="true"><auto-complete source="vm.searchLocations($query)" min-length="3" max-results-to-show="10"></auto-complete></tags-input></div><p><strong>OR, create a new location</strong></p></form><form id="location-edit-form" name="editFormLocation" role="form" novalidate ng-submit="vm.saveLocation()" show-validation><div class="location-btn-group clearfix"><!-- search/go to current location --><div class="col-lg-6"><div class="input-group"><input type="text" ng-model="vm.search" class="form-control"><div class="input-group-btn"><button class="btn btn-primary" type="button" ng-click="vm.geoCode()" ng-disabled="vm.search.length == 0 || vm.tagLocation.length > 0" title="search"><span class="glyphicon glyphicon-search"></span>&nbsp;<span>Find Location</span></button></div><!-- <button class="btn" type="button" ng-click="gotoCurrentLocation()" title="current location">\n                &nbsp;<span class="glyphicon glyphicon-home"></span>\n              </button> --></div></div><div class="col-lg-6"><button type="submit" ng-disabled="editFormLocation.$invalid || vm.isSaving || vm.location.id" class="btn btn-primary" form="location-edit-form"><span class="glyphicon glyphicon-map-marker"></span>&nbsp;<span>Save Location</span></button></div></div><h4>Location Name</h4><div class="location-btn-group clearfix"><div class="col-lg-6"><!-- <label class="control-label" for="field_location_title">Location name</label> --> <input type="text" class="form-control" name="title" id="field_location_title" ng-model="vm.location.title" placeholder="Give location a name" required><!-- <div ng-show="editFormLocation.title.$invalid">\n          <p class="text-danger"\n              ng-show="editFormLocation.title.$error.required" translate="entity.validation.required">\n              This field is required.\n          </p>\n        </div> --></div><div class="col-lg-6"><button type="button" ng-disabled="editFormLocation.$invalid || vm.isSaving" class="btn btn-info" ng-click="vm.clearLocation()"><span class="glyphicon glyphicon-trash"></span>&nbsp;<span>Clear Location</span></button></div></div><div class="row hidden"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_latitude">Latitude</label><input type="number" class="form-control" name="latitude" id="field_latitude" ng-model="vm.location.geoPoint.lat" required readonly="readonly"><div ng-show="editFormLocation.latitude.$invalid"><p class="text-danger" ng-show="editFormLocation.latitude.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_longitude">Longitude</label><input type="number" class="form-control" name="longitude" id="field_longitude" ng-model="vm.location.geoPoint.lon" required readonly="readonly"><div ng-show="editFormLocation.longitude.$invalid"><p class="text-danger" ng-show="editFormLocation.longitude.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="map-holder"><p>Please <b>click</b> on the <i>Map</i> to give precise location or search for an <i>address</i> or a <i>place</i>!</p><div ng-if="vm.location.geoPoint.lat && vm.location.geoPoint.lon"><ng-map zoom="17" center="[{{vm.location.geoPoint.lat}}, {{vm.location.geoPoint.lon}}]" on-click="vm.addMarker()"><marker position="[{{vm.location.geoPoint.lat}}, {{vm.location.geoPoint.lon}}]" title="{{vm.location.title}}" centered="true"></marker></ng-map></div><div ng-if="!vm.location.geoPoint.lat || !vm.location.geoPoint.lon"><ng-map default-style="true" center="current-location" zoom="16" on-click="vm.addMarker()"></ng-map></div></div></form><div class="file-holder"><div ng-if="!vm.event.thumbnail" id="field_thumbnailFile"><h4>Event Thumbnail</h4><button type="file" class="btn btn-primary" ng-disabled="(editForm.$invalid || vm.isSaving) && !vm.errFile" ngf-select="vm.uploadFile($file, $invalidFiles)" accept="image/jpeg,image/png" ngf-max-size="5MB" ngf-min-height="720" ngf-min-width="1280"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button><div ng-show="vm.errFile.$error"><span style="font-size:smaller">{{vm.errFile.name}}</span><p class="alert-danger" ng-show="vm.errFile.$error == \'minHeight\'">Minimum image height should be 720px</p><p class="alert-danger" ng-show="vm.errFile.$error == \'minWidth\'">Minimum image width should be 1280px</p><p class="alert-danger" ng-show="vm.errFile.$error == \'maxSize\'">Maximum image size permitted is 5MB</p></div><span style="font-size:smaller">{{vm.f.name}}</span> <span class="progress" ng-show="vm.f.progress >= 0"><div ng-style="{width: vm.f.progress + \'%\'}" ng-bind="vm.f.progress + \'%\'"></div></span><p>{{vm.errorMsg}}</p></div><div ng-if="vm.event.thumbnail"><h4>Event Thumbnail</h4><button type="button" ng-click="vm.deleteThumbnail()" class="btn btn-danger"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete Thumbnail</span></button><hr><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Event Thumbnail"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" form="evnet-edit-form"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save Report</span></button></div><script type="text/ng-template" id="reporter-tag-template"><div class="tag-template">\n    <div class="left-panel">\n      <span>{{data.firstName}}</span>\n      <span>{{data.lastName}}</span>\n      <span>({{$getDisplayText()}})</span>\n      <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n    </div>\n  </div></script><script type="text/ng-template" id="reporter-tag-autocomplete-template"><div class="autocomplete-template">\n    <div class="left-panel">\n      <span>{{data.firstName}}</span>\n      <span>{{data.lastName}}</span>\n      <span>({{$getDisplayText()}})</span>\n    </div>\n  </div></script>');
$templateCache.put('app/entities/event/event-email-dialog.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Email</h4></div><div class="modal-body"><form id="event-email-form" name="emailForm" ng-submit="vm.sendEmail()"><jhi-alert-error></jhi-alert-error><div class="form-group"><h4>Reporters</h4><label class="category-label" ng-repeat="contact in vm.jobApplicants"><input type="checkbox" name="emails[]" value="{{contact.reporter.email}}" ng-checked="vm.contacts.indexOf(contact.reporter.email) > -1" ng-click="vm.toggleContact(contact.reporter.email)"> {{contact.reporter.firstName}}&nbsp;{{contact.reporter.lastName}}&nbsp;&lt;{{contact.reporter.email}}&gt;&nbsp;Role:{{contact.reporterJobRole}}</label><div ng-show="vm.contacts.length < 1"><p class="help-block">At least one contact has to be selected</p></div></div><div class="form-group"><label class="control-label" for="field_title">Subject</label><input class="form-control" id="field_subject" name="subject" ng-model="vm.email.subject" required="required" type="text"><div ng-show="emailForm.subject.$invalid"><p class="help-block" ng-show="emailForm.subject.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_message">Message</label><textarea class="form-control" id="field_message" name="message" required="required" rows="8" ng-model="vm.email.message"></textarea><div ng-show="emailForm.message.$invalid"><p class="help-block" ng-show="emailForm.message.$error.required" translate="entity.validation.required">This field is required.</p></div></div></form></div><div class="modal-footer bkg-wb-yellow" style="text-align:center" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-default rounded-0" ng-disabled="emailForm.$invalid || vm.contacts.length < 1" form="event-email-form"><span class="glyphicon glyphicon-share-alt"></span>&nbsp; <span>Email</span></button></div>');
$templateCache.put('app/entities/event/event-email-prospective-publisher-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Email Prospective Publishers</h4></div><div class="modal-body"><div class="modal-content-holder"><div class="row"><div class="col-lg-6"><form name="searchForm" class="form-inline"><jhi-alert-error></jhi-alert-error><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Type search criteria..."> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clearPublishers()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form><div class="modal-table-holder"><table class="jh-table table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="companyName"><span>Publication</span> <span class="glyphicon glyphicon-sort"></span></th><!-- <th jh-sort-by="email">\n                                            <span>Email</span>\n                                            <span class="glyphicon glyphicon-sort"></span>\n                                        </th> --><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']" infinite-scroll-container="\'.modal-table-holder\'"><tr ng-repeat="publisher in vm.publishers track by publisher.id"><td><a ui-sref="prospective-publisher-detail({id:publisher.id})">{{publisher.id}}</a></td><td><div>{{publisher.companyName}}</div><div>{{(publisher.firstName || \'\') +\' \'+ (publisher.lastName || \'\')}}</div><div>{{publisher.email}}</div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-if="vm.contacts.indexOf(publisher) === -1" type="submit" ng-click="vm.toggleContact(publisher)" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-plus-sign"></span></button> <button ng-if="vm.contacts.indexOf(publisher) > -1" type="submit" ng-click="vm.toggleContact(publisher)" class="btn btn-info btn-sm rounded-0 label-danger"><span class="glyphicon glyphicon-minus-sign"></span></button></div></td></tr></tbody></table></div></div><div class="col-lg-6"><form id="event-email-form" name="emailForm" ng-submit="vm.sendEmail()"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="category-label"><input type="checkbox" name="toAll" ng-model="vm.email.toAll"> &nbsp;Send to All</label></div><div class="form-group" ng-show="!vm.email.toAll"><label class="category-label" ng-repeat="contact in vm.contacts"><input type="checkbox" name="emails[]" value="{{contact}}" ng-checked="vm.contacts.indexOf(contact) > -1" ng-click="vm.toggleContact(contact)"> {{contact.companyName}}&nbsp;&lt;{{contact.email}}&gt;</label><div ng-show="vm.contacts.length < 1 && !vm.email.toAll"><p class="help-block">At least one publisher has to be selected</p></div></div><div class="form-group"><label class="control-label" for="field_title">Subject</label><input class="form-control" id="field_subject" name="subject" ng-model="vm.email.subject" required type="text"><div ng-show="emailForm.subject.$invalid"><p class="help-block" ng-show="emailForm.subject.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_greetings">Greetings</label><input class="form-control" id="field_greetings" name="greetings" ng-model="vm.email.greetings" required type="text" placeholder="Dear Publisher"><div ng-show="emailForm.greetings.$invalid"><p class="help-block" ng-show="emailForm.greetings.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_message">Message</label><textarea class="form-control" id="field_message" name="message" required="required" rows="10" ng-model="vm.email.message"></textarea><div ng-show="emailForm.message.$invalid"><p class="help-block" ng-show="emailForm.message.$error.required" translate="entity.validation.required">This field is required.</p></div></div></form></div></div></div></div><div class="modal-footer" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success" ng-disabled="emailForm.$invalid || (vm.contacts.length < 1 && !vm.email.toAll)" form="event-email-form"><span class="glyphicon glyphicon-share-alt"></span>&nbsp; <span>Email</span></button></div>');
$templateCache.put('app/entities/event/event-readytofilm-dialog.html','<form name="radytofilmForm" ng-submit="vm.confirmMove()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm move to Ready to Film</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to move this Report into Ready to Film state?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="radytofilmForm.$invalid || vm.isSaving" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span>Move to Ready to Film</span></button></div></form>');
$templateCache.put('app/entities/event/event-share-dialog.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Share Report</h4></div><div class="modal-body"><form id="event-share-form" name="shareForm" ng-submit="vm.shareEvent(vm.event.id)"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_title">Title</label><input class="form-control" id="field_title" name="title" ng-model="vm.event.title" required="required" type="text"><div ng-show="shareForm.title.$invalid"><p class="help-block" ng-show="shareForm.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_description">Description</label><textarea class="form-control" id="field_description" name="description" ng-model="vm.event.description"></textarea></div><div has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><!-- <div class="checkbox">\n          <label for="field_youtube">\n            <input type="checkbox" name="youtube" id="field_youtube"\n                    ng-model="vm.share.youtube"\n                     /><strong>Upload to WinkBall\'s YouTube channel</strong>\n          </label>\n        </div> --><!-- <div class="checkbox">\n          <label>\n            <input type="checkbox" name="youtube" id="field_facebook"\n                  ng-model="vm.share.facebook"\n                   /><strong>Publish to WinkBall\'s Facebook page</strong>\n          </label>\n        </div>\n        <div class="checkbox">\n          <label>\n            <input type="checkbox" name="twitter" id="field_twitter"\n                    ng-model="vm.share.twitter"\n                     /> <strong>Share on WinkBall\'s Twitter stream</strong>\n          </label>\n        </div> --></div><div class="form-group"><label class="control-label" for="field_message">Message</label><textarea class="form-control" id="field_message" name="twitter-message" ng-model="vm.share.message" ng-trim="false"></textarea><span class="pull-right" ng-class="{\'text-warning\': vm.share.message.length >= 120, \'text-danger\': vm.share.message.length > 140}"><strong>{{140 - vm.share.message.length}}</strong></span><p class="help-block">Add hashtags and edit message as required. Used by Twitter and Facebook only.</p></div></form><hr><h4>Share via your social channels</h4><ul class="icon-list"><li><!-- Sharingbutton Facebook --> <a class="resp-sharing-button__link social-facebook" href="https://facebook.com/sharer/sharer.php?u=https://www.winkball.com/events/{{vm.event.id}}&amp;display=popup" target="_blank" aria-label=""><div class="resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewbox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g><path d="M18.768,7.465H14.5V5.56c0-0.896,0.594-1.105,1.012-1.105s2.988,0,2.988,0V0.513L14.171,0.5C10.244,0.5,9.5,3.438,9.5,5.32 v2.145h-3v4h3c0,5.212,0,12,0,12h5c0,0,0-6.85,0-12h3.851L18.768,7.465z"/></g></svg></div></div></a></li><li><!-- Sharingbutton Twitter --> <a class="resp-sharing-button__link social-twitter" ng-href="{{vm.twitterUrl}}" target="_blank" aria-label=""><div class="resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewbox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g><path d="M23.444,4.834c-0.814,0.363-1.5,0.375-2.228,0.016c0.938-0.562,0.981-0.957,1.32-2.019c-0.878,0.521-1.851,0.9-2.886,1.104 C18.823,3.053,17.642,2.5,16.335,2.5c-2.51,0-4.544,2.036-4.544,4.544c0,0.356,0.04,0.703,0.117,1.036 C8.132,7.891,4.783,6.082,2.542,3.332C2.151,4.003,1.927,4.784,1.927,5.617c0,1.577,0.803,2.967,2.021,3.782 C3.203,9.375,2.503,9.171,1.891,8.831C1.89,8.85,1.89,8.868,1.89,8.888c0,2.202,1.566,4.038,3.646,4.456 c-0.666,0.181-1.368,0.209-2.053,0.079c0.579,1.804,2.257,3.118,4.245,3.155C5.783,18.102,3.372,18.737,1,18.459 C3.012,19.748,5.399,20.5,7.966,20.5c8.358,0,12.928-6.924,12.928-12.929c0-0.198-0.003-0.393-0.012-0.588 C21.769,6.343,22.835,5.746,23.444,4.834z"/></g></svg></div></div></a></li><li><!-- Sharingbutton E-Mail --> <a class="resp-sharing-button__link social-email" ng-href="{{vm.mailToUrl}}" target="_self" aria-label=""><div class="resp-sharing-button resp-sharing-button--email resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewbox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><path d="M22,4H2C0.897,4,0,4.897,0,6v12c0,1.103,0.897,2,2,2h20c1.103,0,2-0.897,2-2V6C24,4.897,23.103,4,22,4z M7.248,14.434 l-3.5,2C3.67,16.479,3.584,16.5,3.5,16.5c-0.174,0-0.342-0.09-0.435-0.252c-0.137-0.239-0.054-0.545,0.186-0.682l3.5-2 c0.24-0.137,0.545-0.054,0.682,0.186C7.571,13.992,7.488,14.297,7.248,14.434z M12,14.5c-0.094,0-0.189-0.026-0.271-0.08l-8.5-5.5 C2.997,8.77,2.93,8.46,3.081,8.229c0.15-0.23,0.459-0.298,0.691-0.147L12,13.405l8.229-5.324c0.232-0.15,0.542-0.084,0.691,0.147 c0.15,0.232,0.083,0.542-0.148,0.691l-8.5,5.5C12.189,14.474,12.095,14.5,12,14.5z M20.934,16.248 C20.842,16.41,20.673,16.5,20.5,16.5c-0.084,0-0.169-0.021-0.248-0.065l-3.5-2c-0.24-0.137-0.323-0.442-0.186-0.682 s0.443-0.322,0.682-0.186l3.5,2C20.988,15.703,21.071,16.009,20.934,16.248z"/></svg></div></div></a></li><li><!-- Sharingbutton Pinterest --> <a class="resp-sharing-button__link social-pinterest" ng-href="{{vm.pinterestUrl}}" target="_blank" aria-label=""><div class="resp-sharing-button resp-sharing-button--pinterest resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewbox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><path d="M12.137,0.5C5.86,0.5,2.695,5,2.695,8.752c0,2.272,0.8 ,4.295,2.705,5.047c0.303,0.124,0.574,0.004,0.661-0.33 c0.062-0.231,0.206-0.816,0.271-1.061c0.088-0.331,0.055-0.446-0.19-0.736c-0.532-0.626-0.872-1.439-0.872-2.59 c0-3.339,2.498-6.328,6.505-6.328c3.548,0,5.497,2.168,5.497,5.063c0,3.809-1.687,7.024-4.189,7.024 c-1.382,0-2.416-1.142-2.085-2.545c0.397-1.675,1.167-3.479,1.167-4.688c0-1.081-0.58-1.983-1.782-1.983 c-1.413,0-2.548,1.461-2.548,3.42c0,1.247,0.422,2.09,0.422,2.09s-1.445,6.126-1.699,7.199c-0.505,2.137-0.076,4.756-0.04,5.02 c0.021,0.157,0.224,0.195,0.314,0.078c0.13-0.171,1.813-2.25,2.385-4.325c0.162-0.589,0.929-3.632,0.929-3.632 c0.459,0.876,1.801,1.646,3.228,1.646c4.247,0,7.128-3.871,7.128-9.053C20.5,4.15,17.182,0.5,12.137,0.5z"/></svg></div></div></a></li><!-- <li><a class="alt download-link" href="#"><span class="icon-download"></span></a></li> --></ul><hr><div class="form-group"><label for="embed-code" class="control-label">Embed code</label><textarea id="embed-code" class="embedtext form-control" onclick="this.select();" name="embed-code">{{vm.videoEmbed}}</textarea></div></div><div class="modal-footer bkg-wb-yellow rounded-0" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-default rounded-0" ng-disabled="shareForm.$invalid || vm.share.message.length > 140" form="event-share-form"><span class="glyphicon glyphicon-share-alt"></span>&nbsp;<span>Share</span></button></div>');
$templateCache.put('app/entities/event/event-status-dialog.html','<form name="radytofilmForm" ng-submit="vm.confirmMove()"><div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="winkballApp.event.status.confirm" translate-values="{name: \'{{vm.statusName}}\'}"></h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to move this Report to {{vm.statusName}} state?</p></div><div class="modal-footer bkg-wb-yellow"><button type="button" class="btn btn-default rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid || vm.isSaving" class="btn btn-danger rounded-0"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span>Move to {{vm.statusName}}</span></button></div></form>');
$templateCache.put('app/entities/event/event-update-team-dialog.html','<form name="updateForm" ng-submit="vm.confirmUpdate()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm team update</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to save below team for this Report?</p><table class="jh-table table" style="text-align: center"><thead><tr><th><span>No</span></th><th><span>First Name</span></th><th><span>Last Name</span></th><th><span>Email</span></th><th><span>Role</span></th></tr></thead><tbody><tr ng-repeat="applicant in vm.applicants track by applicant.id" ng-if="applicant.accepted"><td>{{applicant.id}}</td><td>{{applicant.reporter.firstName}}</td><td>{{applicant.reporter.lastName}}</td><td>{{applicant.reporter.email}}</td><td>{{applicant.reporterJobRole}}</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="updateForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp; <span>Save</span></button></div></form>');
$templateCache.put('app/entities/event/events.html','<div class="clearfix"><form name="filterForm" class="pull-right form-inline"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="filter1">All</label><input id="filter1" type="radio" value="all" ng-model="vm.filter" ng-change="vm.setFilter()"><label for="filter6">Mine</label><input id="filter6" type="radio" value="mine" ng-model="vm.filter" ng-change="vm.setFilter()"></div><!-- <div class="form-group">\n        <label for="filter7" class="btn btn-info bkg-proposal rounded-0">\n            <input id="filter7" type="radio" value="proposal" ng-model="vm.filter" ng-change="vm.goToProposals()" />\n            Proposal\n        </label>\n    </div> --><div class="form-group"><label for="filter2" class="btn btn-default bkg-in-production rounded-0"><input id="filter2" type="checkbox" value="IN_PRODUCTION" ng-checked="vm.statuses.indexOf(\'IN_PRODUCTION\') > -1" ng-click="vm.setStatus(\'IN_PRODUCTION\')"> In-Production</label></div><div class="form-group"><label for="filter3" class="btn btn-default bkg-ready-to-film rounded-0"><input id="filter3" type="checkbox" value="READY_TO_FILM" ng-checked="vm.statuses.indexOf(\'READY_TO_FILM\') > -1" ng-click="vm.setStatus(\'READY_TO_FILM\')"> Ready To Film</label></div><div class="form-group"><label for="filter4" class="btn btn-default bkg-awaiting-signoff rounded-0"><input id="filter4" type="checkbox" value="AWATING_SIGN_OFF" ng-checked="vm.statuses.indexOf(\'AWATING_SIGN_OFF\') > -1" ng-click="vm.setStatus(\'AWATING_SIGN_OFF\')"> Awaiting Sign Off</label></div><div class="form-group"><label for="filter5" class="btn btn-default completed rounded-0"><input id="filter5" type="checkbox" value="COMPLETED" ng-checked="vm.statuses.indexOf(\'COMPLETED\') > -1" ng-click="vm.setStatus(\'COMPLETED\')"> Completed</label></div><div class="form-group"><label for="filter7" class="btn btn-default bkg-cancelled rounded-0"><input id="filter7" type="checkbox" value="CANCELLED" ng-checked="vm.statuses.indexOf(\'CANCELLED\') > -1" ng-click="vm.setStatus(\'CANCELLED\')"> Cancelled</label></div></form><h2 translate="winkballApp.event.home.title">Reports</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-success rounded-0" ui-sref="event.new" ng-class="!vm.canDelete() ? \'invisible\' : \'\'"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.event.home.createLabel">Create new Event</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.event.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs hidden-sm">Thumbnail</th><th jh-sort-by="title"><span translate="winkballApp.event.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="startDate"><span translate="winkballApp.event.startDate">Start Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="reportDueDate"><span>Due Date</span> <span class="glyphicon glyphicon-sort"></span></th><!-- <th jh-sort-by="endDate"><span translate="winkballApp.event.endDate">End Date</span> <span class="glyphicon glyphicon-sort"></span></th> --><th><span translate="winkballApp.event.published">Published</span></th><th jh-sort-by="manager.login"><span translate="winkballApp.event.manager">Manager</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="event in vm.events track by event.id"><td><a ui-sref="event-detail({id:event.id})">{{event.id}}</a></td><td class="hidden-xs hidden-sm"><div class="img-container list-thumbnail"><img ng-if="event.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{vm.getImageSrc(event.thumbnail, 384, 216) | trustURL}}" alt="Thumbnail"> <img ng-if="!event.thumbnail" class="img-responsive" ng-src="{{\'content/images/noperson.png\'}}" alt="Thumbnail"></div></td><td>{{event.title}}</td><td>{{event.startDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{event.reportDueDate | date:\'dd/MM/yyyy HH:mm\'}}</td><!-- <td>{{event.endDate | date:\'short\'}}</td> --><td><span class="label label-danger" ng-show="!event.published"><span class="glyphicon glyphicon-minus-sign"></span> </span><span class="label label-success" ng-show="event.published"><span class="glyphicon glyphicon-ok-sign"></span></span></td><td><a ui-sref="reporter-detail({id: event.manager.id})">{{event.manager.firstName + " " + event.manager.lastName}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container status-btn-group"><button type="submit" ng-if="event.reportStatus === \'PROPOSAL\'" ui-sref="event-detail({id:event.id})" class="btn btn-default bkg-proposal rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">Proposal</span></button> <button type="submit" ng-if="event.reportStatus === \'IN_PRODUCTION\'" ui-sref="event-detail({id:event.id})" class="btn btn-default bkg-in-production rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">In Production</span></button> <button type="submit" ng-if="event.reportStatus === \'READY_TO_FILM\'" ui-sref="event-detail({id:event.id})" class="btn btn-default bkg-ready-to-film rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">Ready To Film</span></button> <button type="submit" ng-if="event.reportStatus === \'AWATING_SIGN_OFF\'" ui-sref="event-detail({id:event.id})" class="btn btn-default bkg-awaiting-signoff rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">Awaiting Sign Off</span></button> <button type="submit" ng-if="event.reportStatus === \'COMPLETED\'" ui-sref="event-detail({id:event.id})" class="btn btn-default completed rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">Completed</span></button> <button type="submit" ng-if="event.reportStatus === \'CANCELLED\'" ui-sref="event-detail({id:event.id})" class="btn btn-default bkg-cancelled rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">Cancelled</span></button><!-- <button type="submit" ng-disabled="!event.published"\n                                  ui-sref="event.share({id:event.id})"\n                                  class="btn btn-warning rounded-0">\n                              <span class="glyphicon glyphicon-share-alt"></span>\n                              <span class="hidden-xs hidden-sm">Share</span>\n                          </button> --><!-- <button type="submit"\n                                    ui-sref="event-detail({id:event.id})"\n                                    class="btn btn-info rounded-0">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-xs hidden-sm" translate="entity.action.view"></span>\n                            </button> --><!-- <button type="submit" ng-if="vm.canEdit(event)"\n                                    ui-sref="event.edit({id:event.id})"\n                                    class="btn btn-success rounded-0">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span>\n                            </button> --> <button type="submit" ng-if="vm.canDelete()" ui-sref="event.delete({id:event.id})" class="btn btn-danger rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/film/film-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.film.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.film.delete.question" translate-values="{id: \'{{vm.film.id}}\'}">Are you sure you want to delete this Report?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/film/film-detail.html','<div><button type="submit" ng-click="vm.back()" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button><div class="btn-group pull-right"><button type="button" ui-sref="film-detail.edit({id:vm.film.id})" class="btn btn-primary btn-lg rounded-0" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button> <button type="button" ui-sref="film-detail.delete({id:vm.film.id})" class="btn btn-danger btn-lg rounded-0" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div><h2><span>Report Film</span> {{vm.film.id}}</h2><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.film.puid">Puid</span></dt><dd><span>{{vm.film.puid}}</span></dd><dt><span translate="winkballApp.film.title">Title</span></dt><dd><span>{{vm.film.title}}</span></dd><dt><span translate="winkballApp.film.description">Description</span></dt><dd><span>{{vm.film.description}}</span></dd><dt><span translate="winkballApp.film.published">Published</span></dt><dd><span>{{vm.film.published}}</span></dd><dt><span translate="winkballApp.film.dateCompleted">Date Completed</span></dt><dd><span>{{vm.film.dateCompleted | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span>Sign Off Date</span></dt><dd><span>{{vm.film.internalSignOffDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span>Thumbnail</span></dt><dd><span>{{vm.film.thumbnail}}</span></dd><dt><span>Film rating</span></dt><dd><span>{{vm.film.filmRating}}</span></dd><dt><span translate="winkballApp.film.event">Event</span></dt><dd><a ui-sref="report-detail({id:vm.film.eventId})">{{vm.film.eventId}}</a></dd><dt><span translate="winkballApp.film.videoFile">Video File</span></dt><dd><a ui-sref="video-file-detail({id:vm.film.videoFileId})">{{vm.film.videoFileId}}</a></dd><dt><span translate="winkballApp.film.location">Location</span></dt><dd><a ui-sref="location-detail({id:vm.film.locationId})">{{vm.film.locationId}}</a></dd><dt><span>Editor</span></dt><dd><a ui-sref="reporter-detail({id:vm.film.editor.id})">{{vm.film.editor.login}}</a></dd><dt><span>Lead Reporter</span></dt><dd><a ui-sref="reporter-detail({id:vm.film.leadReporter.id})">{{vm.film.leadReporter.login}}</a></dd><dt><span>Reporters</span></dt><dd><span ng-repeat="reporter in vm.film.reporters"><a ui-sref="reporter-detail({id: reporter.id})">{{reporter.login}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="winkballApp.film.keywords">Keywords</span></dt><dd><span ng-repeat="keywords in vm.film.keywords"><a ui-sref="keyword-detail({id: keywords.id})">{{keywords.text}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><div ng-if="vm.film.thumbnail"><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Thumbnail"><hr></div><div ng-if="vm.film.videoFileGuid"><h3>Private video URL:</h3><em>Player: </em><a target="_blank" href="{{\'https://www.winkball.com/iplayer/\' + vm.film.videoFileGuid}}">{{\'https://www.winkball.com/iplayer/\' + vm.film.videoFileGuid}}</a><hr></div><div ng-show="vm.film.videoFileGuid"><video ng-src="{{vm.getVideoSrc() | trustURL}}" controls></video></div></div>');
$templateCache.put('app/entities/film/film-dialog.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFilmLabel">Create or edit a Report</h4></div><div class="modal-body"><form id="edit-film-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" has-any-authority="ROLE_ADMIN" ng-show="vm.film.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.film.id" readonly="readonly"></div><div class="col-md-6" ng-show="vm.film.puid"><label class="control-label" translate="winkballApp.film.puid" for="field_puid">Puid</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.film.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"><div ng-show="editForm.puid.$invalid"><p class="help-block" ng-show="editForm.puid.$error.minlength" translate="entity.validation.minlength" translate-value-min="12">This field is required to be at least 12 characters.</p><p class="help-block" ng-show="editForm.puid.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="12">This field cannot be longer than 12 characters.</p></div></div></div><div class="form-group"><label class="control-label" translate="winkballApp.film.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.film.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.film.description" for="field_description">Description</label><textarea type="text" class="form-control" name="description" id="field_description" ng-model="vm.film.description"></textarea></div><div class="form-group" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><label class="control-label" translate="winkballApp.film.published" for="field_published">Published</label><input type="checkbox" class="form-control" name="published" id="field_published" ng-model="vm.film.published"><div ng-show="editForm.published.$invalid"><p class="help-block" ng-show="editForm.published.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.film.dateCompleted" for="field_dateCompleted">Date Completed</label><div class="input-group"><input id="field_dateCompleted" type="text" class="form-control" name="dateCompleted" datetime-picker="{{dateformat}}" ng-model="vm.film.dateCompleted" is-open="vm.datePickerOpenStatus.dateCompleted"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateCompleted\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-6"><label class="control-label" translate="winkballApp.film.internalSignOffDate" for="field_internalSignOffDate">Internal Sign Off Date</label><div class="input-group"><input id="field_internalSignOffDate" type="text" class="form-control" name="internalSignOffDate" datetime-picker="{{dateformat}}" ng-model="vm.film.internalSignOffDate" is-open="vm.datePickerOpenStatus.internalSignOffDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'internalSignOffDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group"><label class="control-label" for="field_filmRating">Report Rating</label><input type="number" step="1" min="0" max="5" class="form-control" name="filmRating" id="field_filmRating" ng-model="vm.film.filmRating"></div><div class="form-group"><h4>Event</h4><angucomplete-alt id="field_event" placeholder="Add an Event" pause="400" selected-object="vm.getEvent" remote-api-handler="vm.searchEvents" title-field="title" input-class="form-control form-control-small"></div><div class="form-group"><h4 translate="winkballApp.film.location">Location</h4><tags-input ng-model="vm.tagLocation" max-tags="1" replace-spaces-with-dashes="false" display-property="title" key-property="id" placeholder="Add a location" add-from-autocomplete-only="true"><auto-complete source="vm.searchLocation($query)" min-length="3" max-results-to-show="10"></auto-complete></tags-input></div><div class="form-group"><h4>Keywords</h4><tags-input ng-model="vm.film.keywords" display-property="text" placeholder="Add keywords" add-from-autocomplete-only="false"><auto-complete source="vm.searchKeywords($query)" min-length="3" max-results-to-show="10"></auto-complete></tags-input></div><!-- <div class="form-group">\n            <label for="field_editor">Editor</label>\n            <select class="form-control" id="field_editor" name="editor" ng-model="vm.film.editor" ng-options="reporter as (reporter.firstName + \' \' + reporter.lastName) for reporter in vm.reporters track by reporter.id"></select>\n        </div> --><div class="form-group"><h4>Editor</h4><angucomplete-alt id="field_editor" placeholder="Add an editor" pause="400" selected-object="vm.getEditor" initial-value="vm.film.editor" remote-api-handler="vm.searchReporters" title-field="firstName,lastName" description-field="email" input-class="form-control form-control-small"></div><!-- <div class="form-group">\n            <label for="field_lead_reporter">Lead Reporter</label>\n            <select class="form-control" id="field_lead_reporter" name="leadReporter" ng-model="vm.film.leadReporter" ng-options="reporter as (reporter.firstName + \' \' + reporter.lastName) for reporter in vm.reporters track by reporter.id"></select>\n        </div> --><div class="form-group"><h4>Lead Reporter</h4><angucomplete-alt id="field_lead_reporter" placeholder="Add a lead reporter" pause="400" selected-object="vm.getLeadReporter" initial-value="vm.film.leadReporter" remote-api-handler="vm.searchReporters" title-field="firstName,lastName" description-field="email" input-class="form-control form-control-small"></div><div class="form-group"><h4>Reporters</h4><tags-input ng-model="vm.film.reporters" display-property="login" placeholder="{{vm.film.reporters.length > 0 ? \' \' : \'Type reporter name\'}}" add-from-autocomplete-only="true" template="reporter-tag-template"><auto-complete source="vm.searchReporters($query)" min-length="2" max-results-to-show="10" template="reporter-tag-autocomplete-template"></auto-complete></tags-input></div></form><div class="file-holder"><div ng-if="!vm.film.thumbnail" id="field_thumbnail"><h4>Thumbnail</h4><button type="file" class="btn btn-primary" ng-disabled="(editForm.$invalid || vm.isSaving) && !errFile" ngf-select="uploadFile($file, $invalidFiles, true)" accept="image/jpeg,image/png" ngf-min-height="720" ngf-min-width="1280" ngf-max-size="5MB"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button><div ng-show="errFile.$error && !video"><span style="font-size:smaller">{{errFile.name}}</span><p class="alert-danger" ng-show="errFile.$error == \'minHeight\'">Minimum image height should be 720px</p><p class="alert-danger" ng-show="errFile.$error == \'minWidth\'">Minimum image width should be 1280px</p><p class="alert-danger" ng-show="errFile.$error == \'maxSize\'">Maximum image size permitted is 5MB</p></div><span ng-show="!video" style="font:smaller">{{f.name}}</span> <span class="progress" ng-show="f.progress >= 0 && !video"><div style="width:{{f.progress}}%" ng-bind="f.progress + \'%\'"></div></span><p>{{errorMsg}}</p></div><div ng-if="vm.film.thumbnail"><h4>Thumbnail</h4><button type="button" ng-click="vm.deleteThumbnail()" class="btn btn-danger"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete Thumbnail</span></button><hr><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Thumbnail"></div><div ng-if="!vm.film.videoFileGuid" id="field_videoFile"><h4 translate="winkballApp.film.videoFile">Video File</h4><button type="file" class="btn btn-primary" ng-disabled="editForm.$invalid || vm.isSaving" ngf-select="uploadFile($file, $invalidFiles)" accept="video/mp4" ngf-max-size="800MB"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button> <span ng-show="video" style="font:smaller">{{f.name}} {{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}}</span> <span class="progress" ng-show="f.progress >= 0 && video"><div style="width:{{f.progress}}%" ng-bind="f.progress + \'%\'"></div></span><p>{{errorMsg}}</p></div><div ng-if="vm.film.videoFileGuid"><h4>Video File</h4><hr><video ng-src="{{vm.getVideoSrc() | trustURL}}" controls></video></div></div></div><div class="modal-footer bkg-wb-yellow"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-default rounded-0" form="edit-film-form"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div><script type="text/ng-template" id="reporter-tag-template"><div class="tag-template">\n    <div class="left-panel">\n      <span>{{data.firstName}}</span>\n      <span>{{data.lastName}}</span>\n      <span>({{$getDisplayText()}})</span>\n      <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n    </div>\n  </div></script><script type="text/ng-template" id="reporter-tag-autocomplete-template"><div class="autocomplete-template">\n    <div class="left-panel">\n      <span>{{data.firstName}}</span>\n      <span>{{data.lastName}}</span>\n      <span>({{$getDisplayText()}})</span>\n    </div>\n  </div></script>');
$templateCache.put('app/entities/film/film-share-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Share Report</h4></div><div class="modal-body"><form id="film-share-form" name="shareForm" ng-submit="vm.shareFilm(vm.film.id)"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_title">Title</label><input class="form-control" id="field_title" name="title" ng-model="vm.film.title" required="required" type="text"><div ng-show="shareForm.title.$invalid"><p class="help-block" ng-show="shareForm.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_description">Description</label><textarea class="form-control" id="field_description" name="description" ng-model="vm.film.description"></textarea></div><!-- <div class="checkbox">\n        <label for="field_youtube">\n          <input type="checkbox" name="youtube" id="field_youtube"\n                  ng-model="vm.share.youtube"\n                   /><strong>Upload to WinkBall\'s YouTube channel</strong>\n        </label>\n      </div> --><div class="checkbox"><label><input type="checkbox" name="youtube" id="field_facebook" ng-model="vm.share.facebook"><strong>Publish to WinkBall\'s Facebook page</strong></label></div><div class="checkbox"><label><input type="checkbox" name="twitter" id="field_twitter" ng-model="vm.share.twitter"> <strong>Share on WinkBall\'s Twitter stream</strong></label></div><div class="form-group"><label class="control-label" for="field_message">Message</label><textarea class="form-control" id="field_message" name="twitter-message" ng-model="vm.share.message" ng-trim="false"></textarea><span class="pull-right" ng-class="{\'text-warning\': vm.share.message.length >= 120, \'text-danger\': vm.share.message.length > 140}"><strong>{{140 - vm.share.message.length}}</strong></span><p class="help-block">Add hashtags and edit message as required. Used by Twitter and Facebook only.</p></div></form><hr><h4>Share via your social channels</h4><ul class="icon-list"><li><!-- Sharingbutton Facebook --> <a class="resp-sharing-button__link social-facebook" href="https://facebook.com/sharer/sharer.php?u=https://www.winkball.com/films/{{vm.film.id}}&amp;display=popup" target="_blank" aria-label=""><div class="resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewbox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g><path d="M18.768,7.465H14.5V5.56c0-0.896,0.594-1.105,1.012-1.105s2.988,0,2.988,0V0.513L14.171,0.5C10.244,0.5,9.5,3.438,9.5,5.32 v2.145h-3v4h3c0,5.212,0,12,0,12h5c0,0,0-6.85,0-12h3.851L18.768,7.465z"/></g></svg></div></div></a></li><li><!-- Sharingbutton Twitter --> <a class="resp-sharing-button__link social-twitter" ng-href="{{vm.twitterUrl}}" target="_blank" aria-label=""><div class="resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewbox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g><path d="M23.444,4.834c-0.814,0.363-1.5,0.375-2.228,0.016c0.938-0.562,0.981-0.957,1.32-2.019c-0.878,0.521-1.851,0.9-2.886,1.104 C18.823,3.053,17.642,2.5,16.335,2.5c-2.51,0-4.544,2.036-4.544,4.544c0,0.356,0.04,0.703,0.117,1.036 C8.132,7.891,4.783,6.082,2.542,3.332C2.151,4.003,1.927,4.784,1.927,5.617c0,1.577,0.803,2.967,2.021,3.782 C3.203,9.375,2.503,9.171,1.891,8.831C1.89,8.85,1.89,8.868,1.89,8.888c0,2.202,1.566,4.038,3.646,4.456 c-0.666,0.181-1.368,0.209-2.053,0.079c0.579,1.804,2.257,3.118,4.245,3.155C5.783,18.102,3.372,18.737,1,18.459 C3.012,19.748,5.399,20.5,7.966,20.5c8.358,0,12.928-6.924,12.928-12.929c0-0.198-0.003-0.393-0.012-0.588 C21.769,6.343,22.835,5.746,23.444,4.834z"/></g></svg></div></div></a></li><li><!-- Sharingbutton E-Mail --> <a class="resp-sharing-button__link social-email" ng-href="{{vm.mailToUrl}}" target="_self" aria-label=""><div class="resp-sharing-button resp-sharing-button--email resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewbox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><path d="M22,4H2C0.897,4,0,4.897,0,6v12c0,1.103,0.897,2,2,2h20c1.103,0,2-0.897,2-2V6C24,4.897,23.103,4,22,4z M7.248,14.434 l-3.5,2C3.67,16.479,3.584,16.5,3.5,16.5c-0.174,0-0.342-0.09-0.435-0.252c-0.137-0.239-0.054-0.545,0.186-0.682l3.5-2 c0.24-0.137,0.545-0.054,0.682,0.186C7.571,13.992,7.488,14.297,7.248,14.434z M12,14.5c-0.094,0-0.189-0.026-0.271-0.08l-8.5-5.5 C2.997,8.77,2.93,8.46,3.081,8.229c0.15-0.23,0.459-0.298,0.691-0.147L12,13.405l8.229-5.324c0.232-0.15,0.542-0.084,0.691,0.147 c0.15,0.232,0.083,0.542-0.148,0.691l-8.5,5.5C12.189,14.474,12.095,14.5,12,14.5z M20.934,16.248 C20.842,16.41,20.673,16.5,20.5,16.5c-0.084,0-0.169-0.021-0.248-0.065l-3.5-2c-0.24-0.137-0.323-0.442-0.186-0.682 s0.443-0.322,0.682-0.186l3.5,2C20.988,15.703,21.071,16.009,20.934,16.248z"/></svg></div></div></a></li><li><!-- Sharingbutton Pinterest --> <a class="resp-sharing-button__link social-pinterest" ng-href="{{vm.pinterestUrl}}" target="_blank" aria-label=""><div class="resp-sharing-button resp-sharing-button--pinterest resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewbox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><path d="M12.137,0.5C5.86,0.5,2.695,5,2.695,8.752c0,2.272,0.8 ,4.295,2.705,5.047c0.303,0.124,0.574,0.004,0.661-0.33 c0.062-0.231,0.206-0.816,0.271-1.061c0.088-0.331,0.055-0.446-0.19-0.736c-0.532-0.626-0.872-1.439-0.872-2.59 c0-3.339,2.498-6.328,6.505-6.328c3.548,0,5.497,2.168,5.497,5.063c0,3.809-1.687,7.024-4.189,7.024 c-1.382,0-2.416-1.142-2.085-2.545c0.397-1.675,1.167-3.479,1.167-4.688c0-1.081-0.58-1.983-1.782-1.983 c-1.413,0-2.548,1.461-2.548,3.42c0,1.247,0.422,2.09,0.422,2.09s-1.445,6.126-1.699,7.199c-0.505,2.137-0.076,4.756-0.04,5.02 c0.021,0.157,0.224,0.195,0.314,0.078c0.13-0.171,1.813-2.25,2.385-4.325c0.162-0.589,0.929-3.632,0.929-3.632 c0.459,0.876,1.801,1.646,3.228,1.646c4.247,0,7.128-3.871,7.128-9.053C20.5,4.15,17.182,0.5,12.137,0.5z"/></svg></div></div></a></li><!-- <li><a class="alt download-link" href="#"><span class="icon-download"></span></a></li> --></ul><hr><div class="form-group"><label for="embed-code" class="control-label">Embed code</label><textarea id="embed-code" class="embedtext form-control" onclick="this.select();" name="embed-code">{{vm.videoEmbed}}</textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.share.message.length > 140" form="film-share-form"><span class="glyphicon glyphicon-share-alt"></span>&nbsp;<span>Share</span></button></div>');
$templateCache.put('app/entities/film/films.html','<div><h2 translate="winkballApp.film.home.title">Reports</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-success rounded-0" ui-sref="film.new" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Report Film</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.film.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><!-- <th jh-sort-by="puid"><span translate="winkballApp.film.puid">Puid</span> <span class="glyphicon glyphicon-sort"></span></th> --><th jh-sort-by="title"><span translate="winkballApp.film.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="published"><span translate="winkballApp.film.published">Published</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="dateCompleted"><span>Completed</span> <span class="glyphicon glyphicon-sort"></span></th><!-- <th jh-sort-by="internalSignOffDate"><span>Signed Off</span> <span class="glyphicon glyphicon-sort"></span></th> --><th jh-sort-by="eventId"><span translate="winkballApp.film.event">Event</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="videoFileId"><span translate="winkballApp.film.videoFile">Video File</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="locationId"><span translate="winkballApp.film.location">Location</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="film in vm.films track by film.id"><td><a ui-sref="film-detail({id:film.id})">{{film.id}}</a></td><td>{{film.title}}</td><td><span class="label label-danger" ng-show="!film.published"><span class="glyphicon glyphicon-minus-sign"></span> </span><span class="label label-success" ng-show="film.published"><span class="glyphicon glyphicon-ok-sign"></span></span></td><td>{{film.dateCompleted | date:\'dd/MM/yyyy HH:mm\'}}</td><td><a ui-sref="report-detail({id:film.eventId})">{{film.eventId}}</a></td><td><a ui-sref="video-file-detail({id:film.videoFileId})">{{film.videoFileId}}</a></td><td><a ui-sref="location-detail({id:film.locationId})">{{film.locationId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><!-- <button type="submit" ng-disabled="!film.published"\n                                  ui-sref="film.share({id:film.id})"\n                                  class="btn btn-success btn-sm">\n                              <span class="glyphicon glyphicon-share-alt"></span>\n                              <span class="hidden-xs hidden-sm">Share</span>\n                          </button> --> <button type="submit" ui-sref="film-detail({id:film.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ng-disabled="!vm.canEdit(film)" ui-sref="film.edit({id:film.id})" class="btn btn-success btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ng-disabled="!vm.canDelete()" ui-sref="film.delete({id:film.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/film-comment/film-comment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.filmComment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.filmComment.delete.question" translate-values="{id: \'{{vm.filmComment.id}}\'}">Are you sure you want to delete this Film Comment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/film-comment/film-comment-detail.html','<div><h2><span translate="winkballApp.filmComment.detail.title">Film Comment</span> {{vm.filmComment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.filmComment.comment">Comment</span></dt><dd><span>{{vm.filmComment.comment}}</span></dd><dt><span translate="winkballApp.filmComment.rating">Rating</span></dt><dd><span>{{vm.filmComment.rating}}</span></dd><dt><span translate="winkballApp.filmComment.film">Film</span></dt><dd><a ui-sref="film-detail({id:vm.filmComment.film.id})">{{vm.filmComment.film.id}}</a></dd><dt><span translate="winkballApp.filmComment.author">Author</span></dt><dd>{{vm.filmComment.createdBy}}</dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="film-comment-detail.edit({id:vm.filmComment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/film-comment/film-comment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFilmCommentLabel" translate="winkballApp.filmComment.home.createOrEditLabel">Create or edit a Film Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.filmComment.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.filmComment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="winkballApp.filmComment.comment" for="field_comment">Comment</label><textarea type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.filmComment.comment" required></textarea><div ng-show="editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.filmComment.rating" for="field_rating">Rating</label><input type="number" class="form-control" name="rating" id="field_rating" step="1" min="0" max="5" ng-model="vm.filmComment.rating"></div><div class="form-group"><label translate="winkballApp.filmComment.film" for="field_film">Film</label><select class="form-control" id="field_film" name="film" ng-model="vm.filmComment.film" ng-options="film as film.id for film in vm.films track by film.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/film-comment/film-comments.html','<div><h2 translate="winkballApp.filmComment.home.title">Film Comments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="film-comment.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.filmComment.home.createLabel">Create new Film Comment</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.filmComment.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span translate="winkballApp.filmComment.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="rating"><span translate="winkballApp.filmComment.rating">Rating</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="film.id"><span translate="winkballApp.filmComment.film">Film</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="author.login"><span translate="winkballApp.filmComment.author">Author</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="filmComment in vm.filmComments track by filmComment.id"><td><a ui-sref="film-comment-detail({id:filmComment.id})">{{filmComment.id}}</a></td><td>{{filmComment.comment}}</td><td>{{filmComment.rating}}</td><td><a ui-sref="film-detail({id:filmComment.film.id})">{{filmComment.film.id}}</a></td><td>{{filmComment.author.login}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="film-comment-detail({id:filmComment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="film-comment.edit({id:filmComment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="film-comment.delete({id:filmComment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/image/image-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.image.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.image.delete.question" translate-values="{id: \'{{vm.image.id}}\'}">Are you sure you want to delete this Image?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/image/image-detail.html','<div><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="image-detail.edit({id:vm.image.id})" has-any-authority="ROLE_REPORTER,ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN" class="btn btn-primary btn-lg rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button><h2><span translate="winkballApp.image.detail.title">Image</span> {{vm.image.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.image.puid">Puid</span></dt><dd><span>{{vm.image.puid}}</span></dd><dt><span translate="winkballApp.image.title">Title</span></dt><dd><span>{{vm.image.title}}</span></dd><dt><span translate="winkballApp.image.fileName">File Name</span></dt><dd><span>{{vm.image.fileName}}</span></dd><dt><span translate="winkballApp.image.type">File Type</span></dt><dd><span>{{vm.image.type}}</span></dd><dt><span translate="winkballApp.image.size">File Size</span></dt><dd><span>{{vm.image.size | bytesFilter:\'MB\'}}</span></dd><dt><span translate="winkballApp.image.published">Published</span></dt><dd><span>{{vm.image.published}}</span></dd><dt>URL</dt><dd><span>{{vm.getImageSrc()}}</span></dd></dl><div ng-if="vm.image.puid"><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Thumbnail"><hr></div></div>');
$templateCache.put('app/entities/image/image-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVideoLabel" translate="winkballApp.image.home.createOrEditLabel">Create or edit a Video</h4></div><div class="modal-body"><form name="editForm" id="imageEditForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.image.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.image.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.image.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.image.published" for="field_published">Published</label><input type="checkbox" class="form-control" name="published" id="field_published" ng-model="vm.image.published"><div ng-show="editForm.published.$invalid"><p class="help-block" ng-show="editForm.published.$error.required" translate="entity.validation.required">This field is required.</p></div></div></form><div class="file-holder"><div ng-if="!vm.image.puid" id="field_thumbnail"><h4>Thumbnail</h4><button type="file" class="btn btn-primary" ng-disabled="editForm.$invalid || vm.isSaving" ngf-select="vm.uploadFile($file, $invalidFiles)" accept="image/jpeg, image/png" ngf-max-size="15MB"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button> <span style="font:smaller">{{vm.f.name}} {{vm.errFile.name}} {{vm.errFile.$error}} {{vm.errFile.$errorParam}}</span> <span class="progress" ng-show="vm.f.progress >= 0"><div ng-style="{width: vm.f.progress + \'%\'}" ng-bind="vm.f.progress + \'%\'"></div></span><p>{{errorMsg}}</p></div><div ng-if="vm.image.puid"><h4>Thumbnail</h4><button type="button" ng-click="vm.deleteThumbnail()" class="btn btn-danger"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete Thumbnail</span></button><hr><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Thumbnail"><hr></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" form="imageEditForm"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/entities/image/images.html','<div><h2>Images</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary rounded-0" ui-sref="image.new" has-any-authority="ROLE_REPORTER,ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Image</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Search for images"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs hidden-sm">Thumbnail</th><th class="hidden-xs hidden-sm">PUID</th><th jh-sort-by="title"><span>Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fileName"><span>File Name</span> <span class="glyphicon glyphicon-sort"></span></th><!-- <th jh-sort-by="type"><span>Type</span> <span class="glyphicon glyphicon-sort"></span></th> --><th jh-sort-by="size"><span>Size</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="published"><span translate="winkballApp.image.published">Published</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="image in vm.images track by image.id"><td><a ui-sref="image-detail({id:image.id})">{{image.id}}</a></td><td class="hidden-xs hidden-sm"><div class="img-container list-thumbnail"><img ng-if="image.puid" class="img-responsive" src="content/images/spinner.svg" ng-src="{{vm.getImageSrc(image.puid, 384, 216) | trustURL}}" alt="Thumbnail"> <img ng-if="!image.puid" class="img-responsive" ng-src="{{\'content/images/noperson.png\'}}" alt="Thumbnail"></div></td><td class="text-center">{{image.puid}}</td><td>{{image.title}}</td><td>{{image.fileName}}</td><!-- <td>{{image.type}}</td> --><td class="text-center">{{image.size | bytesFilter:\'MB\'}}</td><td class="text-center">{{image.published}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="image-detail({id:image.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" has-any-authority="ROLE_REPORTER,ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN" ui-sref="image.edit({id:image.id})" class="btn btn-primary btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" has-any-authority="ROLE_MANAGER,ROLE_ADMIN" ui-sref="image.delete({id:image.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/interview/interview-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.interview.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.interview.delete.question" translate-values="{id: \'{{vm.interview.id}}\'}">Are you sure you want to delete this Interview?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/interview/interview-detail.html','<div><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="interview-detail.edit({id:vm.interview.id})" class="btn btn-success btn-lg rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button><div class="btn-group pull-right"><button type="button" ng-if="vm.interview.eventId" ui-sref="location-detail({id:vm.interview.eventId})" class="btn btn-primary btn-lg rounded-0"><span class="glyphicon glyphicon-map-marker"></span> <span class="hidden-xs hidden-sm">View Location</span></button> <button type="button" ng-if="vm.interview.eventId" ui-sref="report-detail({id:vm.interview.eventId})" class="btn btn-primary btn-lg rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">View Report</span></button></div><h2><span translate="winkballApp.interview.detail.title">Interview</span> {{vm.interview.id}}</h2><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.interview.puid">Puid</span></dt><dd><span>{{vm.interview.puid}}</span></dd><dt><span>Name or Title</span></dt><dd><span>{{vm.interview.title}}</span></dd><dt><span translate="winkballApp.interview.description">Description</span></dt><dd><span>{{vm.interview.description}}</span></dd><dt><span translate="winkballApp.interview.published">Published</span></dt><dd><span>{{vm.interview.published}}</span></dd><dt><span translate="winkballApp.interview.interviewDate">Interview Date</span></dt><dd><span>{{vm.interview.interviewDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt ng-if="vm.interview.thumbnail"><span>Thumbnail</span></dt><dd ng-if="vm.interview.thumbnail"><span>{{vm.interview.thumbnail}}</span></dd><dt ng-if="vm.isManager()"><span translate="winkballApp.interview.videoFile">Video File</span></dt><dd ng-if="vm.isManager()"><a ui-sref="video-file-detail({id:vm.interview.videoFileId})">{{vm.interview.videoFileId}}</a></dd><dt ng-if="vm.interview.intervieweeDetails.email"><span>Email</span></dt><dd ng-if="vm.interview.intervieweeDetails.email"><span>{{vm.interview.intervieweeDetails.email}}</span></dd><dt ng-if="vm.interview.intervieweeDetails.telephone"><span>Telephone</span></dt><dd ng-if="vm.interview.intervieweeDetails.telephone"><span>{{vm.interview.intervieweeDetails.telephone}}</span></dd><dt><span>Twitter</span></dt><dd><span>{{vm.interview.intervieweeDetails.twitter}}</span></dd><dt><span>Facebook</span></dt><dd><span>{{vm.interview.intervieweeDetails.facebook}}</span></dd><dt><span>Instagram</span></dt><dd><a ng-href="{{vm.interview.intervieweeDetails.instagram | trustURL}}">{{vm.interview.intervieweeDetails.instagram}}</a></dd><dt ng-if="vm.interview.intervieweeDetails.website"><span>Website</span></dt><dd ng-if="vm.interview.intervieweeDetails.website"><a ng-href="{{vm.interview.intervieweeDetails.website | trustURL}}">{{vm.interview.intervieweeDetails.website}}</a></dd><dt ng-if="vm.interview.intervieweeDetails.jobTitle"><span>Job title</span></dt><dd ng-if="vm.interview.intervieweeDetails.jobTitle"><span>{{vm.interview.intervieweeDetails.jobTitle}}</span></dd><dt ng-if="vm.interview.intervieweeDetails.address"><span>Address</span></dt><dd ng-if="vm.interview.intervieweeDetails.address"><span>{{vm.interview.intervieweeDetails.address}}</span></dd><dt><span translate="winkballApp.interview.keywords">Keywords</span></dt><dd><span ng-repeat="keywords in vm.interview.keywords"><a ui-sref="keyword-detail({id: keywords.id})">{{keywords.text}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span translate="winkballApp.interview.reporters">Reporters</span></dt><dd><span ng-repeat="reporter in vm.interview.reporters"><a ui-sref="reporter-detail({id: reporter.id})">{{reporter.firstName +\' \'+reporter.lastName}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt ng-if="vm.interview.intervieweeDetails.notes"><span>Notes</span></dt><dd ng-if="vm.interview.intervieweeDetails.notes"><span>{{vm.interview.intervieweeDetails.notes}}</span></dd></dl><div ng-if="vm.interview.thumbnail"><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Thumbnail"></div><div ng-show="vm.interview.videoFileGuid"><video ng-src="{{vm.getVideoSrc() | trustURL}}" controls></video></div></div>');
$templateCache.put('app/entities/interview/interview-dialog.html','<div class="modal-header bkg-wb-yellow"><button aria-hidden="true" class="close" data-dismiss="modal" ng-click="vm.clear()" type="button">&times;</button><h4 class="modal-title" id="myInterviewLabel" translate="winkballApp.interview.home.createOrEditLabel">Create or edit a Interview</h4></div><div class="modal-body"><form id="interview-edit-form" name="editForm" ng-submit="vm.save()" novalidate="novalidate" role="form" show-validation="show-validation"><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" has-any-authority="ROLE_ADMIN" ng-show="vm.interview.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input class="form-control" id="id" name="id" ng-model="vm.interview.id" readonly="readonly" type="text"></div><div class="col-md-6" ng-show="vm.interview.puid"><label class="control-label" for="field_puid" translate="winkballApp.interview.puid">Puid</label><input class="form-control" id="field_puid" name="puid" ng-maxlength="12" ng-minlength="12" ng-model="vm.interview.puid" readonly="readonly" type="text"><div ng-show="editForm.puid.$invalid"><p class="help-block" ng-show="editForm.puid.$error.minlength" translate-value-min="12" translate="entity.validation.minlength">This field is required to be at least 12 characters.</p><p class="help-block" ng-show="editForm.puid.$error.maxlength" translate-value-max="12" translate="entity.validation.maxlength">This field cannot be longer than 12 characters.</p></div></div></div><div class="form-group"><label class="control-label" for="field_title">Name or Title</label><input class="form-control" id="field_title" name="title" ng-model="vm.interview.title" required="required" type="text"><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" translate="entity.validation.required">This field is required.</p></div><p class="help-block">Please enter interviewee name or title of the Interview.</p></div><div class="form-group"><label class="control-label" for="field_description" translate="winkballApp.interview.description">Description</label><textarea class="form-control" id="field_description" name="description" ng-model="vm.interview.description"></textarea></div><div class="form-group" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><label class="control-label" for="field_published" translate="winkballApp.interview.published">Published</label><input class="form-control" id="field_published" name="published" ng-model="vm.interview.published" type="checkbox"><div ng-show="editForm.published.$invalid"><p class="help-block" ng-show="editForm.published.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_interviewDate" translate="winkballApp.interview.interviewDate">Interview Date</label><div class="input-group"><input class="form-control" datetime-picker="{{dateformat}}" id="field_interviewDate" is-open="vm.datePickerOpenStatus.interviewDate" name="interviewDate" ng-model="vm.interview.interviewDate" type="text"> <span class="input-group-btn"><button class="btn btn-default" ng-click="vm.openCalendar(\'interviewDate\')" type="button"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><h4 translate="winkballApp.interview.location">Location</h4><tags-input ng-model="vm.tagLocation" max-tags="1" replace-spaces-with-dashes="false" display-property="title" key-property="id" placeholder="Add a single location" add-from-autocomplete-only="true"><auto-complete source="vm.searchLocations($query)" min-length="3" max-results-to-show="10"></auto-complete></tags-input></div><div class="form-group"><h4>Report</h4><angucomplete-alt id="field_event" placeholder="Add a Report" pause="400" selected-object="vm.getEvent" remote-api-handler="vm.searchEvents" title-field="title" input-class="form-control form-control-small"></div><!-- Interviewee Details --><h4>Interviewee Details</h4><hr><div class="form-group"><!-- <label class="control-label" for="field_interviewee_name">Name</label> --> <input class="form-control" id="field_interviewee_name" name="name" ng-value="vm.interview.intervieweeDetails.name" type="hidden"></div><div class="form-group"><label class="control-label" for="field_interviewee_job_title">Job title</label><input class="form-control" id="field_interviewee_job_title" name="job_title" ng-maxlength="100" ng-model="vm.interview.intervieweeDetails.jobTitle" type="text"><div ng-show="editForm.job_title.$invalid"><p class="help-block" ng-show="editForm.job_title.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_interviewee_email">Email</label><input class="form-control" id="field_interviewee_email" name="email" ng-maxlength="100" ng-model="vm.interview.intervieweeDetails.email" type="email"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="col-md-6"><label class="control-label" for="field_interviewee_telephone">Telephone</label><input class="form-control" id="field_interviewee_telephone" name="telephone" ng-maxlength="100" ng-model="vm.interview.intervieweeDetails.telephone" type="text"><div ng-show="editForm.telephone.$invalid"><p class="help-block" ng-show="editForm.telephone.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><label class="control-label" for="field_interviewee_twitter">Twitter</label><input class="form-control" id="field_interviewee_twitter" name="twitter" ng-maxlength="100" ng-model="vm.interview.intervieweeDetails.twitter" type="text"><div ng-show="editForm.twitter.$invalid"><p class="help-block" ng-show="editForm.twitter.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_interviewee_facebook">Facebook</label><input class="form-control" id="field_interviewee_facebook" name="facebook" ng-maxlength="100" ng-model="vm.interview.intervieweeDetails.facebook" type="text"><div ng-show="editForm.facebook.$invalid"><p class="help-block" ng-show="editForm.facebook.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_interviewee_instagram">Instagram</label><input class="form-control" id="field_interviewee_instagram" name="instagram" ng-maxlength="150" ng-model="vm.interview.intervieweeDetails.instagram" type="url"><div ng-show="editForm.instagram.$invalid"><p class="help-block" ng-show="editForm.instagram.$error.maxlength" translate-value-max="150" translate="entity.validation.maxlength">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.instagram.$error.url" translate="global.messages.validate.url.invalid">Your URL link is invalid.</p></div></div><div class="form-group"><label class="control-label" for="field_interviewee_website">Website</label><input class="form-control" id="field_interviewee_website" name="website" ng-maxlength="100" ng-model="vm.interview.intervieweeDetails.website" type="url"><div ng-show="editForm.website.$invalid"><p class="help-block" ng-show="editForm.website.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.website.$error.url" translate="global.messages.validate.url.invalid">Your URL link is invalid.</p></div></div><div class="form-group"><label class="control-label" for="field_interviewee_address">Address</label><input class="form-control" id="field_interviewee_address" name="address" ng-model="vm.interview.intervieweeDetails.address" type="text"><p class="help-block">Please enter a comma separated postal address, e.g. 50 Kendal Close, Newham, E15 1SS</p></div><div class="form-group"><label class="control-label" for="field_interviewee_notes">Notes</label><textarea class="form-control" id="field_interviewee_notes" name="notes" ng-model="vm.interview.intervieweeDetails.notes"></textarea></div><hr><!-- Interviewee Details End --><div class="form-group"><h4>Keywords</h4><tags-input add-from-autocomplete-only="false" display-property="text" ng-model="vm.interview.keywords" placeholder="Add keywords"><auto-complete max-results-to-show="10" min-length="3" source="vm.searchKeywords($query)"></auto-complete></tags-input></div><!-- <div class="form-group">\n            <label for="field_reporters" translate="winkballApp.interview.reporters">Reporters</label>\n            <select\n                class="form-control"\n                id="field_reporters"\n                multiple="multiple"\n                name="reporters"\n                ng-model="vm.interview.reporters"\n                ng-options="reporter as (reporter.firstName + \' \' + reporter.lastName) for reporter in vm.reporters track by reporter.id"></select>\n        </div> --><div class="form-group"><h4>Reporters</h4><tags-input ng-model="vm.interview.reporters" display-property="login" placeholder="Add reporters" add-from-autocomplete-only="true" template="reporter-tag-template"><auto-complete source="vm.searchReporters($query)" min-length="2" max-results-to-show="10" template="reporter-tag-autocomplete-template"></auto-complete></tags-input></div></form><div class="file-holder"><div id="field_thumbnail" ng-if="!vm.interview.thumbnail"><h4>Thumbnail</h4><button accept="image/jpeg,image/png" class="btn btn-primary" ng-disabled="(editForm.$invalid || vm.isSaving) && !errFile" ngf-max-size="5MB" ngf-min-height="720" ngf-min-width="1280" ngf-select="uploadFile($file, $invalidFiles, true)" type="file"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button><div ng-show="errFile.$error && !video"><span style="font-size: smaller">{{errFile.name}}</span><p class="alert-danger" ng-show="errFile.$error == \'minHeight\'">Minimum image height should be 720px</p><p class="alert-danger" ng-show="errFile.$error == \'minWidth\'">Minimum image width should be 1280px</p><p class="alert-danger" ng-show="errFile.$error == \'maxSize\'">Maximum image size permitted is 5MB</p></div><span ng-show="!video" style="font-size: smaller">{{f.name}}</span> <span class="progress" ng-show="f.progress >= 0 && !video"><div ng-bind="f.progress + \'%\'" style="width: {{f.progress}}%"></div></span><p>{{errorMsg}}</p></div><div ng-if="vm.interview.thumbnail"><h4>Thumbnail</h4><button class="btn btn-danger" ng-click="vm.deleteThumbnail()" type="button"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete Thumbnail</span></button><hr><img alt="Thumbnail" class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}"></div><div id="field_videoFile" ng-if="!vm.interview.videoFileGuid"><h4>Video File</h4><button accept="video/mp4" class="btn btn-primary" ng-disabled="editForm.$invalid || vm.isSaving" ngf-max-size="800MB" ngf-select="uploadFile($file, $invalidFiles)" type="file"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button> <span ng-show="video" style="font: smaller">{{f.name}} {{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}}</span> <span class="progress" ng-show="f.progress >= 0 && video"><div ng-bind="f.progress + \'%\'" style="width: {{f.progress}}%"></div></span><p>{{errorMsg}}</p></div><div ng-if="vm.interview.videoFileGuid"><h4>Video File</h4><hr><video controls="controls" ng-src="{{vm.getVideoSrc() | trustURL}}"></video></div></div></div><div class="modal-footer bkg-wb-yellow"><button class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.clear()" type="button"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button class="btn btn-default rounded-0" form="interview-edit-form" ng-disabled="editForm.$invalid || vm.isSaving" type="submit"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div><script type="text/ng-template" id="reporter-tag-template"><div class="tag-template">\n    <div class="left-panel">\n      <span>{{data.firstName}}</span>\n      <span>{{data.lastName}}</span>\n      <span>({{$getDisplayText()}})</span>\n      <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n    </div>\n  </div></script><script type="text/ng-template" id="reporter-tag-autocomplete-template"><div class="autocomplete-template">\n    <div class="left-panel">\n      <span>{{data.firstName}}</span>\n      <span>{{data.lastName}}</span>\n      <span>({{$getDisplayText()}})</span>\n    </div>\n  </div></script>');
$templateCache.put('app/entities/interview/interview-share-dialog.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Share Interview</h4></div><div class="modal-body"><form id="interview-share-form" name="shareForm" ng-submit="vm.shareInterview(vm.interview.id)"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_title">Title</label><input class="form-control" id="field_title" name="title" ng-model="vm.interview.title" required="required" type="text"><div ng-show="shareForm.title.$invalid"><p class="help-block" ng-show="shareForm.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_description">Description</label><textarea class="form-control" id="field_description" name="description" ng-model="vm.interview.description"></textarea></div><div has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><div class="checkbox"><label for="field_youtube"><input type="checkbox" name="youtube" id="field_youtube" ng-model="vm.share.youtube"><strong>Upload to WinkBall\'s YouTube channel</strong></label></div><div class="checkbox"><label><input type="checkbox" name="youtube" id="field_facebook" ng-model="vm.share.facebook"><strong>Publish to WinkBall\'s Facebook page</strong></label></div><div class="checkbox"><label><input type="checkbox" name="twitter" id="field_twitter" ng-model="vm.share.twitter"> <strong>Share on WinkBall\'s Twitter stream</strong></label></div></div><div class="form-group"><label class="control-label" for="field_message">Message</label><textarea class="form-control" id="field_message" name="twitter-message" ng-model="vm.share.message" ng-trim="false"></textarea><span class="pull-right" ng-class="{\'text-warning\': vm.share.message.length >= 120, \'text-danger\': vm.share.message.length > 140}"><strong>{{140 - vm.share.message.length}}</strong></span><p class="help-block">Add hashtags and edit message as required. Used by Twitter and Facebook only.</p></div></form><hr><h4>Share via your social channels</h4><ul class="icon-list"><li><!-- Sharingbutton Facebook --> <a class="resp-sharing-button__link social-facebook" href="https://facebook.com/sharer/sharer.php?u=https://www.winkball.com/interviews/{{vm.interview.id}}&amp;display=popup" target="_blank" aria-label=""><div class="resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewbox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g><path d="M18.768,7.465H14.5V5.56c0-0.896,0.594-1.105,1.012-1.105s2.988,0,2.988,0V0.513L14.171,0.5C10.244,0.5,9.5,3.438,9.5,5.32 v2.145h-3v4h3c0,5.212,0,12,0,12h5c0,0,0-6.85,0-12h3.851L18.768,7.465z"/></g></svg></div></div></a></li><li><!-- Sharingbutton Twitter --> <a class="resp-sharing-button__link social-twitter" ng-href="{{vm.twitterUrl}}" target="_blank" aria-label=""><div class="resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewbox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><g><path d="M23.444,4.834c-0.814,0.363-1.5,0.375-2.228,0.016c0.938-0.562,0.981-0.957,1.32-2.019c-0.878,0.521-1.851,0.9-2.886,1.104 C18.823,3.053,17.642,2.5,16.335,2.5c-2.51,0-4.544,2.036-4.544,4.544c0,0.356,0.04,0.703,0.117,1.036 C8.132,7.891,4.783,6.082,2.542,3.332C2.151,4.003,1.927,4.784,1.927,5.617c0,1.577,0.803,2.967,2.021,3.782 C3.203,9.375,2.503,9.171,1.891,8.831C1.89,8.85,1.89,8.868,1.89,8.888c0,2.202,1.566,4.038,3.646,4.456 c-0.666,0.181-1.368,0.209-2.053,0.079c0.579,1.804,2.257,3.118,4.245,3.155C5.783,18.102,3.372,18.737,1,18.459 C3.012,19.748,5.399,20.5,7.966,20.5c8.358,0,12.928-6.924,12.928-12.929c0-0.198-0.003-0.393-0.012-0.588 C21.769,6.343,22.835,5.746,23.444,4.834z"/></g></svg></div></div></a></li><li><!-- Sharingbutton E-Mail --> <a class="resp-sharing-button__link social-email" ng-href="{{vm.mailToUrl}}" target="_self" aria-label=""><div class="resp-sharing-button resp-sharing-button--email resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewbox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><path d="M22,4H2C0.897,4,0,4.897,0,6v12c0,1.103,0.897,2,2,2h20c1.103,0,2-0.897,2-2V6C24,4.897,23.103,4,22,4z M7.248,14.434 l-3.5,2C3.67,16.479,3.584,16.5,3.5,16.5c-0.174,0-0.342-0.09-0.435-0.252c-0.137-0.239-0.054-0.545,0.186-0.682l3.5-2 c0.24-0.137,0.545-0.054,0.682,0.186C7.571,13.992,7.488,14.297,7.248,14.434z M12,14.5c-0.094,0-0.189-0.026-0.271-0.08l-8.5-5.5 C2.997,8.77,2.93,8.46,3.081,8.229c0.15-0.23,0.459-0.298,0.691-0.147L12,13.405l8.229-5.324c0.232-0.15,0.542-0.084,0.691,0.147 c0.15,0.232,0.083,0.542-0.148,0.691l-8.5,5.5C12.189,14.474,12.095,14.5,12,14.5z M20.934,16.248 C20.842,16.41,20.673,16.5,20.5,16.5c-0.084,0-0.169-0.021-0.248-0.065l-3.5-2c-0.24-0.137-0.323-0.442-0.186-0.682 s0.443-0.322,0.682-0.186l3.5,2C20.988,15.703,21.071,16.009,20.934,16.248z"/></svg></div></div></a></li><li><!-- Sharingbutton Pinterest --> <a class="resp-sharing-button__link social-pinterest" ng-href="{{vm.pinterestUrl}}" target="_blank" aria-label=""><div class="resp-sharing-button resp-sharing-button--pinterest resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid"><svg version="1.1" x="0px" y="0px" width="24px" height="24px" viewbox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"><path d="M12.137,0.5C5.86,0.5,2.695,5,2.695,8.752c0,2.272,0.8 ,4.295,2.705,5.047c0.303,0.124,0.574,0.004,0.661-0.33 c0.062-0.231,0.206-0.816,0.271-1.061c0.088-0.331,0.055-0.446-0.19-0.736c-0.532-0.626-0.872-1.439-0.872-2.59 c0-3.339,2.498-6.328,6.505-6.328c3.548,0,5.497,2.168,5.497,5.063c0,3.809-1.687,7.024-4.189,7.024 c-1.382,0-2.416-1.142-2.085-2.545c0.397-1.675,1.167-3.479,1.167-4.688c0-1.081-0.58-1.983-1.782-1.983 c-1.413,0-2.548,1.461-2.548,3.42c0,1.247,0.422,2.09,0.422,2.09s-1.445,6.126-1.699,7.199c-0.505,2.137-0.076,4.756-0.04,5.02 c0.021,0.157,0.224,0.195,0.314,0.078c0.13-0.171,1.813-2.25,2.385-4.325c0.162-0.589,0.929-3.632,0.929-3.632 c0.459,0.876,1.801,1.646,3.228,1.646c4.247,0,7.128-3.871,7.128-9.053C20.5,4.15,17.182,0.5,12.137,0.5z"/></svg></div></div></a></li><!-- <li><a class="alt download-link" href="#"><span class="icon-download"></span></a></li> --></ul><hr><div class="form-group"><label for="embed-code" class="control-label">Embed code</label><textarea id="embed-code" class="embedtext form-control" onclick="this.select();" name="embed-code">{{vm.videoEmbed}}</textarea></div></div><div class="modal-footer bkg-wb-yellow" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-default rounded-0" ng-disabled="editForm.$invalid || vm.share.message.length > 140" form="interview-share-form"><span class="glyphicon glyphicon-share-alt"></span>&nbsp;<span>Share</span></button></div>');
$templateCache.put('app/entities/interview/interviews.html','<div><h2 translate="winkballApp.interview.home.title">Interviews</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-success rounded-0" ui-sref="interview.new" has-any-authority="ROLE_ADMIN,ROLE_MANAGER"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.interview.home.createLabel">Create new Interview</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.interview.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span translate="winkballApp.interview.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span translate="winkballApp.interview.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="published"><span translate="winkballApp.interview.published">Published</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="interviewDate"><span translate="winkballApp.interview.interviewDate">Interview Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="locationId"><span translate="winkballApp.interview.location">Location</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="interview in vm.interviews track by interview.id"><td><a ui-sref="interview-detail({id:interview.id})">{{interview.id}}</a></td><td>{{interview.title}}</td><td>{{interview.description}}</td><td><span class="label label-danger" ng-show="!interview.published"><span class="glyphicon glyphicon-minus-sign"></span> </span><span class="label label-success" ng-show="interview.published"><span class="glyphicon glyphicon-ok-sign"></span></span></td><td>{{interview.interviewDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td><a ui-sref="location-detail({id:interview.location.id})">{{interview.location.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-disabled="!interview.published" ui-sref="interview.share({id:interview.id})" class="btn btn-warning btn-sm rounded-0"><span class="glyphicon glyphicon-share-alt"></span> <span class="hidden-xs hidden-sm">Share</span></button> <button type="submit" ui-sref="interview-detail({id:interview.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="interview.edit({id:interview.id})" class="btn btn-success btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ng-if="vm.canDelete()" ui-sref="interview.delete({id:interview.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/interview-comment/interview-comment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.interviewComment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.interviewComment.delete.question" translate-values="{id: \'{{vm.interviewComment.id}}\'}">Are you sure you want to delete this Interview Comment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/interview-comment/interview-comment-detail.html','<div><h2><span translate="winkballApp.interviewComment.detail.title">Interview Comment</span> {{vm.interviewComment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.interviewComment.comment">Comment</span></dt><dd><span>{{vm.interviewComment.comment}}</span></dd><dt><span translate="winkballApp.interviewComment.rating">Rating</span></dt><dd><span>{{vm.interviewComment.rating}}</span></dd><dt><span translate="winkballApp.interviewComment.interview">Interview</span></dt><dd><a ui-sref="interview-detail({id:vm.interviewComment.interview.id})">{{vm.interviewComment.interview.id}}</a></dd><dt><span translate="winkballApp.interviewComment.author">Author</span></dt><dd>{{vm.interviewComment.createdBy}}</dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="interview-comment-detail.edit({id:vm.interviewComment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/interview-comment/interview-comment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInterviewCommentLabel" translate="winkballApp.interviewComment.home.createOrEditLabel">Create or edit a Interview Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.interviewComment.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.interviewComment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="winkballApp.interviewComment.comment" for="field_comment">Comment</label><textarea class="form-control" name="comment" id="field_comment" ng-model="vm.interviewComment.comment" required></textarea><div ng-show="editForm.comment.$invalid"><p class="help-block" ng-show="editForm.comment.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.interviewComment.rating" for="field_rating">Rating</label><input type="number" class="form-control" name="rating" id="field_rating" step="1" min="0" max="5" ng-model="vm.interviewComment.rating"></div><div class="form-group"><label translate="winkballApp.interviewComment.interview" for="field_interview">Interview</label><select class="form-control" id="field_interview" name="interview" ng-model="vm.interviewComment.interview" ng-options="interview as interview.id for interview in vm.interviews track by interview.id"><option value=""></option></select></div><!-- <div class="form-group">\n            <label translate="winkballApp.interviewComment.author" for="field_author">Author</label>\n            <select class="form-control" id="field_author" name="author" ng-model="vm.interviewComment.author" ng-options="user as user.login for user in vm.users track by user.id">\n                <option value=""></option>\n            </select>\n        </div> --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/interview-comment/interview-comments.html','<div><h2 translate="winkballApp.interviewComment.home.title">Interview Comments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="interview-comment.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.interviewComment.home.createLabel">Create new Interview Comment</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.interviewComment.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="comment"><span translate="winkballApp.interviewComment.comment">Comment</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="rating"><span translate="winkballApp.interviewComment.rating">Rating</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="interview.id"><span translate="winkballApp.interviewComment.interview">Interview</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="author.login"><span translate="winkballApp.interviewComment.author">Author</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="interviewComment in vm.interviewComments track by interviewComment.id"><td><a ui-sref="interview-comment-detail({id:interviewComment.id})">{{interviewComment.id}}</a></td><td>{{interviewComment.comment}}</td><td>{{interviewComment.rating}}</td><td><a ui-sref="interview-detail({id:interviewComment.interview.id})">{{interviewComment.interview.id}}</a></td><td>{{interviewComment.author.login}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="interview-comment-detail({id:interviewComment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="interview-comment.edit({id:interviewComment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="interview-comment.delete({id:interviewComment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/inventory-item/inventory-item-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.inventoryItem.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.inventoryItem.delete.question" translate-values="{id: \'{{vm.inventoryItem.id}}\'}">Are you sure you want to delete this Inventory Item?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/inventory-item/inventory-item-detail.html','<div><h2><span translate="winkballApp.inventoryItem.detail.title">Inventory Item</span> {{vm.inventoryItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.inventoryItem.assetNumber">Asset Number</span></dt><dd><span>{{vm.inventoryItem.assetNumber}}</span></dd><dt><span translate="winkballApp.inventoryItem.model">Model</span></dt><dd><span>{{vm.inventoryItem.model}}</span></dd><dt><span translate="winkballApp.inventoryItem.name">Name</span></dt><dd><span>{{vm.inventoryItem.name}}</span></dd><dt><span translate="winkballApp.inventoryItem.quantity">Quantity</span></dt><dd><span>{{vm.inventoryItem.quantity}}</span></dd><dt><span translate="winkballApp.inventoryItem.serialNumber">Serial Number</span></dt><dd><span>{{vm.inventoryItem.serialNumber}}</span></dd><dt><span translate="winkballApp.inventoryItem.owner">Owner</span></dt><dd>{{vm.inventoryItem.owner.login}}</dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="inventory-item-detail.edit({id:vm.inventoryItem.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/inventory-item/inventory-item-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInventoryItemLabel" translate="winkballApp.inventoryItem.home.createOrEditLabel">Create or edit a Inventory Item</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.inventoryItem.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.inventoryItem.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="winkballApp.inventoryItem.assetNumber" for="field_assetNumber">Asset Number</label><input type="text" class="form-control" name="assetNumber" id="field_assetNumber" ng-model="vm.inventoryItem.assetNumber"></div><div class="form-group"><label class="control-label" translate="winkballApp.inventoryItem.model" for="field_model">Model</label><input type="text" class="form-control" name="model" id="field_model" ng-model="vm.inventoryItem.model"></div><div class="form-group"><label class="control-label" translate="winkballApp.inventoryItem.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.inventoryItem.name"></div><div class="form-group"><label class="control-label" translate="winkballApp.inventoryItem.quantity" for="field_quantity">Quantity</label><input type="number" class="form-control" name="quantity" id="field_quantity" step="1" min="0" ng-model="vm.inventoryItem.quantity"></div><div class="form-group"><label class="control-label" translate="winkballApp.inventoryItem.serialNumber" for="field_serialNumber">Serial Number</label><input type="text" class="form-control" name="serialNumber" id="field_serialNumber" ng-model="vm.inventoryItem.serialNumber"></div><div class="form-group"><label translate="winkballApp.inventoryItem.owner" for="field_owner">Owner</label><select class="form-control" id="field_owner" name="owner" ng-model="vm.inventoryItem.owner" ng-options="user as user.login for user in vm.users track by user.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/inventory-item/inventory-items.html','<div><h2 translate="winkballApp.inventoryItem.home.title">Inventory Items</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="inventory-item.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.inventoryItem.home.createLabel">Create new Inventory Item</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.inventoryItem.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="assetNumber"><span translate="winkballApp.inventoryItem.assetNumber">Asset Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="model"><span translate="winkballApp.inventoryItem.model">Model</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span translate="winkballApp.inventoryItem.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="quantity"><span translate="winkballApp.inventoryItem.quantity">Quantity</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="serialNumber"><span translate="winkballApp.inventoryItem.serialNumber">Serial Number</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="owner.login"><span translate="winkballApp.inventoryItem.owner">Owner</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="inventoryItem in vm.inventoryItems track by inventoryItem.id"><td><a ui-sref="inventory-item-detail({id:inventoryItem.id})">{{inventoryItem.id}}</a></td><td>{{inventoryItem.assetNumber}}</td><td>{{inventoryItem.model}}</td><td>{{inventoryItem.name}}</td><td>{{inventoryItem.quantity}}</td><td>{{inventoryItem.serialNumber}}</td><td>{{inventoryItem.owner.login}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="inventory-item-detail({id:inventoryItem.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="inventory-item.edit({id:inventoryItem.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="inventory-item.delete({id:inventoryItem.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/keyword/keyword-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.keyword.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.keyword.delete.question" translate-values="{id: \'{{vm.keyword.id}}\'}">Are you sure you want to delete this Keyword?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/keyword/keyword-detail.html','<div><h2><span translate="winkballApp.keyword.detail.title">Keyword</span> {{vm.keyword.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.keyword.text">Text</span></dt><dd><span>{{vm.keyword.text}}</span></dd><dt><span translate="winkballApp.keyword.weight">Weight</span></dt><dd><span>{{vm.keyword.weight}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="keyword-detail.edit({id:vm.keyword.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/keyword/keyword-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myKeywordLabel" translate="winkballApp.keyword.home.createOrEditLabel">Create or edit a Keyword</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.keyword.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.keyword.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="winkballApp.keyword.text" for="field_text">Text</label><input type="text" class="form-control" name="text" id="field_text" ng-model="vm.keyword.text" required ng-maxlength="80"><div ng-show="editForm.text.$invalid"><p class="help-block" ng-show="editForm.text.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.text.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="80">This field cannot be longer than 80 characters.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.keyword.weight" for="field_weight">Weight</label><input type="number" class="form-control" name="weight" id="field_weight" step="1" min="1" ng-model="vm.keyword.weight" ng-init="vm.keyword.weight=1" required><div ng-show="editForm.weight.$invalid"><p class="help-block" ng-show="editForm.weight.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.weight.$error.number" translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/keyword/keywords.html','<div><h2 translate="winkballApp.keyword.home.title">Keywords</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="keyword.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.keyword.home.createLabel">Create new Keyword</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.keyword.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="text"><span translate="winkballApp.keyword.text">Text</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="weight"><span translate="winkballApp.keyword.weight">Weight</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="keyword in vm.keywords track by keyword.id"><td><a ui-sref="keyword-detail({id:keyword.id})">{{keyword.id}}</a></td><td>{{keyword.text}}</td><td>{{keyword.weight}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="keyword-detail({id:keyword.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="keyword.edit({id:keyword.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="keyword.delete({id:keyword.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/job/job-apply-dialog.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Apply to work on: {{vm.job.title}}</h4></div><div class="modal-body"><form id="apply-job-form" name="applyForm" ng-submit="vm.applyForJob()"><jhi-alert-error></jhi-alert-error><div class="radio"><label><input type="checkbox" id="field_role1" name="role" value="PRESENTER" ng-click="vm.toggleRoles(\'PRESENTER\')" ng-checked="vm.selectedRoles.indexOf(\'PRESENTER\') > -1"> PRESENTER</label><label><input type="checkbox" id="field_role3" name="role" value="CAMERA" ng-click="vm.toggleRoles(\'CAMERA\')" ng-checked="vm.selectedRoles.indexOf(\'CAMERA\') > -1"> VIDEOGRAPHER</label><label><input type="checkbox" id="field_role2" name="role" value="EDITOR" ng-click="vm.toggleRoles(\'EDITOR\')" ng-checked="vm.selectedRoles.indexOf(\'EDITOR\') > -1"> EDITOR</label><p class="help-block">Select your preferred role.</p></div></form></div><div class="modal-footer bkg-wb-yellow" style="text-align:center"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-default rounded-0" ng-disabled="applyForm.$invalid" form="apply-job-form"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span>Apply</span></button></div>');
$templateCache.put('app/entities/job/job-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.job.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.job.delete.question" translate-values="{id: \'{{vm.job.id}}\'}">Are you sure you want to delete this Project Proposal?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/job/job-detail.html','<div ng-class="vm.getStatusClass()" print-section><button type="submit" ng-click="vm.back()" class="btn btn-info btn-lg rounded-0" print-remove><span class="glyphicon glyphicon-arrow-left"></span>&nbsp; <span translate="entity.action.back" class="hidden-xs hidden-sm">Back</span></button> <button type="button" ng-if="vm.canEdit()" print-remove ui-sref="job-detail.edit({id:vm.job.id})" class="btn btn-success btn-lg rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit Proposal</span></button> <button print-btn class="btn btn-info btn-lg rounded-0" print-remove><span class="glyphicon glyphicon-print"></span> <span class="hidden-xs hidden-sm">Print</span></button><h2 class="bkg-dimgray"><strong>PROPOSAL</strong>: {{vm.job.title}}</h2><hr><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-3" print-remove><div class="img-container"><img ng-if="vm.job.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Thumbnail"> <img ng-if="!vm.job.thumbnail" class="img-responsive" ng-src="{{\'content/images/noperson.png\' | trustURL}}" alt="Thumbnail"></div></div><div class="col-md-9"><strong>Start Date</strong><span>: {{vm.job.startDate | date:\'dd/MM/yyyy HH:mm\'}}</span><br><strong>Report Due Date</strong><span>: {{vm.job.reportDueDate | date:\'dd/MM/yyyy HH:mm\'}}</span><hr><p>{{vm.job.description}}</p></div></div><hr><dl class="dl-horizontal jh-entity-details"><dt ng-if="vm.isManager()"><span>ID</span></dt><dd ng-if="vm.isManager()"><span>{{vm.job.id}}</span></dd><dt print-remove><span>Created by</span></dt><dd print-remove><span>{{vm.creator.firstName +\' \'+ vm.creator.lastName}}</span></dd><dt><span>Proposed price</span></dt><dd><span>{{vm.job.projectPrice | currency: "GBP \xA3" : 2}}</span></dd><dt><span>Editorial Story Line</span></dt><dd><p>{{vm.job.editorialStoryline}}</p></dd><dt><span>Key Talent(s)</span></dt><dd><p>{{vm.job.keyTalent}}</p></dd><dt><span>Social Media</span></dt><dd><p>{{vm.job.socialMedia}}</p></dd><dt><span>Weblink</span></dt><dd><span>{{vm.job.weblink}}</span></dd><dt print-remove><span>Private</span></dt><dd print-remove><span>{{vm.job.privacy}}</span></dd><dt print-remove><span>Approved</span></dt><dd print-remove><span>{{vm.job.approved}}</span></dd><dt print-remove><span>Categories</span></dt><dd print-remove><span ng-repeat="category in vm.job.categories"><mark>{{category}}</mark>&nbsp;</span></dd></dl><div ng-if="vm.isCurrentUserApproved() || vm.canEdit()"><h3>Contact Details</h3><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.job.contactName">Contact Name</span></dt><dd><span>{{vm.job.contactName}}</span></dd><dt><span translate="winkballApp.job.contactPhone">Contact Phone</span></dt><dd><span>{{vm.job.contactPhone}}</span></dd><dt><span>Contact Email</span></dt><dd><span>{{vm.job.contactEmail}}</span></dd></dl></div><div class="map-holder" ng-show="vm.job.location.geoPoint.lon && vm.job.location.geoPoint.lat"><h3>Location: <a ui-sref="location-detail({id:vm.job.location.id})">{{vm.job.location.title}}</a></h3><ng-map zoom="16" center="[{{vm.job.location.geoPoint.lat}}, {{vm.job.location.geoPoint.lon}}]"><marker position="[{{vm.job.location.geoPoint.lat}}, {{vm.job.location.geoPoint.lon}}]" title="{{vm.job.location.title}}" centered="true"></marker></ng-map></div><div print-remove class="table-responsive" ng-if="vm.events.length > 0"><h3>Report</h3><table class="jh-table table table-striped"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span>Title</span></th><th><span>Start Date</span></th><th><span>Published</span></th><th><span>Manager</span></th><th></th></tr></thead><tbody><tr ng-repeat="event in vm.events track by event.id"><td><a ui-sref="sponsor-detail({id:sponsor.id})">{{event.id}}</a></td><td>{{event.title}}</td><td>{{event.startDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{event.published}}</td><td>{{event.manager.firstName +\' \'+ event.manager.lastName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="event-detail({id:event.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button></div></td></tr></tbody></table></div><div print-remove class="table-responsive"><h3>Sponsor</h3><button type="button" ng-disabled="vm.sponsors.length > 0" ui-sref="new-sponsor({job:vm.job.id})" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Propose Sponsor</span></button><table class="jh-table table table-striped" ng-if="vm.sponsors.length > 0"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span>Sponsor Name</span></th><th><span>Contact Name</span></th><th><span>Contact Email</span></th><th><span>Created Date</span></th><th><span>Sponsor Finder</span></th><th></th></tr></thead><tbody><tr ng-repeat="sponsor in vm.sponsors track by sponsor.id"><td><a ui-sref="sponsor-detail({id:sponsor.id})">{{sponsor.id}}</a></td><td>{{sponsor.sponsorName}}</td><td>{{sponsor.contactName}}</td><td>{{sponsor.contactEmail}}</td><td>{{sponsor.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{sponsor.finder.firstName +\' \'+sponsor.finder.lastName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sponsor-detail({id:sponsor.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button></div></td></tr></tbody></table></div><div print-remove class="table-responsive"><h3>Team</h3><button type="button" ui-sref="job-detail.apply({id:vm.job.id})" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-edit"></span> <span class="hidden-xs">Apply to work on this Project</span></button><table class="jh-table table table-striped" ng-if="vm.jobApplicants.length > 0"><thead><tr><th><span>No</span></th><th><span>First Name</span></th><th><span>Last Name</span></th><th><span>Email</span></th><th><span>Role</span></th><th><span>Accepted</span></th><th><span>Application Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="applicant in vm.jobApplicants track by applicant.id"><td><a ui-sref="sponsor-detail({id:applicant.reporter.id})">{{applicant.id}}</a></td><td>{{applicant.reporter.firstName}}</td><td>{{applicant.reporter.lastName}}</td><td>{{applicant.reporter.email}}</td><td>{{applicant.reporterJobRole}}</td><td class="text-center"><span class="label label-danger" ng-show="!applicant.accepted"><span class="glyphicon glyphicon-minus-sign"></span> </span><span class="label label-success" ng-show="applicant.accepted"><span class="glyphicon glyphicon-ok-sign"></span></span></td><td>{{applicant.createdDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="reporter-detail({id:applicant.reporter.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button></div></td></tr></tbody></table></div><div print-remove class="btn-group pull-right"><button type="button" ng-if="vm.job.approved && vm.isManager()" ng-click="vm.toggleApproved()" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-minus-sign"></span> <span class="hidden-xs">Disapprove</span></button> <button type="button" ng-if="!vm.job.approved && vm.isManager()" ng-click="vm.toggleApproved()" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-ok-sign"></span> <span class="">Approve</span></button> <button type="submit" ng-if="(vm.job.approved && vm.canEdit(vm.job) && !(vm.events.length > 0))" ng-disabled="vm.sponsors.length < 1" ui-sref="job-inproduction({id:vm.job.id})" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-right"></span> <span class="">Move to Production</span></button></div></div>');
$templateCache.put('app/entities/job/job-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myJobLabel">Create or Edit Project Proposal</h4></div><div class="modal-body"><form id="job-edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" ng-show="vm.job.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.job.id" readonly="readonly"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.job.puid" for="field_puid">PUID</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.job.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"></div></div><div class="form-group"><label class="control-label" for="field_title">Project Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.job.title" required="required"><div ng-show="editForm.title.$invalid"><p class="text-danger" ng-show="editFormLocation.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.job.description" for="field_description">Description</label><textarea class="form-control" name="description" id="field_description" ng-model="vm.job.description" required="required" rows="6"></textarea><div ng-show="editForm.description.$invalid"><p class="text-danger" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><div class="col-md-6"><label class="control-label" for="field_startDate">Event Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" datetime-picker="{{dateformat}}" ng-model="vm.job.startDate" is-open="vm.datePickerOpenStatus.startDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><p class="help-block">Please enter a start date</p></div><div class="col-md-6"><label class="control-label" for="field_dueDate">Report Due Date</label><div class="input-group"><input id="field_dueDate" type="text" class="form-control" name="reportDueDate" datetime-picker="{{dateformat}}" datepicker-options="vm.datePickerOptions" ng-model="vm.job.reportDueDate" is-open="vm.datePickerOpenStatus.reportDueDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'reportDueDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><p class="help-block">Please enter a film due date</p></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_price">Project Proposed Price (GBP \xA3)</label><input id="field_price" type="number" step="any" class="form-control" name="field_price" min="0" ng-model="vm.job.projectPrice" required="required"><div ng-show="editForm.field_price.$invalid"><p class="text-danger">This field is required, only positive values are allowed.</p></div></div><div class="col-md-6"><label class="control-label">Check pricing strategy</label><div class="button-wrapper"><button class="btn btn-info" ui-sref="job-estimator"><span class="glyphicon glyphicon-blackboard"></span> <span class="hidden-xs">Cost Estimator</span></button></div></div></div><div class="form-group"><label class="control-label" for="field_editorial_storyline">Editorial Story Line</label><textarea class="form-control" name="editorialStoryline" id="field_editorial_storyline" ng-model="vm.job.editorialStoryline" ng-maxlength="1000" rows="4"></textarea><div ng-show="editForm.editorialStoryline.$invalid"><p class="text-danger" ng-show="editForm.editorialStoryline.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_key_talent">Key Talent(s)</label><textarea class="form-control" name="keytalent" id="field_key_talent" ng-model="vm.job.keyTalent" ng-maxlength="1000" rows="5"></textarea><div ng-show="editForm.keytalent.$invalid"><p class="text-danger" ng-show="editForm.keytalent.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" for="social_media">Social Media</label><textarea class="form-control" name="socialMedia" id="social_media" placeholder="Facebook, Instagram, Twitter, etc" ng-model="vm.job.socialMedia" ng-maxlength="400" rows="4"></textarea><div ng-show="editForm.socialMedia.$invalid"><p class="text-danger" ng-show="editForm.socialMedia.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="400">This field cannot be longer than 400 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_website">Weblink</label><input type="text" class="form-control" name="weblink" id="field_website" ng-model="vm.job.weblink" ng-maxlength="100" placeholder="http(s)://"><div ng-show="editForm.weblink.$invalid"><p class="text-danger" ng-show="editForm.weblink.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><!-- <p class="help-block" ng-show="editForm.weblink.$error.url"\n            translate="global.messages.validate.url.invalid">\n            Your URL link is invalid.\n          </p> --></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.job.contactName" for="field_contactName">Contact Name</label><input type="text" class="form-control" name="contactName" id="field_contactName" ng-model="vm.job.contactName"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.job.contactPhone" for="field_contactPhone">Contact Phone</label><input type="text" class="form-control" name="contactPhone" id="field_contactPhone" ng-maxlength="21" ng-pattern="vm.phoneRegex" ng-model="vm.job.contactPhone" placeholder="e.g. +440123456789"><div ng-show="editForm.contactPhone.$invalid"><p class="text-danger" ng-show="editForm.contactPhone.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="text-danger" ng-show="editForm.contactPhone.$error.pattern">Phone number is invalid. Please make sure there is no white spaces or braces.</p></div></div></div><div class="form-group"><div class="col-md-6"><label class="control-label" for="field_contact_email">Contact Email</label><input class="form-control" id="field_contact_email" name="email" ng-maxlength="100" ng-model="vm.job.contactEmail" type="email"><div ng-show="editForm.email.$invalid"><p class="text-danger" ng-show="editForm.email.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p><p class="text-danger" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="col-md-6"><label class="control-label" for="field_privacy">Show only to reporters internally <input class="form-control" id="field_privacy" name="privacy" ng-model="vm.job.privacy" type="checkbox"></label></div></div><div class="form-group"><h4>Categories</h4><label class="category-label" ng-repeat="category in vm.categories"><input type="checkbox" name="selectedCategories[]" value="{{category.name}}" ng-checked="vm.job.categories.indexOf(category.name) > -1" ng-click="vm.toggleCategory(category.name)"> {{category.display}}</label></div><div class="form-group" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><label class="control-label" for="field_approved">Approved</label><input class="form-control" id="field_approved" name="approved" ng-model="vm.job.approved" type="checkbox"><p class="help-block">Please tick to approve this Job</p></div><div class="form-group" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><label class="control-label" for="field_manager">Manager</label><select class="form-control" id="field_manager" name="manager" ng-model="vm.job.manager" ng-options="user as (user.firstName + \' \' + user.lastName) for user in vm.users track by user.id"><option value=""></option></select><p class="help-block">Please select a Manager for this Job</p></div><div class="form-group" ng-show="vm.job.claimed"><label class="control-label" for="field_claimed">Claimed</label><input class="form-control" id="field_claimed" name="claimed" ng-model="vm.job.claimed" type="checkbox" ng-disabled="true"><p class="help-block">The tick indicates whether this job has been claimed, e.g. has an owner</p></div><div class="form-group"><h4>Location</h4><tags-input ng-model="vm.tagLocation" max-tags="1" replace-spaces-with-dashes="false" on-tag-removed="vm.locationRemoved()" on-tag-added="vm.locationAdded()" display-property="title" key-property="id" placeholder="{{vm.tagLocation.length > 0 ? \' \' : \'Type to search for an existing location\'}}" add-from-autocomplete-only="true"><auto-complete source="vm.searchLocation($query)" min-length="3" max-results-to-show="10"></auto-complete></tags-input></div><p><strong>OR, create a new location below</strong></p></form><form id="location-edit-form" name="editFormLocation" role="form" novalidate ng-submit="vm.saveLocation()" show-validation><!-- <h4>Location</h4> --><div class="location-btn-group clearfix"><!-- search/go to current location --><div class="col-lg-6"><div class="input-group"><input type="text" ng-model="vm.search" class="form-control" placeholder="Search for an address or place"><div class="input-group-btn"><button class="btn btn-primary" type="button" ng-click="vm.geoCode()" ng-disabled="vm.search.length == 0 || vm.tagLocation.length > 0" title="search"><span class="glyphicon glyphicon-search"></span>&nbsp;<span>Find Location</span></button></div><!-- <button class="btn" type="button" ng-click="gotoCurrentLocation()" title="current location">\n                &nbsp;<span class="glyphicon glyphicon-home"></span>\n              </button> --></div></div><div class="col-lg-6"><button type="submit" ng-disabled="editFormLocation.$invalid || vm.isSaving || vm.location.id" class="btn btn-info" form="location-edit-form"><span class="glyphicon glyphicon-map-marker"></span>&nbsp;<span>Save Location</span></button></div></div><h5>Give location a name</h5><div class="location-btn-group clearfix"><!-- <label class="control-label" for="field_location_title">Location name</label> --><div class="col-lg-6"><input type="text" class="form-control" name="title" id="field_location_title" ng-model="vm.location.title" required><!-- <div ng-show="editFormLocation.title.$invalid">\n          <p class="help-block"\n              ng-show="editFormLocation.title.$error.required" translate="entity.validation.required">\n              This field is required.\n          </p>\n        </div> --></div><div class="col-lg-6"><button type="button" ng-disabled="editFormLocation.$invalid || vm.isSaving" class="btn btn-info" ng-click="vm.clearLocation()"><span class="glyphicon glyphicon-trash"></span>&nbsp;<span>Clear Location</span></button></div></div><div class="row hidden"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_latitude">Latitude</label><input type="number" class="form-control" name="latitude" id="field_latitude" ng-model="vm.location.geoPoint.lat" required readonly="readonly"><div ng-show="editFormLocation.latitude.$invalid"><p class="text-danger" ng-show="editFormLocation.latitude.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_longitude">Longitude</label><input type="number" class="form-control" name="longitude" id="field_longitude" ng-model="vm.location.geoPoint.lon" required readonly="readonly"><div ng-show="editFormLocation.longitude.$invalid"><p class="text-danger" ng-show="editFormLocation.longitude.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="map-holder"><p>Please <b>click</b> on the <i>Map</i> to give precise location or search for an <i>address</i> or a <i>place</i>!</p><div ng-if="vm.location.geoPoint.lat && vm.location.geoPoint.lon"><ng-map zoom="17" center="[{{vm.location.geoPoint.lat}}, {{vm.location.geoPoint.lon}}]" on-click="vm.addMarker()"><marker position="[{{vm.location.geoPoint.lat}}, {{vm.location.geoPoint.lon}}]" title="{{vm.location.title}}" centered="true"></marker></ng-map></div><div ng-if="!vm.location.geoPoint.lat || !vm.location.geoPoint.lon"><ng-map default-style="true" center="current-location" zoom="16" on-click="vm.addMarker()"></ng-map></div></div></form><div class="file-holder"><div ng-if="!vm.job.thumbnail" id="field_videoFile"><h4>Project Thumbnail</h4><button type="file" class="btn btn-primary" ng-disabled="(editForm.$invalid || vm.isSaving) && !vm.errFile" ngf-select="vm.uploadFile($file, $invalidFiles)" ngf-accept="\'image/jpeg,image/png\'" ngf-max-size="5MB" ngf-min-width="48"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button><div ng-show="vm.errFile.$error"><span style="font-size:smaller">{{vm.errFile.name}}</span><p class="alert-danger" ng-show="vm.errFile.$error == \'minWidth\'">Minimum image width should be 48px</p><p class="alert-danger" ng-show="vm.errFile.$error == \'maxSize\'">Maximum image size permitted is 5MB</p></div><span style="font-size:smaller">{{vm.f.name}}</span> <span class="progress" ng-show="vm.f.progress >= 0"><div ng-style="{width: vm.f.progress + \'%\'}" ng-bind="vm.f.progress + \'%\'"></div></span><p>{{vm.errorMsg}}</p></div><div ng-if="vm.job.thumbnail"><h4>Project Thumbnail</h4><button type="button" ng-click="vm.deleteThumbnail()" class="btn btn-danger"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete Thumbnail</span></button><hr><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Event Thumbnail"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" form="job-edit-form"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save Proposal</span></button></div>');
$templateCache.put('app/entities/job/job-estimator.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Estimate Project Cost</h4></div><div class="modal-body"><form id="estimate-form" class="form-horizontal" name="estimateForm" ng-submit="vm.calculate()"><div class="form-group"><label for="reporter" class="col-sm-4 control-label">Project Price (\xA3)</label><div class="col-sm-5"><input class="form-control" type="number" name="project_price" step="any" min="0" ng-model="vm.projectPrice" ng-change="vm.calculate()" required></div><div class="col-sm-3"><strong>Each (\xA3)</strong></div></div><div class="form-group"><label for="reporter" class="col-sm-4 control-label">Reporter (18.75%)</label><div class="col-sm-5"><select class="form-control" id="reporter" ng-model="vm.numReporters" ng-options="num as num for num in vm.numTeam" ng-change="vm.calculate()"></select></div><div class="col-sm-3"><span>{{vm.eachReporter}}</span></div></div><div class="form-group"><label for="videographer" class="col-sm-4 control-label">Videographer (18.75%)</label><div class="col-sm-5"><select class="form-control" id="videographer" ng-model="vm.numVideographers" ng-options="num as num for num in vm.numTeam" ng-change="vm.calculate()"></select></div><div class="col-sm-3"><span>{{vm.eachVideographer}}</span></div></div><div class="form-group"><label for="editor" class="col-sm-4 control-label">Editor (18.75%)</label><div class="col-sm-5"><select class="form-control" id="editor" ng-model="vm.numEditors" onkeypress="" ng-options="num as num for num in vm.numTeam" ng-change="vm.calculate()"></select></div><div class="col-sm-3"><span>{{vm.eachEditor}}</span></div></div><div class="form-group"><label for="finder" class="col-sm-4 control-label">Finder (18.75%)</label><div class="col-sm-5"><select class="form-control" id="finder" ng-model="vm.numFinders" ng-options="num as num for num in vm.numTeam" ng-change="vm.calculate()"></select></div><div class="col-sm-3"><span>{{vm.eachFinder}}</span></div></div><div class="form-group"><label for="winkball" class="col-sm-4 control-label">WinkBall (25%)</label><div class="col-sm-5"><input class="form-control" type="number" name="winkball" value="1" required ng-readonly="true"></div><div class="col-sm-3"><span>{{vm.winkball}}</span></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.reset()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Reset</span></button> <button type="button" class="btn btn-default" ng-disabled="estimateForm.$invalid" form="estimate-form" ng-click="vm.clear()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Close</span></button></div>');
$templateCache.put('app/entities/job/job-inproduction-dialog.html','<form name="inproductionForm" ng-submit="vm.confirmMove()"><div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm move to Production</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to move this Project Proposal into Production?</p></div><div class="modal-footer bkg-wb-yellow"><button type="button" class="btn btn-default rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid || vm.isSaving" class="btn btn-danger rounded-0"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span>Move to Production</span></button></div></form>');
$templateCache.put('app/entities/job/jobs.html','<div><form name="filterForm" class="pull-right form-inline"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="filter1">All</label><input id="filter1" type="radio" value="all" ng-model="vm.filter" ng-change="vm.setFilter()"><label for="filter6">Mine</label><input id="filter6" type="radio" value="mine" ng-model="vm.filter" ng-change="vm.setFilter()"></div><div class="form-group"><label for="filter7" class="btn btn-default bkg-proposal rounded-0"><input id="filter7" type="checkbox" value="PROPOSAL" ng-checked="vm.statuses.indexOf(\'PROPOSAL\') > -1" ng-click="vm.setStatus(\'PROPOSAL\')"> Proposal</label></div><div class="form-group"><label for="filter2" class="btn btn-default bkg-in-production rounded-0"><input id="filter2" type="checkbox" value="IN_PRODUCTION" ng-checked="vm.statuses.indexOf(\'IN_PRODUCTION\') > -1" ng-click="vm.setStatus(\'IN_PRODUCTION\')"> In-Production</label></div><div class="form-group"><label for="filter3" class="btn btn-default bkg-ready-to-film rounded-0"><input id="filter3" type="checkbox" value="READY_TO_FILM" ng-checked="vm.statuses.indexOf(\'READY_TO_FILM\') > -1" ng-click="vm.setStatus(\'READY_TO_FILM\')"> Ready To Film</label></div><div class="form-group"><label for="filter4" class="btn btn-default bkg-awaiting-signoff rounded-0"><input id="filter4" type="checkbox" value="AWATING_SIGN_OFF" ng-checked="vm.statuses.indexOf(\'AWATING_SIGN_OFF\') > -1" ng-click="vm.setStatus(\'AWATING_SIGN_OFF\')"> Awaiting Sign Off</label></div><div class="form-group"><label for="filter5" class="btn btn-default completed rounded-0"><input id="filter5" type="checkbox" value="COMPLETED" ng-checked="vm.statuses.indexOf(\'COMPLETED\') > -1" ng-click="vm.setStatus(\'COMPLETED\')"> Completed</label></div></form><h2>Projects</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-2 col-sm-4 no-padding-left"><button class="btn btn-success rounded-0" ui-sref="job.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs hidden-sm">Propose a story or idea for a report</span></button></div><div class="col-xs-10 col-sm-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.job.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs hidden-sm">Logo</th><th jh-sort-by="title"><span>Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="startDate"><span translate="winkballApp.job.startDate">Start Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="reportDueDate"><span>Due Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="approved"><span>Approved</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="job in vm.jobs track by job.id"><td><a ui-sref="job-detail({id:job.id})">{{job.id}}</a></td><td class="hidden-xs hidden-sm"><div class="img-container list-thumbnail"><img ng-if="job.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{vm.getImageSrc(job.thumbnail) | trustURL}}" alt="Thumbnail"> <img ng-if="!job.thumbnail" class="img-responsive" ng-src="{{\'content/images/noperson.png\'}}" alt="Thumbnail"> <span class="img-overlay" ng-if="!job.claimed">Awaiting Sponsor</span> <span class="img-overlay sponsored" ng-if="job.claimed">Sponsored</span></div></td><td>{{job.title}}</td><td>{{job.startDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{job.reportDueDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td class="text-center"><span class="label label-danger" ng-click="vm.setApproved(job, true)" ng-show="!job.approved"><span class="glyphicon glyphicon-minus-sign"></span> </span><span class="label label-success" ng-click="vm.setApproved(job, false)" ng-show="job.approved"><span class="glyphicon glyphicon-ok-sign"></span></span></td><!-- <td class="text-center">\n                      <span class="label label-danger" ng-show="!job.claimed">\n                        <span class="glyphicon glyphicon-gbp"></span>\n                      </span>\n                      <span class="label label-success" ng-show="job.claimed">\n                        <span class="glyphicon glyphicon-gbp"></span>\n                      </span>\n                    </td> --><td class="text-right"><div class="btn-group flex-btn-group-container status-btn-group"><button type="submit" ng-if="job.reportStatus !== \'CANCELLED\'" ng-disabled="job.reportStatus !== \'PROPOSAL\'" ui-sref="job-detail({id:job.id})" ng-disabled="vm.inTransit" class="btn btn-default bkg-proposal rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">Proposal</span></button> <button type="submit" ng-if="job.reportStatus !== \'CANCELLED\'" ng-disabled="job.reportStatus !== \'IN_PRODUCTION\'" ng-click="vm.goToReport(job.id)" ng-disabled="vm.inTransit" class="btn btn-default bkg-in-production rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">In-Production</span></button> <button type="submit" ng-if="job.reportStatus !== \'CANCELLED\'" ng-disabled="job.reportStatus !== \'READY_TO_FILM\'" ng-click="vm.goToReport(job.id)" ng-disabled="vm.inTransit" class="btn btn-default bkg-ready-to-film rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">Ready To Film</span></button> <button type="submit" ng-if="job.reportStatus !== \'CANCELLED\'" ng-disabled="job.reportStatus !== \'AWATING_SIGN_OFF\'" ng-click="vm.goToReport(job.id)" ng-disabled="vm.inTransit" class="btn btn-default bkg-awaiting-signoff rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">Awaiting Sign Off</span></button> <button type="submit" ng-if="job.reportStatus !== \'CANCELLED\'" ng-disabled="job.reportStatus !== \'COMPLETED\'" ng-click="vm.goToReport(job.id)" ng-disabled="vm.inTransit" class="btn btn-default completed rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">Completed</span></button> <button type="submit" ng-if="job.reportStatus === \'CANCELLED\'" ng-click="vm.goToReport(job.id)" ng-disabled="vm.inTransit" class="btn btn-default bkg-cancelled rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">Cancelled</span></button> <button type="submit" ng-if="vm.canDelete()" ui-sref="job.delete({id:job.id})" ng-disabled="vm.inTransit" class="btn btn-danger rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/location/location-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.location.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.location.delete.question" translate-values="{id: \'{{vm.location.id}}\'}">Are you sure you want to delete this Location?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/location/location-detail.html','<div><button type="submit" ng-click="vm.back()" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back">Back</span></button> <button type="button" ui-sref="location-detail.edit({id:vm.location.id})" class="btn btn-success btn-lg rounded-0" ng-disabled="!vm.canEdit()"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button><h2><span translate="winkballApp.location.detail.title">Location</span> : {{vm.location.title}}</h2><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="global.field.id">ID</span></dt><dd><span>{{vm.location.id}}</span></dd><dt><span translate="winkballApp.location.createdDate">Created Date</span></dt><dd><span>{{vm.location.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span translate="winkballApp.location.latitude">Latitude</span></dt><dd><span>{{vm.location.geoPoint.lat}}</span></dd><dt><span translate="winkballApp.location.longitude">Longitude</span></dt><dd><span>{{vm.location.geoPoint.lon}}</span></dd><dt><span>Created By</span></dt><dd>{{vm.location.createdBy}}</dd></dl><div class="map-holder" ng-show="vm.location.geoPoint.lon && vm.location.geoPoint.lat"><ng-map zoom="16" center="[{{vm.location.geoPoint.lat}}, {{vm.location.geoPoint.lon}}]"><marker position="[{{vm.location.geoPoint.lat}}, {{vm.location.geoPoint.lon}}]" title="{{vm.location.title}}" centered="true"></marker></ng-map></div></div>');
$templateCache.put('app/entities/location/location-dialog.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLocationLabel" translate="winkballApp.location.home.createOrEditLabel">Create or edit a Location</h4></div><div class="modal-body"><form id="location-edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" has-any-authority="ROLE_ADMIN" ng-show="vm.location.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.location.id" readonly="readonly"></div><div class="col-md-6" ng-show="vm.location.puid"><label class="control-label" translate="winkballApp.location.puid" for="field_puid">Puid</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.location.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"><div ng-show="editForm.puid.$invalid"><p class="help-block" ng-show="editForm.puid.$error.minlength" translate="entity.validation.minlength" translate-value-min="12">This field is required to be at least 12 characters.</p><p class="help-block" ng-show="editForm.puid.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="12">This field cannot be longer than 12 characters.</p></div></div></div><div class="form-group"><label class="control-label" translate="winkballApp.location.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.location.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="row" has-any-authority="ROLE_ADMIN"><div class="col-lg-6"><div class="form-group"><label class="control-label" translate="winkballApp.location.latitude" for="field_latitude">Latitude</label><input type="number" class="form-control" name="latitude" id="field_latitude" ng-model="vm.location.geoPoint.lat" required><div ng-show="editForm.latitude.$invalid"><p class="help-block" ng-show="editForm.latitude.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" translate="winkballApp.location.longitude" for="field_longitude">Longitude</label><input type="number" class="form-control" name="longitude" id="field_longitude" ng-model="vm.location.geoPoint.lon" required><div ng-show="editForm.longitude.$invalid"><p class="help-block" ng-show="editForm.longitude.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="map-holder"><p>Please <b>click</b> on the <i>Map</i> to select location coordinates or search for an <i>address</i> or a <i>place</i>!</p><div ng-if="vm.location.geoPoint.lat && vm.location.geoPoint.lon"><ng-map zoom="17" center="[{{vm.location.geoPoint.lat}}, {{vm.location.geoPoint.lon}}]" on-click="vm.addMarker()"><marker position="[{{vm.location.geoPoint.lat}}, {{vm.location.geoPoint.lon}}]" title="{{vm.location.title}}" centered="true"></marker></ng-map></div><div ng-if="!vm.location.geoPoint.lat || !vm.location.geoPoint.lon"><ng-map default-style="true" center="current-location" zoom="16" on-click="vm.addMarker()"></ng-map></div></div></form></div><div class="modal-footer bkg-wb-yellow"><div class="row"><!-- search/go to current location --><div class="col-lg-6"><div class="input-group rounded-0"><input type="text" ng-model="vm.search" class="form-control rounded-0"><div class="input-group-btn"><button class="btn btn-default rounded-0" type="button" ng-click="vm.geoCode()" ng-disabled="vm.search.length == 0" title="search"><span class="glyphicon glyphicon-search"></span>&nbsp;<span>Address</span></button></div><!-- <button class="btn" type="button" ng-click="gotoCurrentLocation()" title="current location">\n              &nbsp;<span class="glyphicon glyphicon-home"></span>\n            </button> --></div></div><div class="col-lg-6"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-default rounded-0" form="location-edit-form"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></div></div>');
$templateCache.put('app/entities/location/locations.html','<div><h2 translate="winkballApp.location.home.title">Locations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary rounded-0" ui-sref="location.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.location.home.createLabel">Create new Location</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.location.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span translate="winkballApp.location.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><!-- <th jh-sort-by="puid"><span translate="winkballApp.location.puid">Puid</span> <span class="glyphicon glyphicon-sort"></span></th> --><th jh-sort-by="createdDate"><span translate="winkballApp.location.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="longitude"><span translate="winkballApp.location.longitude">Longitude</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="latitude"><span translate="winkballApp.location.latitude">Latitude</span> <span class="glyphicon glyphicon-sort"></span></th><!-- <th jh-sort-by="owner.login"><span translate="winkballApp.location.owner">Owner</span> <span class="glyphicon glyphicon-sort"></span></th> --><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="location in vm.locations track by location.id"><td><a ui-sref="location-detail({id:location.id})">{{location.id}}</a></td><td>{{location.title}}</td><!-- <td>{{location.puid}}</td> --><td>{{location.createdDate | date:\'dd/MM/yyyy\'}}</td><td>{{location.geoPoint.lon}}</td><td>{{location.geoPoint.lat}}</td><!-- <td>\n                        {{location.owner.login}}\n                    </td> --><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="location-detail({id:location.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ng-disabled="!vm.canEdit(location)" ui-sref="location.edit({id:location.id})" class="btn btn-success btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ng-disabled="!vm.canDelete()" ui-sref="location.delete({id:location.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/media-package/media-package-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.mediaPackage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.mediaPackage.delete.question" translate-values="{id: \'{{vm.mediaPackage.id}}\'}">Are you sure you want to delete this Media Package?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/media-package/media-package-detail.html','<div><button type="submit" ng-click="vm.back()" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="media-package-detail.edit({id:vm.mediaPackage.id})" class="btn btn-success btn-lg rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button><h2><span>Media Package</span> {{vm.mediaPackage.id}}</h2><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><!-- <dt><span translate="winkballApp.mediaPackage.instructions">Instructions</span></dt>\n      <dd>\n        <span>{{vm.mediaPackage.instructions}}</span>\n      </dd> --><!-- <dt><span translate="global.field.createdBy">Created By</span></dt>\n      <dd>\n        <a ui-sref="user-management-detail({login: vm.mediaPackage.createdBy})">{{vm.mediaPackage.createdBy}}</a>\n      </dd> --><dt><span translate="global.field.createdDate">Created Date</span></dt><dd><span>{{vm.mediaPackage.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span>Report</span></dt><dd><a ui-sref="report-detail({id:vm.mediaPackage.eventId})">{{vm.mediaPackage.eventId}}</a></dd></dl><h3 ng-if="vm.mediaPackage.sponsorDetails">Sponsor Details</h3><dl class="dl-horizontal jh-entity-details" ng-if="vm.mediaPackage.sponsorDetails"><dt><span>Sponsor Name</span></dt><dd><span>{{vm.mediaPackage.sponsorDetails.name}}</span></dd><!-- <dt><span>Description</span></dt>\n        <dd>\n            <span>{{vm.mediaPackage.sponsorDetails.description}}</span>\n        </dd> --><dt><span>Call to action</span></dt><dd><span>{{vm.mediaPackage.title}}</span></dd><dt><span>Website</span></dt><dd><span>{{vm.mediaPackage.sponsorDetails.website}}</span></dd><!-- <dt><span>Email</span></dt>\n        <dd>\n            <span>{{vm.mediaPackage.sponsorDetails.email}}</span>\n        </dd>\n        <dt><span>Telephone</span></dt>\n        <dd>\n            <span>{{vm.mediaPackage.sponsorDetails.telephone}}</span>\n        </dd> --><dt><span>Twitter</span></dt><dd><span>{{vm.mediaPackage.sponsorDetails.twitter}}</span></dd><dt><span>Facebook</span></dt><dd><span>{{vm.mediaPackage.sponsorDetails.facebook}}</span></dd><dt><span>Youtube</span></dt><dd><span>{{vm.mediaPackage.sponsorDetails.youtube}}</span></dd><dt><span>Instagram</span></dt><dd><span>{{vm.mediaPackage.sponsorDetails.instagram}}</span></dd><dt><span>Snapchat</span></dt><dd><span>{{vm.mediaPackage.sponsorDetails.snapchat}}</span></dd><!-- <dt><span>Address</span></dt>\n        <dd>\n            <span>{{vm.mediaPackage.sponsorDetails.address}}</span>\n        </dd> --><!-- <dt><span>Sponsor PUID</span></dt>\n        <dd>\n            <span>{{vm.mediaPackage.sponsorDetails.logo}}</span>\n        </dd> --></dl><div ng-if="vm.mediaPackage.sponsorDetails.logo"><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Sponsor Ident"></div><!-- <a class="btn btn-primary" ng-href="https://streams2.winkball.com/files/{{vm.mediaPackage.puid}}/download">Download File</a> --></div>');
$templateCache.put('app/entities/media-package/media-package-dialog.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMediaPackageLabel">Create or edit a Media Package</h4></div><div class="modal-body"><form name="editForm" id="mediaPackageEditForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" ng-show="vm.mediaPackage.id" has-any-authority="ROLE_ADMIN"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.mediaPackage.id" readonly="readonly"></div><div class="col-md-6" ng-show="vm.mediaPackage.puid"><label class="control-label" translate="winkballApp.mediaPackage.puid" for="field_puid">Puid</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.mediaPackage.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"></div></div><div class="form-group"><label for="field_event">Event</label><select class="form-control" id="field_event" name="event" ng-model="vm.mediaPackage.eventId" ng-options="event.id as event.title for event in vm.events" ng-disabled="vm.mediaPackage.id"></select></div><p class="text-danger">Note: below information will be publicly available on the website! Please check with sponsor what they want to display!</p><div class="form-group"><label class="control-label" for="field_name">Sponsor Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.mediaPackage.sponsorDetails.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_title">Call to Action Message <span class="text-danger">(appears on the videocard)</span></label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.mediaPackage.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><!-- <div class="form-group clearfix">\n          <div class="col-md-6">\n            <label class="control-label" for="field_sponsor_email">Email</label>\n            <input\n                class="form-control"\n                id="field_sponsor_email"\n                name="email"\n                ng-maxlength="100"\n                ng-model="vm.mediaPackage.sponsorDetails.email"\n                type="email"/>\n            <div ng-show="editForm.email.$invalid">\n                <p\n                    class="help-block"\n                    ng-show="editForm.email.$error.maxlength"\n                    translate-value-max="100"\n                    translate="entity.validation.maxlength">\n                    This field cannot be longer than 100 characters.</p>\n                <p\n                    class="help-block"\n                    ng-show="editForm.email.$error.email"\n                    translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p>\n            </div>\n          </div>\n          <div class="col-md-6">\n            <label class="control-label" for="field_sponsor_telephone">Telephone</label>\n            <input\n                class="form-control"\n                id="field_sponsor_telephone"\n                name="telephone"\n                ng-maxlength="100"\n                ng-model="vm.mediaPackage.sponsorDetails.telephone"\n                type="text"/>\n            <div ng-show="editForm.telephone.$invalid">\n                <p\n                    class="help-block"\n                    ng-show="editForm.telephone.$error.maxlength"\n                    translate-value-max="100"\n                    translate="entity.validation.maxlength">\n                    This field cannot be longer than 100 characters.</p>\n            </div>\n          </div>\n        </div> --><!-- <div class="form-group">\n            <label class="control-label" for="field_sponsor_address">Address</label>\n            <input\n                class="form-control"\n                id="field_sponsor_address"\n                name="address"\n                ng-model="vm.mediaPackage.sponsorDetails.address"\n                type="text"/>\n            <p class="help-block">Please enter a comma separated postal address, e.g. 50\n                Kendal Close, Newham, E15 1SS</p>\n        </div> --><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_sponsor_website">Website</label><input class="form-control" id="field_sponsor_website" name="website" ng-maxlength="100" ng-model="vm.mediaPackage.sponsorDetails.website" type="text"><div ng-show="editForm.website.$invalid"><p class="help-block" ng-show="editForm.website.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p></div></div><div class="col-md-6"><label class="control-label" for="field_sponsor_snapchat">Snapchat</label><input class="form-control" id="field_sponsor_snapchat" name="snapchat" ng-maxlength="150" ng-model="vm.mediaPackage.sponsorDetails.snapchat" type="text"><div ng-show="editForm.snapchat.$invalid"><p class="help-block" ng-show="editForm.snapchat.$error.maxlength" translate-value-max="150" translate="entity.validation.maxlength">This field cannot be longer than 150 characters.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_sponsor_twitter">Twitter</label><input class="form-control" id="field_sponsor_twitter" name="twitter" ng-maxlength="100" ng-model="vm.mediaPackage.sponsorDetails.twitter" type="text"><div ng-show="editForm.twitter.$invalid"><p class="help-block" ng-show="editForm.twitter.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p></div></div><div class="col-md-6"><label class="control-label" for="field_sponsor_facebook">Facebook</label><input class="form-control" id="field_sponsor_facebook" name="facebook" ng-maxlength="150" ng-model="vm.mediaPackage.sponsorDetails.facebook" type="text"><div ng-show="editForm.facebook.$invalid"><p class="help-block" ng-show="editForm.facebook.$error.maxlength" translate-value-max="150" translate="entity.validation.maxlength">This field cannot be longer than 150 characters.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_sponsor_youtube">Youtube</label><input class="form-control" id="field_sponsor_youtube" name="youtube" ng-maxlength="150" ng-model="vm.mediaPackage.sponsorDetails.youtube" type="text"><div ng-show="editForm.youtube.$invalid"><p class="help-block" ng-show="editForm.youtube.$error.maxlength" translate-value-max="150" translate="entity.validation.maxlength">This field cannot be longer than 150 characters.</p></div></div><div class="col-md-6"><label class="control-label" for="field_sponsor_instagram">Instagram</label><input class="form-control" id="field_sponsor_instagram" name="instagram" ng-maxlength="150" ng-model="vm.mediaPackage.sponsorDetails.instagram" type="text"><div ng-show="editForm.instagram.$invalid"><p class="help-block" ng-show="editForm.instagram.$error.maxlength" translate-value-max="150" translate="entity.validation.maxlength">This field cannot be longer than 150 characters.</p></div></div></div></form><div class="file-holder"><div id="field_logo" ng-if="!vm.mediaPackage.sponsorDetails.logo"><h4>Sponsor\'s Logo</h4><button ngf-accept="\'image/*\'" class="btn btn-primary" ng-disabled="(editForm.$invalid || vm.isSaving) && !errFile" ngf-max-size="5MB" ngf-min-height="90" ngf-min-width="160" ngf-select="uploadFile($file, $invalidFiles, true)" type="file"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button><div ng-show="errFile.$error && image"><span style="font-size: smaller">{{errFile.name}}</span><p class="alert-danger" ng-show="errFile.$error == \'minHeight\'">Minimum image height should be 90px</p><p class="alert-danger" ng-show="errFile.$error == \'minWidth\'">Minimum image width should be 160px</p><p class="alert-danger" ng-show="errFile.$error == \'maxSize\'">Maximum image size permitted is 5MB</p></div><span ng-show="image" style="font-size: smaller">{{f.name}}</span> <span class="progress" ng-show="f.progress >= 0 && image"><div ng-bind="f.progress + \'%\'" style="width: {{f.progress}}%"></div></span><p>{{errorMsg}}</p></div><div ng-if="vm.mediaPackage.sponsorDetails.logo"><h4>Sponsor\'s Logo</h4><button class="btn btn-danger" ng-click="vm.deleteLogo()" type="button"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete Logo</span></button><hr><img alt="Sponsor Logo" class="img-responsive" ng-src="{{vm.getImageSrc(vm.mediaPackage.sponsorDetails.logo) | trustURL}}"></div><div id="field_poster" ng-if="!vm.mediaPackage.poster"><h4>Sponsor\'s Splash Screen</h4><button ngf-accept="\'image/jpeg,image/png\'" class="btn btn-primary" ng-disabled="(editForm.$invalid || vm.isSaving) && !errFile" ngf-max-size="5MB" ngf-min-height="720" ngf-min-width="1280" ngf-select="uploadFile($file, $invalidFiles, false, true)" type="file"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button><div ng-show="errFile.$error && image"><span style="font-size: smaller">{{errFile.name}}</span><p class="alert-danger" ng-show="errFile.$error == \'minHeight\'">Minimum image height should be 720px</p><p class="alert-danger" ng-show="errFile.$error == \'minWidth\'">Minimum image width should be 1280px</p><p class="alert-danger" ng-show="errFile.$error == \'maxSize\'">Maximum image size permitted is 5MB</p></div><span ng-show="poster" style="font-size: smaller">{{f.name}}</span> <span class="progress" ng-show="f.progress >= 0 && poster"><div ng-bind="f.progress + \'%\'" style="width: {{f.progress}}%"></div></span><p>{{errorMsg}}</p></div><div ng-if="vm.mediaPackage.poster"><h4>Sponsor\'s Splash Screen</h4><button class="btn btn-danger" ng-click="vm.deletePoster()" type="button"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete Poster</span></button><hr><img alt="Splash Screen" class="img-responsive" ng-src="{{vm.getImageSrc(vm.mediaPackage.poster) | trustURL}}"></div><div id="field_videoFile" ng-if="!vm.mediaPackage.videoFileGuid"><h4>Sponsor\'s Video Advert</h4><button accept="video/mp4" class="btn btn-primary" ng-disabled="editForm.$invalid || vm.isSaving" ngf-max-size="800MB" ngf-select="uploadFile($file, $invalidFiles, false, false, true)" type="file"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button> <span ng-show="video" style="font: smaller">{{f.name}} {{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}}</span> <span class="progress" ng-show="f.progress >= 0 && video"><div ng-bind="f.progress + \'%\'" style="width: {{f.progress}}%"></div></span><p>{{errorMsg}}</p></div><div ng-if="vm.mediaPackage.videoFileGuid"><h4>Sponsor\'s Video Advert</h4><button type="button" ng-click="vm.deleteVideo()" class="btn btn-danger"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete Video</span></button><hr><video controls="controls" ng-src="{{vm.getVideoSrc() | trustURL}}"></video></div><!-- <div ng-if="!vm.mediaPackage.puid" id="field_file">\n    <h4>Package File</h4>\n    <button type="file" class="btn btn-primary" ng-disabled="editForm.$invalid || vm.isSaving"\n      ngf-select="uploadFile($file, $invalidFiles, false)"\n      accept="application/zip" ngf-max-size="30MB">\n      <span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span>\n    </button>\n    <span ng-show="!image" style="font:smaller">{{f.name}} {{errFile.name}} {{errFile.$error}} {{errFile.$errorParam}}</span>\n    <span class="progress" ng-show="f.progress >= 0 && !image">\n      <div style="width:{{f.progress}}%" ng-bind="f.progress + \'%\'"></div>\n    </span>\n    <p>\n      {{errorMsg}}\n    </p>\n  </div>\n  <div ng-if="vm.mediaPackage.puid">\n    <h4>Package File</h4>\n    <button type="button" ng-click="vm.deleteFile()" class="btn btn-danger">\n      <span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete File</span>\n    </button>\n    <a class="btn btn-primary" ng-href="https://streams2.winkball.com/files/{{vm.mediaPackage.puid}}/download">Download File</a>\n  </div> --></div></div><div class="modal-footer bkg-wb-yellow"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-default rounded-0" form="mediaPackageEditForm"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/entities/media-package/media-packages.html','<div><h2>Reports Media Packages</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-success rounded-0" ui-sref="media-package.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Media Package</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.mediaPackage.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Sponsor Name</span></th><th jh-sort-by="title"><span>Call to action</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span translate="global.field.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdBy"><span translate="global.field.createdBy">Created By</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Report</span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="mediaPackage in vm.mediaPackages track by mediaPackage.id"><td><a ui-sref="media-package-detail({id:mediaPackage.id})">{{mediaPackage.id}}</a></td><td>{{mediaPackage.sponsorDetails.name}}</td><td>{{mediaPackage.title}}</td><td>{{mediaPackage.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td><a ui-sref="user-management-detail({login: mediaPackage.createdBy})">{{mediaPackage.createdBy}}</a></td><td><a ui-sref="report-detail({id:mediaPackage.eventId})">{{mediaPackage.eventId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="media-package-detail({id:mediaPackage.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="media-package.edit({id:mediaPackage.id})" class="btn btn-success btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="media-package.delete({id:mediaPackage.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/media-contact/media-contact-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.mediaContact.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.mediaContact.delete.question" translate-values="{id: \'{{vm.mediaContact.id}}\'}">Are you sure you want to delete this Media Contact?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/media-contact/media-contact-detail.html','<div><h2><span translate="winkballApp.mediaContact.detail.title">Media Package</span> {{vm.mediaContact.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.mediaContact.puid">PUID</span></dt><dd><span>{{vm.mediaContact.puid}}</span></dd><dt><span translate="winkballApp.mediaContact.category">Category</span></dt><dd><span>{{vm.mediaContact.category}}</span></dd><dt><span translate="winkballApp.mediaContact.name">Name</span></dt><dd><span>{{vm.mediaContact.name}}</span></dd><dt><span translate="winkballApp.mediaContact.contactName">Contact Name</span></dt><dd><span>{{vm.mediaContact.contactName}}</span></dd><dt><span translate="winkballApp.mediaContact.contactPhone">Contact Phone</span></dt><dd><span>{{vm.mediaContact.contactPhone}}</span></dd><dt><span translate="winkballApp.mediaContact.email">Email</span></dt><dd><span>{{vm.mediaContact.email}}</span></dd><dt><span translate="winkballApp.mediaContact.website">Website</span></dt><dd><a href="{{vm.mediaContact.website}}"><span>{{vm.mediaContact.website}}</span></a></dd><dt><span translate="winkballApp.mediaContact.facebook">Facebook</span></dt><dd><a href="{{vm.mediaContact.facebook}}"><span>{{vm.mediaContact.facebook}}</span></a></dd><dt><span translate="winkballApp.mediaContact.facebookFollowers">Facebook followers</span></dt><dd><span>{{vm.mediaContact.facebookFollowers}}</span></dd><dt><span translate="winkballApp.mediaContact.twitter">Twitter</span></dt><dd><a href="{{vm.mediaContact.twitter}}"><span>{{vm.mediaContact.twitter}}</span></a></dd><dt><span translate="winkballApp.mediaContact.twitterFollowers">Twitter followers</span></dt><dd><span>{{vm.mediaContact.twitterFollowers}}</span></dd><dt><span translate="global.field.createdBy">Created By</span></dt><dd><a ui-sref="user-management-detail({login: vm.mediaContact.createdBy})">{{vm.mediaContact.createdBy}}</a></dd><dt><span translate="global.field.createdDate">Created Date</span></dt><dd><span>{{vm.mediaContact.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span>Notes</span></dt><dd><span>{{vm.mediaContact.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="media-contact-detail.edit({id:vm.mediaContact.id})" class="btn btn-primary rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/media-contact/media-contact-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myWebLinkLabel" translate="winkballApp.mediaContact.home.createOrEditLabel">Create or edit a Media Contact</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.mediaContact.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.mediaContact.id" readonly="readonly"></div><div class="form-group" ng-show="vm.mediaContact.puid"><label class="control-label" translate="winkballApp.mediaContact.puid" for="field_puid">Puid</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.mediaContact.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="winkballApp.mediaContact.category" for="field_category">Category</label><select class="form-control" id="field_category" name="category" ng-model="vm.mediaContact.category" required><option value="Arts">Arts</option><option value="Business">Business</option><option value="Charities">Charities</option><option value="Critics">Critics</option><option value="Fashion">Fashion</option><option value="Food">Food</option><option value="LGBT">LGBT</option><option value="Music">Music</option><option value="Sport">Sport</option><option value="Theatre">Theatre</option><option value="Hotel / Travel">Hotel / Travel</option><option value="Wellbeing">Wellbeing</option><option value="Other">Other</option></select><div ng-show="editForm.category.$invalid"><p class="help-block" ng-show="editForm.category.$error.required" translate="entity.validation.required">This field is required.</p><!-- <p class="help-block"\n                    ng-show="editForm.title.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">\n                    This field cannot be longer than 150 characters.\n                </p> --></div></div><div class="form-group"><label class="control-label" translate="winkballApp.mediaContact.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.mediaContact.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.mediaContact.contactName" for="field_contactName">Contact Name</label><input type="text" class="form-control" name="contactName" id="field_contactName" ng-model="vm.mediaContact.contactName"></div><div class="form-group"><label class="control-label" translate="winkballApp.mediaContact.contactPhone" for="field_contactName">Contact Phone</label><input type="text" class="form-control" name="contactPhone" id="field_contactPhone" ng-model="vm.mediaContact.contactPhone"></div><div class="form-group"><label class="control-label" translate="winkballApp.mediaContact.email" for="field_email">Email</label><input type="email" class="form-control" id="field_email" name="email" ng-model="vm.mediaContact.email" ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.mediaContact.website" for="field_website">Website</label><input type="url" class="form-control" name="website" id="field_website" ng-model="vm.mediaContact.website" ng-maxlength="100"><div ng-show="editForm.website.$invalid"><p class="help-block" ng-show="editForm.website.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.website.$error.url" translate="global.messages.validate.url.invalid">Your URL link is invalid.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.mediaContact.facebook" for="field_facebook">Facebook</label><input type="url" class="form-control" name="facebook" id="field_facebook" ng-model="vm.mediaContact.facebook" ng-pattern="vm.facebookPattern"><div ng-show="editForm.facebook.$invalid"><p class="help-block" ng-show="editForm.facebook.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.facebook.$error.url" translate="global.messages.validate.url.invalid">Your URL link is invalid.</p><p class="help-block" ng-show="editForm.facebook.$error.pattern">Your Facebook link is invalid.</p></div></div><div class="form-group"><label class="control-label" for="field_facebookFollowers">Facebook followers</label><input type="number" class="form-control" name="facebookFollowers" id="field_facebookFollowers" ng-model="vm.mediaContact.facebookFollowers" step="any" min="0"></div><div class="form-group"><label class="control-label" translate="winkballApp.mediaContact.twitter" for="field_twitter">Twitter</label><input type="url" class="form-control" name="twitter" id="field_twitter" ng-model="vm.mediaContact.twitter" ng-pattern="vm.twitterPattern"><div ng-show="editForm.twitter.$invalid"><p class="help-block" ng-show="editForm.twitter.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.twitter.$error.url" translate="global.messages.validate.url.invalid">Your URL link is invalid.</p><p class="help-block" ng-show="editForm.twitter.$error.pattern">Your Twitter link is invalid.</p></div></div><div class="form-group"><label class="control-label" for="field_twitterFollowers">Twitter followers</label><input type="number" class="form-control" name="twitterFollowers" id="field_twitterFollowers" ng-model="vm.mediaContact.twitterFollowers" step="any" min="0"></div><div class="form-group"><label class="control-label" for="field_description">Notes</label><textarea type="text" class="form-control" name="description" id="field_description" ng-model="vm.mediaContact.description"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/media-contact/media-contacts.html','<div><h2>Media Contacts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary rounded-0" ui-sref="media-contact.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Media Contacts</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Search for Media Contact"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>PUID</span></th><th jh-sort-by="category"><span>Category</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span>Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span translate="global.field.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="mediaContact in vm.mediaContacts track by mediaContact.id"><td><a ui-sref="media-contact-detail({id:mediaContact.id})">{{mediaContact.id}}</a></td><td>{{mediaContact.puid}}</td><td>{{mediaContact.category}}</td><td>{{mediaContact.name}}</td><td>{{mediaContact.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{mediaContact.email}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="media-contact-detail({id:mediaContact.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="media-contact.edit({id:mediaContact.id})" class="btn btn-primary btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="media-contact.delete({id:mediaContact.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/postal-address/postal-address-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.postalAddress.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.postalAddress.delete.question" translate-values="{id: \'{{vm.postalAddress.id}}\'}">Are you sure you want to delete this Postal Address?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/postal-address/postal-address-detail.html','<div><h2><span translate="winkballApp.postalAddress.detail.title">Postal Address</span> {{vm.postalAddress.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.postalAddress.addressee">Addressee</span></dt><dd><span>{{vm.postalAddress.addressee}}</span></dd><dt><span translate="winkballApp.postalAddress.businessName">Business Name</span></dt><dd><span>{{vm.postalAddress.businessName}}</span></dd><dt><span translate="winkballApp.postalAddress.firlstLineOfAddress">First Line Of Address</span></dt><dd><span>{{vm.postalAddress.firlstLineOfAddress}}</span></dd><dt><span translate="winkballApp.postalAddress.secondLineOfAddress">Second Line Of Address</span></dt><dd><span>{{vm.postalAddress.secondLineOfAddress}}</span></dd><dt><span translate="winkballApp.postalAddress.town">Town</span></dt><dd><span>{{vm.postalAddress.town}}</span></dd><dt><span translate="winkballApp.postalAddress.county">County</span></dt><dd><span>{{vm.postalAddress.county}}</span></dd><dt><span translate="winkballApp.postalAddress.postCode">Post Code</span></dt><dd><span>{{vm.postalAddress.postCode}}</span></dd><dt><span translate="winkballApp.postalAddress.country">Country</span></dt><dd><span>{{vm.postalAddress.country}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="postal-address-detail.edit({id:vm.postalAddress.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/postal-address/postal-address-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPostalAddressLabel" translate="winkballApp.postalAddress.home.createOrEditLabel">Create or edit a Postal Address</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.postalAddress.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.postalAddress.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="winkballApp.postalAddress.addressee" for="field_addressee">Addressee</label><input type="text" class="form-control" name="addressee" id="field_addressee" ng-model="vm.postalAddress.addressee" ng-maxlength="150"><div ng-show="editForm.addressee.$invalid"><p class="help-block" ng-show="editForm.addressee.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.postalAddress.businessName" for="field_businessName">Business Name</label><input type="text" class="form-control" name="businessName" id="field_businessName" ng-model="vm.postalAddress.businessName" ng-maxlength="200"><div ng-show="editForm.businessName.$invalid"><p class="help-block" ng-show="editForm.businessName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.postalAddress.firlstLineOfAddress" for="field_firlstLineOfAddress">First Line Of Address</label><input type="text" class="form-control" name="firlstLineOfAddress" id="field_firlstLineOfAddress" ng-model="vm.postalAddress.firlstLineOfAddress" ng-maxlength="150" required><div ng-show="editForm.firlstLineOfAddress.$invalid"><p class="help-block" ng-show="editForm.firlstLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.firlstLineOfAddress.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.postalAddress.secondLineOfAddress" for="field_secondLineOfAddress">Second Line Of Address</label><input type="text" class="form-control" name="secondLineOfAddress" id="field_secondLineOfAddress" ng-model="vm.postalAddress.secondLineOfAddress" ng-maxlength="150"><div ng-show="editForm.secondLineOfAddress.$invalid"><p class="help-block" ng-show="editForm.secondLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.postalAddress.town" for="field_town">Town</label><input type="text" class="form-control" name="town" id="field_town" ng-model="vm.postalAddress.town" ng-maxlength="100"><div ng-show="editForm.town.$invalid"><p class="help-block" ng-show="editForm.town.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.postalAddress.county" for="field_county">County</label><input type="text" class="form-control" name="county" id="field_county" ng-model="vm.postalAddress.county"></div><div class="form-group"><label class="control-label" translate="winkballApp.postalAddress.postCode" for="field_postCode">Post Code</label><input type="text" class="form-control" name="postCode" id="field_postCode" ng-model="vm.postalAddress.postCode" ng-maxlength="50" required><div ng-show="editForm.postCode.$invalid"><p class="help-block" ng-show="editForm.postCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.postCode.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.postalAddress.country" for="field_country">Country</label><input type="text" class="form-control" name="country" id="field_country" ng-model="vm.postalAddress.country" ng-maxlength="3"><div ng-show="editForm.country.$invalid"><p class="help-block" ng-show="editForm.country.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/postal-address/postal-addresses.html','<div><h2 translate="winkballApp.postalAddress.home.title">Postal Addresses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="postal-address.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.postalAddress.home.createLabel">Create new Postal Address</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.postalAddress.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="addressee"><span translate="winkballApp.postalAddress.addressee">Addressee</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="businessName"><span translate="winkballApp.postalAddress.businessName">Business Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="firlstLineOfAddress"><span translate="winkballApp.postalAddress.firlstLineOfAddress">First Line Of Address</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="secondLineOfAddress"><span translate="winkballApp.postalAddress.secondLineOfAddress">Second Line Of Address</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="town"><span translate="winkballApp.postalAddress.town">Town</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="county"><span translate="winkballApp.postalAddress.county">County</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="postCode"><span translate="winkballApp.postalAddress.postCode">Post Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="country"><span translate="winkballApp.postalAddress.country">Country</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="postalAddress in vm.postalAddresses track by postalAddress.id"><td><a ui-sref="postal-address-detail({id:postalAddress.id})">{{postalAddress.id}}</a></td><td>{{postalAddress.addressee}}</td><td>{{postalAddress.businessName}}</td><td>{{postalAddress.firlstLineOfAddress}}</td><td>{{postalAddress.secondLineOfAddress}}</td><td>{{postalAddress.town}}</td><td>{{postalAddress.county}}</td><td>{{postalAddress.postCode}}</td><td>{{postalAddress.country}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="postal-address-detail({id:postalAddress.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="postal-address.edit({id:postalAddress.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="postal-address.delete({id:postalAddress.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/project/project-detail.html','<div ng-cloak><div class="row main protohome"><div print-remove class="col-lg-3" ng-cloak><div class="rounded-0 bkg-dark-grey"><div class="side-panel-holder"><div class="panel rounded-0 border-none"><button class="btn btn-success rounded-0 text-center" ui-sref="wizard.first" style="width: 100%"><!-- <span class="glyphicon glyphicon-plus"></span> --> <span class="">Create new project</span></button></div><div class="panel rounded-0 bkg-dark-grey"><div class="panel-heading rounded-0 border-none" style="padding: 0 15px"><div class="row"><a ui-sref="reporter-detail-login({login: vm.account.login})"><div class="img-container"><img ng-if="vm.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{vm.thumbnail | trustURL}}" alt="Profile Picture"> <img ng-if="!vm.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{\'content/images/noperson.png\'}}" alt="Profile Picture"></div></a></div></div><a ui-sref="reporter-detail-login({login: vm.account.login})"><div class="panel-footer rounded-0 text-dark-grey bkg-light-grey"><span class="pull-left">View Profile</span> <span class="pull-right"><span class="glyphicon glyphicon-circle-arrow-right"></span></span><div class="clearfix"></div></div></a></div><div class="clearfix mg-b-1"><div class="h5 text-center"><span class="glyphicon glyphicon-user"></span> <span>Team</span></div><button type="button" ui-sref="project-detail.team({id: vm.job.id})" class="btn btn-default bkg-wb-yellow rounded-0 mw" ng-disabled="!(vm.jobApplicants.length > 0)"><span>Manage Team</span></button> <button type="button" ui-sref="project-detail.apply({id: vm.job.id})" class="btn btn-warning rounded-0 mw"><span>Apply to Work</span></button></div><!-- <div class="clearfix mg-b-1">\n                      <div class="h5 text-center">\n                          <span class="glyphicon glyphicon-picture"></span>\n                          <span>Project Media Package</span>\n                      </div>\n\n                      <button type="button" class="btn btn-default bkg-wb-yellow rounded-0 mw" ng-click="vm.back()">\n                          <span>Edit Media Package</span>\n                      </button>\n                  </div> --><div class="clearfix mg-b-1"><div class="h5 text-center"><span class="glyphicon glyphicon-usd"></span> <span>Sponsor</span></div><button type="button" ng-if="!(vm.sponsors.length > 0)" ui-sref="project-detail.sponsor({id:vm.job.id})" class="btn btn-default bkg-wb-yellow rounded-0 mw"><span>Propose Sponsor</span></button> <button ng-if="vm.sponsors.length > 0" type="button" class="btn btn-default bkg-wb-yellow rounded-0 mw" ui-sref="sponsor-detail({id:vm.sponsors[0].id})"><span>View Sponsor</span></button></div><div class="panel rounded-0 text-center"><h4>Project status colour codes</h4></div><div class="panel rounded-0 bkg-proposal"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Proposal</div></div></div></div><div class="panel rounded-0 bkg-in-production"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">In-Production</div></div></div></div><div class="panel rounded-0 bkg-ready-to-film"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Ready to Film</div></div></div></div><div class="panel rounded-0 bkg-awaiting-signoff"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Awaiting Sign Off</div></div></div></div><div class="panel rounded-0 completed"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Completed</div></div></div></div><div class="panel rounded-0 bkg-cancelled"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Cancelled</div></div></div></div></div></div></div><div ng-cloak class="col-lg-9"><div class="rounded-0 bkg-dark-grey"><div><jhi-alert></jhi-alert><div><ul class="nav nav-tabs"><li ng-class="vm.filter == \'mine\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'mine\');">My projects</a></li><li ng-class="vm.filter == \'accepted\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'accepted\');">Accepted projects</a></li><li ng-class="vm.filter == \'new\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'new\')">New projects</a></li><li ng-class="vm.filter == \'opened\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'opened\')">Opened projects</a></li></ul></div><div class="row bkg-white"><div class="btn-group-center" style="text-align:center"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" ng-click="vm.back()"><span translate="entity.action.back">Back</span></button> <button print-btn print-remove type="button" class="btn btn-default bkg-wb-yellow rounded-0"><span>Print</span></button> <button type="button" class="btn btn-default bkg-wb-yellow rounded-0" ng-disabled="vm.event.reportStatus !== \'COMPLETED\'"><span>Share</span></button></div></div><div print-section class="row home-tiles bkg-white"><div class="col-xs-12"><div class="h3 bkg-proposal mg-t-0 p-h-1">{{vm.job.title}}<span class="pull-right">{{vm.statusName}}</span></div></div><div class="col-xs-10"><div class="h4 p-h-1 mg-t-0 bkg-edit-label">About the Event</div></div><div class="col-xs-2"><button type="button" class="btn btn-default bkg-awaiting-signoff rounded-0 mw" ui-sref="project-detail.first({id: vm.job.id})"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Project ID</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.job.id}}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Keep this Proposal private?</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.job.privacy ? \'Yes\' : \'No\'}}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Has this project been approved?</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.job.approved ? \'Yes\' : \'No\'}}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Project Proposed Price (GBP)</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.job.projectPrice | currency: "\xA3" : 2}}</div></div><div class="table-row hidden-sm hidden-xs mw"><div class="col-xs-6 col-sm-6 col-md-4 table-cell"><div class="h5 mg-0 p-h-1 bkg-edit-item" style="position:absolute;top:0;bottom:0;left:15px;right:15px">Event Description</div></div><div class="col-xs-6 col-sm-6 col-md-8 table-cell"><div class="h5 mg-0 p-h-1">{{vm.job.description}}</div></div></div><div class="col-xs-12 hidden-md hidden-lg"><div class="h5 mg-0 p-h-1 bkg-edit-item">Event Description</div></div><div class="col-xs-12 hidden-md hidden-lg"><div class="h5 mg-0 p-h-1">{{vm.job.description}}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Event Website</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.job.weblink || \'N/A\' }}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Event Start Date</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.job.startDate | date:\'dd/MM/yyyy HH:mm\'}}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Report Due Date</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.job.reportDueDate | date:\'dd/MM/yyyy HH:mm\'}}</div></div><div class="col-xs-10 section-header"><div class="h4 p-h-1 mg-t-0 bkg-edit-label">Event Contact</div></div><div class="col-xs-2 section-header"><button type="button" class="btn btn-default bkg-awaiting-signoff rounded-0 mw" ui-sref="project-detail.first({id: vm.job.id})"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Contact Name</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.job.contactName || \'N/A\' }}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Contact Email</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.job.contactEmail || \'N/A\' }}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Contact Phone</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.job.contactPhone || \'N/A\' }}</div></div><div class="col-xs-10 section-header"><div class="h4 p-h-1 mg-t-0 bkg-edit-label">Event Detail</div></div><div class="col-xs-2 section-header"><button type="button" class="btn btn-default bkg-awaiting-signoff rounded-0 mw" ui-sref="project-detail.second({id: vm.job.id, project: vm.job})"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div><div class="table-row mw"><div class="col-xs-6 col-sm-6 col-md-4 table-cell"><div class="h5 mg-0 p-h-1 bkg-edit-item" style="position:absolute;top:0;bottom:0;left:15px;right:15px">Editorial Story Line</div></div><div class="col-xs-6 col-sm-6 col-md-8 table-cell"><div class="h5 mg-0 p-h-1">{{vm.job.editorialStoryline || \'N/A\'}}</div></div></div><div class="table-row mw"><div class="col-xs-6 col-sm-6 col-md-4 table-cell"><div class="h5 mg-0 p-h-1 bkg-edit-item" style="position:absolute;top:0;bottom:0;left:15px;right:15px">Key Talent(s)</div></div><div class="col-xs-6 col-sm-6 col-md-8 table-cell"><div class="h5 mg-0 p-h-1">{{vm.job.keyTalent || \'N/A\'}}</div></div></div><div class="table-row mw"><div class="col-xs-6 col-sm-6 col-md-4 table-cell"><div class="h5 mg-0 p-h-1 bkg-edit-item" style="position:absolute;top:0;bottom:0;left:15px;right:15px">Social Media</div></div><div class="col-xs-6 col-sm-6 col-md-8 table-cell"><div class="h5 mg-0 p-h-1">{{vm.job.socialMedia || \'N/A\'}}</div></div></div><div class="table-row mw"><div class="col-xs-6 col-sm-6 col-md-4 table-cell"><div class="h5 mg-0 p-h-1 bkg-edit-item" style="position:absolute;top:0;bottom:0;left:15px;right:15px">Categories</div></div><div class="col-xs-6 col-sm-6 col-md-8 table-cell"><div class="h5 mg-0 p-h-1"><span ng-repeat="category in vm.job.categories"><mark>{{vm.getCategoryDisplayName(category)}}</mark>&nbsp;</span></div></div></div><div class="col-xs-10 section-header"><div class="h4 p-h-1 mg-t-0 bkg-edit-label">Team</div></div><div class="col-xs-2 section-header"><button type="button" class="btn btn-default bkg-awaiting-signoff rounded-0 mw" ui-sref="project-detail.team({id: vm.job.id})" ng-disabled="!(vm.jobApplicants.length > 0)"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Manage Team</span></button></div><div print-remove class="table-responsive col-xs-12"><table class="jh-table table table-striped" ng-if="vm.jobApplicants.length > 0"><thead><tr><th><span>No</span></th><th><span>First Name</span></th><th><span>Last Name</span></th><th><span>Email</span></th><th><span>Role</span></th><th><span>Accepted</span></th><th><span>Application Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="applicant in vm.jobApplicants track by applicant.id"><td><a ui-sref="sponsor-detail({id:applicant.reporter.id})">{{applicant.id}}</a></td><td>{{applicant.reporter.firstName}}</td><td>{{applicant.reporter.lastName}}</td><td>{{applicant.reporter.email}}</td><td>{{applicant.reporterJobRole}}</td><td class="text-center"><span class="label label-danger" ng-show="!applicant.accepted"><span class="glyphicon glyphicon-minus-sign"></span> </span><span class="label label-success" ng-show="applicant.accepted"><span class="glyphicon glyphicon-ok-sign"></span></span></td><td>{{applicant.createdDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="reporter-detail({id:applicant.reporter.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button></div></td></tr></tbody></table></div><div class="col-xs-12 section-header"><div class="h4 p-h-1 mg-t-0 bkg-edit-label">Sponsor Information</div></div><!-- <div class="col-xs-2 section-header">\n                        <button type="button" class="btn btn-default bkg-awaiting-signoff rounded-0 mw" \n                        ng-disable="!(vm.sponsors.length > 0)" ng-click="vm.back()">\n                          <span class="glyphicon glyphicon-pencil"></span>\n                          <span class="hidden-xs hidden-sm"> Edit</span>\n                        </button>\n                    </div> --><div print-remove class="table-responsive col-xs-12"><table class="jh-table table table-striped" ng-if="vm.sponsors.length > 0"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span>Sponsor Name</span></th><th><span>Contact Name</span></th><th><span>Contact Email</span></th><th><span>Created Date</span></th><th><span>Sponsor Finder</span></th><th></th></tr></thead><tbody><tr ng-repeat="sponsor in vm.sponsors track by sponsor.id"><td><a ui-sref="sponsor-detail({id:sponsor.id})">{{sponsor.id}}</a></td><td>{{sponsor.sponsorName}}</td><td>{{sponsor.contactName}}</td><td>{{sponsor.contactEmail}}</td><td>{{sponsor.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{sponsor.finder.firstName +\' \'+sponsor.finder.lastName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sponsor-detail({id:sponsor.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button></div></td></tr></tbody></table></div><div class="col-xs-10 section-header"><div class="h4 p-h-1 mg-t-0 bkg-edit-label">Location</div></div><div class="col-xs-2 section-header"><button type="button" class="btn btn-default bkg-awaiting-signoff rounded-0 mw" ng-disabled="!vm.job.location" ui-sref="project-detail.location({id:vm.job.id, locationId: vm.job.location.id})"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div><div class="col-xs-12"><div class="h5 mg-0 p-h-1">{{vm.job.location.title}}</div></div><div class="col-xs-12" ng-show="vm.job.location.geoPoint.lon && vm.job.location.geoPoint.lat"><ng-map zoom="16" center="[{{vm.job.location.geoPoint.lat}}, {{vm.job.location.geoPoint.lon}}]"><marker position="[{{vm.job.location.geoPoint.lat}}, {{vm.job.location.geoPoint.lon}}]" title="{{vm.job.location.title}}" centered="true"></marker></ng-map></div></div><!-- end of .row --></div></div></div></div><div print-remove class="row detail-footer bkg-edit-label text-left"><div class="btn-group-center" style="text-align: right"><button type="button" ng-if="vm.job.approved && vm.isManager()" ng-click="vm.toggleApproved()" class="btn btn-info rounded-0"><span class="glyphicon glyphicon-minus-sign"></span> <span class="hidden-xs">Disapprove</span></button> <button type="button" ng-if="!vm.job.approved && vm.isManager()" ng-click="vm.toggleApproved()" class="btn btn-info rounded-0"><span class="glyphicon glyphicon-ok-sign"></span> <span class="">Approve</span></button> <button type="submit" ng-if="(vm.job.approved && vm.canEdit(vm.job) && !(vm.events.length > 0))" ng-disabled="vm.sponsors.length < 1" ui-sref="project-inproduction({id:vm.job.id})" class="btn btn-default bkg-in-production rounded-0"><span class="glyphicon glyphicon-arrow-right"></span> <span class="">Move to Production</span></button></div></div></div>');
$templateCache.put('app/entities/project/project-edit.html','<div class="row main protohome"><div class="col-lg-3"><div class="rounded-0 bkg-dark-grey"><div class="side-panel-holder"><div class="panel rounded-0 border-none"><button class="btn btn-success rounded-0 text-center" ui-sref="wizard.first" style="width: 100%"><!-- <span class="glyphicon glyphicon-plus"></span> --> <span class="">Create new project</span></button></div><div class="panel rounded-0 bkg-dark-grey"><div class="panel-heading rounded-0 border-none" style="padding: 0 15px"><div class="row"><a ui-sref="reporter-detail-login({login: vm.account.login})"><div class="img-container"><img ng-if="vm.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{vm.thumbnail | trustURL}}" alt="Profile Picture"> <img ng-if="!vm.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{\'content/images/noperson.png\'}}" alt="Profile Picture"></div></a></div></div><a ui-sref="reporter-detail-login({login: vm.account.login})"><div class="panel-footer rounded-0 text-dark-grey bkg-light-grey"><span class="pull-left">View Profile</span> <span class="pull-right"><span class="glyphicon glyphicon-circle-arrow-right"></span></span><div class="clearfix"></div></div></a></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><a href="https://webmail.winkball.com" target="_blank"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left"><span>WinkBall Email</span></div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-envelope"></i></div></div></a></div></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><!-- <a ui-sref="winkball-chat"> --> <a href="https://chat.winkballhub.com" target="_blank"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left"><span>WinkBall Chat</span></div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-bell"></i></div></div></a></div></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><a ui-sref="reporter" target="_blank"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Members Directory</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-list-alt"></i></div></div></a></div></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><a ui-sref="member-software"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Members Software</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-save-file"></i></div></div></a></div></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><a ui-sref="sales-documents"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Sales Documents</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-briefcase"></i></div></div></a></div></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><a ui-sref="#"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Social Media</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-share"></i></div></div></a></div><!-- <a ui-sref="social-media"> --></div><div class="panel rounded-0 bkg-light-grey"><div class="h5"><a ui-sref="training-videos"><div class="clearfix text-dark-grey"><div class="col-xs-9 text-left">Training Videos</div><div class="col-xs-3 text-right"><i class="glyphicon glyphicon-expand"></i></div></div></a></div></div><div class="panel rounded-0 text-center"><h4>Project status colour codes</h4></div><div class="panel rounded-0 bkg-proposal"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Proposal</div></div></div></div><div class="panel rounded-0 bkg-in-production"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">In-Production</div></div></div></div><div class="panel rounded-0 bkg-ready-to-film"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Ready to Film</div></div></div></div><div class="panel rounded-0 bkg-awaiting-signoff"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Awaiting Sign Off</div></div></div></div><div class="panel rounded-0 completed"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Completed</div></div></div></div><div class="panel rounded-0 bkg-cancelled"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Cancelled</div></div></div></div></div></div></div><div class="col-lg-9"><div><jhi-alert></jhi-alert><div><ul class="nav nav-tabs"><li ng-class="vm.filter == \'mine\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'mine\');">My projects</a></li><li ng-class="vm.filter == \'accepted\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'accepted\');">Accepted projects</a></li><li ng-class="vm.filter == \'new\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'new\')">New projects</a></li><li ng-class="vm.filter == \'opened\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'opened\')">Opened projects</a></li></ul></div></div></div></div>');
$templateCache.put('app/entities/project/project-team-dialog.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Manage Team on {{vm.job.title}}</h4></div><div class="modal-body"><div print-remove class="table-responsive" ng-if="vm.jobApplicants.length > 0"><table class="jh-table table table-striped" style="text-align: center"><thead><tr><th><span>No</span></th><th><span>First Name</span></th><th><span>Last Name</span></th><th><span>Email</span></th><th><span>Role</span></th><th><span>Application Date</span></th><th><span>Accepted</span></th></tr></thead><tbody><tr ng-repeat="applicant in vm.jobApplicants track by applicant.id"><td>{{applicant.id}}</td><td>{{applicant.reporter.firstName}}</td><td>{{applicant.reporter.lastName}}</td><td>{{applicant.reporter.email}}</td><td>{{applicant.reporterJobRole}}</td><td>{{applicant.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td><label class="category-label"><input type="checkbox" name="applicants[]" ng-disabled="!vm.isManager()" ng-checked="applicant.accepted" ng-click="vm.toggleAccepted(applicant)"></label></td></tr></tbody></table></div></div><div class="modal-footer bkg-wb-yellow" style="text-align:center"><div class="btn-group pull-right" ng-if="vm.isManager()"><button type="button" ng-click="vm.updateTeam()" class="btn btn-default rounded-0"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp; <span class="hidden-xs hidden-sm">Update Team</span></button></div></div>');
$templateCache.put('app/entities/project/project-wizard-first.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myJobLabel" ng-if="!vm.job.id">New Project Proposal</h4><h4 class="modal-title" id="myJobLabel" ng-if="vm.job.id">Edit Project Proposal</h4></div><div class="modal-body"><form id="job-edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" has-any-authority="ROLE_ADMIN" ng-show="vm.job.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.job.id" readonly="readonly"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.job.puid" for="field_puid">PUID</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.job.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"></div></div><div class="form-group"><label class="control-label" for="field_title">Event Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.job.title" required="required"><div ng-show="editForm.title.$invalid"><p class="text-danger" ng-show="editFormLocation.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_price">Project Proposed Price (GBP \xA3)</label><input id="field_price" type="number" step="any" class="form-control" name="field_price" min="0" ng-model="vm.job.projectPrice" required="required"><div ng-show="editForm.field_price.$invalid"><p class="text-danger">This field is required, only positive values are allowed.</p></div></div><div class="col-md-6"><label class="control-label">Check pricing strategy</label><div class="button-wrapper"><button class="btn btn-info rounded-0" ui-sref="job-estimator"><span class="glyphicon glyphicon-blackboard"></span> <span class="hidden-xs">Cost Estimator</span></button></div></div></div><div class="form-group clearfix"><label class="control-label" translate="winkballApp.job.description" for="field_description">Description</label><textarea class="form-control" name="description" id="field_description" ng-model="vm.job.description" required="required" rows="6"></textarea><div ng-show="editForm.description.$invalid"><p class="text-danger" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><div class="col-md-6"><label class="control-label" for="field_startDate">Event Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" datetime-picker="{{dateformat}}" ng-model="vm.job.startDate" is-open="vm.datePickerOpenStatus.startDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.startDate.$invalid"><p class="text-danger" ng-show="editForm.startDate.$error.required" translate="entity.validation.required">This field is required.</p></div><!-- <p class="help-block">Please enter a start date</p> --></div><div class="col-md-6"><label class="control-label" for="field_dueDate">Report Due Date</label><div class="input-group"><input id="field_dueDate" type="text" class="form-control" name="reportDueDate" datetime-picker="{{dateformat}}" datepicker-options="vm.datePickerOptions" ng-model="vm.job.reportDueDate" is-open="vm.datePickerOpenStatus.reportDueDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'reportDueDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><p class="help-block">Please enter a film due date</p></div></div><div class="form-group"><label class="control-label" for="field_website">Event Website</label><input type="text" class="form-control" name="weblink" id="field_website" ng-model="vm.job.weblink" ng-maxlength="100" placeholder="http(s)://"><div ng-show="editForm.weblink.$invalid"><p class="text-danger" ng-show="editForm.weblink.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><!-- <p class="help-block" ng-show="editForm.weblink.$error.url"\n            translate="global.messages.validate.url.invalid">\n            Your URL link is invalid.\n          </p> --></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.job.contactName" for="field_contactName">Contact Name</label><input type="text" class="form-control" name="contactName" id="field_contactName" ng-model="vm.job.contactName"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.job.contactPhone" for="field_contactPhone">Contact Phone</label><input type="text" class="form-control" name="contactPhone" id="field_contactPhone" ng-maxlength="21" ng-pattern="vm.phoneRegex" ng-model="vm.job.contactPhone" placeholder="e.g. +440123456789"><div ng-show="editForm.contactPhone.$invalid"><p class="text-danger" ng-show="editForm.contactPhone.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="text-danger" ng-show="editForm.contactPhone.$error.pattern">Phone number is invalid. Please make sure there is no white spaces or braces.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_contact_email">Contact Email</label><input class="form-control" id="field_contact_email" name="email" ng-maxlength="100" ng-model="vm.job.contactEmail" type="email"><div ng-show="editForm.email.$invalid"><p class="text-danger" ng-show="editForm.email.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p><p class="text-danger" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="col-md-6"><div class="checkbox"><label><input id="field_privacy" name="privacy" ng-model="vm.job.privacy" type="checkbox"> Keep this project private?</label></div><div class="checkbox"><label><input id="field_approved" name="approved" ng-model="vm.job.approved" type="checkbox"> Has this project been approved?</label></div></div></div></form><div class="file-holder"><div ng-if="!vm.job.thumbnail" id="field_videoFile"><h4>Project Thumbnail</h4><button type="file" class="btn btn-primary rounded-0" ng-disabled="(editForm.$invalid || vm.isSaving) && !vm.errFile" ngf-select="vm.uploadFile($file, $invalidFiles)" ngf-accept="\'image/jpeg,image/png\'" ngf-max-size="5MB" ngf-min-width="48"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button><div ng-show="vm.errFile.$error"><span style="font-size:smaller">{{vm.errFile.name}}</span><p class="alert-danger" ng-show="vm.errFile.$error == \'minWidth\'">Minimum image width should be 48px</p><p class="alert-danger" ng-show="vm.errFile.$error == \'maxSize\'">Maximum image size permitted is 5MB</p></div><span style="font-size:smaller">{{vm.f.name}}</span> <span class="progress" ng-show="vm.f.progress >= 0"><div ng-style="{width: vm.f.progress + \'%\'}" ng-bind="vm.f.progress + \'%\'"></div></span><p>{{vm.errorMsg}}</p></div><div ng-if="vm.job.thumbnail"><h4>Project Thumbnail</h4><button type="button" ng-click="vm.deleteThumbnail()" class="btn btn-danger rounded-0"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete Thumbnail</span></button><hr><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Event Thumbnail"></div></div></div><div class="modal-footer bkg-wb-yellow" style="text-align:center"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-default rounded-0" form="job-edit-form"><span class="glyphicon glyphicon-arrow-right"></span>&nbsp;<span>Next</span></button></div>');
$templateCache.put('app/entities/project/project-wizard-last.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myJobLabel">Project: {{vm.job.title}}</h4></div><div class="modal-body"><form id="job-edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" has-any-authority="ROLE_ADMIN" ng-show="vm.job.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.job.id" readonly="readonly"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.job.puid" for="field_puid">PUID</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.job.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"></div></div><div class="form-group clearfix"><h4>Categories</h4><label class="category-label" ng-repeat="category in vm.categories"><input type="checkbox" name="selectedCategories[]" value="{{category.name}}" ng-checked="vm.job.categories.indexOf(category.name) > -1" ng-click="vm.toggleCategory(category.name)"> {{category.display}}</label></div><div class="form-group" ng-show="vm.job.claimed"><label class="control-label" for="field_claimed">Claimed</label><input class="form-control" id="field_claimed" name="claimed" ng-model="vm.job.claimed" type="checkbox" ng-disabled="true"><p class="help-block">The tick indicates whether this job has been claimed, e.g. has an owner</p></div><div class="form-group"><h4>Location</h4><tags-input ng-model="vm.tagLocation" max-tags="1" replace-spaces-with-dashes="false" on-tag-removed="vm.locationRemoved()" on-tag-added="vm.locationAdded()" display-property="title" key-property="id" placeholder="{{vm.tagLocation.length > 0 ? \' \' : \'Type to search for an existing location\'}}" add-from-autocomplete-only="true"><auto-complete source="vm.searchLocation($query)" min-length="3" max-results-to-show="10"></auto-complete></tags-input></div><p><strong>OR, create a new location below</strong></p></form><form id="location-edit-form" name="editFormLocation" role="form" novalidate ng-submit="vm.saveLocation()" show-validation><!-- <h4>Location</h4> --><div class="location-btn-group clearfix"><!-- search/go to current location --><div class="col-lg-6"><div class="input-group"><input type="text" ng-model="vm.search" class="form-control" placeholder="Search for an address or place"><div class="input-group-btn"><button class="btn btn-primary" type="button" ng-click="vm.geoCode()" ng-disabled="vm.search.length == 0 || vm.tagLocation.length > 0" title="search"><span class="glyphicon glyphicon-search"></span>&nbsp;<span>Find Location</span></button></div><!-- <button class="btn" type="button" ng-click="gotoCurrentLocation()" title="current location">\n                &nbsp;<span class="glyphicon glyphicon-home"></span>\n              </button> --></div></div><div class="col-lg-6"><button type="submit" ng-disabled="editFormLocation.$invalid || vm.isSaving || vm.location.id" class="btn btn-info" form="location-edit-form"><span class="glyphicon glyphicon-map-marker"></span>&nbsp;<span>Save Location</span></button></div></div><h5>Give location a name</h5><div class="location-btn-group clearfix"><!-- <label class="control-label" for="field_location_title">Location name</label> --><div class="col-lg-6"><input type="text" class="form-control" name="title" id="field_location_title" ng-model="vm.location.title" required><!-- <div ng-show="editFormLocation.title.$invalid">\n          <p class="help-block"\n              ng-show="editFormLocation.title.$error.required" translate="entity.validation.required">\n              This field is required.\n          </p>\n        </div> --></div><div class="col-lg-6"><button type="button" ng-disabled="editFormLocation.$invalid || vm.isSaving" class="btn btn-info" ng-click="vm.clearLocation()"><span class="glyphicon glyphicon-trash"></span>&nbsp;<span>Clear Location</span></button></div></div><div class="row hidden"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_latitude">Latitude</label><input type="number" class="form-control" name="latitude" id="field_latitude" ng-model="vm.location.geoPoint.lat" required readonly="readonly"><div ng-show="editFormLocation.latitude.$invalid"><p class="text-danger" ng-show="editFormLocation.latitude.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_longitude">Longitude</label><input type="number" class="form-control" name="longitude" id="field_longitude" ng-model="vm.location.geoPoint.lon" required readonly="readonly"><div ng-show="editFormLocation.longitude.$invalid"><p class="text-danger" ng-show="editFormLocation.longitude.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="map-holder"><p>Please <b>click</b> on the <i>Map</i> to give precise location or search for an <i>address</i> or a <i>place</i>!</p><div ng-if="vm.location.geoPoint.lat && vm.location.geoPoint.lon"><ng-map zoom="17" center="[{{vm.location.geoPoint.lat}}, {{vm.location.geoPoint.lon}}]" on-click="vm.addMarker()"><marker position="[{{vm.location.geoPoint.lat}}, {{vm.location.geoPoint.lon}}]" title="{{vm.location.title}}" centered="true"></marker></ng-map></div><div ng-if="!vm.location.geoPoint.lat || !vm.location.geoPoint.lon"><ng-map default-style="true" center="current-location" zoom="16" on-click="vm.addMarker()"></ng-map></div></div></form></div><div class="modal-footer bkg-wb-yellow" style="text-align:center"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.back()"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span>Back</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-default rounded-0" form="job-edit-form"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save Project</span></button></div>');
$templateCache.put('app/entities/project/project-wizard-second.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myJobLabel">Project: {{vm.job.title}}</h4></div><div class="modal-body"><form id="job-edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" has-any-authority="ROLE_ADMIN" ng-show="vm.job.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.job.id" readonly="readonly"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.job.puid" for="field_puid">PUID</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.job.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"></div></div><div class="form-group" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><label class="control-label" for="field_manager">Manager</label><select class="form-control" id="field_manager" name="manager" ng-model="vm.job.manager" ng-options="user as (user.firstName + \' \' + user.lastName) for user in vm.users track by user.id"><option value=""></option></select><p class="help-block">Please select a Manager for this Job</p></div><div class="form-group"><label class="control-label" for="field_editorial_storyline">Editorial Story Line</label><textarea class="form-control" name="editorialStoryline" id="field_editorial_storyline" ng-model="vm.job.editorialStoryline" ng-maxlength="1000" rows="4"></textarea><div ng-show="editForm.editorialStoryline.$invalid"><p class="text-danger" ng-show="editForm.editorialStoryline.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_key_talent">Key Talent(s)</label><textarea class="form-control" name="keytalent" id="field_key_talent" ng-model="vm.job.keyTalent" ng-maxlength="1000" rows="5"></textarea><div ng-show="editForm.keytalent.$invalid"><p class="text-danger" ng-show="editForm.keytalent.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" for="social_media">Social Media</label><textarea class="form-control" name="socialMedia" id="social_media" placeholder="Facebook, Instagram, Twitter, etc" ng-model="vm.job.socialMedia" ng-maxlength="400" rows="4"></textarea><div ng-show="editForm.socialMedia.$invalid"><p class="text-danger" ng-show="editForm.socialMedia.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="400">This field cannot be longer than 400 characters.</p></div></div></form></div><div class="modal-footer bkg-wb-yellow" style="text-align:center"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.back()"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span>Back</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-default rounded-0" form="job-edit-form"><span class="glyphicon glyphicon-arrow-right"></span>&nbsp;<span>Next</span></button></div>');
$templateCache.put('app/entities/prospective-publisher/prospective-publisher-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.publisher.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.prospectivePublisher.delete.question" translate-values="{id: \'{{vm.publisher.id}}\'}">Are you sure you want to delete this Prospective Publisher?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/prospective-publisher/prospective-publisher-detail.html','<div><button type="submit" ui-sref="{{ \'prospective-publisher\' }}" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp; <span translate="entity.action.back">Back</span></button> <button type="button" ui-sref="prospective-publisher-detail.edit({id:vm.publisher.id})" class="btn btn-primary btn-lg rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button><div class="btn-group pull-right"><!-- ui-sref="prospective-publisher-invite.new({id:vm.publisher.id})" --> <button type="submit" ng-disabled="vm.prospectivePublisher.activated" ui-sref="prospective-publisher-detail.email({id:vm.publisher.id})" class="btn btn-success btn-lg rounded-0"><span class="glyphicon glyphicon-send"></span> <span class="hidden-xs hidden-sm">Send Invitation</span></button></div><h2><span translate="winkballApp.prospectivePublisher.detail.title">Customer</span> {{vm.publisher.id}}</h2><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-4"><img ng-if="vm.publisher.profilePicture" class="img-responsive" style="background-color: white" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Thumbnail"> <img ng-if="!vm.publisher.profilePicture" class="img-responsive" ng-src="{{\'content/images/noperson.png\' | trustURL}}" alt="Thumbnail"></div><div class="col-md-8"><h2><span>Company Name</span>: {{vm.publisher.companyName}}</h2></div></div><hr><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.prospectivePublisher.companyName">Publication</span></dt><dd><span>{{vm.publisher.companyName}}</span></dd><dt><span>Publication Type</span></dt><dd><span>{{vm.publisher.companyType}}</span></dd><dt><span>Description</span></dt><dd><p>{{vm.publisher.description}}</p></dd><dt><span>Contact Name</span></dt><dd><span>{{(vm.publisher.firstName || \'\') +\' \'+ (vm.publisher.lastName || \'\')}}</span></dd><dt><span>Email</span></dt><dd><span>{{vm.publisher.email}}</span></dd><dt><span translate="winkballApp.prospectivePublisher.contactNumber">Contact Number</span></dt><dd><span>{{vm.publisher.contactNumber}}</span></dd><dt><span>Website</span></dt><dd>{{vm.publisher.website}}</dd><dt><span>Email sent</span></dt><dd>{{vm.publisher.emailSent}}</dd><dt><span>Viewed</span></dt><dd>{{vm.publisher.activated}}</dd><dt><span>Region</span></dt><dd>{{vm.publisher.region}}</dd><dt><span>Monthly Visitors</span></dt><dd>{{vm.publisher.monthlyVisitors}}</dd><dt><span>Categories</span></dt><dd><span ng-repeat="category in vm.publisher.categories"><mark>{{category}}</mark>&nbsp;</span></dd><dt><span>Registration Link</span></dt><dd>{{\'https://www.winkballnews.com/publishers/register?key=\' + vm.publisher.activationKey + \'&email=\' + vm.publisher.email}}</dd></dl></div>');
$templateCache.put('app/entities/prospective-publisher/prospective-publisher-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPublisherLabel" translate="winkballApp.prospectivePublisher.home.createOrEditLabel">Create or edit a Publisher</h4></div><div class="modal-body"><form id="publisherForm" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.publisher.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.publisher.id" readonly="readonly"></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.publisher.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="col-md-6"><label>Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.publisher.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.prospectivePublisher.companyName" for="field_companyName">Publication</label><input type="text" class="form-control" name="companyName" id="field_companyName" ng-model="vm.publisher.companyName" required><div ng-show="editForm.companyName.$invalid"><p class="help-block" ng-show="editForm.companyName.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6"><label class="control-label" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" ng-model="vm.publisher.email" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_contactName">Publication Type</label><input type="text" class="form-control" name="contactName" id="field_contactName" ng-model="vm.publisher.companyType"></div><div class="col-md-6"><label for="field_region">Region</label><select class="form-control" id="field_region" name="region" ng-model="vm.publisher.region"><option value="LONDON">London</option><option value="CYMRU_WALES">Cymru Wales</option><option value="EAST_OF_ENGLAND">East of England</option><option value="NORTH_EAST_AND_CUMBRIA">North East and Cumbria</option><option value="NORTHERN_IRELAND">Northern Ireland</option><option value="SOUTH_EAST">South East</option><option value="WEST_MIDLANDS">West Midlands</option><option value="EAST_MIDLANDS">East Midlands</option><option value="NORTH_WEST">North West</option><option value="SCOTLAND">Scotland</option><option value="SOUTH_WEST">South West</option><option value="YORKSHIRE_AND_THE_HUMBER">Yorkshire and The Humber</option><option value="NATIONWIDE">Nationwide</option></select></div></div><div class="form-group"><label class="control-label" for="field_description">Description</label><textarea class="form-control" name="description" id="field_description" ng-model="vm.publisher.description" rows="6"></textarea></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.prospectivePublisher.contactNumber" for="field_contactNumber">Contact Number</label><input type="text" class="form-control" name="contactNumber" id="field_contactNumber" ng-model="vm.publisher.contactNumber" ng-maxlength="100"><div ng-show="editForm.contactNumber.$invalid"><p class="help-block" ng-show="editForm.contactNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-md-6"><label class="control-label" for="field_website">Website</label><div class="input-group"><input type="url" class="form-control" name="website" id="field_website" ng-model="vm.publisher.website" ng-maxlength="150" placeholder="e.g. https://www.winkball.com"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-disabled="!vm.publisher.website" ng-click="vm.deleteWebsite()"><span class="glyphicon glyphicon-trash"></span></button></span></div><div ng-show="editForm.website.$invalid"><p class="help-block" ng-show="editForm.website.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.website.$error.url" translate="global.messages.validate.url.invalid">Your URL link is invalid.</p></div></div></div><div class="form-group"><label class="control-label" for="field_monthlyVisitors">Monthly visitors</label><input type="number" class="form-control" name="monthlyVisitors" id="field_monthlyVisitors" ng-model="vm.publisher.monthlyVisitors" step="100" min="100" list="defaultNumbers"><p class="help-block">Average number of unique monthly visitors</p><datalist id="defaultNumbers"><option value="100">100+</option><option value="1000">1 000+</option><option value="5000">5 000+</option><option value="10000">10 000+</option><option value="50000">50 000+</option><option value="100000">100 000+</option><option value="500000">500 000+</option><option value="1000000">1 000 000+</option></datalist></div><div class="form-group"><h4>Categories of Interest</h4><label class="category-label" ng-repeat="category in vm.categories"><input type="checkbox" name="selectedCategories[]" value="{{category.name}}" ng-checked="vm.publisher.categories.indexOf(category.name) > -1" ng-click="vm.toggleCategory(category.name)"> {{category.display}}</label></div><div class="file-holder"><div ng-if="!vm.publisher.profilePicture" id="field_videoFile"><div class="form-group clearfix"><div class="col-md-6"><h4>Logo</h4></div><div class="col-md-6"><button type="file" class="btn btn-primary pull-right" ng-disabled="(editForm.$invalid || vm.isSaving) && !vm.errFile" ngf-select="vm.uploadFile($file, $invalidFiles)" ngf-accept="\'image/jpeg,image/png\'" ngf-max-size="5MB" ngf-min-width="48"><span class="glyphicon glyphicon-upload"></span>&nbsp; <span>Upload Logo</span></button></div><div class="col-md-12"><div ng-show="vm.errFile.$error"><span style="font-size:smaller">{{vm.errFile.name}}</span><p class="alert-danger" ng-show="vm.errFile.$error == \'minWidth\'">Minimum image width should be 48px</p><p class="alert-danger" ng-show="vm.errFile.$error == \'maxSize\'">Maximum image size permitted is 5MB</p></div><span style="font-size:smaller">{{vm.f.name}}</span> <span class="progress" ng-show="vm.f.progress >= 0"><div ng-style="{width: vm.f.progress + \'%\'}" ng-bind="vm.f.progress + \'%\'"></div></span><p>{{vm.errorMsg}}</p></div></div></div><div ng-if="vm.publisher.profilePicture"><div class="form-group clearfix"><div class="col-md-6"><h4>Logo</h4></div><div class="col-md-6"><button type="button" ng-click="vm.deleteThumbnail()" class="btn btn-danger pull-right"><span class="glyphicon glyphicon-remove"></span>&nbsp; <span>Delete Logo</span></button></div></div><hr><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Event Thumbnail"></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" form="publisherForm"><span class="glyphicon glyphicon-save"></span>&nbsp; <span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/entities/prospective-publisher/prospective-publisher-email-dialog.html','<form name="sendForm" ng-submit="vm.confirmEmail()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm invitation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to send invitation to {{vm.publisher.email}}?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="sendForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span>Send</span></button></div></form>');
$templateCache.put('app/entities/prospective-publisher/prospective-publishers.html','<div><h2 translate="winkballApp.prospectivePublisher.home.title">Prospective Publishers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary rounded-0" ui-sref="prospective-publisher.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.prospectivePublisher.home.createLabel">Create new Publisher</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.prospectivePublisher.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th class="hidden-xs hidden-sm">Logo</th><th jh-sort-by="companyName"><span translate="winkballApp.prospectivePublisher.companyName">Publication</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Contact Name</span></th><th><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contactNumber"><span>Tel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailSent"><span>Email Sent</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="publisher in vm.publishers track by publisher.id"><td><a ui-sref="prospective-publisher-detail({id:publisher.id})">{{publisher.id}}</a></td><td class="hidden-xs hidden-sm"><div class="img-container list-thumbnail"><img ng-if="publisher.profilePicture" class="img-responsive" src="content/images/spinner.svg" ng-src="{{vm.getImageSrc(publisher.profilePicture) | trustURL}}" alt="Thumbnail"> <img ng-if="!publisher.profilePicture" class="img-responsive" ng-src="{{\'content/images/noperson.png\'}}" alt="Thumbnail"></div></td><td>{{publisher.companyName}}</td><td>{{(publisher.firstName || \'\') +\' \'+ (publisher.lastName || \'\')}}</td><td>{{publisher.email}}</td><td>{{publisher.contactNumber}}</td><td class="text-center"><span class="label label-danger" ng-show="!publisher.emailSent"><span class="glyphicon glyphicon-minus-sign"></span> </span><span class="label label-success" ng-show="publisher.emailSent"><span class="glyphicon glyphicon-ok-sign"></span></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="prospective-publisher-detail({id:publisher.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="prospective-publisher.edit({id:publisher.id})" class="btn btn-primary btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="prospective-publisher.delete({id:publisher.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/prospective-reporter/prospective-reporter-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.reporter.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.prospectiveReporter.delete.question" translate-values="{id: \'{{vm.reporter.id}}\'}">Are you sure you want to delete this Prospective Reporter?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/prospective-reporter/prospective-reporter-detail.html','<div><button type="submit" ui-sref="{{ \'prospective-reporter\' }}" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp; <span translate="entity.action.back">Back</span></button> <button type="button" ui-sref="prospective-reporter-detail.edit({id:vm.reporter.id})" class="btn btn-primary btn-lg rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button><div class="btn-group pull-right"><!-- ui-sref="prospective-reporter-invite.new({id:vm.reporter.id})" --> <button type="submit" ng-disabled="vm.prospectiveReporter.activated" ui-sref="prospective-reporter-detail.email({id:vm.reporter.id, accepted:false})" class="btn btn-danger btn-lg rounded-0"><span class="glyphicon glyphicon-send"></span> <span class="hidden-xs hidden-sm">Send Rejection</span></button> <button type="submit" ng-disabled="vm.prospectiveReporter.activated" ui-sref="prospective-reporter-detail.email({id:vm.reporter.id, accepted:true})" class="btn btn-success btn-lg rounded-0"><span class="glyphicon glyphicon-send"></span> <span class="hidden-xs hidden-sm">Send Invitation</span></button></div><h2><span translate="winkballApp.prospectiveReporter.detail.title">Prospective Reporter</span> {{vm.reporter.id}}</h2><jhi-alert-error></jhi-alert-error><hr><dl class="dl-horizontal jh-entity-details"><dt><span>Contact Name</span></dt><dd><span>{{(vm.reporter.firstName || \'\') +\' \'+ (vm.reporter.lastName || \'\')}}</span></dd><dt><span>Showreel</span></dt><dd>{{vm.reporter.showreelLink}}</dd><dt><span>About me</span></dt><dd><p>{{vm.reporter.aboutMe}}</p></dd><dt><span>Email</span></dt><dd><span>{{vm.reporter.email}}</span></dd><dt><span translate="winkballApp.prospectiveReporter.contactNumber">Contact Number</span></dt><dd><span>{{vm.reporter.contactNumber}}</span></dd><dt><span>Birthday</span></dt><dd>{{ vm.reporter.birthday | date:short }}</dd><dt><span>Gender</span></dt><dd>{{vm.reporter.gender}}</dd><dt><span>Kit size</span></dt><dd>{{vm.reporter.kitSize}}</dd><dt><span>Membership type</span></dt><dd>{{vm.reporter.membershipType}}</dd><dt><span>Email sent</span></dt><dd>{{vm.reporter.emailSent}}</dd><dt><span>Accepted</span></dt><dd>{{vm.reporter.accepted}}</dd><dt><span>Viewed</span></dt><dd>{{vm.reporter.activated}}</dd><dt><span>Postal Address</span></dt><dd><!-- <a ng-if="vm.reporter.addressId" ui-sref="postal-address-detail({id:vm.reporter.addressId})">{{vm.reporter.address.firlstLineOfAddress + \', \' + vm.reporter.address.postCode}}</a> --> <span ng-if="vm.reporter.address">{{vm.reporter.address.firlstLineOfAddress + \', \' + (vm.reporter.address.secondLineOfAddress ? vm.reporter.address.secondLineOfAddress +\', \' : \'\') + (vm.reporter.address.town ? vm.reporter.address.town +\', \' : \'\') + (vm.reporter.address.county ? vm.reporter.address.county +\', \' : \'\') + vm.reporter.address.postCode}}</span></dd><dt ng-if="vm.reporter.shippingAddress"><span>Shipping Address</span></dt><dd ng-if="vm.reporter.shippingAddress"><span>{{vm.reporter.shippingAddress.firlstLineOfAddress + \', \' + (vm.reporter.shippingAddress.secondLineOfAddress ? vm.reporter.shippingAddress.secondLineOfAddress +\', \' : \'\') + (vm.reporter.shippingAddress.town ? vm.reporter.shippingAddress.town +\', \' : \'\') + (vm.reporter.shippingAddress.county ? vm.reporter.shippingAddress.county +\', \' : \'\') + vm.reporter.shippingAddress.postCode}}</span></dd><dt ng-if="vm.reporter.resume"><span>Candidate\'s CV</span></dt><dd ng-if="vm.reporter.resume"><a class="btn btn-primary" ng-href="https://streams2.winkball.com/files/{{vm.reporter.resume}}/download">Download</a></dd><dt><span>Invitation Link</span></dt><dd>{{\'https://www.winkball.com/memberregistrationnew?key=\' + vm.reporter.activationKey + \'&email=\' + vm.reporter.email}}</dd></dl></div>');
$templateCache.put('app/entities/prospective-reporter/prospective-reporter-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myReporterLabel" translate="winkballApp.prospectiveReporter.home.createOrEditLabel">Create or edit a Reporter</h4></div><div class="modal-body"><form id="reporterForm" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.reporter.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.reporter.id" readonly="readonly"></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.reporter.firstName" ng-maxlength="50" required><div ng-show="editForm.firstName.$invalid"><p class="text-danger" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="text-danger" ng-show="editForm.firstName.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6"><label>Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.reporter.lastName" ng-maxlength="50" required><div ng-show="editForm.lastName.$invalid"><p class="text-danger" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="text-danger" ng-show="editForm.lastName.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label for="field_gender">Gender</label><select class="form-control" id="field_gender" name="gender" ng-model="vm.reporter.gender"><option value="MALE">Male</option><option value="FEMALE">Female</option><option value="OTHER">Other</option></select></div><div class="col-md-6"><label class="control-label" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" ng-model="vm.reporter.email" required><div ng-show="editForm.email.$invalid"><p class="text-danger" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="text-danger" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="text-danger" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="form-group"><label class="control-label" for="field_description">About me</label><textarea class="form-control" name="description" id="field_description" ng-model="vm.reporter.aboutMe" rows="6"></textarea></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.prospectiveReporter.contactNumber" for="field_contactNumber">Contact Number</label><input type="text" class="form-control" name="contactNumber" id="field_contactNumber" ng-model="vm.reporter.contactNumber" ng-maxlength="100"><div ng-show="editForm.contactNumber.$invalid"><p class="text-danger" ng-show="editForm.contactNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-md-6"><label for="field_membership">Membership Type</label><select class="form-control" id="field_membership" name="membershipType" ng-model="vm.reporter.membershipType"><option value="PRESENTER">Presenter</option><option value="VIDEOGRAPHER_EDITOR">Videographer/Editor</option><option value="SPONSOR_FINDER">Sponsor Finder</option></select></div></div><div class="form-group clearfix"><div class="col-md-6"><label for="field_kitSize">Kit Size</label><select class="form-control" id="field_kitSize" name="kitSize" ng-model="vm.reporter.kitSize"><option value="XS">XS</option><option value="S">S</option><option value="M">M</option><option value="L">L</option><option value="XL">XL</option><option value="XXL">XXL</option><option value="XXXL">XXXL</option></select></div><div class="col-md-6"><label class="control-label" for="field_showreel">Showreel</label><div class="input-group"><input type="url" class="form-control" name="showreelLink" id="field_showreel" ng-model="vm.reporter.showreelLink" ng-maxlength="255" placeholder="e.g. https://www.winkball.com"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-disabled="!vm.reporter.showreelLink" ng-click="vm.deleteShowreel()"><span class="glyphicon glyphicon-trash"></span></button></span></div><div ng-show="editForm.showreelLink.$invalid"><p class="text-danger" ng-show="editForm.showreelLink.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p><p class="text-danger" ng-show="editForm.showreelLink.$error.url" translate="global.messages.validate.url.invalid">Your URL link is invalid.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_birthday">Date of Birth</label><div class="input-group"><input id="field_birthday" type="text" class="form-control" name="birthday" datetime-picker="dd/MM/yyyy" date-type="date" save-as="ISO" enable-time="false" ng-model="vm.reporter.birthday" ng-model-options="{timezone: \'utc\'}" is-open="vm.datePickerOpenStatus.birthday" datepicker-options="vm.datePickerOptions" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'birthday\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.birthday.$invalid"><p class="text-danger" ng-show="editForm.birthday.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6"><label class="control-label" for="field_emailSent">Email sent <input class="form-control" id="field_emailSent" name="emailSent" ng-model="vm.reporter.emailSent" type="checkbox" onclick="return false;"></label><label class="control-label pull-right" for="field_emailSent">Accepted <input class="form-control" id="field_accepted" name="accepted" ng-model="vm.reporter.accepted" type="checkbox" onclick="return false;"></label></div></div><div class="form-group"><h4>Reporter Address</h4></div><!-- Postal Address --><div class="form-group" ng-show="vm.reporter.address.id"><label for="address_id" translate="global.field.id">ID</label><input type="text" class="form-control" id="address_id" name="addresid" ng-model="vm.reporter.address.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_firlstLineOfAddress">First Line Of Address</label><input type="text" class="form-control" name="firlstLineOfAddress" id="field_firlstLineOfAddress" ng-model="vm.reporter.address.firlstLineOfAddress" ng-maxlength="150" required><div ng-show="editForm.firlstLineOfAddress.$invalid"><p class="text-danger" ng-show="editForm.firlstLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="text-danger" ng-show="editForm.firlstLineOfAddress.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_secondLineOfAddress">Second Line Of Address</label><input type="text" class="form-control" name="secondLineOfAddress" id="field_secondLineOfAddress" ng-model="vm.reporter.address.secondLineOfAddress" ng-maxlength="150"><div ng-show="editForm.secondLineOfAddress.$invalid"><p class="text-danger" ng-show="editForm.secondLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_town">Town</label><input type="text" class="form-control" name="town" id="field_town" ng-model="vm.reporter.address.town" ng-maxlength="100"><div ng-show="editForm.town.$invalid"><p class="text-danger" ng-show="editForm.town.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_county">County</label><input type="text" class="form-control" name="county" id="field_county" ng-model="vm.reporter.address.county"></div><div class="form-group"><label class="control-label" for="field_postCode">Post Code</label><input type="text" class="form-control" name="postCode" id="field_postCode" ng-model="vm.reporter.address.postCode" ng-maxlength="50" required><div ng-show="editForm.postCode.$invalid"><p class="text-danger" ng-show="editForm.postCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="text-danger" ng-show="editForm.postCode.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-show="vm.reporter.shippingAddress"><h4>Shipping Address</h4></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" form="reporterForm"><span class="glyphicon glyphicon-save"></span>&nbsp; <span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/entities/prospective-reporter/prospective-reporter-email-dialog.html','<form name="sendForm" ng-submit="vm.confirmEmail()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm invitation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to send invitation to {{vm.reporter.email}}?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="sendForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp; <span>Send</span></button></div></form>');
$templateCache.put('app/entities/prospective-reporter/prospective-reporters.html','<div><h2 translate="winkballApp.prospectiveReporter.home.title">Prospective Reporters</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary rounded-0" ui-sref="prospective-reporter.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.prospectiveReporter.home.createLabel">Create new Reporter</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.prospectiveReporter.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Contact Name</span></th><th><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contactNumber"><span>Tel</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailSent"><span>Email Sent</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="emailSent"><span>Accepted</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="reporter in vm.reporters track by reporter.id"><td><a ui-sref="prospective-reporter-detail({id:reporter.id})">{{reporter.id}}</a></td><td>{{(reporter.firstName || \'\') +\' \'+ (reporter.lastName || \'\')}}</td><td>{{reporter.email}}</td><td>{{reporter.contactNumber}}</td><td class="text-center"><span class="label label-danger" ng-show="!reporter.emailSent"><span class="glyphicon glyphicon-minus-sign"></span> </span><span class="label label-success" ng-show="reporter.emailSent"><span class="glyphicon glyphicon-ok-sign"></span></span></td><td class="text-center"><span class="label label-danger" ng-show="!reporter.accepted"><span class="glyphicon glyphicon-minus-sign"></span> </span><span class="label label-success" ng-show="reporter.accepted"><span class="glyphicon glyphicon-ok-sign"></span></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="prospective-reporter-detail({id:reporter.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="prospective-reporter.edit({id:reporter.id})" class="btn btn-primary btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="prospective-reporter.delete({id:reporter.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/publisher/publisher-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.publisher.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.publisher.delete.question" translate-values="{id: \'{{vm.publisher.id}}\'}">Are you sure you want to delete this Publisher?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/publisher/publisher-detail.html','<div><button type="submit" ui-sref="publisher" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="publisher-detail.edit({id:vm.publisher.id})" class="btn btn-primary btn-lg rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm rounded-0" translate="entity.action.edit">Edit</span></button><h2><span translate="winkballApp.publisher.detail.title">Customer</span> {{vm.publisher.id}}</h2><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-4"><div class="img-container"><img ng-if="vm.publisher.profilePicture" class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Thumbnail"> <img ng-if="!vm.publisher.profilePicture" class="img-responsive" ng-src="{{\'content/images/noperson.png\' | trustURL}}" alt="Thumbnail"></div></div><div class="col-md-8"><h2><span>Company Name</span>: {{vm.publisher.companyName}}</h2></div></div><hr><div class="row"><div class="col-md-4"><div class="img-container"><img ng-if="vm.publisher.videoBug" class="img-responsive" ng-src="{{vm.getVideoBugSrc() | trustURL}}" alt="Video bug"> <img ng-if="!vm.publisher.videoBug" class="img-responsive" ng-src="{{\'content/images/noperson.png\' | trustURL}}" alt="Video bug"></div></div><div class="col-md-8"><h2><span>Video bug</span></h2></div></div><hr><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.publisher.companyName">Publication</span></dt><dd><span>{{vm.publisher.companyName}}</span></dd><dt><span>Description</span></dt><dd><p>{{vm.publisher.description}}</p></dd><dt><span>User Name</span></dt><dd><span>{{vm.publisher.firstName +\' \'+ vm.publisher.lastName}}</span></dd><dt><span>Position</span></dt><dd>{{vm.publisher.position}}</dd><dt><span>Login</span></dt><dd>{{vm.publisher.login}}</dd><dt><span>Email</span></dt><dd><span>{{vm.publisher.email}}</span></dd><dt><span translate="winkballApp.publisher.contactNumber">Contact Number</span></dt><dd><span>{{vm.publisher.contactNumber}}</span></dd><dt><span>Website</span></dt><dd>{{vm.publisher.website}}</dd><dt><span>Monthly Visitors</span></dt><dd>{{vm.publisher.monthlyVisitors}}</dd><dt><span>Categories</span></dt><dd><span ng-repeat="category in vm.publisher.categories"><mark>{{category}}</mark>&nbsp;</span></dd><!-- <dt><span translate="winkballApp.publisher.aboutMe">About Me</span></dt>\n        <dd>\n            <span>{{vm.publisher.aboutMe}}</span>\n        </dd> --></dl><h3 ng-if="vm.publisher.address"><span translate="winkballApp.publisher.address">Address</span></h3><dl ng-if="vm.publisher.address" class="dl-horizontal jh-entity-details"><dt>1st Line of address</dt><dd>{{vm.publisher.address.firlstLineOfAddress}}</dd><dt>2nd Line of address</dt><dd>{{vm.publisher.address.secondLineOfAddress}}</dd><dt>Town</dt><dd>{{vm.publisher.address.town}}</dd><dt>County</dt><dd>{{vm.publisher.address.county}}</dd><dt>Post code</dt><dd>{{vm.publisher.address.postCode}}</dd></dl></div>');
$templateCache.put('app/entities/publisher/publisher-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPublisherLabel" translate="winkballApp.publisher.home.createOrEditLabel">Create or edit a Publisher</h4></div><div class="modal-body"><form id="publisherForm" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" ng-show="vm.publisher.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.publisher.id" readonly="readonly"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.publisher.puid" for="field_puid">Puid</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.publisher.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.publisher.firstName" ng-maxlength="50" required><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.firstName.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6"><label>Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.publisher.lastName" ng-maxlength="50" required><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.lastName.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-model="vm.publisher.login" ng-required="vm.publisher.userId == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="col-md-6"><label class="control-label" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" ng-model="vm.publisher.email" required><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.publisher.companyName" for="field_companyName">Publication</label><input type="text" class="form-control" name="companyName" id="field_companyName" ng-model="vm.publisher.companyName" required><div ng-show="editForm.companyName.$invalid"><p class="help-block" ng-show="editForm.companyName.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6"><label class="control-label" for="field_position">Position</label><input type="text" class="form-control" name="position" id="field_position" ng-model="vm.publisher.position" required><div ng-show="editForm.position.$invalid"><p class="help-block" ng-show="editForm.position.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_contactName">Publication Type</label><input type="text" class="form-control" name="contactName" id="field_contactName" ng-model="vm.publisher.companyType"></div><div class="col-md-6"><label for="field_region">Region</label><select class="form-control" id="field_region" name="region" ng-model="vm.publisher.region"><option value="LONDON">London</option><option value="CYMRU_WALES">Cymru Wales</option><option value="EAST_OF_ENGLAND">East of England</option><option value="NORTH_EAST_AND_CUMBRIA">North East and Cumbria</option><option value="NORTHERN_IRELAND">Northern Ireland</option><option value="SOUTH_EAST">South East</option><option value="WEST_MIDLANDS">West Midlands</option><option value="EAST_MIDLANDS">East Midlands</option><option value="NORTH_WEST">North West</option><option value="SCOTLAND">Scotland</option><option value="SOUTH_WEST">South West</option><option value="YORKSHIRE_AND_THE_HUMBER">Yorkshire and The Humber</option><option value="NATIONWIDE">Nationwide</option></select></div></div><div class="form-group"><label class="control-label" for="field_description">Description</label><textarea class="form-control" name="description" id="field_description" ng-model="vm.publisher.description" rows="6"></textarea></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.publisher.contactNumber" for="field_contactNumber">Contact Number</label><input type="text" class="form-control" name="contactNumber" id="field_contactNumber" ng-model="vm.publisher.contactNumber" ng-maxlength="100"><div ng-show="editForm.contactNumber.$invalid"><p class="help-block" ng-show="editForm.contactNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-md-6"><label class="control-label" for="field_website">Website</label><div class="input-group"><input type="url" class="form-control" name="website" id="field_website" ng-model="vm.publisher.website" ng-maxlength="150" placeholder="e.g. https://www.winkball.com"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-disabled="!vm.publisher.website" ng-click="vm.deleteWebsite()"><span class="glyphicon glyphicon-trash"></span></button></span></div><div ng-show="editForm.website.$invalid"><p class="help-block" ng-show="editForm.website.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.website.$error.url" translate="global.messages.validate.url.invalid">Your URL link is invalid.</p></div></div></div><div class="form-group"><h4>Postal Address</h4></div><div class="form-group"><label class="control-label" for="field_firlstLineOfAddress">1st Line Of Address</label><input type="text" class="form-control" name="firlstLineOfAddress" id="field_firlstLineOfAddress" ng-model="vm.publisher.address.firlstLineOfAddress" ng-maxlength="150" required><div ng-show="editForm.firlstLineOfAddress.$invalid"><p class="help-block" ng-show="editForm.firlstLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.firlstLineOfAddress.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_secondLineOfAddress">2nd Line Of Address</label><input type="text" class="form-control" name="secondLineOfAddress" id="field_secondLineOfAddress" ng-model="vm.publisher.address.secondLineOfAddress" ng-maxlength="150"><div ng-show="editForm.secondLineOfAddress.$invalid"><p class="help-block" ng-show="editForm.secondLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_town">Town</label><input type="text" class="form-control" name="town" id="field_town" ng-model="vm.publisher.address.town" ng-maxlength="100"><div ng-show="editForm.town.$invalid"><p class="help-block" ng-show="editForm.town.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_county">County</label><input type="text" class="form-control" name="county" id="field_county" ng-model="vm.publisher.address.county"></div><div class="form-group"><label class="control-label" for="field_postCode">Post Code</label><input type="text" class="form-control" name="postCode" id="field_postCode" ng-model="vm.publisher.address.postCode" ng-maxlength="50" required><div ng-show="editForm.postCode.$invalid"><p class="help-block" ng-show="editForm.postCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.postCode.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_monthlyVisitors">Monthly visitors</label><input type="number" class="form-control" name="monthlyVisitors" id="field_monthlyVisitors" ng-model="vm.publisher.monthlyVisitors" step="100" min="100" list="defaultNumbers"><p class="help-block">Average number of unique monthly visitors</p><datalist id="defaultNumbers"><option value="100">100+</option><option value="1000">1 000+</option><option value="5000">5 000+</option><option value="10000">10 000+</option><option value="50000">50 000+</option><option value="100000">100 000+</option><option value="500000">500 000+</option><option value="1000000">1 000 000+</option></datalist></div><div class="col-md-6"><label for="activated"><input ng-disabled="vm.publisher.id === null" type="checkbox" id="activated" ng-model="vm.publisher.activated"> <span>Activated</span></label></div></div><div class="form-group"><h4>Categories of Interest</h4><label class="category-label" ng-repeat="category in vm.categories"><input type="checkbox" name="selectedCategories[]" value="{{category.name}}" ng-checked="vm.publisher.categories.indexOf(category.name) > -1" ng-click="vm.toggleCategory(category.name)"> {{category.display}}</label></div><div class="file-holder"><div ng-if="!vm.publisher.profilePicture" id="field_videoFile"><div class="form-group clearfix"><div class="col-md-6"><h4>Logo</h4></div><div class="col-md-6"><button type="file" class="btn btn-primary pull-right" ng-disabled="(editForm.$invalid || vm.isSaving) && !vm.errFile" ngf-select="vm.uploadFile($file, false, $invalidFiles)" ngf-accept="\'image/jpeg,image/png\'" ngf-max-size="4MB" ngf-min-height="100" ngf-min-width="200"><span class="glyphicon glyphicon-upload"></span>&nbsp; <span>Upload Logo</span></button></div><div class="col-md-12"><div ng-show="vm.errFile.$error"><span style="font-size:smaller">{{vm.errFile.name}}</span><p class="alert-danger" ng-show="vm.errFile.$error == \'minHeight\'">Minimum image height should be 100px</p><p class="alert-danger" ng-show="vm.errFile.$error == \'minWidth\'">Minimum image width should be 200px</p><p class="alert-danger" ng-show="vm.errFile.$error == \'maxSize\'">Maximum image size permitted is 4MB</p></div><span style="font-size:smaller">{{vm.f.name}}</span> <span class="progress" ng-show="vm.f.progress >= 0"><div ng-style="{width: vm.f.progress + \'%\'}" ng-bind="vm.f.progress + \'%\'"></div></span><p>{{vm.errorMsg}}</p></div></div></div><hr><div ng-if="vm.publisher.profilePicture"><div class="form-group clearfix"><div class="col-md-6"><h4>Logo</h4></div><div class="col-md-6"><button type="button" ng-click="vm.deleteThumbnail()" class="btn btn-danger pull-right"><span class="glyphicon glyphicon-remove"></span>&nbsp; <span>Delete Logo</span></button></div></div><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Event Thumbnail"></div><hr><div ng-if="!vm.publisher.videoBug" id="field_videoBug"><div class="form-group clearfix"><div class="col-md-6"><h4>Logo</h4></div><div class="col-md-6"><button type="file" class="btn btn-primary pull-right" ng-disabled="(editForm.$invalid || vm.isSaving) && !vm.errFile" ngf-select="vm.uploadFile($file, true, $invalidFiles)" ngf-accept="\'image/jpeg,image/png\'" ngf-max-size="4MB" ngf-min-height="48" ngf-min-width="48"><span class="glyphicon glyphicon-upload"></span>&nbsp; <span>Upload Video Bug</span></button></div><div class="col-md-12"><div ng-show="vm.errFile.$error"><span style="font-size:smaller">{{vm.errFile.name}}</span><p class="alert-danger" ng-show="vm.errFile.$error == \'minHeight\'">Minimum image height should be 48px</p><p class="alert-danger" ng-show="vm.errFile.$error == \'minWidth\'">Minimum image width should be 48px</p><p class="alert-danger" ng-show="vm.errFile.$error == \'maxSize\'">Maximum image size permitted is 4MB</p></div><span style="font-size:smaller">{{vm.f.name}}</span> <span class="progress" ng-show="vm.f.progress >= 0"><div ng-style="{width: vm.f.progress + \'%\'}" ng-bind="vm.f.progress + \'%\'"></div></span><p>{{vm.errorMsg}}</p></div></div></div><div ng-if="vm.publisher.videoBug"><div class="form-group clearfix"><div class="col-md-6"><h4>Video Bug</h4></div><div class="col-md-6"><button class="btn btn-danger pull-right" ng-click="vm.deleteVideoBug()" type="button"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete Video Bug</span></button></div></div><img alt="Splash Screen" class="img-responsive" ng-src="{{vm.getVideoBugSrc() | trustURL}}"></div></div><!-- <div class="form-group">\n            <label class="control-label" translate="winkballApp.publisher.aboutMe" for="field_aboutMe">About Me</label>\n            <input type="text" class="form-control" name="aboutMe" id="field_aboutMe"\n                    ng-model="vm.publisher.aboutMe"\n                     />\n        </div> --></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" form="publisherForm"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/entities/publisher/publishers.html','<div><h2 translate="winkballApp.publisher.home.title">Publishers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary rounded-0" ui-sref="publisher.new" has-any-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.publisher.home.createLabel">Create new Publisher</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.publisher.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="companyName"><span translate="winkballApp.publisher.companyName">Publication</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Contact Name</span></th><th><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contactNumber"><span translate="winkballApp.publisher.contactNumber">Contact Number</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="publisher in vm.publishers track by publisher.id"><td><a ui-sref="publisher-detail({id:publisher.id})">{{publisher.id}}</a></td><td>{{publisher.companyName}}</td><td>{{publisher.firstName + \' \' + publisher.lastName}}</td><td>{{publisher.email}}</td><td>{{publisher.contactNumber}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="publisher-detail({id:publisher.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="publisher.edit({id:publisher.id})" class="btn btn-primary btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="publisher.delete({id:publisher.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/report/report-detail.html','<div ng-cloak><div class="row main protohome"><div print-remove class="col-lg-3" ng-cloak><div class="rounded-0 bkg-dark-grey"><div class="side-panel-holder"><div class="panel rounded-0 border-none"><button class="btn btn-success rounded-0 text-center" ui-sref="report-detail.new-first" style="width: 100%"><!-- <span class="glyphicon glyphicon-plus"></span> --> <span class="">Create new project</span></button></div><div class="panel rounded-0 bkg-dark-grey"><div class="panel-heading rounded-0 border-none" style="padding: 0 15px"><div class="row"><a ui-sref="reporter-detail-login({login: vm.account.login})"><div class="img-container"><img ng-if="vm.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{vm.thumbnail | trustURL}}" alt="Profile Picture"> <img ng-if="!vm.thumbnail" class="img-responsive" src="content/images/spinner.svg" ng-src="{{\'content/images/noperson.png\'}}" alt="Profile Picture"></div></a></div></div><a ui-sref="reporter-detail-login({login: vm.account.login})"><div class="panel-footer rounded-0 text-dark-grey bkg-light-grey"><span class="pull-left">View Profile</span> <span class="pull-right"><span class="glyphicon glyphicon-circle-arrow-right"></span></span><div class="clearfix"></div></div></a></div><div class="clearfix mg-b-1"><div class="h5 text-center"><span class="glyphicon glyphicon-user"></span> <span>Team</span></div><button type="button" ui-sref="report-detail.team({jobId: vm.event.job.id})" class="btn btn-default bkg-wb-yellow rounded-0 mw" ng-disabled="!(vm.jobApplicants.length > 0) || !vm.canEdit(vm.event)"><span>Manage Team</span></button> <button type="button" ui-sref="report-detail.apply({jobId: vm.event.job.id})" class="btn btn-warning rounded-0 mw" ng-if="vm.event.reportStatus === \'IN_PRODUCTION\' || vm.event.reportStatus === \'READY_TO_FILM\'"><span>Apply to Work</span></button></div><!-- <div class="clearfix mg-b-1">\n                        <div class="h5 text-center">\n                            <span class="glyphicon glyphicon-picture"></span>\n                            <span>Project Media Package</span>\n                        </div>\n  \n                        <button type="button" class="btn btn-default bkg-wb-yellow rounded-0 mw" ng-click="vm.back()">\n                            <span>Edit Media Package</span>\n                        </button>\n                    </div> --><div class="clearfix mg-b-1"><div class="h5 text-center"><span class="glyphicon glyphicon-usd"></span> <span>Sponsor</span></div><button type="button" ng-if="!(vm.sponsors.length > 0)" ui-sref="report-detail.sponsor({type:\'event\'})" class="btn btn-default bkg-wb-yellow rounded-0 mw"><span>Propose Sponsor</span></button> <button ng-if="vm.sponsors.length > 0" type="button" class="btn btn-default bkg-wb-yellow rounded-0 mw" ui-sref="sponsor-detail({id:vm.sponsors[0].id})"><span>View Sponsor</span></button></div><div class="clearfix mg-b-1" print-remove><div class="h5 text-center"><span class="glyphicon glyphicon-film"></span> <span>Film</span></div><button type="button" ng-disabled="!(vm.event.films.length > 0)" ui-sref="report-detail.film({filmId:vm.event.films[0].id})" class="btn btn-default bkg-wb-yellow rounded-0 mw"><span>View Film</span></button></div><div class="clearfix mg-b-1" print-remove><div class="h5 text-center"><span class="glyphicon glyphicon-cd"></span> <span>Media Package</span></div><button type="button" ng-if="!vm.hasSponsorPack() && vm.event.reportStatus !== \'CANCELLED\'" ui-sref="report-detail.new-media-package({event:vm.event.id})" class="btn btn-default bkg-wb-yellow rounded-0 mw"><span>Add Media Package</span></button> <button type="button" ng-if="vm.hasSponsorPack()" ui-sref="media-package-detail({id:vm.event.id})" class="btn btn-default bkg-wb-yellow rounded-0 mw"><span>View Media Package</span></button></div><div class="panel rounded-0 text-center"><h4>Project status colour codes</h4></div><div class="panel rounded-0 bkg-proposal"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Proposal</div></div></div></div><div class="panel rounded-0 bkg-in-production"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">In-Production</div></div></div></div><div class="panel rounded-0 bkg-ready-to-film"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Ready to Film</div></div></div></div><div class="panel rounded-0 bkg-awaiting-signoff"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Awaiting Sign Off</div></div></div></div><div class="panel rounded-0 completed"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Completed</div></div></div></div><div class="panel rounded-0 bkg-cancelled"><div class="h5"><div class="clearfix text-dark-grey"><div class="col-xs-12">Cancelled</div></div></div></div></div></div></div><div ng-cloak class="col-lg-9"><div class="rounded-0 bkg-dark-grey"><div><jhi-alert></jhi-alert><div><ul class="nav nav-tabs"><li ng-class="vm.filter == \'mine\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'mine\');">My projects</a></li><li ng-class="vm.filter == \'accepted\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'accepted\');">Accepted projects</a></li><li ng-class="vm.filter == \'new\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'new\')">New projects</a></li><li ng-class="vm.filter == \'opened\' ? \'active\' : \'\'"><a href="#" ng-click="vm.setFilter($event, \'opened\')">Opened projects</a></li></ul></div><div class="row bkg-white"><div class="btn-group-center" style="text-align:center"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" ng-click="vm.back()"><span translate="entity.action.back">Back</span></button> <button print-btn print-remove type="button" class="btn btn-default bkg-wb-yellow rounded-0"><span>Print</span></button> <button type="button" class="btn btn-default bkg-wb-yellow rounded-0" ng-disabled="vm.event.reportStatus !== \'COMPLETED\'" ui-sref="report-detail.share({id:vm.event.id})"><span>Share</span></button></div></div><div print-section class="row home-tiles bkg-white"><div class="col-xs-12"><div class="h3 mg-t-0 p-h-1" ng-class="vm.getStatusClass()">{{vm.event.title}}<span class="pull-right">{{vm.statusName}}</span></div></div><div class="col-xs-10"><div class="h4 p-h-1 mg-t-0 bkg-edit-label">About the Event</div></div><div class="col-xs-2"><button type="button" class="btn btn-default bkg-awaiting-signoff rounded-0 mw" ui-sref="report-detail.first({id: vm.event.id})"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Report ID</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.event.id}}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Has this report been published?</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.event.published ? \'Yes\' : \'No\'}}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Project Proposed Price (GBP)</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.event.job.projectPrice | currency: "\xA3" : 2}}</div></div><div class="table-row hidden-sm hidden-xs mw"><div class="col-xs-6 col-sm-6 col-md-4 table-cell"><div class="h5 mg-0 p-h-1 bkg-edit-item" style="position:absolute;top:0;bottom:0;left:15px;right:15px">Event Description</div></div><div class="col-xs-6 col-sm-6 col-md-8 table-cell"><div class="h5 mg-0 p-h-1">{{vm.event.description || \'N/A\'}}</div></div></div><div class="col-xs-12 hidden-md hidden-lg"><div class="h5 mg-0 p-h-1 bkg-edit-item">Event Description</div></div><div class="col-xs-12 hidden-md hidden-lg"><div class="h5 mg-0 p-h-1">{{vm.event.description}}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Event Website</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.event.job.weblink || \'N/A\' }}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Event Start Date</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.event.startDate | date:\'dd/MM/yyyy HH:mm\'}}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Event End Date</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.event.endDate | date:\'dd/MM/yyyy HH:mm\'}}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Report Due Date</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.event.reportDueDate | date:\'dd/MM/yyyy HH:mm\'}}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Interviews Due Date</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.event.interviewsDueDate | date:\'dd/MM/yyyy HH:mm\'}}</div></div><div class="col-xs-10 section-header"><div class="h4 p-h-1 mg-t-0 bkg-edit-label">Event Contact</div></div><div class="col-xs-2 section-header"><button type="button" class="btn btn-default bkg-awaiting-signoff rounded-0 mw" ui-sref="report-detail.first({report: vm.event})"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Contact Name</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.event.contactName || \'N/A\' }}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Contact Email</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.event.contactEmail || \'N/A\' }}</div></div><div class="col-xs-12 col-sm-6 col-md-4"><div class="h5 mg-0 p-h-1 bkg-edit-item">Contact Phone</div></div><div class="col-xs-12 col-sm-6 col-md-8"><div class="h5 mg-0 p-h-1">{{vm.event.contactPhone || \'N/A\' }}</div></div><div class="col-xs-10 section-header"><div class="h4 p-h-1 mg-t-0 bkg-edit-label">Event Detail</div></div><div class="col-xs-2 section-header"><button type="button" class="btn btn-default bkg-awaiting-signoff rounded-0 mw" ui-sref="report-detail.second({report: vm.event})"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div><div class="table-row mw"><div class="col-xs-6 col-sm-6 col-md-4 table-cell"><div class="h5 mg-0 p-h-1 bkg-edit-item" style="position:absolute;top:0;bottom:0;left:15px;right:15px">Editorial Story Line</div></div><div class="col-xs-6 col-sm-6 col-md-8 table-cell"><div class="h5 mg-0 p-h-1">{{vm.event.editorialStoryline || \'N/A\'}}</div></div></div><div class="table-row mw"><div class="col-xs-6 col-sm-6 col-md-4 table-cell"><div class="h5 mg-0 p-h-1 bkg-edit-item" style="position:absolute;top:0;bottom:0;left:15px;right:15px">Key Talent(s)</div></div><div class="col-xs-6 col-sm-6 col-md-8 table-cell"><div class="h5 mg-0 p-h-1">{{vm.event.keyTalent || \'N/A\'}}</div></div></div><div class="table-row mw"><div class="col-xs-6 col-sm-6 col-md-4 table-cell"><div class="h5 mg-0 p-h-1 bkg-edit-item" style="position:absolute;top:0;bottom:0;left:15px;right:15px">Social Media</div></div><div class="col-xs-6 col-sm-6 col-md-8 table-cell"><div class="h5 mg-0 p-h-1">{{vm.event.socialMedia || \'N/A\'}}</div></div></div><div class="table-row mw"><div class="col-xs-6 col-sm-6 col-md-4 table-cell"><div class="h5 mg-0 p-h-1 bkg-edit-item" style="position:absolute;top:0;bottom:0;left:15px;right:15px">Categories</div></div><div class="col-xs-6 col-sm-6 col-md-8 table-cell"><div class="h5 mg-0 p-h-1"><span ng-repeat="category in vm.event.categories"><mark>{{vm.getCategoryDisplayName(category)}}</mark>&nbsp; </span><span ng-if="!(vm.event.categories.length > 0)">N/A</span></div></div></div><div class="table-row mw"><div class="col-xs-6 col-sm-6 col-md-4 table-cell"><div class="h5 mg-0 p-h-1 bkg-edit-item" style="position:absolute;top:0;bottom:0;left:15px;right:15px">Keywords</div></div><div class="col-xs-6 col-sm-6 col-md-8 table-cell"><div class="h5 mg-0 p-h-1"><span ng-repeat="keyword in vm.event.keywords"><mark>{{keyword.text}}</mark>&nbsp;{{$last ? \'\' : \', \'}} </span><span ng-if="!(vm.event.keywords.length > 0)">N/A</span></div></div></div><div class="table-row mw"><div class="col-xs-6 col-sm-6 col-md-4 table-cell"><div class="h5 mg-0 p-h-1 bkg-edit-item" style="position:absolute;top:0;bottom:0;left:15px;right:15px">Manager</div></div><div class="col-xs-6 col-sm-6 col-md-8 table-cell"><div class="h5 mg-0 p-h-1"><a ui-sref="reporter-detail({id: vm.event.manager.id})">{{vm.event.manager.firstName + \' \' + vm.event.manager.lastName}}</a></div></div></div><div class="col-xs-10 section-header"><div class="h4 p-h-1 mg-t-0 bkg-edit-label">Team</div></div><div class="col-xs-2 section-header"><button type="button" class="btn btn-default bkg-awaiting-signoff rounded-0 mw" ui-sref="report-detail.team({jobId: vm.event.job.id})" ng-disabled="!(vm.jobApplicants.length > 0)"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Manage Team</span></button></div><div print-remove class="table-responsive col-xs-12"><table class="jh-table table table-striped" ng-if="vm.jobApplicants.length > 0"><thead><tr><th><span>No</span></th><th><span>First Name</span></th><th><span>Last Name</span></th><th><span>Email</span></th><th><span>Role</span></th><th><span>Accepted</span></th><th><span>Application Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="applicant in vm.jobApplicants track by applicant.id"><td><a ui-sref="sponsor-detail({id:applicant.reporter.id})">{{applicant.id}}</a></td><td>{{applicant.reporter.firstName}}</td><td>{{applicant.reporter.lastName}}</td><td>{{applicant.reporter.email}}</td><td>{{applicant.reporterJobRole}}</td><td class="text-center"><span class="label label-danger" ng-show="!applicant.accepted"><span class="glyphicon glyphicon-minus-sign"></span> </span><span class="label label-success" ng-show="applicant.accepted"><span class="glyphicon glyphicon-ok-sign"></span></span></td><td>{{applicant.createdDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="reporter-detail({id:applicant.reporter.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button></div></td></tr></tbody></table></div><div class="col-xs-12 section-header"><div class="h4 p-h-1 mg-t-0 bkg-edit-label">Sponsor Information</div></div><!-- <div class="col-xs-2 section-header">\n                          <button type="button" class="btn btn-default bkg-awaiting-signoff rounded-0 mw" \n                          ng-disable="!(vm.sponsors.length > 0)" ng-click="vm.back()">\n                            <span class="glyphicon glyphicon-pencil"></span>\n                            <span class="hidden-xs hidden-sm"> Edit</span>\n                          </button>\n                      </div> --><div print-remove class="table-responsive col-xs-12"><table class="jh-table table table-striped" ng-if="vm.sponsors.length > 0"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span>Sponsor Name</span></th><th><span>Contact Name</span></th><th><span>Contact Email</span></th><th><span>Created Date</span></th><th><span>Sponsor Finder</span></th><th></th></tr></thead><tbody><tr ng-repeat="sponsor in vm.sponsors track by sponsor.id"><td><a ui-sref="sponsor-detail({id:sponsor.id})">{{sponsor.id}}</a></td><td>{{sponsor.sponsorName}}</td><td>{{sponsor.contactName}}</td><td>{{sponsor.contactEmail}}</td><td>{{sponsor.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{sponsor.finder.firstName +\' \'+sponsor.finder.lastName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sponsor-detail({id:sponsor.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button></div></td></tr></tbody></table></div><div class="col-xs-12 section-header"><div class="h4 p-h-1 mg-t-0 bkg-edit-label">Interviews <span ng-if="vm.event.interviewsDueDate">(Due date: {{vm.event.interviewsDueDate | date:\'dd/MM/yyyy HH:mm\'}})</span></div></div><div class="col-xs-12"><div ng-if="vm.event.interviews.length" class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span>Title</span></th><th><span>Interview Date</span></th><th><span>Interview Creation Date</span></th><th><span>Published</span></th><th></th></tr></thead><tbody><tr ng-repeat="interview in vm.event.interviews track by interview.id"><td><a ui-sref="interview-detail({id:interview.id})">{{interview.id}}</a></td><td>{{interview.title}}</td><td>{{interview.interviewDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{interview.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{interview.published}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ng-disabled="!interview.published" ui-sref="report-detail.share-interview({interviewId:interview.id})" class="btn btn-success btn-sm rounded-0"><span class="glyphicon glyphicon-share-alt"></span> <span class="hidden-xs hidden-sm">Share</span></button> <button type="submit" ui-sref="interview-detail({id:interview.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view">View</span></button> <button type="submit" ui-sref="interview.edit({id:interview.id})" ng-if="vm.canEdit(vm.event)" class="btn btn-primary btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button> <button type="submit" ui-sref="interview.delete({id:interview.id})" ng-if="vm.isManager()" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete">Delete</span></button></div></td></tr></tbody></table></div></div><div class="col-xs-10 section-header"><div class="h4 p-h-1 mg-t-0 bkg-edit-label">Location</div></div><div class="col-xs-2 section-header"><button type="button" class="btn btn-default bkg-awaiting-signoff rounded-0 mw" ng-disabled="!vm.event.location" ui-sref="report-detail.location({id:vm.event.id, locationId: vm.event.location.id})"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div><div class="col-xs-12"><div class="h5 mg-0 p-h-1">{{vm.event.location.title}}</div></div><div class="col-xs-12" ng-show="vm.event.location.geoPoint.lon && vm.event.location.geoPoint.lat"><ng-map zoom="16" center="[{{vm.event.location.geoPoint.lat}}, {{vm.event.location.geoPoint.lon}}]"><marker position="[{{vm.event.location.geoPoint.lat}}, {{vm.event.location.geoPoint.lon}}]" title="{{vm.event.location.title}}" centered="true"></marker></ng-map></div></div><!-- end of .row --></div></div></div></div><div print-remove class="row detail-footer bkg-edit-label text-left"><div class="btn-group-center" style="text-align: right" ng-if="vm.isManager()"><button type="button" ng-if="vm.event.published" ui-sref="report-email-prospective-publisher({id:vm.event.id})" class="btn btn-info rounded-0"><span class="glyphicon glyphicon-envelope"></span> <span class="hidden-xs hidden-sm">Email Publishers</span></button> <button type="button" ui-sref="report-email({id:vm.event.id})" class="btn btn-info rounded-0"><span class="glyphicon glyphicon-envelope"></span> <span class="hidden-xs hidden-sm">Email Team</span></button> <button type="button" ui-sref="report-delete({id:vm.event.id})" class="btn btn-danger rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete">Delete</span></button> <button type="button" ng-if="vm.event.reportStatus !== \'COMPLETED\' && vm.event.reportStatus !== \'CANCELLED\'" ui-sref="report-status({id:vm.event.id, status: \'CANCELLED\'})" class="btn btn-info rounded-0"><span class="glyphicon glyphicon-remove"></span> <span class="">Cancel Report</span></button> <button type="button" ng-disabled="!vm.hasSponsorPack()" ng-if="vm.event.reportStatus === \'IN_PRODUCTION\'" ui-sref="report-status({id:vm.event.id, status: \'READY_TO_FILM\'})" class="btn btn-info rounded-0"><span class="glyphicon glyphicon-arrow-right"></span> <span class="">Move to Ready to Film</span></button> <button type="button" ng-if="vm.event.reportStatus === \'READY_TO_FILM\'" ui-sref="report-status({id:vm.event.id, status:\'AWATING_SIGN_OFF\'})" class="btn btn-info rounded-0"><span class="glyphicon glyphicon-arrow-right"></span> <span class="">Move to Awaiting Sign Off</span></button> <button type="button" ng-if="vm.event.reportStatus === \'AWATING_SIGN_OFF\'" ui-sref="report-status({id:vm.event.id, status:\'COMPLETED\'})" class="btn btn-info rounded-0"><span class="glyphicon glyphicon-arrow-right"></span> <span class="">Move to Completed</span></button> <button type="button" ng-if="vm.event.reportStatus === \'CANCELLED\'" ui-sref="report-status({id:vm.event.id, status: \'IN_PRODUCTION\'})" class="btn btn-info rounded-0"><span class="glyphicon glyphicon-arrow-right"></span> <span class="">Move to In-Production</span></button></div></div></div>');
$templateCache.put('app/entities/report/report-film-detail.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.film.title}}</h4></div><div class="modal-body"><div class="embed-responsive embed-responsive-16by9"><video class="embed-responsive-item" ng-src="{{vm.getVideoSrc() | trustURL}}" ng-attr-poster="{{vm.getImageSrc() | trustURL}}" controls></video></div></div><div class="modal-footer bkg-wb-yellow"><!-- TODO: add un/publish btn --></div>');
$templateCache.put('app/entities/report/report-wizard-first.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myJobLabel" ng-if="!vm.event.id">New Report</h4><h4 class="modal-title" id="myJobLabel" ng-if="vm.event.id">Edit Report</h4></div><div class="modal-body"><form id="job-edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" has-any-authority="ROLE_ADMIN" ng-show="vm.event.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.event.id" readonly="readonly"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.job.puid" for="field_puid">PUID</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.event.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"></div></div><div class="form-group"><label class="control-label" for="field_title">Event Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.event.title" required="required"><div ng-show="editForm.title.$invalid"><p class="text-danger" ng-show="editFormLocation.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_price">Project Proposed Price (GBP \xA3)</label><input id="field_price" type="number" step="any" class="form-control" name="field_price" min="0" ng-model="vm.event.job.projectPrice" required="required"><div ng-show="editForm.field_price.$invalid"><p class="text-danger">This field is required, only positive values are allowed.</p></div></div><div class="col-md-6"><label class="control-label">Check pricing strategy</label><div class="button-wrapper"><button class="btn btn-info rounded-0" ui-sref="job-estimator"><span class="glyphicon glyphicon-blackboard"></span> <span class="hidden-xs">Cost Estimator</span></button></div></div></div><div class="form-group clearfix"><label class="control-label" translate="winkballApp.job.description" for="field_description">Description</label><textarea class="form-control" name="description" id="field_description" ng-model="vm.event.description" required="required" rows="6"></textarea><div ng-show="editForm.description.$invalid"><p class="text-danger" ng-show="editForm.description.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><div class="col-md-6"><label class="control-label" for="field_startDate">Event Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" datetime-picker="{{dateformat}}" ng-model="vm.event.startDate" is-open="vm.datePickerOpenStatus.startDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.startDate.$invalid"><p class="text-danger" ng-show="editForm.startDate.$error.required" translate="entity.validation.required">This field is required.</p></div><!-- <p class="help-block">Please enter a start date</p> --></div><div class="col-md-6"><label class="control-label" for="field_dueDate">Report Due Date</label><div class="input-group"><input id="field_dueDate" type="text" class="form-control" name="reportDueDate" datetime-picker="{{dateformat}}" datepicker-options="vm.datePickerOptions" ng-model="vm.event.reportDueDate" is-open="vm.datePickerOpenStatus.reportDueDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'reportDueDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><p class="help-block">Please enter a film due date</p></div></div><div class="form-group"><div class="col-md-6"><label class="control-label" for="field_endDate">Event End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" datetime-picker="{{dateformat}}" ng-model="vm.event.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><!-- <p class="help-block">Please enter a start date</p> --></div><div class="col-md-6"><label class="control-label" for="field_interviewsDueDate">Interviews Due Date</label><div class="input-group"><input id="field_interviewsDueDate" type="text" class="form-control" name="interviewsDueDate" datetime-picker="{{dateformat}}" datepicker-options="vm.datePickerOptions" ng-model="vm.event.interviewsDueDate" is-open="vm.datePickerOpenStatus.interviewsDueDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'interviewsDueDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><p class="help-block">Please enter interviews due date</p></div></div><div class="form-group"><label class="control-label" for="field_website">Event Website</label><input type="text" class="form-control" name="weblink" id="field_website" ng-model="vm.event.job.weblink" ng-maxlength="100" placeholder="http(s)://"><div ng-show="editForm.weblink.$invalid"><p class="text-danger" ng-show="editForm.weblink.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><!-- <p class="help-block" ng-show="editForm.weblink.$error.url"\n            translate="global.messages.validate.url.invalid">\n            Your URL link is invalid.\n          </p> --></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.job.contactName" for="field_contactName">Contact Name</label><input type="text" class="form-control" name="contactName" id="field_contactName" ng-model="vm.event.contactName"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.job.contactPhone" for="field_contactPhone">Contact Phone</label><input type="text" class="form-control" name="contactPhone" id="field_contactPhone" ng-maxlength="21" ng-pattern="vm.phoneRegex" ng-model="vm.event.contactPhone" placeholder="e.g. +440123456789"><div ng-show="editForm.contactPhone.$invalid"><p class="text-danger" ng-show="editForm.contactPhone.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p><p class="text-danger" ng-show="editForm.contactPhone.$error.pattern">Phone number is invalid. Please make sure there is no white spaces or braces.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_contact_email">Contact Email</label><input class="form-control" id="field_contact_email" name="email" ng-maxlength="100" ng-model="vm.event.contactEmail" type="email"><div ng-show="editForm.email.$invalid"><p class="text-danger" ng-show="editForm.email.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p><p class="text-danger" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="col-md-6"><div class="checkbox"><label><input id="field_privacy" name="privacy" ng-model="vm.event.published" type="checkbox"> Keep this project published?</label></div><!-- <div class="checkbox">\n          <label>\n            <input id="field_approved"\n              name="approved"\n              ng-model="vm.event.approved"\n              type="checkbox"/>\n              Has this project been approved?\n          </label>\n        </div> --></div></div></form><div class="file-holder"><div ng-if="!vm.event.thumbnail" id="field_videoFile"><h4>Project Thumbnail</h4><button type="file" class="btn btn-primary rounded-0" ng-disabled="(editForm.$invalid || vm.isSaving) && !vm.errFile" ngf-select="vm.uploadFile($file, $invalidFiles)" ngf-accept="\'image/jpeg,image/png\'" ngf-max-size="5MB" ngf-min-width="48"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button><div ng-show="vm.errFile.$error"><span style="font-size:smaller">{{vm.errFile.name}}</span><p class="alert-danger" ng-show="vm.errFile.$error == \'minWidth\'">Minimum image width should be 48px</p><p class="alert-danger" ng-show="vm.errFile.$error == \'maxSize\'">Maximum image size permitted is 5MB</p></div><span style="font-size:smaller">{{vm.f.name}}</span> <span class="progress" ng-show="vm.f.progress >= 0"><div ng-style="{width: vm.f.progress + \'%\'}" ng-bind="vm.f.progress + \'%\'"></div></span><p>{{vm.errorMsg}}</p></div><div ng-if="vm.event.thumbnail"><h4>Project Thumbnail</h4><button type="button" ng-click="vm.deleteThumbnail()" class="btn btn-danger rounded-0"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete Thumbnail</span></button><hr><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Event Thumbnail"></div></div></div><div class="modal-footer bkg-wb-yellow" style="text-align:center"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-default rounded-0" form="job-edit-form"><span class="glyphicon glyphicon-arrow-right"></span>&nbsp;<span>Next</span></button></div>');
$templateCache.put('app/entities/report/report-wizard-last.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myJobLabel">Report: {{vm.event.title}}</h4></div><div class="modal-body"><form id="job-edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix"><h4>Categories</h4><label class="category-label" ng-repeat="category in vm.categories"><input type="checkbox" name="selectedCategories[]" value="{{category.name}}" ng-checked="vm.event.categories.indexOf(category.name) > -1" ng-click="vm.toggleCategory(category.name)"> {{category.display}}</label></div><div class="form-group"><h4>Keywords</h4><tags-input ng-model="vm.event.keywords" replace-spaces-with-dashes="false" display-property="text" placeholder="{{vm.event.keywords.length > 0 ? \' \' : \'Type to add a keyword\'}}" add-from-autocomplete-only="false"><auto-complete source="vm.searchKeywords($query)" min-length="3" max-results-to-show="10"></auto-complete></tags-input></div><div class="form-group" ng-show="vm.event.claimed"><label class="control-label" for="field_claimed">Claimed</label><input class="form-control" id="field_claimed" name="claimed" ng-model="vm.event.claimed" type="checkbox" ng-disabled="true"><p class="help-block">The tick indicates whether this job has been claimed, e.g. has an owner</p></div><div class="form-group"><h4>Location</h4><tags-input ng-model="vm.tagLocation" max-tags="1" replace-spaces-with-dashes="false" on-tag-removed="vm.locationRemoved()" on-tag-added="vm.locationAdded()" display-property="title" key-property="id" placeholder="{{vm.tagLocation.length > 0 ? \' \' : \'Type to search for an existing location\'}}" add-from-autocomplete-only="true"><auto-complete source="vm.searchLocation($query)" min-length="3" max-results-to-show="10"></auto-complete></tags-input></div><p><strong>OR, create a new location below</strong></p></form><form id="location-edit-form" name="editFormLocation" role="form" novalidate ng-submit="vm.saveLocation()" show-validation><!-- <h4>Location</h4> --><div class="location-btn-group clearfix"><!-- search/go to current location --><div class="col-lg-6"><div class="input-group"><input type="text" ng-model="vm.search" class="form-control" placeholder="Search for an address or place"><div class="input-group-btn"><button class="btn btn-primary" type="button" ng-click="vm.geoCode()" ng-disabled="vm.search.length == 0 || vm.tagLocation.length > 0" title="search"><span class="glyphicon glyphicon-search"></span>&nbsp;<span>Find Location</span></button></div><!-- <button class="btn" type="button" ng-click="gotoCurrentLocation()" title="current location">\n                &nbsp;<span class="glyphicon glyphicon-home"></span>\n              </button> --></div></div><div class="col-lg-6"><button type="submit" ng-disabled="editFormLocation.$invalid || vm.isSaving || vm.location.id" class="btn btn-info" form="location-edit-form"><span class="glyphicon glyphicon-map-marker"></span>&nbsp;<span>Save Location</span></button></div></div><h5>Give location a name</h5><div class="location-btn-group clearfix"><!-- <label class="control-label" for="field_location_title">Location name</label> --><div class="col-lg-6"><input type="text" class="form-control" name="title" id="field_location_title" ng-model="vm.location.title" required><!-- <div ng-show="editFormLocation.title.$invalid">\n          <p class="help-block"\n              ng-show="editFormLocation.title.$error.required" translate="entity.validation.required">\n              This field is required.\n          </p>\n        </div> --></div><div class="col-lg-6"><button type="button" ng-disabled="editFormLocation.$invalid || vm.isSaving" class="btn btn-info" ng-click="vm.clearLocation()"><span class="glyphicon glyphicon-trash"></span>&nbsp;<span>Clear Location</span></button></div></div><div class="row hidden"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_latitude">Latitude</label><input type="number" class="form-control" name="latitude" id="field_latitude" ng-model="vm.location.geoPoint.lat" required readonly="readonly"><div ng-show="editFormLocation.latitude.$invalid"><p class="text-danger" ng-show="editFormLocation.latitude.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_longitude">Longitude</label><input type="number" class="form-control" name="longitude" id="field_longitude" ng-model="vm.location.geoPoint.lon" required readonly="readonly"><div ng-show="editFormLocation.longitude.$invalid"><p class="text-danger" ng-show="editFormLocation.longitude.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div></div><div class="map-holder"><p>Please <b>click</b> on the <i>Map</i> to give precise location or search for an <i>address</i> or a <i>place</i>!</p><div ng-if="vm.location.geoPoint.lat && vm.location.geoPoint.lon"><ng-map zoom="17" center="[{{vm.location.geoPoint.lat}}, {{vm.location.geoPoint.lon}}]" on-click="vm.addMarker()"><marker position="[{{vm.location.geoPoint.lat}}, {{vm.location.geoPoint.lon}}]" title="{{vm.location.title}}" centered="true"></marker></ng-map></div><div ng-if="!vm.location.geoPoint.lat || !vm.location.geoPoint.lon"><ng-map default-style="true" center="current-location" zoom="16" on-click="vm.addMarker()"></ng-map></div></div></form></div><div class="modal-footer bkg-wb-yellow" style="text-align:center"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.back()"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span>Back</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-default rounded-0" form="job-edit-form"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save Report</span></button></div>');
$templateCache.put('app/entities/report/report-wizard-second.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myJobLabel">Report: {{vm.event.title}}</h4></div><div class="modal-body"><form id="job-edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" has-any-authority="ROLE_ADMIN" ng-show="vm.event.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.event.id" readonly="readonly"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.job.puid" for="field_puid">PUID</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.event.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"></div></div><div class="form-group" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><h4>Manager</h4><angucomplete-alt id="field_manager" placeholder="Add a manager" pause="400" selected-object="vm.getManager" initial-value="vm.event.manager" remote-api-handler="vm.searchUser" title-field="firstName,lastName" description-field="email" input-class="form-control form-control-small"></div><div class="form-group"><label class="control-label" for="field_editorial_storyline">Editorial Story Line</label><textarea class="form-control" name="editorialStoryline" id="field_editorial_storyline" ng-model="vm.event.editorialStoryline" ng-maxlength="1000" rows="4"></textarea><div ng-show="editForm.editorialStoryline.$invalid"><p class="text-danger" ng-show="editForm.editorialStoryline.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_key_talent">Key Talent(s)</label><textarea class="form-control" name="keytalent" id="field_key_talent" ng-model="vm.event.keyTalent" ng-maxlength="1000" rows="5"></textarea><div ng-show="editForm.keytalent.$invalid"><p class="text-danger" ng-show="editForm.keytalent.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" for="social_media">Social Media</label><textarea class="form-control" name="socialMedia" id="social_media" placeholder="Facebook, Instagram, Twitter, etc" ng-model="vm.event.socialMedia" ng-maxlength="400" rows="4"></textarea><div ng-show="editForm.socialMedia.$invalid"><p class="text-danger" ng-show="editForm.socialMedia.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="400">This field cannot be longer than 400 characters.</p></div></div></form></div><div class="modal-footer bkg-wb-yellow" style="text-align:center"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.back()"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span>Back</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-default rounded-0" form="job-edit-form"><span class="glyphicon glyphicon-arrow-right"></span>&nbsp;<span>Next</span></button></div>');
$templateCache.put('app/entities/reporter/reporter-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.reporter.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.reporter.delete.question" translate-values="{id: \'{{vm.reporter.id}}\'}">Are you sure you want to delete this Reporter?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/reporter/reporter-detail.html','<div><button type="button" ng-click="vm.back()" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="reporter-detail.edit({id:vm.reporter.id})" ng-disabled="!vm.checkEditPermission()" class="btn btn-primary btn-lg rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit Profile</span></button><hr><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-md-4"><div class="img-container"><img ng-if="vm.reporter.profilePicture" class="img-responsive" src="content/images/spinner.svg" ng-src="{{vm.getImageSrc(384,216) | trustURL}}" alt="Profile Picture"> <img ng-if="!vm.reporter.profilePicture" class="img-responsive" ng-src="{{\'content/images/noperson.png\' | trustURL}}" alt="Profile Picture"></div></div><div class="col-md-8"><h2><span translate="winkballApp.reporter.detail.title">Reporter</span>: {{vm.reporter.firstName +\' \'+ vm.reporter.lastName}}</h2><span>Date Joined: <span>{{vm.reporter.dateJoined | date:\'dd/MM/yyyy\'}}</span></span></div></div><hr><!-- <div ng-if="vm.reporter.profilePicture">\n      <img class="img-thumbnail" width="160" height="160" ng-src="{{vm.getImageSrc(160,160) | trustURL}}" alt="Profile Picture"/>\n    </div> --><dl class="dl-horizontal jh-entity-details dl-stripped"><!-- <dt><span translate="winkballApp.reporter.puid">Puid</span></dt>\n        <dd>\n            <span>{{vm.reporter.puid}}</span>\n        </dd> --><dt has-any-authority="ROLE_ADMIN"><span>ID</span></dt><dd has-any-authority="ROLE_ADMIN"><span>{{vm.reporter.id}}</span></dd><dt><span>Full Name</span></dt><dd><span>{{vm.reporter.firstName + \' \' + vm.reporter.lastName}}</span></dd><dt><span translate="winkballApp.reporter.login">Login</span></dt><dd><span>{{vm.reporter.login}}</span></dd><dt><span translate="winkballApp.reporter.email">Email</span></dt><dd><span>{{vm.reporter.email}}</span></dd><dt has-any-authority="ROLE_ADMIN,ROLE_MANAGER"><span>Personal Email</span></dt><dd has-any-authority="ROLE_ADMIN,ROLE_MANAGER"><span>{{vm.reporter.contactEmail}}</span></dd><dt><span translate="winkballApp.reporter.contactNumber">Contact Number</span></dt><dd><span>{{vm.reporter.contactNumber}}</span></dd><!-- <dt><span translate="winkballApp.reporter.level">Level</span></dt>\n        <dd>\n            <span>{{vm.reporter.level}}</span>\n        </dd>\n        <dt><span translate="winkballApp.reporter.rating">Rating</span></dt>\n        <dd>\n            <span>{{vm.reporter.rating}}</span>\n        </dd> --><!-- <dt><span translate="winkballApp.reporter.profilePicture">Profile Picture</span></dt>\n        <dd>\n            <span>{{vm.reporter.profilePicture}}</span>\n        </dd> --><!-- <dt><span>Featured Film</span></dt>\n        <dd>\n            <a ui-sref="film-detail({id:vm.reporter.featuredFilmId})">{{vm.reporter.featuredFilmId}}</a>\n        </dd> --><dt><span>Skills</span></dt><dd><span ng-repeat="skill in vm.reporter.skills"><!-- <a ui-sref="skill-detail({id: skill.id})">{{skill.name}}</a>{{$last ? \'\' : \', \'}} --> <span>{{skill.name}}</span>{{$last ? \'\' : \', \'}}</span></dd><dt><span>My interests</span></dt><dd><span>{{vm.reporter.aboutMe}}</span></dd><dt><span>My region</span></dt><dd><span>{{vm.reporter.region}}</span></dd><dt><span>Twitter</span></dt><dd><span>{{vm.twitter.url}}</span></dd><dt><span>Facebook</span></dt><dd><span>{{vm.facebook.url}}</span></dd><dt><span>Instagram</span></dt><dd><span>{{vm.instagram.url}}</span></dd><dt><span>Website</span></dt><dd><span>{{vm.website.url}}</span></dd><dt ng-if="vm.checkEditPermission()"><span>Postal Address</span></dt><dd ng-if="vm.checkEditPermission()"><!-- <a ng-if="vm.reporter.addressId" ui-sref="postal-address-detail({id:vm.reporter.addressId})">{{vm.address.firlstLineOfAddress + \', \' + vm.address.postCode}}</a> --> <span ng-if="vm.reporter.addressId">{{vm.address.firlstLineOfAddress + \', \' + (vm.address.secondLineOfAddress ? vm.address.secondLineOfAddress +\', \' : \'\') + (vm.address.town ? vm.address.town +\', \' : \'\') + (vm.address.county ? vm.address.county +\', \' : \'\') + vm.address.postCode}}</span></dd><dt has-any-authority="ROLE_ADMIN"><span translate="winkballApp.reporter.activated">Activated</span></dt><dd has-any-authority="ROLE_ADMIN"><span>{{vm.reporter.activated}}</span></dd><dt has-any-authority="ROLE_ADMIN"><span>Public</span></dt><dd has-any-authority="ROLE_ADMIN"><span>{{vm.reporter.published}}</span></dd><dt has-any-authority="ROLE_ADMIN"><span translate="winkballApp.reporter.langKey">Language</span></dt><dd has-any-authority="ROLE_ADMIN"><span>{{vm.reporter.langKey}}</span></dd><dt has-any-authority="ROLE_ADMIN"><span translate="winkballApp.reporter.user">User</span></dt><dd has-any-authority="ROLE_ADMIN">{{vm.reporter.userId}}</dd></dl></div>');
$templateCache.put('app/entities/reporter/reporter-dialog.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myReporterLabel" translate="winkballApp.reporter.home.createOrEditLabel">Create or edit a Reporter</h4></div><div class="modal-body"><form name="editForm" id="reporterEditForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix"><div class="col-md-6" ng-show="vm.reporter.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.reporter.id" readonly="readonly"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.reporter.login">Login</label><input ng-readonly="!vm.isManager()" type="text" class="form-control" name="login" ng-model="vm.reporter.login" ng-required="vm.reporter.userId == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group" ng-show="vm.reporter.puid"><input type="hidden" class="form-control" name="puid" id="field_puid" ng-model="vm.reporter.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.reporter.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.reporter.firstName" ng-maxlength="50" required><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.firstName.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-6"><label translate="winkballApp.reporter.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.reporter.lastName" ng-maxlength="50" required><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.lastName.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.reporter.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.reporter.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="col-md-6"><label class="control-label" translate="winkballApp.reporter.contactNumber" for="field_contactNumber">Contact Number</label><input type="text" class="form-control" name="contactNumber" id="field_contactNumber" ng-model="vm.reporter.contactNumber" ng-maxlength="100"><div ng-show="editForm.contactNumber.$invalid"><p class="help-block" ng-show="editForm.contactNumber.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><label class="control-label">Personal email</label><input type="email" class="form-control" name="contactEmail" ng-model="vm.reporter.contactEmail" ng-maxlength="100"><div ng-show="editForm.contactEmail.$invalid"><p class="help-block" ng-show="editForm.contactEmail.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.contactEmail.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" translate="winkballApp.reporter.dateJoined" for="field_dateJoined">Date Joined</label><div class="input-group"><input id="field_dateJoined" type="text" class="form-control" name="dateJoined" datetime-picker="{{dateformat}}" ng-model="vm.reporter.dateJoined" is-open="vm.datePickerOpenStatus.dateJoined"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateJoined\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-6"><label for="field_region">My Region</label><select class="form-control" id="field_region" name="address" ng-model="vm.reporter.region"><option value="LONDON">London</option><option value="CYMRU_WALES">Cymru Wales</option><option value="EAST_OF_ENGLAND">East of England</option><option value="NORTH_EAST_AND_CUMBRIA">North East and Cumbria</option><option value="NORTHERN_IRELAND">Northern Ireland</option><option value="SOUTH_EAST">South East</option><option value="WEST_MIDLANDS">West Midlands</option><option value="EAST_MIDLANDS">East Midlands</option><option value="NORTH_WEST">North West</option><option value="SCOTLAND">Scotland</option><option value="SOUTH_WEST">South West</option><option value="YORKSHIRE_AND_THE_HUMBER">Yorkshire and The Humber</option><option value="NATIONWIDE">Nationwide</option></select></div></div><div class="form-group" ng-show="false"><label translate="winkballApp.reporter.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.reporter.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group clearfix" ng-show="vm.reporter.id" has-any-authority="ROLE_ADMIN"><div class="col-md-6"><label class="control-label" translate="winkballApp.reporter.level" for="field_level">Level</label><select class="form-control" id="field_level" name="level" ng-model="vm.reporter.level" ng-options="level as level for level in vm.levels track by level"></select></div><div class="col-md-6"><label class="control-label" translate="winkballApp.reporter.rating" for="field_rating">Rating</label><input type="number" class="form-control" name="rating" id="field_rating" ng-model="vm.reporter.rating" step="1" min="0" max="5"></div></div><div class="form-group" has-any-authority="ROLE_ADMIN,ROLE_MANAGER"><div class="col-md-6"><label for="activated"><input ng-disabled="vm.reporter.id === null" type="checkbox" id="activated" ng-model="vm.reporter.activated"> <span translate="winkballApp.reporter.activated">Activated</span></label><label for="published"><input type="checkbox" id="published" ng-model="vm.reporter.published"> <span>Public</span></label></div><div class="col-md-6" ng-show="vm.reporter.profilePicture"><label class="control-label" translate="winkballApp.reporter.profilePicture" for="field_profilePicture">Profile Picture</label><input type="text" class="form-control" name="profilePicture" id="field_profilePicture" ng-model="vm.reporter.profilePicture"></div></div><div class="form-group"><h4>Skills</h4><label class="category-label" ng-repeat="skill in vm.skills"><input type="checkbox" name="selectedSkills[]" value="{{skill.id}}" ng-checked="vm.checkedSkill(skill)" ng-click="vm.toggleSkill(skill)"> {{skill.name}}</label></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_twitter">Twitter</label><div class="input-group"><input type="url" class="form-control" name="twitter" id="field_twitter" ng-model="vm.twitter.url" ng-maxlength="150" placeholder="e.g. https://twitter.com/winkball" ng-pattern="/^https?:\\/\\/(www\\.)?twitter\\.com\\/(#!\\/)?([^\\/]+)(\\/\\w+)*$/"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-disabled="!vm.twitter.url" ng-click="vm.deleteLink(vm.twitter)"><span class="glyphicon glyphicon-trash"></span></button></span></div><div ng-show="editForm.twitter.$invalid"><p class="help-block" ng-show="editForm.twitter.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.twitter.$error.url" translate="global.messages.validate.url.invalid">Your URL link is invalid.</p><p class="help-block" ng-show="editForm.twitter.$error.pattern">Please enter valid Twitter URL</p></div></div><div class="col-md-6"><label class="control-label" for="field_facebook">Facebook</label><div class="input-group"><input type="url" class="form-control" name="facebook" id="field_facebook" ng-model="vm.facebook.url" ng-maxlength="150" placeholder="e.g. https://www.facebook.com/WinkBall" ng-pattern="/^https?:\\/\\/(www\\.)?facebook\\.com\\/(#!\\/)?([^\\/]+)(\\/\\w+)*$/"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-disabled="!vm.facebook.url" ng-click="vm.deleteLink(vm.facebook)"><span class="glyphicon glyphicon-trash"></span></button></span></div><div ng-show="editForm.facebook.$invalid"><p class="help-block" ng-show="editForm.facebook.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.facebook.$error.url" translate="global.messages.validate.url.invalid">Your URL link is invalid.</p><p class="help-block" ng-show="editForm.facebook.$error.pattern">Please enter valid Facebook URL</p></div></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_instagram">Instagram</label><div class="input-group"><input type="url" class="form-control" name="instagram" id="field_instagram" ng-model="vm.instagram.url" ng-maxlength="150" placeholder="e.g. https://www.instagram.com/winkballvideo" ng-pattern="/^https?:\\/\\/(www\\.)?instagram\\.com\\/(#!\\/)?([^\\/]+)(\\/\\w+)*$/"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-disabled="!vm.instagram.url" ng-click="vm.deleteLink(vm.instagram)"><span class="glyphicon glyphicon-trash"></span></button></span></div><div ng-show="editForm.instagram.$invalid"><p class="help-block" ng-show="editForm.instagram.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.instagram.$error.url" translate="global.messages.validate.url.invalid">Your URL link is invalid.</p><p class="help-block" ng-show="editForm.instagram.$error.pattern">Please enter valid Instagram URL</p></div></div><div class="col-md-6"><label class="control-label" for="field_website">Website</label><div class="input-group"><input type="url" class="form-control" name="website" id="field_website" ng-model="vm.website.url" ng-maxlength="150" placeholder="e.g. https://www.winkball.com"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-disabled="!vm.website.url" ng-click="vm.deleteLink(vm.website)"><span class="glyphicon glyphicon-trash"></span></button></span></div><div ng-show="editForm.website.$invalid"><p class="help-block" ng-show="editForm.website.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.website.$error.url" translate="global.messages.validate.url.invalid">Your URL link is invalid.</p></div></div></div><div class="form-group"><label class="control-label" for="field_aboutMe">My Interests</label><textarea class="form-control" name="aboutMe" id="field_aboutMe" ng-model="vm.reporter.aboutMe"></textarea></div><!-- <div class="form-group">\n            <label for="field_featured_film">Featured Film</label>\n            <select class="form-control" id="field_featured_film" name="featuredFilm" ng-model="vm.reporter.featuredFilmId" ng-options="featuredFilm.id as featuredFilm.title for featuredFilm in vm.films">\n                <option value=""></option>\n            </select>\n        </div> --><div class="form-group"><h4>Postal Address</h4></div><!-- Postal Address --><div class="form-group" ng-show="false"><label for="address_id" translate="global.field.id">ID</label><input type="text" class="form-control" id="address_id" name="addresid" ng-model="vm.address.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_firlstLineOfAddress">First Line Of Address</label><input type="text" class="form-control" name="firlstLineOfAddress" id="field_firlstLineOfAddress" ng-model="vm.address.firlstLineOfAddress" ng-maxlength="150" required><div ng-show="editForm.firlstLineOfAddress.$invalid"><p class="help-block" ng-show="editForm.firlstLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="help-block" ng-show="editForm.firlstLineOfAddress.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_secondLineOfAddress">Second Line Of Address</label><input type="text" class="form-control" name="secondLineOfAddress" id="field_secondLineOfAddress" ng-model="vm.address.secondLineOfAddress" ng-maxlength="150"><div ng-show="editForm.secondLineOfAddress.$invalid"><p class="help-block" ng-show="editForm.secondLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_town">Town</label><input type="text" class="form-control" name="town" id="field_town" ng-model="vm.address.town" ng-maxlength="100"><div ng-show="editForm.town.$invalid"><p class="help-block" ng-show="editForm.town.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_county">County</label><input type="text" class="form-control" name="county" id="field_county" ng-model="vm.address.county"></div><div class="form-group"><label class="control-label" for="field_postCode">Post Code</label><input type="text" class="form-control" name="postCode" id="field_postCode" ng-model="vm.address.postCode" ng-maxlength="50" required><div ng-show="editForm.postCode.$invalid"><p class="help-block" ng-show="editForm.postCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.postCode.$error.required" translate="entity.validation.required">This field is required.</p></div></div></form><div class="file-holder"><div ng-if="!vm.reporter.profilePicture" id="field_videoFile"><h4>Profile Picture</h4><button type="file" class="btn btn-primary" ng-disabled="(editForm.$invalid || vm.isSaving) && !errFile" ngf-select="uploadFile($file, $invalidFiles)" accept="image/jpeg,image/png" ngf-min-height="720" ngf-min-width="1280" ngf-max-size="5MB"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button><div ng-show="errFile.$error"><span style="font-size:smaller">{{errFile.name}}</span><p class="alert-danger" ng-show="errFile.$error == \'minHeight\'">Minimum image height should be 720px</p><p class="alert-danger" ng-show="errFile.$error == \'minWidth\'">Minimum image width should be 1280px</p><p class="alert-danger" ng-show="errFile.$error == \'maxSize\'">Maximum image size permitted is 5MB</p></div><span style="font:smaller">{{f.name}}</span> <span class="progress" ng-show="f.progress >= 0"><div style="width:{{f.progress}}%" ng-bind="f.progress + \'%\'"></div></span><p>{{errorMsg}}</p></div><div ng-if="vm.reporter.profilePicture"><h4>Profile Picture</h4><button type="button" ng-click="vm.deleteProfilePicture()" class="btn btn-danger"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete Picture</span></button><hr><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Profile Picture"></div></div></div><div class="modal-footer bkg-wb-yellow"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-default rounded-0" form="reporterEditForm"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/entities/reporter/reporters.html','<div><h2 translate="winkballApp.reporter.home.title">Reporters</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary rounded-0" ui-sref="reporter.new" has-any-authority="ROLE_ADMIN,ROLE_MANAGER"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.reporter.home.createLabel">Create new Reporter</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.reporter.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="winkballApp.reporter.firstName">First Name</span></th><th><span translate="winkballApp.reporter.lastName">Last Name</span></th><th><span translate="winkballApp.reporter.email">Email</span></th><!-- <th jh-sort-by="dateJoined"><span translate="winkballApp.reporter.dateJoined">Date Joined</span> <span class="glyphicon glyphicon-sort"></span></th> --><th jh-sort-by="contactNumber"><span translate="winkballApp.reporter.contactNumber">Contact Number</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="reporter in vm.reporters track by reporter.id"><td><a ui-sref="reporter-detail({id:reporter.id})">{{reporter.id}}</a></td><td>{{reporter.firstName}}</td><td>{{reporter.lastName}}</td><td>{{reporter.email}}</td><!-- <td>{{reporter.dateJoined | date:\'dd/MM/yyyy\'}}</td> --><td>{{reporter.contactNumber}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="reporter-detail({id:reporter.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ng-if="vm.canEdit()" ui-sref="reporter.edit({id:reporter.id})" class="btn btn-primary btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ng-if="vm.canEdit()" ui-sref="reporter.delete({id:reporter.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/skill/skill-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.skill.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.skill.delete.question" translate-values="{id: \'{{vm.skill.id}}\'}">Are you sure you want to delete this Skill?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/skill/skill-detail.html','<div><h2><span translate="winkballApp.skill.detail.title">Skill</span> {{vm.skill.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.skill.name">Name</span></dt><dd><span>{{vm.skill.name}}</span></dd><dt><span translate="winkballApp.skill.description">Description</span></dt><dd><span>{{vm.skill.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="skill-detail.edit({id:vm.skill.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/skill/skill-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySkillLabel" translate="winkballApp.skill.home.createOrEditLabel">Create or edit a Skill</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.skill.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.skill.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="winkballApp.skill.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.skill.name" required ng-maxlength="100"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.skill.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.skill.description"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/skill/skills.html','<div><h2 translate="winkballApp.skill.home.title">Skills</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="skill.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.skill.home.createLabel">Create new Skill</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.skill.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span translate="winkballApp.skill.name">Name</span></th><th><span translate="winkballApp.skill.description">Description</span></th><th></th></tr></thead><tbody><tr ng-repeat="skill in vm.skills track by skill.id"><td><a ui-sref="skill-detail({id:skill.id})">{{skill.id}}</a></td><td>{{skill.name}}</td><td>{{skill.description}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="skill-detail({id:skill.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="skill.edit({id:skill.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="skill.delete({id:skill.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/sponsor/sponsor-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sponsor.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.sponsor.delete.question" translate-values="{id: \'{{vm.sponsor.id}}\'}">Are you sure you want to delete this Sponsor?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/sponsor/sponsor-detail.html','<div><button type="submit" ng-click="vm.back()" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="sponsor-detail.edit({id:vm.sponsor.id})" class="btn btn-primary btn-lg rounded-0" ng-disabled="!vm.canEdit()"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button><!-- <div class="btn-group pull-right">\n    <button type="submit" ng-disabled="vm.sponsorInvoice || !vm.isManager()"\n        ui-sref="sponsor-invoice.new({sponsor:vm.sponsor.id})"\n        class="btn btn-success">\n      <span class="glyphicon glyphicon-plus"></span>\n      <span class="hidden-xs hidden-sm"> Create Invoice</span>\n    </button>\n  </div> --><h2><span translate="winkballApp.sponsor.detail.title">Sponsor</span> : {{vm.sponsor.sponsorName}}</h2><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt ng-if="vm.isManager()"><span>ID</span></dt><dd ng-if="vm.isManager()"><span>{{vm.sponsor.id}}</span></dd><dt><span translate="winkballApp.sponsor.sponsorName">Sponsor Name</span></dt><dd><span>{{vm.sponsor.sponsorName}}</span></dd><dt><span translate="winkballApp.sponsor.contactName">Contact Name</span></dt><dd><span>{{vm.sponsor.contactName}}</span></dd><dt><span translate="winkballApp.sponsor.contactEmail">Contact Email</span></dt><dd><span>{{vm.sponsor.contactEmail}}</span></dd><dt><span>Telephone</span></dt><dd><span>{{vm.sponsor.telephone}}</span></dd><dt><span>Project Proposal</span></dt><dd><a ui-sref="job-detail({id:vm.sponsor.job.id})">{{vm.sponsor.job.title}}</a></dd><dt><span>Amount</span></dt><dd><span>{{vm.sponsor.sponsorshipAmount | currency: "GBP \xA3" : 2}}</span></dd><dt><span>Sponsor Finder</span></dt><dd><a ui-sref="reporter-detail({id:vm.sponsor.finder.id})">{{vm.sponsor.finder.firstName +\' \'+ vm.sponsor.finder.lastName }}</a></dd><dt><span>1st Line Of Address</span></dt><dd><span>{{vm.sponsor.address.firlstLineOfAddress}}</span></dd><dt><span>2nd Line Of Address</span></dt><dd><span>{{vm.sponsor.address.secondLineOfAddress}}</span></dd><dt><span>Town</span></dt><dd><span>{{vm.sponsor.address.town}}</span></dd><dt><span>County</span></dt><dd><span>{{vm.sponsor.address.county}}</span></dd><dt><span>Post Code</span></dt><dd><span>{{vm.sponsor.address.postCode}}</span></dd><dt><span>Country</span></dt><dd><span>{{vm.sponsor.address.country}}</span></dd></dl><div class="table-responsive" ng-if="vm.sponsorInvoice && vm.isManager()"><h3>Payment</h3><table class="jh-table table table-striped"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span>Paid</span></th><th><span>Amount</span></th><th><span>Created Date</span></th><th><span>Created By</span></th><th></th></tr></thead><tbody><tr><td><a ui-sref="sponsor-invoice-detail({id:vm.sponsorInvoice.id})">{{vm.sponsorInvoice.id}}</a></td><td>{{vm.sponsorInvoice.paymentDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{vm.sponsorInvoice.amount | currency: "GBP \xA3" : 2}}</td><td>{{vm.sponsorInvoice.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{vm.sponsorInvoice.createdBy}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sponsor-invoice-detail({id:vm.sponsorInvoice.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/sponsor/sponsor-dialog.html','<div class="modal-header bkg-wb-yellow"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySponsorLabel" translate="winkballApp.sponsor.home.createOrEditLabel">Create or edit a Sponsor</h4></div><div class="modal-body"><form id="sponsor-edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" ng-show="vm.sponsor.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sponsor.id" readonly="readonly"></div><div class="col-md-6" ng-show="vm.sponsor.puid"><label class="control-label" translate="winkballApp.sponsor.puid" for="field_puid">Puid</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.sponsor.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"><div ng-show="editForm.puid.$invalid"><p class="text-danger" ng-show="editForm.puid.$error.minlength" translate="entity.validation.minlength" translate-value-min="12">This field is required to be at least 12 characters.</p><p class="text-danger" ng-show="editForm.puid.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="12">This field cannot be longer than 12 characters.</p></div></div></div><div class="form-group"><label class="control-label" translate="winkballApp.sponsor.sponsorName" for="field_sponsorName">Sponsor Name</label><input type="text" class="form-control" name="sponsorName" id="field_sponsorName" ng-model="vm.sponsor.sponsorName" required><div ng-show="editForm.sponsorName.$invalid"><p class="text-danger" ng-show="editForm.sponsorName.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.sponsor.contactName" for="contactName">Contact Name</label><input type="text" class="form-control" name="contactName" id="field_contactName" ng-model="vm.sponsor.contactName" required><div ng-show="editForm.contactName.$invalid"><p class="text-danger" ng-show="editForm.contactName.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group clearfix"><div class="col-md-6"><label class="control-label" for="field_sponsor_email" translate="winkballApp.sponsor.contactEmail">Email</label><input class="form-control" id="field_sponsor_email" name="email" ng-maxlength="100" ng-model="vm.sponsor.contactEmail" type="email"><div ng-show="editForm.email.$invalid"><p class="text-danger" ng-show="editForm.email.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p><p class="text-danger" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="col-md-6"><label class="control-label" for="field_sponsor_telephone">Telephone</label><input class="form-control" id="field_sponsor_telephone" name="telephone" ng-maxlength="100" ng-model="vm.sponsor.telephone" type="text"><div ng-show="editForm.telephone.$invalid"><p class="text-danger" ng-show="editForm.telephone.$error.maxlength" translate-value-max="100" translate="entity.validation.maxlength">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><label class="control-label" for="field_price">Sponsorship Amount (GBP \xA3)</label><input id="field_price" type="number" step="any" class="form-control" name="field_price" min="0" ng-model="vm.sponsor.sponsorshipAmount" required="required"><div ng-show="editForm.field_price.$invalid"><p class="text-danger">This field is required, only positive values are allowed.</p></div></div><div class="form-group"><label for="field_job">Project Proposal</label><select class="form-control" id="field_job" name="job" ng-model="vm.sponsor.job" ng-options="job as job.title for job in vm.jobs track by job.id"><option value=""></option></select></div><div class="form-group"><label translate="winkballApp.sponsor.finder" for="field_finder">Sponsor Finder</label><select class="form-control" id="field_finder" name="finder" ng-model="vm.sponsor.finder" ng-options="user as (user.firstName + \' \' + user.lastName) for user in vm.users track by user.id"><option value=""></option></select></div><hr><div class="form-group"><h4>Sponsor Address</h4></div><!-- Postal Address --><div class="form-group" ng-show="vm.sponsor.address.id"><label for="address_id" translate="global.field.id">ID</label><input type="text" class="form-control" id="address_id" name="addresid" ng-model="vm.sponsor.address.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_firlstLineOfAddress">First Line Of Address</label><input type="text" class="form-control" name="firlstLineOfAddress" id="field_firlstLineOfAddress" ng-model="vm.sponsor.address.firlstLineOfAddress" ng-maxlength="150" required><div ng-show="editForm.firlstLineOfAddress.$invalid"><p class="text-danger" ng-show="editForm.firlstLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p><p class="text-danger" ng-show="editForm.firlstLineOfAddress.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_secondLineOfAddress">Second Line Of Address</label><input type="text" class="form-control" name="secondLineOfAddress" id="field_secondLineOfAddress" ng-model="vm.sponsor.address.secondLineOfAddress" ng-maxlength="150"><div ng-show="editForm.secondLineOfAddress.$invalid"><p class="text-danger" ng-show="editForm.secondLineOfAddress.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_town">Town</label><input type="text" class="form-control" name="town" id="field_town" ng-model="vm.sponsor.address.town" ng-maxlength="100"><div ng-show="editForm.town.$invalid"><p class="text-danger" ng-show="editForm.town.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_county">County</label><input type="text" class="form-control" name="county" id="field_county" ng-model="vm.sponsor.address.county"></div><div class="form-group"><label class="control-label" for="field_postCode">Post Code</label><input type="text" class="form-control" name="postCode" id="field_postCode" ng-model="vm.sponsor.address.postCode" ng-maxlength="50" required><div ng-show="editForm.postCode.$invalid"><p class="text-danger" ng-show="editForm.postCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="text-danger" ng-show="editForm.postCode.$error.required" translate="entity.validation.required">This field is required.</p></div></div><!-- <div class="form-group">\n      <label class="control-label" for="field_country">Country</label>\n      <input type="text" class="form-control" name="country" id="field_country"\n              ng-model="vm.sponsor.address.country"\n              ng-maxlength="3" />\n      <div ng-show="editForm.country.$invalid">\n          <p class="text-danger"\n              ng-show="editForm.country.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="3">\n              This field cannot be longer than 3 characters.\n          </p>\n      </div>\n  </div> --></form></div><div class="modal-footer bkg-wb-yellow" style="text-align:center"><button type="button" class="btn btn-default bkg-wb-yellow rounded-0" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-default rounded-0" form="sponsor-edit-form"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/entities/sponsor/sponsors.html','<div><h2 translate="winkballApp.sponsor.home.title">Sponsors</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-success rounded-0" ui-sref="sponsor.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.sponsor.home.createLabel">Create new Sponsor</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.sponsor.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sponsorName"><span translate="winkballApp.sponsor.sponsorName">Sponsor Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contactName"><span translate="winkballApp.sponsor.contactName">Contact Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="contactEmail"><span translate="winkballApp.sponsor.contactEmail">Contact Email</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdDate"><span translate="winkballApp.sponsor.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="finder.login"><span translate="winkballApp.sponsor.finder">Sponsor Finder</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="sponsor in vm.sponsors track by sponsor.id"><td><a ui-sref="sponsor-detail({id:sponsor.id})">{{sponsor.id}}</a></td><td>{{sponsor.sponsorName}}</td><td>{{sponsor.contactName}}</td><td>{{sponsor.contactEmail}}</td><td>{{sponsor.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{sponsor.finder.login}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sponsor-detail({id:sponsor.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ng-disabled="!vm.canEdit(sponsor)" ui-sref="sponsor.edit({id:sponsor.id})" class="btn btn-primary btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ng-disabled="!vm.isManager()" ui-sref="sponsor.delete({id:sponsor.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/video-file/video-file-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.videoFile.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.videoFile.delete.question" translate-values="{id: \'{{vm.videoFile.id}}\'}">Are you sure you want to delete this Video File?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/video-file/video-file-detail.html','<div><h2><span translate="winkballApp.videoFile.detail.title">Video File</span> {{vm.videoFile.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.videoFile.guid">Guid</span></dt><dd><span>{{vm.videoFile.guid}}</span></dd><!-- <dt><span translate="winkballApp.videoFile.puid">Puid</span></dt>\n        <dd>\n            <span>{{vm.videoFile.puid}}</span>\n        </dd> --><dt><span translate="winkballApp.videoFile.status">Status</span></dt><dd><span translate="{{\'winkballApp.VideoStatus.\' + vm.videoFile.status}}">{{vm.videoFile.status}}</span></dd><dt><span>File Name</span></dt><dd><span>{{vm.videoFile.fileName}}</span></dd><dt><span>Deleted</span></dt><dd><span>{{vm.videoFile.deleted}}</span></dd><dt><span>Created Date</span></dt><dd><span>{{vm.videoFile.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span>Created By</span></dt><dd><a ui-sref="user-management-detail({login:vm.videoFile.createdBy})">{{vm.videoFile.createdBy}}</a></dd><dt><span translate="winkballApp.videoFile.bitrate">Bitrate</span></dt><dd><span>{{vm.videoFile.bitrate}}</span></dd><dt><span translate="winkballApp.videoFile.audiosamplerate">Audiosamplerate</span></dt><dd><span>{{vm.videoFile.audiosamplerate}}</span></dd><dt><span translate="winkballApp.videoFile.filesize">Filesize</span><span> (MB)</span></dt><dd><span>{{vm.videoFile.filesize/1000000 | number:0 }}</span></dd><dt><span translate="winkballApp.videoFile.duration">Duration</span><span> (min)</span></dt><dd><span>{{vm.videoFile.duration/60000 | number:2}}</span></dd><dt><span translate="winkballApp.videoFile.framerate">Framerate</span></dt><dd><span>{{vm.videoFile.framerate}}</span></dd><dt><span translate="winkballApp.videoFile.width">Width</span></dt><dd><span>{{vm.videoFile.width}}</span></dd><dt><span translate="winkballApp.videoFile.height">Height</span></dt><dd><span>{{vm.videoFile.height}}</span></dd><dt><span translate="winkballApp.videoFile.codec">Codec</span></dt><dd><span>{{vm.videoFile.codec}}</span></dd><dt><span translate="winkballApp.videoFile.audiocodec">Audiocodec</span></dt><dd><span>{{vm.videoFile.audiocodec}}</span></dd></dl><div ng-show="vm.videoFile.guid && !vm.videoFile.deleted"><video ng-src="{{vm.getVideoSrc() | trustURL}}" controls></video></div><hr><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="video-file-detail.edit({id:vm.videoFile.id})" has-any-authority="ROLE_ADMIN,ROLE_MANAGER" class="btn btn-primary rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/video-file/video-file-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVideoFileLabel" translate="winkballApp.videoFile.home.createOrEditLabel">Create or edit a Video File</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.videoFile.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.videoFile.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="winkballApp.videoFile.guid" for="field_guid">Guid</label><input type="text" class="form-control" name="guid" id="field_guid" ng-model="vm.videoFile.guid" ng-maxlength="36" readonly="readonly"><div ng-show="editForm.guid.$invalid"><p class="help-block" ng-show="editForm.guid.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="36">This field cannot be longer than 36 characters.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.videoFile.puid" for="field_puid">Puid</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.videoFile.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"><div ng-show="editForm.puid.$invalid"><p class="help-block" ng-show="editForm.puid.$error.minlength" translate="entity.validation.minlength" translate-value-min="12">This field is required to be at least 12 characters.</p><p class="help-block" ng-show="editForm.puid.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="12">This field cannot be longer than 12 characters.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.videoFile.status" for="field_status">Status</label><select class="form-control" name="status" ng-model="vm.videoFile.status" id="field_status" required><option value="UNINITIALISED" translate="winkballApp.VideoStatus.UNINITIALISED">UNINITIALISED</option><option value="IMPORTED" translate="winkballApp.VideoStatus.IMPORTED">IMPORTED</option><option value="FAILED" translate="winkballApp.VideoStatus.FAILED">FAILED</option><option value="PENDING" translate="winkballApp.VideoStatus.PENDING">PENDING</option><option value="PROCESSING" translate="winkballApp.VideoStatus.PROCESSING">PROCESSING</option><option value="OK" translate="winkballApp.VideoStatus.OK">OK</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.videoFile.bitrate" for="field_bitrate">Bitrate</label><input type="number" class="form-control" name="bitrate" id="field_bitrate" ng-model="vm.videoFile.bitrate"></div><div class="form-group"><label class="control-label" translate="winkballApp.videoFile.audiosamplerate" for="field_audiosamplerate">Audiosamplerate</label><input type="number" class="form-control" name="audiosamplerate" id="field_audiosamplerate" ng-model="vm.videoFile.audiosamplerate"></div><div class="form-group"><label class="control-label" translate="winkballApp.videoFile.filesize" for="field_filesize">Filesize</label><input type="number" class="form-control" name="filesize" id="field_filesize" ng-model="vm.videoFile.filesize"></div><div class="form-group"><label class="control-label" for="field_filename">File Name</label><input type="text" class="form-control" name="fileName" id="field_filename" ng-model="vm.videoFile.fileName"></div><div class="form-group"><label class="control-label" translate="winkballApp.videoFile.duration" for="field_duration">Duration</label><input type="number" class="form-control" name="duration" id="field_duration" ng-model="vm.videoFile.duration"></div><div class="form-group"><label class="control-label" translate="winkballApp.videoFile.framerate" for="field_framerate">Framerate</label><input type="number" class="form-control" name="framerate" id="field_framerate" ng-model="vm.videoFile.framerate"></div><div class="form-group"><label class="control-label" translate="winkballApp.videoFile.width" for="field_width">Width</label><input type="number" class="form-control" name="width" id="field_width" ng-model="vm.videoFile.width"></div><div class="form-group"><label class="control-label" translate="winkballApp.videoFile.height" for="field_height">Height</label><input type="number" class="form-control" name="height" id="field_height" ng-model="vm.videoFile.height"></div><div class="form-group"><label class="control-label" translate="winkballApp.videoFile.codec" for="field_codec">Codec</label><input type="text" class="form-control" name="codec" id="field_codec" ng-model="vm.videoFile.codec"></div><div class="form-group"><label class="control-label" translate="winkballApp.videoFile.audiocodec" for="field_audiocodec">Audiocodec</label><input type="text" class="form-control" name="audiocodec" id="field_audiocodec" ng-model="vm.videoFile.audiocodec"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/video-file/video-files.html','<div><h2 translate="winkballApp.videoFile.home.title">Video Files</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!-- <button class="btn btn-primary" ui-sref="video-file.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span class="hidden-xs"  translate="winkballApp.videoFile.home.createLabel">\n                        Create new Video File\n                    </span>\n                </button> --></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.videoFile.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="guid"><span translate="winkballApp.videoFile.guid">Guid</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="status"><span translate="winkballApp.videoFile.status">Status</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fileName"><span>Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="filesize"><span>Size (MB)</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="duration"><span translate="winkballApp.videoFile.duration">Duration</span> <span>(min)</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="videoFile in vm.videoFiles track by videoFile.id"><td><a ui-sref="video-file-detail({id:videoFile.id})">{{videoFile.id}}</a></td><td>{{videoFile.guid}}</td><td translate="{{\'winkballApp.VideoStatus.\' + videoFile.status}}">{{videoFile.status}}</td><td>{{videoFile.fileName}}</td><td>{{videoFile.filesize/1000000 | number:0}}</td><td>{{videoFile.duration/60000 | number:2}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="video-file-detail({id:videoFile.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button><!-- <button type="submit"\n                                    ui-sref="video-file.edit({id:videoFile.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span>\n                            </button> --> <button type="submit" has-any-authority="ROLE_ADMIN,ROLE_MANAGER" ui-sref="video-file.delete({id:videoFile.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/video/video-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.video.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.video.delete.question" translate-values="{id: \'{{vm.video.id}}\'}">Are you sure you want to delete this Video?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/video/video-detail.html','<div><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info btn-lg rounded-0"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="video-detail.edit({id:vm.video.id})" has-any-authority="ROLE_REPORTER,ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN" class="btn btn-primary btn-lg rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button><h2><span translate="winkballApp.video.detail.title">Video</span> {{vm.video.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.video.puid">Puid</span></dt><dd><span>{{vm.video.puid}}</span></dd><dt><span translate="winkballApp.video.title">Title</span></dt><dd><span>{{vm.video.title}}</span></dd><dt><span translate="winkballApp.video.description">Description</span></dt><dd><span>{{vm.video.description}}</span></dd><dt><span translate="winkballApp.video.published">Published</span></dt><dd><span>{{vm.video.published}}</span></dd><dt><span>Thumbnail</span></dt><dd><span>{{vm.video.thumbnail}}</span></dd><dt><span>Category</span></dt><dd><span>{{vm.video.category}}</span></dd><dt><span translate="winkballApp.video.videoFile">Video File</span></dt><dd><a ui-sref="video-file-detail({id:vm.video.videoFileId})">{{vm.video.videoFileId}}</a></dd><dt><span translate="winkballApp.video.location">Location</span></dt><dd><a ui-sref="location-detail({id:vm.video.locationId})">{{vm.video.locationId}}</a></dd><dt><span translate="winkballApp.video.keywords">Keywords</span></dt><dd><span ng-repeat="keywords in vm.video.keywords"><a ui-sref="keyword-detail({id: keywords.id})">{{keywords.text}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><div ng-if="vm.video.thumbnail"><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Thumbnail"><hr></div><div ng-if="vm.video.videoFileGuid"><h3>Private video URLs:</h3><em>Player: </em><a target="_blank" href="{{\'https://www.winkball.com/iplayer/\' + vm.video.videoFileGuid}}">{{\'https://www.winkball.com/iplayer/\' + vm.video.videoFileGuid}}</a><br><em>Player and sharing panel: </em><a target="_blank" href="{{\'https://www.winkball.com/videos/\' + vm.video.id}}">{{\'https://www.winkball.com/videos/\' + vm.video.id}}</a><hr></div><div ng-show="vm.video.videoFileGuid" class="embed-responsive embed-responsive-16by9"><video class="embed-responsive-item" ng-src="{{vm.getVideoSrc() | trustURL}}" controls></video></div></div>');
$templateCache.put('app/entities/video/video-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVideoLabel" translate="winkballApp.video.home.createOrEditLabel">Create or edit a Video</h4></div><div class="modal-body"><form name="editForm" id="videoEditForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" ng-show="vm.video.id"><div class="col-md-6"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.video.id" readonly="readonly"></div><div class="col-md-6"><label class="control-label" translate="winkballApp.video.puid" for="field_puid">Puid</label><input type="text" class="form-control" name="puid" id="field_puid" ng-model="vm.video.puid" ng-minlength="12" ng-maxlength="12" readonly="readonly"></div></div><div class="form-group"><label class="control-label" translate="winkballApp.video.title" for="field_title">Title</label><input type="text" class="form-control" name="title" id="field_title" ng-model="vm.video.title" required><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" translate="winkballApp.video.description" for="field_description">Description</label><textarea class="form-control" name="description" id="field_description" rows="5" ng-model="vm.video.description"></textarea></div><div class="form-group"><label class="control-label" translate="winkballApp.video.published" for="field_published">Published</label><input type="checkbox" class="form-control" name="published" id="field_published" ng-model="vm.video.published"><div ng-show="editForm.published.$invalid"><p class="help-block" ng-show="editForm.published.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><h4>Location</h4><tags-input ng-model="vm.tagLocation" max-tags="1" replace-spaces-with-dashes="false" display-property="title" key-property="id" placeholder="{{vm.tagLocation.length > 0 ? \' \' : \'Type to search for an existing location\'}}" add-from-autocomplete-only="true"><auto-complete source="vm.searchLocation($query)" min-length="3" max-results-to-show="10"></auto-complete></tags-input></div><div class="form-group"><h4 translate="winkballApp.video.keywords">Keywords</h4><tags-input add-from-autocomplete-only="true" display-property="text" ng-model="vm.video.keywords" placeholder="{{vm.video.keywords.length > 0 ? \' \' : \'Add a keyword\'}}"><auto-complete max-results-to-show="10" min-length="3" source="vm.loadKeywords($query)"></auto-complete></tags-input></div><div class="form-group"><label for="field_category">Category</label><select class="form-control" id="field_category" name="category" ng-model="vm.video.category" ng-options="category as category for category in vm.categories"></select></div></form><div class="file-holder"><div ng-if="!vm.video.thumbnail" id="field_thumbnail"><h4>Thumbnail</h4><button type="file" class="btn btn-primary" ng-disabled="editForm.$invalid || vm.isSaving" ngf-select="vm.uploadFile($file, $invalidFiles, true)" accept="image/jpeg,image/png" ngf-max-size="5MB"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button> <span ng-show="!vm.videofile" style="font:smaller">{{vm.f.name}} {{vm.errFile.name}} {{vm.errFile.$error}} {{vm.errFile.$errorParam}}</span> <span class="progress" ng-show="vm.f.progress >= 0 && !vm.videofile"><div ng-style="{width: vm.f.progress + \'%\'}" ng-bind="vm.f.progress + \'%\'"></div></span><p>{{errorMsg}}</p></div><div ng-if="vm.video.thumbnail"><h4>Thumbnail</h4><button type="button" ng-click="vm.deleteThumbnail()" class="btn btn-danger"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span>Delete Thumbnail</span></button><hr><img class="img-responsive" ng-src="{{vm.getImageSrc() | trustURL}}" alt="Thumbnail"><hr></div><div ng-if="!vm.video.videoFileGuid" id="field_videoFile"><h4 translate="winkballApp.video.videoFile">Video File</h4><button type="file" class="btn btn-primary" ng-disabled="editForm.$invalid || vm.isSaving" ngf-select="vm.uploadFile($file, $invalidFiles)" accept="video/mp4" ngf-max-size="800MB"><span class="glyphicon glyphicon-upload"></span>&nbsp;<span translate="entity.action.upload">Upload</span></button> <span ng-show="vm.videofile" style="font:smaller">{{vm.f.name}} {{vm.errFile.name}} {{vm.errFile.$error}} {{vm.errFile.$errorParam}}</span> <span class="progress" ng-show="vm.f.progress >= 0 && vm.videofile"><div ng-style="{width: vm.f.progress + \'%\'}" ng-bind="vm.f.progress + \'%\'"></div></span><p>{{errorMsg}}</p></div><div ng-if="vm.video.videoFileGuid" class="embed-responsive embed-responsive-16by9"><h4 translate="winkballApp.video.videoFile">Video File</h4><hr><video class="embed-responsive-item" ng-src="{{vm.getVideoSrc() | trustURL}}" controls></video></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" form="videoEditForm"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/entities/video/videos.html','<div><h2 translate="winkballApp.video.home.title">Videos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary rounded-0" ui-sref="video.new" has-any-authority="ROLE_REPORTER,ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.video.home.createLabel">Create new Video</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.video.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="puid"><span translate="winkballApp.video.puid">Puid</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span translate="winkballApp.video.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="category"><span>Category</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="published"><span translate="winkballApp.video.published">Published</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="videoFileId"><span translate="winkballApp.video.videoFile">Video File</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="locationId"><span translate="winkballApp.video.location">Location</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="video in vm.videos track by video.id"><td><a ui-sref="video-detail({id:video.id})">{{video.id}}</a></td><td>{{video.puid}}</td><td>{{video.title}}</td><td>{{video.category}}</td><td>{{video.published}}</td><td><a ui-sref="video-file-detail({id:video.videoFileId})">{{video.videoFileId}}</a></td><td><a ui-sref="location-detail({id:video.locationId})">{{video.locationId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="video-detail({id:video.id})" class="btn btn-info btn-sm rounded-0"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" has-any-authority="ROLE_REPORTER,ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN" ui-sref="video.edit({id:video.id})" class="btn btn-primary btn-sm rounded-0"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" has-any-authority="ROLE_REPORTER,ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN" ui-sref="video.delete({id:video.id})" class="btn btn-danger btn-sm rounded-0"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/sponsor-invoice/sponsor-invoice-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sponsorInvoice.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.sponsorInvoice.delete.question" translate-values="{id: \'{{vm.sponsorInvoice.id}}\'}">Are you sure you want to delete this Sponsor Invoice?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/sponsor-invoice/sponsor-invoice-detail.html','<div><button type="submit" ng-click="vm.back()" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="sponsor-invoice-detail.edit({id:vm.sponsorInvoice.id})" class="btn btn-primary" ng-disabled="!vm.canEdit()"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button><h2><span translate="winkballApp.sponsorInvoice.detail.title">Sponsor Payment</span> : {{vm.sponsorInvoice.sponsor.sponsorName}}</h2><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>ID</span></dt><dd><span>{{vm.sponsorInvoice.id}}</span></dd><dt><span translate="winkballApp.sponsorInvoice.paymentDate">Payment Date</span></dt><dd><span>{{vm.sponsorInvoice.paymentDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span translate="winkballApp.sponsorInvoice.amount">Amount</span></dt><dd><span>{{vm.sponsorInvoice.amount}}</span></dd><dt><span>Created Date</span></dt><dd><span>{{vm.sponsorInvoice.createdDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span>Created By</span></dt><dd><span>{{vm.sponsorInvoice.createdBy}}</span></dd><dt><span>Last Modified Date</span></dt><dd><span>{{vm.sponsorInvoice.lastModifiedDate | date:\'dd/MM/yyyy HH:mm\'}}</span></dd><dt><span>Last Modified By</span></dt><dd><span>{{vm.sponsorInvoice.lastModifiedBy}}</span></dd></dl></div>');
$templateCache.put('app/entities/sponsor-invoice/sponsor-invoice-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySponsorInvoiceLabel" translate="winkballApp.sponsorInvoice.home.createOrEditLabel">Create or edit a Sponsor Invoice</h4></div><div class="modal-body"><form id="sponsor-invoice-edit-form" name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><jhi-alert-error></jhi-alert-error><div class="form-group clearfix" ng-show="vm.sponsorInvoice.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sponsorInvoice.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_price">Amount (GBP \xA3)</label><input id="field_price" type="number" step="any" class="form-control" name="field_price" step="any" min="0" ng-model="vm.sponsorInvoice.amount" required="required"><div ng-show="editForm.field_price.$invalid"><p class="help-block">This field is required, only positive values are allowed.</p></div></div><div class="form-group"><label for="field_sponsor">Sponsor</label><select class="form-control" id="field_sponsor" name="sponsor" ng-model="vm.sponsorInvoice.sponsor" ng-options="sponsor as sponsor.sponsorName for sponsor in vm.sponsors track by sponsor.id"><option value=""></option></select></div><div class="form-group"><label class="control-label" for="field_paymentDate">Payment Date</label><div class="input-group"><input id="field_paymentDate" type="text" class="form-control" name="paymentDate" datetime-picker="{{dateformat}}" ng-model="vm.sponsorInvoice.paymentDate" is-open="vm.datePickerOpenStatus.paymentDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'paymentDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><p class="help-block">Please enter a payment date</p></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" form="sponsor-invoice-edit-form"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/entities/sponsor-invoice/sponsor-invoices.html','<div><h2>Sponsor Payments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="sponsor-invoice.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Sponsor Payment</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.sponsorInvoice.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span translate="global.field.id">ID</span></th><th><span>Payment Date</span></th><th><span>Amount</span></th><th><span>Sponsor</span></th><th></th></tr></thead><tbody><tr ng-repeat="sponsorInvoice in vm.sponsorInvoices track by sponsorInvoice.id"><td><a ui-sref="sponsor-invoice-detail({id:sponsorInvoice.id})">{{sponsorInvoice.id}}</a></td><td>{{sponsorInvoice.paymentDate | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{sponsorInvoice.amount}}</td><td>{{sponsorInvoice.sponsor.sponsorName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sponsor-invoice-detail({id:sponsorInvoice.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ng-disabled="!vm.canEdit(sponsorInvoice)" ui-sref="sponsor-invoice.edit({id:sponsorInvoice.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ng-disabled="!vm.canEdit(sponsorInvoice)" ui-sref="sponsor-invoice.delete({id:sponsorInvoice.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div class="alert alert-danger" translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/entities/web-link/web-link-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.webLink.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="winkballApp.webLink.delete.question" translate-values="{id: \'{{vm.webLink.id}}\'}">Are you sure you want to delete this Web Link?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/web-link/web-link-detail.html','<div><h2><span translate="winkballApp.webLink.detail.title">Web Link</span> {{vm.webLink.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="winkballApp.webLink.title">Title</span></dt><dd><span>{{vm.webLink.title}}</span></dd><dt><span translate="winkballApp.webLink.url">Url</span></dt><dd><span>{{vm.webLink.url}}</span></dd><!-- <dt><span translate="winkballApp.webLink.customer">Customer</span></dt>\n        <dd>\n            <a ui-sref="customer-detail({id:vm.webLink.customer.id})">{{vm.webLink.customer.id}}</a>\n        </dd> --><dt><span translate="winkballApp.webLink.reporter">Reporter</span></dt><dd><a ui-sref="reporter-detail({id:vm.webLink.reporterId})">{{vm.webLink.reporterId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="web-link-detail.edit({id:vm.webLink.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/web-link/web-link-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myWebLinkLabel" translate="winkballApp.webLink.home.createOrEditLabel">Create or edit a Web Link</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.webLink.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.webLink.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="winkballApp.webLink.title" for="field_title">Title</label><select class="form-control" id="field_title" name="reporter" ng-model="vm.webLink.title" required><option value="blog">Blog</option><option value="facebook">Facebook</option><option value="forum">Forum</option><option value="twitter">Twitter</option><option value="website">Website</option><option value="youtube">YouTube</option></select><!-- <input type="text" class="form-control" name="title" id="field_title"\n                    ng-model="vm.webLink.title"\n                    required ng-maxlength="150" /> --><div ng-show="editForm.title.$invalid"><p class="help-block" ng-show="editForm.title.$error.required" translate="entity.validation.required">This field is required.</p><!-- <p class="help-block"\n                    ng-show="editForm.title.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="150">\n                    This field cannot be longer than 150 characters.\n                </p> --></div></div><div class="form-group"><label class="control-label" translate="winkballApp.webLink.url" for="field_url">Url</label><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.webLink.url" required><div ng-show="editForm.url.$invalid"><p class="help-block" ng-show="editForm.url.$error.required" translate="entity.validation.required">This field is required.</p></div></div><!-- <div class="form-group" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN">\n            <label translate="winkballApp.webLink.customer" for="field_customer">Customer</label>\n            <select class="form-control" id="field_customer" name="customer" ng-model="vm.webLink.customer" ng-options="customer as customer.id for customer in vm.customers track by customer.id">\n                <option value=""></option>\n            </select>\n        </div> --><div class="form-group"><label translate="winkballApp.webLink.reporter" for="field_reporter">Reporter</label><select class="form-control" id="field_reporter" name="reporter" ng-model="vm.webLink.reporterId" required ng-options="reporter.id as (reporter.firstName + \' \' + reporter.lastName) for reporter in vm.reporters"><option value=""></option></select><div ng-show="editForm.url.$invalid"><p class="help-block" ng-show="editForm.url.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/web-link/web-links.html','<div><h2 translate="winkballApp.webLink.home.title">Web Links</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="web-link.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="winkballApp.webLink.home.createLabel">Create new Web Link</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'winkballApp.webLink.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title"><span translate="winkballApp.webLink.title">Title</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="url"><span translate="winkballApp.webLink.url">Url</span> <span class="glyphicon glyphicon-sort"></span></th><!-- <th jh-sort-by="customer.id"><span translate="winkballApp.webLink.customer">Customer</span> <span class="glyphicon glyphicon-sort"></span></th> --><th jh-sort-by="reporter.id"><span translate="winkballApp.webLink.reporter">Reporter</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="webLink in vm.webLinks track by webLink.id"><td><a ui-sref="web-link-detail({id:webLink.id})">{{webLink.id}}</a></td><td>{{webLink.title}}</td><td>{{webLink.url}}</td><!-- <td>\n                        <a ui-sref="customer-detail({id:webLink.customer.id})">{{webLink.customer.id}}</a>\n                    </td> --><td><a ui-sref="reporter-detail({id:webLink.reporterId})">{{webLink.reporterId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="web-link-detail({id:webLink.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="web-link.edit({id:webLink.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="web-link.delete({id:webLink.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-inverse rounded-0" role="navigation"><div class="container-fluid"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img hidden-sm hidden-xs" src="content/images/logo-winkball-hub.png"> <img class="logo-img hidden-md hidden-lg" src="content/images/wblogo.png"> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav pull-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm">Menu </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" has-any-authority="ROLE_MANAGER,ROLE_ADMIN"><a ui-sref="job" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Projects</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_MANAGER,ROLE_ADMIN"><a ui-sref="sponsor" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Sponsors</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="sponsor-invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Sponsor Payments</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_MANAGER,ROLE_ADMIN"><a ui-sref="event" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.event">Event</span></a></li><li ui-sref-active="active"><a ui-sref="film" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.film">Report</span></a></li><li ui-sref-active="active"><a ui-sref="interview" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.interview">Interview</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_REPORTER,ROLE_ADMIN"><a ui-sref="media-package" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Media Packages</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="location" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.location">Location</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="keyword" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.keyword">Keyword</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="web-link" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.webLink">Web Link</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><a ui-sref="postal-address" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.postalAddress">Postal Address</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_MANAGER,ROLE_SUPERVISOR"><a ui-sref="advert" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.advert">Advert</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><a ui-sref="video" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.video">Video</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><a ui-sref="image" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Images</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a ui-sref="video-file" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.videoFile">Video File</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_MANAGER"><a ui-sref="prospective-reporter" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Prospective Reporters</span></a></li><li ui-sref-active="active"><a ui-sref="reporter" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.reporter">Reporter</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><a ui-sref="media-contact" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Media Contacts</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_MANAGER,ROLE_SUPERVISOR,ROLE_ADMIN"><a ui-sref="inventory-item" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.inventoryItem">Inventory Item</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="event-comment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.eventComment">Event Comment</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="interview-comment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.interviewComment">Interview Comment</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="film-comment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Report Comment</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="skill" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.skill">Skill</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_MANAGER,ROLE_ADMIN"><a ui-sref="prospective-publisher" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Prospective Publishers</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_MANAGER,ROLE_ADMIN"><a ui-sref="publisher" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Publishers</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_REPORTER,ROLE_ADMIN"><a ui-sref="customer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Businesses</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_MANAGER,ROLE_ADMIN"><a ui-sref="commission-report-request" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Commission Report Requests</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true" has-authority="ROLE_REPORTER"><a ui-sref="reporter-detail-login({login: vm.username})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span>Your profile</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span translate="global.menu.account.login">Sign in</span></a></li><!-- <li ui-sref-active="active" ng-switch-when="false">\n                            <a ui-sref="register" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-plus-sign"></span>&nbsp;\n                                <span translate="global.menu.account.register">Register</span>\n                            </a>\n                        </li> --></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="entity-audit" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span translate="global.menu.admin.entity-audit">Entity Audit</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm" has-authority="ROLE_USER"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();